(function () {
    'use strict';

    angular
        .module('gruposinAdmin', ['ngAnimate',
            'ngCookies',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ngResource',
            'ui.router',
            'ui.bootstrap',
            'toastr',
            'ui.grid', 
            'ui.grid.expandable', 
            'ui.grid.selection', 
            'ui.grid.pinning',
            'ui.grid.exporter',
            'ui.grid.pagination',
            'ngMaterial',
            'LocalStorageModule',
            'ui.grid.autoResize',
            'ui.grid.pinning',
            'ui.utils.masks',
            'ui.grid.edit',
            'ui.grid.cellNav',
            'lfNgMdFileInput',
            'ngTagsInput',
            'ngFileUpload',
            'user-friendly-angular-json-tree'
        ]);
})();

(function() {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('VendedorController', VendedorController)

  /** @ngInject */
  function VendedorController($timeout, toastr, UserService, $scope, uiGridConstants, $mdDialog, uiGridExporterService, uiGridExporterConstants, AuthenticationFactory, $window, $document) {

    var API = UserService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.exportReport = function(router){
      AuthenticationFactory.exportReport(router);
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.export = function(){
      var exportService=uiGridExporterService;
      var grid=$scope.gridApi.grid;
      var fileName= 'Vendedores.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function() {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };

    vm.edit = function(ev, item) {

        var obj = {};
        obj.dataNascimento = new Date();
        obj.role = 'Vendedor';

        if(item){
          item.dataNascimento = $window.moment(item.dataNascimento).toDate(); //new Date(item.dataNascimento);

          obj = item;
        }

        $mdDialog.show({
                controller: function($scope, $http, AuthenticationFactory) {

                  var vm = this;
                  vm.form = obj;

                  vm.refresh = function(){
                      getPage();
                      vm.hide();
                  };

                  vm.updateAddress = function() {
                    AuthenticationFactory.getCEP(vm.form.cep)
                        .then(function(endereco) {
                            vm.form.enderecoResidencial = endereco.logradouro;
                            vm.form.cidade = endereco.localidade;
                            vm.form.bairro = endereco.bairro;
                            vm.form.uf = endereco.uf.toLowerCase();
                    });
                  };

                  vm.hide = function() {
                      $mdDialog.hide();
                  };

                  vm.cancel = function() {
                      $mdDialog.cancel();
                  };

                  vm.save = function() {

                      if(vm.form._id){
                        API.update({id: vm.form._id}, vm.form, vm.refresh);
                      }else{
                        API.save(vm.form, vm.refresh);
                      }
                  };
                },
                controllerAs: 'ctrl',
                templateUrl: 'app/vendedor/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {local: [vm.editDialog, vm]},
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        { name: 'createdAt', enableSorting: true, width:170, displayName: 'Data Cadastro',  type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'' },
        { name: 'name', enableSorting: true, displayName: 'Nome' },
        { name: 'username', enableSorting: true, displayName: 'Nome de Usuário'},
        { name: 'cpf', enableSorting: true, displayName: 'CPF' },
        { name: 'email', enableSorting: true, displayName: 'E-mail' },
        { name: 'comissaoVendedor', enableSorting: true, displayName: '% Comissão' },
        { name: 'status', enableSorting: true, displayName: 'Status' },
        { name: 'edit', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditVendedor" module="vendedores" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteVendedor" module="vendedores" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.loading = true;
    var getPage = function() {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;
      var obj = {};

      if(role === 'Vendedor'){
        obj = {_id : id};
      }

      

      API.query(obj).$promise.then(function(resp){
        vm.gridOptions.data = resp.filter(function(item){ return item.role === 'Vendedor' });
        vm.loading = false;
      });
    };

    getPage();
  }

})();

(function () {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('ValidacaoController', ValidacaoController)
    .factory('ValidacaoService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'pedido/:id?populate=cliente profissional unidade', {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
      return data;
    });

  /** @ngInject */
  function ValidacaoController(uiGridConstants, ValidacaoService, AuthenticationFactory, $mdDialog, $document, RedeService, $location, API_PAGAMENTO_DRACHEI_HOST) {

    var API = ValidacaoService;
    var vm = this;

    var userProfile = AuthenticationFactory.profile;

    if (userProfile.user.role === 'Atendente' || userProfile.user.role === 'AdmRede') {
      try {
        var rede = userProfile.user.rede;
        if (!rede && !rede._id) {
          throw new Error();
        }
      } catch (error) {
        alert('Usuário não está cadastrado em nenhuma rede, entre em contato com o Administrador do sistema.');
        $location.path("/");
      }
    }

    vm.toggleFiltering = function () {
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
    }

    let pagamentoAtoTemplate = "<div class=\"ui-grid-cell-contents ng-binding ng-scope\">{{ row.entity.pagamentoAto ? 'SIM' : '' }}</div>"
    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      enableGridMenu: true,
      exporterExcelFilename: 'validação-' + (new Date()).toLocaleDateString() + '.xlsx',
      columnDefs: [{
          name: 'createdAt',
          enableFiltering: false,
          enableSorting: true,
          displayName: 'Data',
          width: 170,
          type: 'date',
          cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\''
        },
        {
          name: 'zoop_transaction_id',
          enableFiltering: false,
          enableSorting: false,
          displayName: 'ID Transação Zoop',
          width: 270
        },
        {
          name: 'formaPagamento',
          enableFiltering: false,
          enableSorting: false,
          displayName: 'Forma de Pagamento',
          width: 180
        },
        {
          name: 'pagamentoAto',
          field: 'pagamentoAto',
          enableFiltering: false,
          enableSorting: false,
          displayName: 'Pagamento no Ato?',
          cellTemplate: pagamentoAtoTemplate,
          width: 180
        },
        {
          name: 'cliente.cpf',
          enableFiltering: true,
          enableSorting: false,
          displayName: 'CPF',
          width: 130
        },
        {
          name: 'cliente.cartao.numeroCartao',
          enableFiltering: true,
          enableSorting: false,
          displayName: 'Número do Cartão',
          width: 170
        },
        {
          name: 'codigo',
          enableFiltering: true,
          enableSorting: false,
          displayName: 'Voucher',
          width: 100
        },
        {
          name: 'cliente.name',
          enableFiltering: false,
          enableSorting: true,
          displayName: 'Nome do Cliente',
          width: 200
        },
        {
          name: 'tipoPagamento',
          enableFiltering: false,
          enableSorting: true,
          displayName: 'Tipo Pedido',
          width: 170
        },
        {
          name: 'cliente.cartao.status',
          enableFiltering: false,
          enableSorting: true,
          displayName: 'Situação SinSaúde',
          width: 170
        },
        {
          name: 'statusPagamento',
          enableFiltering: false,
          enableSorting: true,
          displayName: 'Situação Pagamento',
          width: 170
        },
        {
          name: 'statusAtendimento',
          enableFiltering: false,
          enableSorting: true,
          displayName: 'Situação Atendimento',
          width: 170
        },
        {
          name: 'cliente.email',
          enableFiltering: false,
          enableSorting: false,
          displayName: 'E-mail',
          width: 170
        },
        {
          name: 'cliente.telefoneCelular',
          enableFiltering: false,
          enableSorting: false,
          displayName: 'Celular',
          width: 140
        },
        {
          name: 'edit',
          enableColumnResizing: false,
          pinnedRight: true,
          width: 50,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" permission="btnEditValidacao" module="validacao" ng-click="grid.appScope.edit($event, row.entity)" title="Informar Atendimento">edit</i>'
        }
      ],
      onRegisterApi: function (gridApi) {
        vm.gridApi = gridApi;

        vm.gridApi.core.on.filterChanged(null, function (v) {
          console.log(v);
        });
      }
    };

    vm.gridOptions.exporterFieldCallback = function ( grid, row, col, value ) {
      if ( col.name === 'createdAt' ) {
        value = new Date(value).toLocaleDateString();
      }
      return value;
    }

    vm.edit = function (ev, item) {
      $mdDialog.show({
        controller: function ($http, AuthenticationFactory) {
          var vm = this;
          vm.form = angular.copy(item);
          vm.loading = false;

          vm.userRole = userProfile.user.role;

          vm.dataHoraAgendamento = null;
          if (vm.form.agendamento && vm.form.agendamento.dataEscolhida) {
            var data;
            if (vm.form.agendamento.dataEscolhida.includes('-')) {
              data = vm.form.agendamento.dataEscolhida.split('T')[0].split('-');
            } else {
              data = vm.form.agendamento.dataEscolhida.split('/');
              var dia = data[0];
              var mes = data[1];
              var ano = data[2];
              data[2] = dia;
              data[1] = mes;
              data[0] = ano;
            }
            var hora = vm.form.agendamento.horarioEscolhido.horario;
            vm.dataHoraAgendamento = data[2] + '/' + data[1] + '/' + data[0] + ' ' + hora;
          }

          vm.valorTotalFormatado = vm.form.valorTotal.toFixed(2);

          vm.refresh = function () {
            vm.loading = false;
            getPage();
            vm.hide();
          };

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.update = function () {
            if (confirm('Essa operação não poderá ser desfeita, confirma atendimento?')) {
              vm.loading = true;
              vm.form.statusAtendimento = 'REALIZADO';
              try {
                API.update({
                  id: vm.form._id
                }, vm.form, vm.refresh);

                if (!vm.form.pagamentoAto) {
                  var profile = AuthenticationFactory.profile;
                  var redeID = item.unidade._id;

                  var total = parseFloat(vm.valorTotalFormatado)

                  var tipoPagamento = vm.form.tipoPagamento;
                  var valorSinSaude = calculateSinSaudeValue(vm.form);

                  var transactionID = item.zoop_transaction_id || item.transaction.id;

                  $http.post(API_PAGAMENTO_DRACHEI_HOST + '/api/v1/split/p2p', {
                      amount: total,
                      description: 'Transferência de validação',
                      data: vm.dataSplit,
                      rede_id: redeID,
                      tipo_pagamento: tipoPagamento,
                      valor_sin_saude: valorSinSaude,
                      transaction_id: transactionID
                    })
                    .then(function (resp) {
                      alert('Operação realizada com sucesso')
                    }).catch(function (error) {
                      console.log(error)
                      alert('Ocorreu um erro ao processar o pagamento. Verifique com o administrador do sistema')
                    })
                }
              } catch (error) {
                console.log(error)
                alert('Ocorreu um erro ao processar o pagamento. Verifique com o administrador do sistema')
              }
            }
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/validacao/dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.loading = true;
    var getPage = function () {
      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var obj = {};

      if (role === 'Vendedor') {
        vm.gridOptions.data = [];
        return
      }

      if (role === 'Atendente' || role === 'AdmRede') {
        var redeId = profile.user.rede._id;
        obj = {
          unidade: redeId
        };
      }

      API.query(obj).$promise.then(function (resp) {
        vm.gridOptions.data = resp || [];
        vm.loading = false;
      });
    };

    var calculateSinSaudeValue = function (pedido) {
      var totalSinSaude = 0;

      if (pedido.tipoPedido === 'EXAME') {
        pedido.exames.forEach(function (exame) {
          totalSinSaude += exame.valorSinSaude;
        });
      } else {
        totalSinSaude = pedido.consulta.valorSinSaude;
      }

      return parseFloat(totalSinSaude);
    };

    getPage();
  }

})();

(function () {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('UserController', UserController)
    .factory('UserService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'user/:id?populate=juridica', {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
      return data;
    });

  /** @ngInject */
  function UserController($timeout, toastr, UserService, $scope, uiGridConstants, $mdDialog, AuthenticationFactory, $document) {

    var API = UserService;
    var vm = this;

    var roles = ['Administrador', 'Master', 'Funcionario', 'Vendedor', 'AdmRede', 'Atendente'];


    var agendamentos = {
      module: 'agendamento',
      moduleName: 'Agendamento',
      rules: [{
          label: 'Listar Agendamentos',
          labelAction: 'btnListAgendamento'
        },
        {
          label: 'Cadastrar Agendamentos',
          labelAction: 'btnNewAgendamento'
        },
        {
          label: 'Editar Agendamentos',
          labelAction: 'btnEditAgendamento'
        },
        {
          label: 'Remover Agendamentos',
          labelAction: 'btnDeleteAgendamento'
        },
        {
          label: 'Exportar Agendamentos',
          labelAction: 'btnExportAgendamento'
        },
        {
          label: 'Importar Agendamentos',
          labelAction: 'btnImportAgendamento'
        }
      ]
    };

    var apolices = {
      module: 'Apolices',
      moduleName: 'Apolices',
      rules: [{
          label: 'Listar Apólices',
          labelAction: 'btnListApolice'
        },
        {
          label: 'Cadastrar Apólices',
          labelAction: 'btnNewApolice'
        },
        {
          label: 'Editar Apólices',
          labelAction: 'btnEditApolice'
        },
        {
          label: 'Remover Apólices',
          labelAction: 'btnDeleteApolice'
        },
        {
          label: 'Exportar Apólices',
          labelAction: 'btnExportApolice'
        },
        {
          label: 'Imprimir Apólices',
          labelAction: 'btnPrintApolice'
        }
      ]
    };

    var cartao = {
      module: 'cartao',
      moduleName: 'Cartões',
      rules: [{
          label: 'Listar Cartões',
          labelAction: 'btnListCartao'
        },
        {
          label: 'Cadastrar Cartões',
          labelAction: 'btnNewCartao'
        },
        {
          label: 'Editar Cartões',
          labelAction: 'btnEditCartao'
        },
        {
          label: 'Remover Cartões',
          labelAction: 'btnDeleteCartao'
        },
        {
          label: 'Exportar Cartões',
          labelAction: 'btnExportCartao'
        }
      ]
    };

    var clientes = {
      module: 'client',
      moduleName: 'Cliente',
      rules: [{
          label: 'Listar Clientes',
          labelAction: 'btnListClient'
        },
        {
          label: 'Cadastrar Clientes',
          labelAction: 'btnNewClient'
        },
        {
          label: 'Editar Clientes',
          labelAction: 'btnEditClient'
        },
        {
          label: 'Remover Clientes',
          labelAction: 'btnDeleteClient'
        },
        {
          label: 'Exportar Clientes',
          labelAction: 'btnExportClient'
        },
        {
          label: 'Alterar Status dos Clientes',
          labelAction: 'btnStatusClient'
        },
        {
          label: 'Importar Clientes',
          labelAction: 'btnImportClient'
        },
        {
          label: 'Gerar Cobranças',
          labelAction: 'btnGenerateBilling'
        },
        {
          label: 'Listar Cobranças',
          labelAction: 'btnListBilling'
        }
      ]
    };

    var cupons = {
      module: 'cupom',
      moduleName: 'Cupom',
      rules: [{
          label: 'Listar Cupons',
          labelAction: 'btnListCupom'
        },
        {
          label: 'Cadastrar Cupons',
          labelAction: 'btnNewCupom'
        },
        {
          label: 'Editar Cupons',
          labelAction: 'btnEditCupom'
        },
        {
          label: 'Remover Cupons',
          labelAction: 'btnDeleteCupom'
        },
        {
          label: 'Exportar Cupons',
          labelAction: 'btnExportCupom'
        }
      ]
    };

    var documentos = {
      module: 'documento',
      moduleName: 'Documentos',
      rules: [{
          label: 'Listar Documentos',
          labelAction: 'btnListDocumento'
        },
        {
          label: 'Cadastrar Documentos',
          labelAction: 'btnNewDocumento'
        },
        {
          label: 'Editar Documentos',
          labelAction: 'btnEditDocumento'
        },
        {
          label: 'Remover Documentos',
          labelAction: 'btnDeleteDocumento'
        }
      ]
    };

    var emails = {
      module: 'email',
      moduleName: 'E-mails',
      rules: [{
          label: 'Listar E-mails',
          labelAction: 'btnListEmail'
        },
        {
          label: 'Cadastrar E-mails',
          labelAction: 'btnNewEmail'
        },
        {
          label: 'Editar E-mails',
          labelAction: 'btnEditEmail'
        },
        {
          label: 'Remover E-mails',
          labelAction: 'btnDeleteEmail'
        },
        {
          label: 'Exportar E-mails',
          labelAction: 'btnExportEmail'
        }
      ]
    };

    var emprestimos = {
      module: 'emprestimo',
      moduleName: 'Empréstimos',
      rules: [{
          label: 'Listar Empréstimos',
          labelAction: 'btnListEmprestimo'
        },
        {
          label: 'Cadastrar Empréstimos',
          labelAction: 'btnNewEmprestimo'
        },
        {
          label: 'Editar Empréstimos',
          labelAction: 'btnEditEmprestimo'
        },
        {
          label: 'Remover Empréstimos',
          labelAction: 'btnDeleteEmprestimo'
        }
      ]
    };

    var pjuridica = {
      module: 'pjuridica',
      moduleName: 'P. Jurídica',
      rules: [{
          label: 'Listar P.J',
          labelAction: 'btnListPJ'
        },
        {
          label: 'Cadastrar P.J',
          labelAction: 'btnNewPJ'
        },
        {
          label: 'Editar P.J',
          labelAction: 'btnEditPJ'
        },
        {
          label: 'Remover P.J',
          labelAction: 'btnDeletePJ'
        },
        {
          label: 'Exportar Relatório',
          labelAction: 'btnExportPJ'
        },
        {
          label: 'Gerar Cobrança',
          labelAction: 'btnGenerateBillingPJ'
        },
        {
          label: 'Listar CobrançaPJ',
          labelAction: 'btnListBillingPJ'
        }
      ]
    };

    var planos = {
      module: 'plan',
      moduleName: 'Planos',
      rules: [{
          label: 'Listar Planos',
          labelAction: 'btnListPlano'
        },
        {
          label: 'Cadastrar Plano',
          labelAction: 'btnNewPlano'
        },
        {
          label: 'Editar Plano',
          labelAction: 'btnEditPlano'
        },
        {
          label: 'Remover plano',
          labelAction: 'btnDeletePlano'
        }
        // {
        //   label: 'Modificar nome do Plano',
        //   labelAction: 'btnDeletePlano'
        // },
        // {
        //   label: 'Modificar valor do Plano',
        //   labelAction: 'btnDeletePlano'
        // },
        // {
        //   label: 'Modificar valor de taxa de adesão',
        //   labelAction: 'btnDeletePlano'
        // },
        // {
        //   label: 'Modificar imagem do plano',
        //   labelAction: 'btnDeletePlano'
        // }
      ]
    };

    var redes = {
      module: 'rede',
      moduleName: 'Redes',
      rules: [{
          label: 'Listar Redes',
          labelAction: 'btnListRede'
        },
        {
          label: 'Cadastrar Redes',
          labelAction: 'btnNewRede'
        },
        {
          label: 'Visualizar Redes',
          labelAction: 'btnViewRede'
        },
        {
          label: 'Editar Redes',
          labelAction: 'btnEditRede'
        },
        {
          label: 'Remover Redes',
          labelAction: 'btnDeleteRede'
        },
        {
          label: 'Exportar Redes',
          labelAction: 'btnExportRede'
        },
        {
          label: 'Importar Redes',
          labelAction: 'btnImportRede'
        },
        {
          label: 'Listar Documentos de Redes',
          labelAction: 'btnListRedeDocumento'
        }
      ]
    };

    var redeDocumentos = {
      module: 'redeDocumento',
      moduleName: 'RedeDocumentos',
      rules: [{
          label: 'Cadastrar Documentos de Redes',
          labelAction: 'btnNewRedeDocumento'
        },
        {
          label: 'Editar Documentos de Redes',
          labelAction: 'btnEditRedeDocumento'
        },
        {
          label: 'Remover Documentos de Redes',
          labelAction: 'btnDeleteRedeDocumento'
        }
      ]
    };

    var saudes = {
      module: 'saude',
      moduleName: 'Todos os pedidos',
      rules: [{
          label: 'Listar Pedidos',
          labelAction: 'btnListSaude'
        },
        {
          label: 'Cadastrar Pedidos',
          labelAction: 'btnNewSaude'
        },
        {
          label: 'Editar Pedidos',
          labelAction: 'btnEditSaude'
        },
        {
          label: 'Remover Pedidos',
          labelAction: 'btnDeleteSaude'
        },
        {
          label: 'Exportar Pedidos',
          labelAction: 'btnExportSaude'
        }
      ]
    };

    var seguros = {
      module: 'seguro',
      moduleName: 'Seguros',
      rules: [{
          label: 'Listar Seguros',
          labelAction: 'btnListSeguro'
        },
        {
          label: 'Cadastrar Seguros',
          labelAction: 'btnNewSeguro'
        },
        {
          label: 'Editar Seguros',
          labelAction: 'btnEditSeguro'
        },
        {
          label: 'Remover Seguros',
          labelAction: 'btnDeleteSeguro'
        }
      ]
    };

    var users = {
      module: 'user',
      moduleName: 'Usuários',
      rules: [{
          label: 'Listar Usuários',
          labelAction: 'btnListUser'
        },
        {
          label: 'Cadastrar Usuários',
          labelAction: 'btnNewUser'
        }, {
          label: 'Editar Usuários',
          labelAction: 'btnEditUser'
        }, {
          label: 'Remover Usuários',
          labelAction: 'btnDeleteUser'
        }
      ]
    };

    var vendedores = {
      module: 'vendedores',
      moduleName: 'Vendedores',
      rules: [{
          label: 'Listar Vendedores',
          labelAction: 'btnListVendedor'
        },
        {
          label: 'Cadastrar Vendedores',
          labelAction: 'btnNewVendedor'
        },
        {
          label: 'Editar Vendedores',
          labelAction: 'btnEditVendedor'
        },
        {
          label: 'Remover Vendedores',
          labelAction: 'btnDeleteVendedor'
        },
        {
          label: 'Exportar Vendedores',
          labelAction: 'btnExportVendedor'
        }
      ]
    };

    var produtos = {
      module: 'produtos',
      moduleName: 'Produtos',
      rules: [{
          label: 'Listar Produtos',
          labelAction: 'btnListProdutos'
        },
        {
          label: 'Cadastrar Produtos',
          labelAction: 'btnNewProdutos'
        }, {
          label: 'Editar Produtos',
          labelAction: 'btnEditProdutos'
        }, {
          label: 'Remover Produtos',
          labelAction: 'btnDeleteProdutos'
        }
      ]
    };

    var corpoClinico = {
      module: 'corpoCLinico',
      moduleName: 'CorpoClinico',
      rules: [{
          label: 'Listar Corpo Clinico',
          labelAction: 'btnListCorpoClinico'
        },
        {
          label: 'Cadastrar Corpo Clinico',
          labelAction: 'btnNewCorpoClinico'
        }, {
          label: 'Editar Corpo Clinico',
          labelAction: 'btnEditCorpoClinico'
        }, {
          label: 'Remover Corpo Clinico',
          labelAction: 'btnDeleteCorpoClinico'
        }
      ]
    };

    var exames = {
      module: 'exames',
      moduleName: 'Exames',
      rules: [{
          label: 'Listar Exames',
          labelAction: 'btnListExames'
        },
        {
          label: 'Cadastrar Exames',
          labelAction: 'btnNewExames'
        }, {
          label: 'Editar Exames',
          labelAction: 'btnEditExames'
        }, {
          label: 'Remover Exames',
          labelAction: 'btnDeleteExames'
        }
      ]
    };


    var validacao = {
      module: 'validacao',
      moduleName: 'Validação',
      rules: [{
          label: 'Listar Validações',
          labelAction: 'btnListValidacao'
        },
        {
          label: 'Cadastar Validaçao',
          labelAction: 'btnNewValidacao'
        },
        {
          label: 'Editar Validação',
          labelAction: 'btnEditValidacao'
        },
        {
          label: 'Remover Validação',
          labelAction: 'btnDeleteValidacao'
        },
        {
          label: 'Exportar Relatório',
          labelAction: 'btnExportReport'
        }
      ]
    };

    var totalizadores = {
      module: 'totalizadores',
      moduleName: 'Totalizadores',
      rules: [{
        label: 'Listar Totalizadores',
        labelAction: 'btnListTotalizadores'
      }]
    };

    var transferencias = {
      module: 'transferencias',
      moduleName: 'Transferências',
      rules: [{
        label: 'Listar Transferências',
        labelAction: 'btnListTransferencias'
      }]
    };

    var log = {
      module: 'log',
      moduleName: 'Log',
      rules: [{
        label: 'Listar Log',
        labelAction: 'btnListLog'
      }]
    };

    var especialidades = {
      module: 'redeEspecialidade',
      moduleName: 'Especialidades',
      rules: [{
          label: 'Listar Especialidades',
          labelAction: 'btnListEspecialidade'
        },
        {
          label: 'Cadastrar Especialidade',
          labelAction: 'btnNewRedeEspecialidade'
        }, {
          label: 'Editar Especialidade',
          labelAction: 'btnEditRedeEspecialidade'
        }, {
          label: 'Remover Especialidade',
          labelAction: 'btnDeleteRedeEspecialidade'
        }
      ]
    };


    var modules = [];
    modules.push(agendamentos);
    modules.push(apolices);
    modules.push(cartao);
    modules.push(clientes);
    modules.push(cupons);
    modules.push(documentos);
    modules.push(emails);
    modules.push(emprestimos);
    modules.push(pjuridica);
    modules.push(planos);
    modules.push(redes);
    modules.push(produtos);
    modules.push(redeDocumentos);
    modules.push(saudes);
    modules.push(seguros);
    modules.push(users);
    modules.push(vendedores);
    modules.push(validacao);
    modules.push(totalizadores);
    modules.push(log);
    modules.push(corpoClinico);
    modules.push(exames);
    modules.push(transferencias);
    modules.push(especialidades);

    vm.toggleFiltering = function () {
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
    };

    vm.remove = function (ev, item) {
      if (confirm("Deseja realmente remover?")) {
        var data = vm.gridOptions.data;

        API.delete({
          id: item._id
        }, function () {
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.edit = function (ev, item) {

      var obj = {};

      if (item) {
        obj = item;
      }

      $mdDialog.show({
        controller: function ($scope, local, $rootScope, $window, AuthenticationFactory, JuridicaService, RedeService) {

          var vm = this;
          vm.form = angular.copy(obj);
          vm.roles = roles;
          vm.form.permission = angular.merge({}, obj.permission, modules);
          vm.vendedores = [];
          vm.selectedItemEmpresa = vm.form.juridica
          vm.validarUserRede = function(){
            let perfisRede = ['AdmRede', 'Atendente']
            return perfisRede.some(function(x) { return x === vm.form.role})
          }

          //#region  Empresas/Juridica
          JuridicaService.query({}).$promise.then(function (resp) {
            vm.companies = resp;
          });

          vm.selectedItemChangeEmpresa = function (company) {
            if (company) {
              vm.form.juridica = company._id;
            } else {
              vm.form.juridica = null;
            }
          };
          vm.searchCompanyEmpresa = function (search) {
            return vm.companies.filter(function (item) {
              return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.cnpj && item.cnpj.toUpperCase().indexOf(search.toUpperCase()) >= 0);
            });
          };
          //#endregion

          //#region Rede
          RedeService.query().$promise.then(function(response){
            vm.redes = response
            if (item)
              vm.selectedRede = response.filter(function(item){
                return item._id == vm.form.rede._id
              })[0]
          })


          vm.selectedItemChangeRede = function (rede) {
            if (rede) {
              vm.form.rede = rede._id;
              vm.form.codigoUnidade = rede.codigoUnidade;
              vm.form.nomeRede = rede.nomeRede;
            } else {
              vm.form.rede = null;
              vm.form.codigoUnidade = null
            }
          };
          vm.searchRede = function (search) {
            return vm.redes.filter(function (item) {
              if (item.nomeRede)
                return item.nomeRede.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.codigoUnidade == search);
            });
          };

          //#endregion

          var profile = AuthenticationFactory.profile;
          var role = profile.user.role;

          vm.disabled = true;
          if (profile.user._id == vm.form._id || role == 'Administrador') {
            vm.disabled = false;
          }

          vm.profile = profile;
          vm.role = role;

          vm.refresh = function () {
            $window.location.reload();
            vm.loading = false;
          };

          vm.error = function () {
            $window.alert('Ocorreu algum erro durante o cadastro');
            vm.loading = false;
          };

          if (obj.vendedor) {
            vm.selectedItem = obj.vendedor;
          }

          vm.updateAddress = function () {
            AuthenticationFactory.getCEP(vm.form.cep)
              .then(function (endereco) {
                vm.form.enderecoResidencial = endereco.logradouro;
                vm.form.cidade = endereco.localidade;
                vm.form.bairro = endereco.bairro;
                vm.form.uf = endereco.uf.toLowerCase();
              });
          };

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.loading = false;

          vm.save = function () {

            vm.loading = true;

            if (vm.form.role == 'Atendente')
              vm.form.permission = [PermissaoSubMaster()]



            if (vm.form._id) {
              API.update({
                id: vm.form._id
              }, vm.form, vm.refresh, vm.error);
            } else {
              API.save(vm.form, vm.refresh, vm.error);
            }
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/user/dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        locals: {
          local: [vm.editDialog, vm]
        },
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [{
          name: 'createdAt',
          enableColumnResizing: false,
          width: 170,
          enableColumnMenu: false,
          displayName: 'Data Cadastro',
          type: 'date',
          cellFilter: 'date:"dd/MM/yyyy HH:mm:ss"'
        },
        {
          name: 'name',
          enableSorting: true,
          displayName: 'Nome'
        },
        {
          name: 'username',
          enableSorting: true,
          displayName: 'Nome de Usuário'
        },
        {
          name: 'password',
          enableSorting: true,
          displayName: 'Senha'
        },
        {
          name: 'role',
          enableSorting: true,
          displayName: 'Tipo de Usuário'
        },
        {
          name: 'status',
          enableSorting: true,
          displayName: 'Status'
        },
        {
          name: 'edit',
          enableColumnResizing: false,
          pinnedRight: true,
          width: 50,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" ng-show="row.entity.disabledEdit" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'
        },
        {
          name: 'remove',
          enableColumnResizing: false,
          pinnedRight: true,
          width: 50,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteUser" module="user" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'
        }
      ],
      onRegisterApi: function (gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.loading = true;
    vm.role = '';
    var getPage = function () {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;
      var obj = {};

      vm.role = role;

      if (role === 'Vendedor') {
        obj = {
          _id: id
        };
      }

      API.query(obj).$promise.then(function (resp) {

        resp.forEach(function (item) {
          item.disabledEdit = false;
          if (item._id == id || role == 'Administrador') {
            item.disabledEdit = true;
          }
        });


        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };

    getPage();
  }
})();

function PermissaoSubMaster() {
  return {
    "module": "validacao",
    "moduleName": "Validação",
    "rules": [{
      "label": "Listar Validações",
      "labelAction": "btnListValidacao",
      "value": true
    }, {
      "label": "Cadastar Validaçao",
      "labelAction": "btnNewValidacao",
      "value": true
    }, {
      "label": "Editar Validação",
      "labelAction": "btnEditValidacao",
      "value": true
    }, {
      "label": "Remover Validação",
      "labelAction": "btnDeleteValidacao",
      "value": true
    }, {
      "label": "Exportar Relatório",
      "labelAction": "btnExportReport",
      "value": true
    }]
  }
}

(function() {
  'use strict';

  angular.module('gruposinAdmin')
    .controller('TransferenciasController', TransferenciasController)
    .factory('TransferenciasService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'zooptransfers/:id', {id: '@id'}, {
        update:{
          method:'PUT'
        }
      });
      return data;
    });

  /** @ngInject */
  function TransferenciasController(uiGridConstants, AuthenticationFactory, TransferenciasService) {

    var API = TransferenciasService;
    var vm = this;

    var userProfile = AuthenticationFactory.profile;

    vm.toggleFiltering = function() {
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    }

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      showColumnFooter: true,
      enableGridMenu: true,
      exporterExcelFilename: 'transferencias-' + (new Date()).toLocaleDateString() + '.xlsx',
      columnDefs: [
        { name: 'created_at', enableFiltering: true, enableSorting: true, displayName: 'Data/Hora Transação Realizada', width: 230, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'' },
        { name: 'transfer_date_formatted', enableFiltering: true, enableSorting: true, displayName: 'Data/Hora Transferência', width: 230, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'' },
        { name: 'rede.nomeRede', enableFiltering: true, enableSorting: true, displayName: 'Nome do Credenciado', width: 270 },
        { name: 'rede.cpf', enableFiltering: true, enableSorting: true, displayName: 'CPF Credenciado', width: 230 },
        { name: 'rede.cnpj', enableFiltering: true, enableSorting: true, displayName: 'CNPJ Credenciado', width: 230 },
        { name: 'rede.codigoUnidade', enableFiltering: true, enableSorting: true, displayName: 'Código Unidade Credenciado', width: 230 },
        { name: 'id', enableFiltering: true, enableSorting: true, displayName: 'ID Transferência Zoop', width: 270 },
        { name: 'transactionID', enableFiltering: true, enableSorting: true, displayName: 'ID Transação Zoop', width: 270 },
        { name: 'pedido.codigo', enableFiltering: true, enableSorting: true, displayName: 'Número Voucher', width: 200 },
        { name: 'pedido.tipoPedido', enableFiltering: true, enableSorting: true, displayName: 'Compra Realizada', width: 230 },
        { name: 'valor_total_transacao', aggregationType: calculateVlTotalTransacao, aggregationHideLabel: true, enableFiltering: true, enableSorting: false, displayName: 'Valor da Transação Total', width: 230 },
        { name: 'amount', aggregationType: calculateAmount, aggregationHideLabel: true, enableFiltering: true, enableSorting: false, displayName: 'Valor Recebido Credenciado', width: 230 },
        { name: 'valor_diferenca', aggregationType: calculateVlDiferenca, aggregationHideLabel: true, enableFiltering: true, enableSorting: false, displayName: 'Valor Recebido Grupo Sin', width: 230 },
        { name: 'valor_recebido_zoop', aggregationType: calculateVlRecebidoZoop, aggregationHideLabel: true, enableFiltering: true, enableSorting: false, displayName: 'Valor Recebido Zoop', width: 230 },
        { name: 'cliente.nome', enableFiltering: true, enableSorting: false, displayName: 'Nome do Cliente que Realizou a Compra', width: 270 },
        { name: 'cliente.cpf', enableFiltering: true, enableSorting: false, displayName: 'CPF do Cliente que Realizou a Compra', width: 270 }
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.gridOptions.exporterFieldCallback = function ( grid, row, col, value ) {
      if ( col.name === 'createdAt' ) {
        value = new Date(value).toLocaleDateString();
      }
      return value;
    }
    
    function calculateVlTotalTransacao () {
      if(!vm.gridApi) {
        return 0;
      }
      
      var sum = 0;

      //if it is filtered/sorted you want the filtered/sorted rows only)
      var visibleRows = vm.gridApi.core.getVisibleRows(vm.gridApi.grid);

      for (var i = 0; i < visibleRows.length; i++) {
        sum += parseFloat(visibleRows[i].entity.valor_total_transacao) || 0;
      }

      return sum.toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
    }

    function calculateAmount () {
      if(!vm.gridApi) {
        return 0;
      }
      
      var sum = 0;

      //if it is filtered/sorted you want the filtered/sorted rows only)
      var visibleRows = vm.gridApi.core.getVisibleRows(vm.gridApi.grid);

      for (var i = 0; i < visibleRows.length; i++) {
        sum += parseFloat(visibleRows[i].entity.amount) || 0;
      }

      return sum.toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
    }

    function calculateVlDiferenca () {
      if(!vm.gridApi) {
        return 0;
      }
      
      var sum = 0;

      //if it is filtered/sorted you want the filtered/sorted rows only)
      var visibleRows = vm.gridApi.core.getVisibleRows(vm.gridApi.grid);

      for (var i = 0; i < visibleRows.length; i++) {
        sum += parseFloat(visibleRows[i].entity.valor_diferenca) || 0;
      }

      return sum.toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
    }

    function calculateVlRecebidoZoop () {
      if(!vm.gridApi) {
        return 0;
      }
      
      var sum = 0;

      //if it is filtered/sorted you want the filtered/sorted rows only)
      var visibleRows = vm.gridApi.core.getVisibleRows(vm.gridApi.grid);

      for (var i = 0; i < visibleRows.length; i++) {
        sum += parseFloat(visibleRows[i].entity.valor_recebido_zoop) || 0;
      }

      return sum.toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
    }

    // Hide columns conditions
    if (userProfile.user.role !== 'Administrador' && userProfile.user.role !== 'Funcionario') {
      vm.gridOptions.columnDefs[12].visible = false;
      vm.gridOptions.columnDefs[13].visible = false;
    }

    vm.loading = true;
    var getPage = function() {
      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var payload = {};

      API.query(payload).$promise.then(function(resp){
        var arr = resp || [];

        if (role === 'AdmRede' || role === 'Atendente') {
          vm.gridOptions.data = arr.filter(function(obj) { return obj.rede.id === profile.user.rede._id});
        } else {
          vm.gridOptions.data = arr;
        }

        vm.loading = false;
      });
    };

    getPage();
  }

})();
(function() {
  'use strict';

  angular.module('gruposinAdmin').controller('TotalizadoresController', TotalizadoresController);

  /** @ngInject */
  function TotalizadoresController(AuthenticationFactory, ValidacaoService, $http, $scope, $location, API_PAGAMENTO_DRACHEI_HOST) {
    var vm = this;
    vm.loading = true;
    vm.loadingCount = 0;
    
    var userProfile = AuthenticationFactory.profile;

    var sellerID = '00144ce4189d4cc49377e0e23b2f701f';

    var urlZoopAccountBalances = API_PAGAMENTO_DRACHEI_HOST + '/api/v1/seller/balances/:sellerID';

    var objPesquisa = {};
    if (userProfile.user.role !== 'Funcionario' && userProfile.user.role !== 'Administrador') {
      var redeId;
      try {
        redeId = userProfile.user.rede._id;
      } catch (error) {
        alert('Usuário não registrado em nenhuma rede, operação cancelada!');
        $location.path("/");
        return
      }
      
      sellerID = userProfile.user.rede.zoop_seller_id;
      objPesquisa = { unidade: redeId };
    }

    vm.zoopCurrentBalance = '0,00';
    vm.totalCreditValue = '0,00';
    vm.totalBoletoPayedValue = '0,00';
    vm.totalBoletoPaymentValue = '0,00';

    vm.getZoopCurrentBalance = getZoopCurrentBalance;
    vm.getTotalCreditValue = getTotalCreditValue;
    vm.getTotalBoletoPayedValue = getTotalBoletoPayedValue;
    vm.getTotalBoletoPaymentValue = getTotalBoletoPaymentValue;

    function getZoopCurrentBalance() {
      $http.get(urlZoopAccountBalances.replace(':sellerID', sellerID))
        .then(function(response) {
          try {
            vm.zoopCurrentBalance = parseFloat(response.data.data.items.account_balance).toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
          } catch (error) {
            // lancar exception?
          }
          
          vm.loadingCount++;
        });
    }

    function getTotalCreditValue () {
      objPesquisa.statusPagamento = 'CONCLUIDO';
      ValidacaoService.query(objPesquisa).$promise.then(function(resp){
        if (resp && resp.length > 0) {
          vm.totalCreditValue = calculateTotal(resp).toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
        }
        vm.loadingCount++;
      });
    }

    function getTotalBoletoPayedValue () {
      vm.loadingCount++;
    }

    function getTotalBoletoPaymentValue () {
      objPesquisa.statusPagamento = 'INICIADO';
      ValidacaoService.query(objPesquisa).$promise.then(function(resp){
        if (resp && resp.length > 0) {
          vm.totalBoletoPaymentValue = calculateTotal(resp).toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
        }
        vm.loadingCount++;
      });
    }

    function calculateTotal (list) {
      var total = 0;
      for (var i = 0; i < list.length; i++) {
        total += list[i].valorTotal;
      }
      return total;
    }

    $scope.$watch('ctrl.loadingCount', function() {
      if (vm.loadingCount >= 4) {
        vm.loading = false;
      }
    });

    getZoopCurrentBalance();
    getTotalCreditValue();
    getTotalBoletoPayedValue();
    getTotalBoletoPaymentValue();
  }

})();
(function() {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('SeguroController', SeguroController)
    .factory('SeguroService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'seguro/:id', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });

  /** @ngInject */
  function SeguroController($timeout, toastr, SeguroService, $scope, uiGridConstants, $mdDialog, $document) {

    var API = SeguroService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index,1);
        });
      }
    };

    vm.edit = function(ev, item) {

        var obj = {};

        if(item){
          obj = item;
        }
        
        $mdDialog.show({
                controller: function() {

                  var vm = this;
                  vm.form = angular.copy(obj);

                  vm.refresh = function(){
                      getPage();
                      vm.hide();
                  };

                  vm.hide = function() {
                      $mdDialog.hide();
                  };

                  vm.cancel = function() {
                      $mdDialog.cancel();
                  };

                  vm.save = function() {

                      if(vm.form._id){
                        API.update({id: vm.form._id}, vm.form, vm.refresh);
                      }else{
                        API.save(vm.form, vm.refresh);
                      }
                  };
                },
                controllerAs: 'ctrl',
                templateUrl: 'app/seguro/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {local: [vm.editDialog, vm]},
                clickOutsideToClose: false,
                fullscreen: true
            });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        { name: 'name', enableSorting: true, displayName: 'Nome' },
        { name: 'email', enableSorting: true, displayName: 'E-mail' },
        { name: 'cidade', enableSorting: true, displayName: 'Cidade' },
        { name: 'telefone', enableSorting: true, displayName: 'Telefone' },
        { name: 'edit', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditSeguro" module="seguro" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteSeguro" module="seguro" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };
   
    vm.loading = true;   
    var getPage = function() {
      API.query().$promise.then(function(resp){
        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };
   
    getPage();
  }
})();

(function () {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('SaudeController', SaudeController)
    .filter('dateValidate', function () {

      return function (input) {
        return input;
      }
    })
    .factory('SaudeService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'saude/:id', { id: '@id' }, {
        update: {
          method: 'PUT'
        },
        getFatura: {
          method: 'GET',
          url: endpoint + "saude/fatura/:idVindi",
          params: { idVindi: '@idVindi' },
          isArray: false,
          cache: false
        }

      });
      return data;
    });

  /** @ngInject */
  function SaudeController($log, SaudeService, uiGridConstants, $mdDialog, uiGridExporterConstants, uiGridExporterService, AuthenticationFactory, $window, $document, $mdToast, $http, endpoint) {

    var API = SaudeService;
    var vm = this;

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.toggleFiltering = function () {
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
    };

    // Exporta o Grid em Excel
    vm.exportExcel = function (router) {
      AuthenticationFactory.exportReport(router);
    };

    vm.showDeleteAlert = function (ev) {
      $mdDialog.show(
        $mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Cancelado')
          .textContent('Pedido cancelado com sucesso')
          .ok('Ok')
          .targetEvent(ev)
      );
    };

    vm.remove = function (ev, item) {
      if (confirm("Deseja realmente remover?")) {
        var data = vm.gridOptionsBusca.data;

        API.delete({ id: item._id }, function () {
          var index = data.indexOf(item);
          data.splice(index, 1);

        })
      }
    };

    vm.status = function (ev, item) {

      var obj = {};

      if (item) {
        item.dataPagamentoFatura = $window.moment(item.dataPagamentoFatura).toDate();
        obj = item;
        $mdDialog.show({
          controller: function () {

            var vm = this;
            vm.form = obj;
            vm.refresh = function () {
              getPage();
              vm.hide();
            };

            vm.hide = function () {
              $mdDialog.hide();
            };

            vm.cancel = function () {
              $mdDialog.cancel();
            };

            vm.save = function () {
              if (vm.form._id) {
                API.update({ id: vm.form._id }, vm.form, vm.refresh);
              }
            };
          },
          controllerAs: 'ctrl',
          templateUrl: 'app/saude/dialog-status.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          locals: { local: [vm.editDialog, vm] },
          clickOutsideToClose: true,
          fullscreen: false
        });
      }
    };

    vm.exportCsv = function () {
      var exportService = uiGridExporterService;
      var grid = vm.gridApi.grid;
      var fileName = 'Saude-Pedidos.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function () {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };

    vm.exportcvs = function () {
      var myElement = angular.element($document.querySelectorAll(".custom-csv-link-location"));
      vm.gridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL, myElement);
    };

    // retorna o valor que o vendedor tem que ganhar
    vm.valorComissaoVendedor = function (grid, row) {

      var pedido = (row.entity);
      var valor = 0;
      if (pedido.vendedor && pedido.plano) {
        valor = ((pedido.plano.price) * pedido.vendedor.comissaoVendedor) / 100;

        if (pedido.formadePagamento === 'VISTA') {
          valor = ((pedido.plano.price * pedido.plano.months) * pedido.vendedor.comissaoVendedor) / 100
        }

        // sobrescreve tudo
        if (parseInt(pedido.precoDigitado, 10) !== 0 && pedido.formadePagamento === 'VISTA') {
          valor = (pedido.precoDigitado * pedido.vendedor.comissaoVendedor) / 100;
        }

      }

      return valor;
    };

    // retorna o valor que o vendedor tem que ganhar, quando for usado um cupom de desconto em seu nome
    vm.valorComissaoCupomVendedor = function (grid, row) {

      var pedido = (row.entity);
      var valor = 0;

      if (pedido.cupom) {
        valor = ((pedido.vads_amount) * pedido.cupom.comissaoVendedor) / 100;
      }

      return valor;
    };


    // visualiza os dados dos pedidos
    vm.edit = function (ev, item) {

      var obj = {};

      if (item) {

        if (item) {
          item.client.dataNascimento = $window.moment(item.client.dataNascimento).toDate();
          item.dataVencimentoFatura = $window.moment(item.vads_sub_effect_date).toDate();
        }

        obj = item;

        $mdDialog.show({
          controller: function () {

            var vm = this;
            vm.form = obj;

            vm.refresh = function () {
              getPage();
              vm.hide();
            };

            vm.hide = function () {
              $mdDialog.hide();
            };

            vm.cancel = function () {
              $mdDialog.cancel();
            };

            vm.save = function () {

              if (vm.form._id) {
                API.update({ id: vm.form._id }, vm.form, vm.refresh);
              } else {
                API.save(vm.form, vm.refresh);
              }
            };
          },
          controllerAs: 'ctrl',
          templateUrl: 'app/saude/dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          locals: { local: [vm.editDialog, vm] },
          clickOutsideToClose: false,
          fullscreen: true
        });
      }
    };

    vm.insert = function (ev) {

      $mdDialog.show({
        controller: function ($scope, RedeService, ProdutosService, JuridicaService, UserService, PlanService, ClientService, AuthenticationFactory, endpoint, $http, CupomService, $timeout, $document) {

          var vm = this;
          vm.options = [
            {
              value: 'VISA',
              descricao: 'VISA',
              image: 'assets/images/cartoes/visa.png',
              tipoPagamento: 'cartaoCredito'


            }, {
              value: 'MASTERCARD',
              descricao: 'MasterCard',
              image: 'assets/images/cartoes/mastercard.png',
              tipoPagamento: 'cartaoCredito'

            }, {
              value: 'AMEX',
              descricao: 'American Express',
              image: 'assets/images/cartoes/amex.png',
              tipoPagamento: 'cartaoCredito'

            }, {
              value: 'DINERS',
              descricao: 'Dinners',
              image: 'assets/images/cartoes/diners.png',
              tipoPagamento: 'cartaoCredito'

            }, {
              value: 'CIELO_ELO',
              descricao: 'Cielo Elo',
              image: 'assets/images/cartoes/cielo_elo.png',
              tipoPagamento: 'cartaoCredito'

            }, {
              value: 'DISCOVER',
              descricao: 'Discover',
              image: 'assets/images/cartoes/discover.png',
              tipoPagamento: 'cartaoCredito'

            }, {
              value: 'AURA',
              descricao: 'Aura',
              image: 'assets/images/cartoes/aura.png',
              tipoPagamento: 'cartaoCredito'
            }, {
              value: 'JCB',
              descricao: 'JCB',
              image: 'assets/images/cartoes/jcb.png',
              tipoPagamento: 'cartaoCredito'

            }, {
              value: 'HIPER',
              descricao: 'Hyper',
              image: 'assets/images/cartoes/hiper.png',
              tipoPagamento: 'cartaoCredito'

            }, {
              value: 'HIPERCARD',
              descricao: 'HiperCard',
              image: 'assets/images/cartoes/hipercard.png',
              tipoPagamento: 'cartaoCredito'

            }, {
              value: 'ITAU_IB',
              descricao: 'Boleto Itau',
              image: 'assets/images/cartoes/boleto_itau.png',
              tipoPagamento: 'Boleto'

            }, {
              value: 'itau',
              descricao: 'Débito ITAU',
              image: 'assets/images/cartoes/itau_debito.png',
              tipoPagamento: 'debitoConta'

            }, {
              value: 'caixa',
              descricao: 'Débito CAIXA',
              image: 'assets/images/cartoes/caixa_debito1.png',
              tipoPagamento: 'debitoConta'

            }, {
              value: 'AVISTA',
              descricao: 'Dinheiro',
              image: 'assets/images/cartoes/money.png',
              tipoPagamento: 'dinheiro'

            }, {
              value: 'OUTROS',
              descricao: 'Outros',
              image: 'assets/images/cartoes/outros.png',
              tipoPagamento: 'outros'
            }

          ];

          vm.optionsDiasVencimentoBoleto = [
            { key: "", value: "Vencimento Padrão" },
            { key: "0", value: "Hoje" },
            { key: "1", value: "1 dia" },
            { key: "2", value: "2 dias" },
            { key: "3", value: "3 dias" },
            { key: "4", value: "4 dias" },
            { key: "5", value: "5 dias" },
            { key: "6", value: "6 dias" },
            { key: "7", value: "7 dias" },
            { key: "8", value: "8 dias" },
            { key: "9", value: "9 dias" },
            { key: "10", value: "10 dias" },
            { key: "11", value: "11 dias" },
            { key: "12", value: "12 dias" },
            { key: "13", value: "13 dias" },
            { key: "14", value: "14 dias" },
            { key: "15", value: "15 dias" },
            { key: "16", value: "16 dias" },
            { key: "17", value: "17 dias" },
            { key: "18", value: "18 dias" },
            { key: "19", value: "19 dias" },
            { key: "20", value: "20 dias" },
            { key: "21", value: "21 dias" },
            { key: "22", value: "22 dias" },
            { key: "23", value: "23 dias" },
            { key: "24", value: "24 dias" },
            { key: "25", value: "25 dias" },
            { key: "26", value: "26 dias" },
            { key: "27", value: "27 dias" },
            { key: "28", value: "28 dias" },
            { key: "29", value: "29 dias" },
            { key: "30", value: "30 dias" },
            { key: "31", value: "31 dias" }
          ];

          vm.formSIN = {};

          vm.formSIN.cupom = null;
          vm.formSIN.client = null;
          vm.formSIN.juridica = null;
          vm.formSIN.plano = {};
          vm.formSIN.vendedor = null;

          vm.formSIN.valorVendedorGanhar = 0;
          vm.formSIN.valorVendedorGanharCupom = 0;
          vm.formSIN.precoDigitado = 0;
          //vm.formSIN.diaVencimentoBoleto = 5;



          vm.clientes = [];
          vm.juridica = [];
          vm.vendedores = [];
          vm.planos = [];
          vm.loadingPlanos = true;
          vm.cupoms = [];

          vm.tipoPagamento = null;
          vm.formSIN.planoAvulso = true;

          var profile = AuthenticationFactory.profile;
          var role = (profile.user.role);
          var _id = (profile.user._id);

          var rolesVendedor = {
            role: 'Vendedor'
          };

          var objFilterVendedor = {};

          if (role === 'Vendedor') {
            objFilterVendedor = {
              vendedor: _id
            }

            rolesVendedor._id = _id
          }

          //#region ProdutosAvulsos
          vm.formSIN.produtos = vm.formSIN.produtos ? vm.formSIN.produtos : [];
          vm.filtroRede = [];

          vm.CalcValorTotal = function () {
            vm.formSIN.plano.price = vm.formSIN.produtos.reduce(function (a, b) {
              return a + b['valor'];
            }, 0);
          };

          vm.deleteProduto = function (index) {
            vm.formSIN.produtos.splice(index, 1)
            vm.CalcValorTotal()
          }

          //Query CIDADES
          RedeService.query({ select: 'cidade' }).$promise.then(function (resp) {
            var cidades = resp.map(function (item) { if (item.cidade) return item.cidade.toUpperCase().trim() });
            vm.CidadesRede = _.uniq(cidades);
          })

          vm.BuscarCidades = function (searchText) {
            return vm.CidadesRede.filter(function (item) {
              if (item) return item.toUpperCase().indexOf(searchText.toUpperCase()) >= 0;
            });
          };

          vm.toggle = function (rede) {
            var idx = vm.formSIN.produtos.map(function (p) { return p.idServico }).indexOf(rede.idServico)
            if (idx > -1) {
              vm.formSIN.produtos.splice(idx, 1);
            }
            else {
              vm.formSIN.produtos.push(rede);
            }
            vm.CalcValorTotal()
          };

          vm.existeServico = function (rede) {
            if (vm.formSIN.produtos.length == 0) return false;
            return vm.formSIN.produtos.map(function (p) { return p.idServico }).indexOf(rede.idServico) > -1;
          };

          vm.BuscarConsultas = function () {
            let cidade = vm.avulso.cidade;
            let codigoEspecialidade = vm.avulso.codigoEspecialidade;

            if (!cidade && !codigoEspecialidade) return false;

            $http.get(endpoint + 'consultas?cidade=' + cidade + '&especialidade=' + codigoEspecialidade)
              .then(function (response) {
                vm.redes = response.data.data.map(function (val) {
                  return {
                    nomeRede: val.nomeRede,
                    codigoUnidade: val.codigoUnidade,
                    local: val.localAtendimento,
                    valores: [{ label: 'Sin Saude', valor: val.consultas.valorSinSaude },
                    { label: 'Dr Achei', valor: val.consultas.valorDrAchei },
                    { label: 'Particular', valor: val.consultas.valorParticular }],
                    idServico: val.consultas._id,
                    tipoServico: 'Consulta',
                    descServico: val.consultas.descricaoConsulta,
                    nomeEspecialidade: val.especialidade[0].nome

                  }
                }).filter(function (x) { return x.nomeRede });
              }).catch(function (error) {
                $mdToast.showSimple('Nenhum resultado encontrado');
              })
          }

          vm.FiltrarExames = function (searchText) {
            return $http.get(endpoint + 'Exame?nomeExame__regex=/^' + searchText + '/i')
              .then(function (success) {
                return success.data;
              })
          };
         
          vm.BuscarExames = function () {
            let cidade = vm.avulso.cidade;
            let exame = vm.exameSelecionado;

            $http.get(endpoint + 'exames?cidade=' + cidade + '&exame=' + exame.codigoExame)
              .then(function (response) {
                vm.redes = response.data.data.map(function (val) {
                  return {
                    nomeRede: val.nomeRede,
                    codigoUnidade: val.codigoUnidade,
                    local: val.localAtendimento,
                    valores: [{ label: 'Sin Saude', valor: val.exames.valorSinSaude },
                    { label: 'Dr Achei', valor: val.exames.valorDrAchei },
                    { label: 'Particular', valor: val.exames.valorParticular }],
                    idServico: val.exames._id,
                    tipoServico: 'Exame',
                    descServico: val.exames.nomeExame
                  }
                }).filter(function (x) { return x.nomeRede });
              }).catch(function (error) {
                $mdToast.showSimple('Nenhum resultado encontrado');
              })
          }


          vm.loadEspecialidades = function () {
            $http.get(endpoint + 'Especialidade').then(function (success) {
              vm.especialidades = success.data;
            })
          }
          //#endregion ExamesAvulsos

          //#endregion ProdutosAvulsos


          // carrega a lista de clientes pf
          ClientService.query(objFilterVendedor).$promise.then(function (resp) {
            vm.clientes = resp;
          });

          // carrega a lista de empresas
          JuridicaService.query(objFilterVendedor).$promise.then(function (resp) {
            vm.juridica = resp;
          });

          // carrega a lista de vendedores
          UserService.query(rolesVendedor).$promise.then(function (resp) {
            vm.vendedores = resp;
          });

          // carrega a lista de planos
          PlanService.query().$promise.then(function (resp) {
            vm.loadingPlanos = false;
            vm.planos = resp;
          });

          // carrega a lista de cupoms
          CupomService.query(objFilterVendedor).$promise.then(function (resp) {
            vm.cupoms = resp.filter(function (cup) {
              return (cup.status === true && cup.qtdeUtilizada < cup.qtde)
            });
          });

          //***********************************************************************************************
          // dados padrao do payzen'
          //***********************************************************************************************
          vm.form = {};
          vm.form.vads_action_mode = 'SILENT';
          vm.form.vads_amount = 0; // preco + taxa //PRECO CHEIO
          vm.form.vads_sub_init_amount_number = 1;
          vm.form.vads_sub_init_amount = 0;
          vm.form.vads_trans_date = '';
          vm.form.vads_trans_id = '';
          vm.form.vads_order_id = '';
          vm.form.vads_validation_mode = 0;
          vm.form.vads_card_number = '';
          vm.form.vads_expiry_month = '';
          vm.form.vads_expiry_year = '';
          vm.form.vads_cvv = '';


          // consulta cep
          vm.updateAddress = function () {
            AuthenticationFactory.getCEP(vm.form.vads_cust_zip)
              .then(function (endereco) {
                vm.form.vads_cust_address = endereco.logradouro;
                vm.form.vads_cust_city = endereco.localidade;
                vm.form.vads_cust_district = endereco.bairro;
                vm.form.vads_cust_state = endereco.uf.toLowerCase();
              });
          };

          // preco digitado
          $scope.$watch('ctrl.formSIN.precoDigitado', function (value) {
            if (value) {
              vm.form.vads_amount = value
            }

            vm.calculaComissaoVendedor();
            vm.calculateDescontoCupom();
          })

          // verifica se é boleto ou cartao
          $scope.$watch('ctrl.form.vads_payment_cards', function (value) {
            if (value) {
              switch (value.tipoPagamento) {
                case 'Boleto':
                  vm.tipoPagamento = 'Boleto'
                  break;
                case 'cartaoCredito':
                  vm.tipoPagamento = "CartaoCredito";
                  break;
                case 'debitoConta':
                  vm.tipoPagamento = "DebitoConta"
                  break;
                default:
                  break;
              }
            }
          });


          vm.calculateDesconto = function () {
            // verifica se tem cupom
            if (vm.formSIN.cupom) {


              var porcentagem = parseFloat(vm.formSIN.cupom.descontoCliente);
              var valor = parseFloat(vm.formSIN.valordeCalculoSecudario);

              var desconto = parseFloat(valor * (porcentagem / 100));

              vm.form.vads_sub_amount = (parseFloat(valor) - parseFloat(desconto)).toFixed(2).replace(".", "");
            }
          };

          vm.setPlano = function (plano) {

            vm.formSIN.plano = plano;

            vm.form.vads_amount = (parseFloat(plano.price));

            // se o preco digitado exitir, sobrescreve o valor do plano
            if (vm.formSIN.precoDigitado) {
              vm.form.vads_amount = vm.formSIN.precoDigitado;
            }

            vm.calculaComissaoVendedor();
            vm.calculateDescontoCupom();
          };

          // somente comissoes
          // calcula as comissoes do vendedor - normal e baseada no cupom
          vm.calculaComissaoVendedor = function () {

            if (!vm.formSIN.plano) {
              return false;
            }

            // O vendedor pode ganhar 2 tipos de comissao, 1 com cupom outra sem cupom
            // calcula a comissao com base no cupom
            if (vm.formSIN.cupom) {
              vm.formSIN.valorVendedorGanharCupom = ((vm.formSIN.plano.price) * vm.formSIN.cupom.comissaoVendedor) / 100;

              if (vm.formSIN.formadePagamento === 'VISTA' && vm.formSIN.plano) {
                vm.formSIN.valorVendedorGanharCupom = ((vm.formSIN.plano.price * vm.formSIN.plano.months) * vm.formSIN.cupom.comissaoVendedor) / 100
              }

              // sobrescreve o valor da comissao
              if (vm.formSIN.precoDigitado !== 0 && vm.formSIN.formadePagamento === 'VISTA') {
                vm.formSIN.valorVendedorGanharCupom = ((vm.formSIN.precoDigitado) * vm.formSIN.cupom.comissaoVendedor) / 100;
              }
            } else {
              vm.formSIN.valorVendedorGanharCupom = 0;
            }


            if (vm.formSIN.vendedor) {
              vm.formSIN.valorVendedorGanhar = ((vm.formSIN.plano.price) * vm.formSIN.vendedor.comissaoVendedor) / 100;

              if (vm.formSIN.formadePagamento === 'VISTA' && vm.formSIN.plano) {
                vm.formSIN.valorVendedorGanhar = ((vm.formSIN.plano.price * vm.formSIN.plano.months) * vm.formSIN.vendedor.comissaoVendedor) / 100
              }

              if (vm.formSIN.precoDigitado !== 0 && vm.formSIN.formadePagamento === 'VISTA') {
                vm.formSIN.valorVendedorGanhar = ((vm.formSIN.precoDigitado) * vm.formSIN.vendedor.comissaoVendedor) / 100;
              }
            } else {
              vm.formSIN.valorVendedorGanhar = 0;
            }
          };

          vm.calculateDescontoCupom = function () {

            var desconto = 0;
            var valor = 0;

            if (!vm.formSIN.plano) {
              return false;
            }

            valor = vm.formSIN.plano.price;


            //sem cupom de desconto e recorrente
            vm.form.vads_amount = valor;

            // com cupom de desconto e recorrente
            if (vm.formSIN.cupom) {
              desconto = (valor * vm.formSIN.cupom.descontoCliente) / 100;

              vm.form.vads_amount = (valor - desconto);
            }


            //sem cupom de desconto e a vista (calcula o valor * meses + taxa de adesao)
            if (vm.formSIN.formadePagamento === 'VISTA' && !vm.formSIN.cupom) {
              valor = valor * vm.formSIN.plano.months;
              vm.form.vads_amount = valor;
            }

            // com cupom de desconto e a vista (calcula o valor * meses + taxa de adesao)
            if (vm.formSIN.formadePagamento === 'VISTA' && vm.formSIN.cupom) {
              valor = valor * vm.formSIN.plano.months;
              desconto = (valor * vm.formSIN.cupom.descontoCliente) / 100;

              vm.form.vads_amount = (valor - desconto);
            }


            // ou sobreescreve tudo
            if (vm.formSIN.precoDigitado !== 0 && vm.formSIN.formadePagamento === 'VISTA') {
              vm.form.vads_amount = vm.formSIN.precoDigitado;
            }
          };

          // cupoms
          vm.searchTextChangeCupom = function () { };
          vm.selectedItemChangeCupom = function (company) {

            if (company) {
              vm.formSIN.cupom = company;
            } else {
              vm.formSIN.cupom = null;
            }

            vm.calculateDescontoCupom();
            vm.calculaComissaoVendedor();
          };
          vm.searchCompanyCupom = function (search) {
            return vm.cupoms.filter(function (item) {
              return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0;
            });
          };

          // clientes
          vm.searchTextChangeCliente = function () { };
          vm.selectedItemChangeCliente = function (company) {
            if (company) {


              if (company.vendedor) {
                vm.selectedItem = company.vendedor;
                vm.formSIN.vendedor = company.vendedor;
              } else {
                vm.selectedItem = null;
                vm.formSIN.vendedor = null;
              }

              vm.formSIN.client = company;
              vm.formSIN.client.dataNascimento = new Date(company.dataNascimento);

              // preenche os dados que sera enviados ao payzen
              vm.form.vads_cust_first_name = company.name;
              vm.form.vads_cust_national_id = company.cpf;
              vm.form.vads_cust_address = company.enderecoResidencial;
              vm.form.vads_cust_zip = company.cep;
              vm.form.vads_cust_city = company.cidade;
              vm.form.vads_cust_district = company.bairro;
              vm.form.vads_cust_state = company.uf;
              vm.form.vads_cust_title = company.estadoCivil;
              vm.form.vads_cust_phone = company.telefoneFixo;
              vm.form.vads_cust_cell_phone = company.telefoneCelular;
              vm.form.vads_cust_email = company.email;

            } else {
              vm.formSIN.client = null;
              vm.formSIN.vendedor = null;
            }

            vm.calculateDescontoCupom();
            vm.calculaComissaoVendedor();

          };
          vm.searchCompanyCliente = function (search) {
            return vm.clientes.filter(function (item) {
              if(item.cpf){
                return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || item.cpf.toUpperCase().indexOf(search.toUpperCase()) >= 0;
              }
            });
          };


          // vendedor
          vm.searchTextChange = function () { };
          vm.selectedItemChange = function (company) {
            if (company) {
              vm.formSIN.vendedor = company;
            } else {
              vm.formSIN.vendedor = null;
            }

            vm.calculateDescontoCupom();
            vm.calculaComissaoVendedor();
          };
          vm.searchCompany = function (search) {
            return vm.vendedores.filter(function (item) {
              return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.cpf && item.cpf.toUpperCase().indexOf(search.toUpperCase()) >= 0);
            });
          };


          // empresa
          vm.searchTextChangeEmpresa = function () { };
          vm.selectedItemChangeEmpresa = function (company) {
            if (company) {
              vm.formSIN.juridica = company;
            } else {
              vm.formSIN.juridica = null;
            }

            vm.calculateDescontoCupom();
            vm.calculaComissaoVendedor();
          };
          vm.searchCompanyEmpresa = function (search) {
            return vm.juridica.filter(function (item) {
              return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || item.cnpj.toUpperCase().indexOf(search.toUpperCase()) >= 0;
            });
          };

          //envia para o nosso banco
          vm.submit = function () {

            vm.sending = true;
            
            // data
            var vads_trans_date = $window.moment(new Date()).utcOffset('+3').format("YYYYMMDDHHmmss");

            var dataPedido = new Date();
            var dia = vm.formSIN.dataVencimento;


            vm.formSIN.dataVencimento = dia;

            if (vm.form.vads_payment_cards.value !== 'ITAU_IB') {
              vm.form.vads_page_action = (vm.formSIN.formadePagamento === 'RECORRENTE' ? 'REGISTER_PAY_SUBSCRIBE' : 'PAYMENT');
            }

            if (vm.formSIN.planoAvulso)
              vm.formSIN.plano.name = 'PEDIDO AVULSO'

            vm.form.vads_trans_date = vads_trans_date;
            vm.form.vads_sub_effect_date = dataPedido;
            vm.form.vads_trans_id = vads_trans_date.slice(8);
            vm.form.vads_order_id = vads_trans_date.slice(8);

            var key = "6611475430291767";
            var values = [];

            var arrayNomes = [];
            var value;

            for (var x in vm.form) {
              if (vm.form[x] !== '' && vm.form[x] !== null && vm.form[x] !== 'undefined') {

                value = vm.form[x];

                if (x === 'vads_amount') {
                  if (angular.isNumber(value)) {
                    value = value.toFixed(2).toString().replace(".", "");
                  }
                }

                arrayNomes.push({ name: x, value: value });
              }
            }

            // ordena o formulario
            var order = arrayNomes.sort(function (a, b) {
              if (a.name < b.name) return -1;
              if (a.name > b.name) return 1;
              return 0;
            });

            var forms = '<form method="POST" action="https://secure.payzen.com.br/vads-payment/" id="payzen-form" target="_blank">';

            order.forEach(function (item) {
              values.push(item.value);
              forms = forms + '<input type="text" name="' + item.name + '" value="' + item.value + '">';

            });

            values.push(key);

            vm.body = {};

            var body = angular.extend(vm.formSIN, vm.form);
            vm.body = angular.extend(vm.body, body);

            function ExibirRetorno(status, msgRetorno) {
              $mdDialog.show(
                $mdDialog.alert()
                  .clickOutsideToClose(true)
                  .title(status)
                  .textContent(msgRetorno)
                  .ok('Ok!')
              );
            }

            // finaliza transacao
            $http.post(endpoint + "saude", vm.body).then(function (status) {
              ExibirRetorno("Sucesso ao criar pedido!")
              console.log(status.data)
              vm.refresh();
            }).catch(function (error) {
              ExibirRetorno("Erro ao criar pedido!")
              console.log(error.data)
              vm.refresh();
            });
          };


          vm.refresh = function () {
            var payzenForm = $document[0].querySelector('#payzen-form');
            if (payzenForm) {
              payzenForm.parentElement.removeChild(payzenForm);
            }
            getPage();
            vm.hide();
          };

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };



        },
        controllerAs: 'ctrl',
        templateUrl: 'app/saude/dialog-pedido.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.isAvulso = function (row) {
      if (row.plano)
        return row.plano.name
      else
        return 'PEDIDO AVULSO'
    };

    vm.gridOptions = {
      appScopeProvider: vm,
      enableFiltering: false,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.ALWAYS,
      columnDefs: [
        {
          name: 'vads_trans_status',
          enableSorting: true,
          displayName: 'Status',
          width: 80,
          cellTemplate: '<i class="material-icons btn-icon" module="saude" title="Informações do pagamento" ng-click="grid.appScope.showDadosFatura($event, row.entity)">credit_card</i>',
          cellClass: function (grid, row) {
            if (row.entity.vads_trans_status) {
              switch (row.entity.vads_trans_status) {
                case 'success':
                case 'paid':
                  return 'status-sucesso text-center'
                case 'rejected':
                case 'failure':
                  return 'status-pendente text-center'
                default:
                  return 'text-center'
              }
            }
            return 'text-center'
          }

        },
        { name: 'vads_trans_id', enableSorting: true, displayName: 'ID', width: 100 },
        { name: 'client.idTransacaoPlanoZoop', enableSorting: false, displayName: 'ID Transação Plano Zoop', width: 280 },
        { name: 'client.idAssinaturaZoop', enableSorting: false, displayName: 'ID Assinatura Plano Zoop', width: 280 },
        { name: 'idPedidoVindi', enableSorting: true, displayName: 'ID', width: 100 },
        {
          name: 'createdAt', enableSorting: true, displayName: 'Data Cadastro', width: 170, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'', filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
          sort: {
            direction: 'desc',
            priority: 0
          },
          headerCellClass: vm.highlightFilteredHeader,
          filters: [{
            filterName: 'maiorQue',
            condition: function (searchTerm, cellValue) {

              var search = new Date(searchTerm);
              var cValue = new Date(cellValue);

              return cValue.getTime() > search.getTime()
            }
          },
          {

            filterName: 'menorQue',
            condition: function (searchTerm, cellValue) {

              var search = new Date(searchTerm);
              var cValue = new Date(cellValue);

              return cValue.getTime() < search.getTime()
            }
          }]
        },
        { name: 'vads_trans_id', enableSorting: true, displayName: 'Nº Pedido', width: 170 },
        { name: 'plano.name', enableSorting: true, displayName: 'Pedido', width: 150, cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.isAvulso(row.entity)}}</div>' },
        { name: 'juridica.name', enableSorting: true, displayName: 'Empresa', width: 170 },
        { name: 'juridica.cnpj', enableSorting: true, displayName: 'CNPJ', width: 170 },
        { name: 'client.name', enableSorting: true, displayName: 'Nome Cliente', width: 170 },
        {
          name: 'client.cpf', enableSorting: true, displayName: 'CPF', width: 170,
          filter: {
            condition: uiGridConstants.filter.STARTS_WITH
          }
        },
        { name: 'client.email', enableSorting: true, displayName: 'E-mail', width: 170 },
        { name: 'vads_payment_cards.descricao', enableSorting: true, displayName: 'Forma de Pagamento', width: 170 },
        { name: 'plano.price', enableSorting: true, displayName: 'Valor Pedido', cellFilter: "currency", width: 170 },
        { name: 'vendedor.comissaoVendedor', enableSorting: true, displayName: '% Cms Vendedor', width: 170 },
        { name: 'valordoVendedor', enableSorting: true, displayName: 'Valor do Vendedor', width: 170, cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.valorComissaoVendedor(grid, row) | currency : "R$ " }}</div>' },
        { name: 'vendedor.name', enableSorting: true, displayName: 'Vendedor', width: 170 },
        { name: 'cupom.name', enableSorting: true, displayName: 'Cupom Usado', width: 170 },
        { name: 'cupom.descontoCliente', enableSorting: true, displayName: '% Desc Cliente', width: 170 },
        { name: 'cupom.comissaoVendedor', enableSorting: true, displayName: '% Cms Vendedor', width: 170 },
        { name: 'valordovendedorCupom', enableSorting: true, displayName: 'Valor do Vendedor', width: 170, cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.valorComissaoCupomVendedor(grid, row) | currency : "R$ " }}</div>' },
        { name: 'edit', enableColumnResizing: false, pinnedRight: true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditSaude" module="saude" title="Visualizar Pedido" ng-click="grid.appScope.edit($event, row.entity)">folder_shared</i>' },
        { name: 'remove', enableColumnResizing: false, pinnedRight: true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteSaude" module="saude" title="Remover Pedido" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>' }
      ],
      onRegisterApi: function (gridApi) {
        vm.gridApi = gridApi
      }
    };

    var getPage = function () {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;

      API.query({}).$promise.then(function (resp) {
        if (role === 'Vendedor') {
          resp = resp.filter(function (item) {
            return (item.vendedor && item.vendedor._id == id);
          });
        }

        if (role === 'Master') {
          resp = resp.filter(function (item) {
            return (item.juridica && item.juridica._id == profile.user.juridica);
          })
        }

        vm.gridOptions.data = resp.data;


        vm.loading = false;
      });
    };

    vm.showDadosFatura = function (ev, item) {
      $mdDialog.show({
        controller: function ($scope, $mdDialog, SaudeService) {
          var vm = this;
          vm.carregando = true
          vm.faturas = null;
          vm.cobranca = {}
          vm.urlBoleto = null
          vm.transacao = {}


          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.traduzirStatusPagamento = function (statusVindi) {
            switch (statusVindi) {
              case 'processing':
                return 'Processando pagamento';
              case 'failure':
                return 'Falha ao processar pagamento';
              case 'rejected':
                return 'Pagamento rejeitado';
              case 'success':
                return 'Pagamento Efetuado';
              case 'paid':
                return 'Pagamento Efetuado';
              case 'waiting':
                return 'Aguardando pagamento';
              case 'canceled':
                return 'Cancelado';
              default:
                return statusVindi;
            }
          }

          if(item.idPedidoVindi){
            SaudeService.getFatura({ idVindi: item.idPedidoVindi }).$promise.then(function (resp) {
              vm.carregando = false;
              if(resp.bills.length > 0)
                vm.faturas = resp.bills;
            });
          }else{
            vm.carregando = false;
          }


        },
        controllerAs: 'ctrl',
        templateUrl: 'app/saude/dados-fatura.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true
      })
    }
    
    vm.busca = function (formBusca){
      vm.loading = true;
      var urlBusca = endpoint+"saude/findAdmin?"
      var mudanca =0;
      if(formBusca in window){
      }else{
        for(var form in formBusca){
          if(formBusca[form] in window){
            if(formBusca.empresa){
              urlBusca+=form+"="+formBusca[form];
              mudanca+=1;
            }
          }else{
            if(formBusca[form] instanceof Date){
              if (mudanca == 0){
                urlBusca+=form+"="+moment(formBusca[form]).format("DD/MM/YYYY");
                mudanca+=1;
              }
              else{
                urlBusca+="&"+form+"="+moment(formBusca[form]).format("DD/MM/YYYY");
              }
            }
            else{
              if(mudanca == 0){
                urlBusca+=form+"="+formBusca[form];
                mudanca+=1;
              }else if(formBusca[form]){
                urlBusca+="&"+form+"="+formBusca[form];
              }
            }
          }
        }
      }
      $http.get(urlBusca).then(function (resp){
        vm.gridOptionsBusca.data=resp.data;
        getPage2();
      })
    }
    vm.gridOptionsBusca = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs:[
        {name:  "vads_trans_id", enableSorting:true, displayName: "Id Pedido",width:115},
        {name: 'idPedidoVindi', enableSorting: true, displayName: "Nº Pedido", width:115},
        {name: 'juridica.name', enableSorting: true, displayName: "Empresa", width:170},
        {name: 'client.name', enableSorting:true, displayName: "Nome Cliente", width: 170},
        {name: "client.cpf", enableSorting:true, displayName: "CPF", width: 170},
        {name: "plano.name", enableSorting: true, displayName: "Plano"},
        {name: 'createdAt', enableSorting: true, displayName: "Data Cadastro ", type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'', filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>'},
        {name: 'edit', enableColumnResizing: false, pinnedRight: true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditSaude" module="saude" title="Visualizar Pedido" ng-click="grid.appScope.edit($event, row.entity)">folder_shared</i>' },
        {name: 'remove', enableColumnResizing: false, pinnedRight: true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteSaude" module="saude" title="Remover Pedido" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi:function(gridApi){
        vm.gridApi = gridApi
        vm.loading = false;
      } 
    };

    var getPage2 = function () {
      
      vm.loading = false
    }
  }
})();





(function() {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('RedeTipoController', RedeTipoController)
    .factory('RedeTipoService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'redeTipo/:id', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });


  /** @ngInject */
  function RedeTipoController($timeout, toastr, JuridicaService, $scope, uiGridConstants, $mdDialog, UserService, RedeTipoService, ClientService, SaudeService, AuthenticationFactory, uiGridExporterService, uiGridExporterConstants, $window, $document) {

    var API = RedeTipoService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.exportExcel = function(router){
      AuthenticationFactory.exportReport(router);
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.dateValidate = function(grid, row){
      return  $window.moment(row.entity.createdAt).add(row.entity.dataRede).format('DD/MM/YYYY HH:mm:ss');
    };


   function parse (str) {

    if(str){
        // validate year as 4 digits, month as 01-12, and day as 01-31
        if ((str = str.match (/^(\d{4})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/))) {
           // make a date
           str[0] = new Date (+str[1], +str[2] - 1, +str[3]);
           // check if month stayed the same (ie that day number is valid)
           if (str[0].getMonth () === +str[2] - 1)
              return str[0];
        }
    }

    return undefined;
   }

    vm.exportCsv = function(){
      var exportService=uiGridExporterService;
      var grid=vm.gridApi.grid;
      var fileName= 'Especialidades.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function() {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };

    vm.edit = function(ev, item) {

        var obj = {};
        obj.status = 'Desabilitado';

        if(item){
          obj = item;
          obj.editable = true;
          if(obj.dataAtivacao){
            obj.dataAtivacao = new Date(obj.dataAtivacao);
          }
        }

        $mdDialog.show({
                controller: function(AuthenticationFactory) {

                  var vm = this;
                  vm.form = angular.copy(obj);
                  vm.clientes = [];
                  vm.redeTipos = [];

                  vm.loading = false;

                  vm.selectedItemClient = obj.client;
                  vm.selectedItemSaude = obj.redeTipo;


                  var profile = AuthenticationFactory.profile;
                  var role = (profile.user.role);
                  var _id = (profile.user._id);


                  vm.refresh = function(){

                      vm.loading = false;

                      getPage();
                      vm.hide();
                  };

                  vm.hide = function() {
                      $mdDialog.hide();
                  };

                  vm.cancel = function() {
                      $mdDialog.cancel();
                  };

                  vm.save = function() {

                      vm.loading = true;

                      if(vm.form._id){

                        if(vm.form.status === 'Habilitado' && !vm.form.dataAtivacao){
                          vm.form.dataAtivacao = new Date();
                        }

                        API.update({id: vm.form._id}, vm.form, vm.refresh);
                      }else{
                        if(vm.form.status === 'Habilitado'){
                          vm.form.dataAtivacao = new Date();
                        }
                        API.save(vm.form, vm.refresh);
                      }
                  };
                },
                controllerAs:'ctrl',
                templateUrl: 'app/redeTipo/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        {

          name: 'createdAt', enableSorting: true, displayName: 'Data Cadastro', width: 170, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'', filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
          filters: [{
            // condition: uiGridConstants.filter.GREATER_THAN
            filterName: 'maiorQue',
            condition: function(searchTerm, cellValue) {

              var search = new Date(searchTerm);
              var cValue = new Date(cellValue);

              return cValue.getTime() > search.getTime()
              // var data = searchTerm.split('/');
              // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
              // return strippedValue.indexOf(searchTerm) >= 0;
            }},
            {
              // condition: uiGridConstants.filter.GREATER_THAN
              filterName: 'menorQue',
              condition: function(searchTerm, cellValue) {

                var search = new Date(searchTerm);
                var cValue = new Date(cellValue);

                return cValue.getTime() < search.getTime()
                // var data = searchTerm.split('/');
                // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
                // return strippedValue.indexOf(searchTerm) >= 0;
              }
            }]
        },
        { name: 'name', enableSorting: true, displayName: 'Especialidade', width: 270 },
        { name: 'edit', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditRedeTipo" module="redeTipo" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteRedeTipo" module="redeTipo" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.loading = true;
    var getPage = function() {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;

      API.query({}).$promise.then(function(resp){

        // resp.forEach(function(item){
        //   console.log(item.redeTipo.vads_sub_effect_date);
        //   item.redeTipo.vads_sub_effect_date = moment(parse(item.redeTipo.vads_sub_effect_date)).toDate();
        //   console.log(item.redeTipo.vads_sub_effect_date);
        // });
        //
        // if(role === 'Vendedor'){
        //   resp = resp.filter(function(item){
        //     return (item.redeTipo.vendedor && item.redeTipo.vendedor._id == id);
        //   })
        // }



        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };

    getPage();
  }

})();

(function() {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('RedeEspecialidadeController', RedeEspecialidadeController)
    .factory('RedeEspecialidadeService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'Especialidade/:id', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });


  /** @ngInject */
  function RedeEspecialidadeController($timeout, toastr, JuridicaService, $scope, uiGridConstants, $mdDialog, UserService, RedeEspecialidadeService, ClientService, SaudeService, AuthenticationFactory, uiGridExporterService, uiGridExporterConstants, $window, $document) {

    var API = RedeEspecialidadeService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };
    
    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.dateValidate = function(grid, row){
      return  $window.moment(row.entity.createdAt).add(row.entity.dataRede).format('DD/MM/YYYY HH:mm:ss');
    };     

    vm.edit = function(ev, item) {        

        $mdDialog.show({
                controller: function() {

                  var vm = this;
                  
                  vm.form = {}

                  if (item)
                    vm.form = item

                  vm.loading = false;
                  
                  vm.refresh = function(){

                      vm.loading = false;

                      getPage();
                      vm.hide();
                  };

                  vm.hide = function() {
                      $mdDialog.hide();
                  };

                  vm.cancel = function() {
                      $mdDialog.cancel();
                  };

                  vm.save = function() {

                      vm.loading = true;
                      API.save(vm.form, vm.refresh);
                      
                  };
                },
                controllerAs:'ctrl',
                templateUrl: 'app/redeEspecialidade/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      enableGridMenu: true,
      columnDefs: [
        {
          name: '_id', enableSorting: true, displayName: 'Codigo Especialidade', width: 250, type: 'number', sort: {
            direction: uiGridConstants.ASC,
            priority: 0
          }
        },
        { name: 'nome', enableSorting: true, displayName: 'Nome Especialidade', width: 400 },
        { name: 'edit', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditRedeEspecialidade" module="redeEspecialidade" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteRedeEspecialidade" module="redeEspecialidade" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.loading = true;
    var getPage = function() {

      

      API.query({}).$promise.then(function(resp){
        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };

    getPage();
  }

})();

(function() {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('RedeDocumentoController', RedeDocumentoController)
    .factory('RedeDocumentoService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'redeDocumento/:id?populate=rede', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });

  /** @ngInject */
  function RedeDocumentoController($timeout, toastr, $stateParams, RedeDocumentoService, $scope, uiGridConstants, $mdDialog, AuthenticationFactory, RedeService, RedeTipoService, $document) {

    var API = RedeDocumentoService;
    var vm = this;
    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.lista = [
      'Anexo documentação clínica','Contrato','Ficha de inscrição','Formulário de credenciamento','Outros'
    ];

    vm.edit = function(ev, item) {

        $mdDialog.show({
                controller: function($scope) {

                  var vm = this;
                  if(item){
                    vm.form = angular.copy(item);
                  }
                  vm.loading = false;


                    vm.refresh = function(){
                        getPage();
                        vm.hide();
                        vm.loading = false;
                    };

                    vm.hide = function() {
                        $mdDialog.hide();
                    };

                    vm.items = [
                      'Anexo documentação clínica','Contrato','Ficha de inscrição','Formulário de credenciamento','Outros'
                    ];

                    vm.cancel = function() {
                        $mdDialog.cancel();
                    };

                    vm.save = function() {
                      vm.loading = true;
                      vm.form.rede = $stateParams.redeId;
                      if(vm.form._id){
                        API.update({id: vm.form._id}, vm.form, vm.refresh);
                      }else{
                        API.save(vm.form, vm.refresh);
                      }
                    };
                },
                controllerAs: 'ctrl',
                templateUrl: 'app/redeDocumento/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {local: [vm.editDialog, vm]},
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        { name: 'createdAt', enableColumnResizing: false, width: 170, enableColumnMenu: false, displayName:'Data Cadastro', type: 'date', cellFilter: 'date:"dd/MM/yyyy HH:mm:ss"' },
        { name: 'name', enableSorting: true, displayName: 'Nome do documento' },
        { name: 'tipo', enableSorting: false, displayName: 'Tipo', width: 170, cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.lista[row.entity.tipo]}}</div>'},
        { name: 'arquivo', enableSorting: false, displayName: '', width: 50, enableFiltering: false, enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<a href="https://www.gruposin.com.br/uploads/{{row.entity.arquivo}}" target="_blank" title="Download"><i class="material-icons">file_download</i></a>' },
        { name: 'edit', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditRedeDocumento" module="redeDocumento" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteRedeDocumento" module="redeDocumento" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.loading = true;
    var getPage = function() {

      API.query({rede:$stateParams.redeId}).$promise.then(function(resp){
        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };

    getPage();
  }
})();

(function () {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('RedeController', RedeController)
    .factory('RedeService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'rede/:id?populate=especialidades', {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
      return data;
    })
    .factory('RedeExamesService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'exames/:id', {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
      return data;
    })
    .factory('RedeConsultasService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'consultas/:id', {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
      return data;
    });


  /** @ngInject */
  function RedeController(toastr, RedeExamesService, RedeConsultasService, RedeService, $state, $scope, uiGridConstants, $mdDialog, uiGridExporterService, uiGridExporterConstants, ClientService, AuthenticationFactory, endpoint, $document, url_upload, RedeTipoService, RedeEspecialidadeService, $http , API_PAGAMENTO_DRACHEI_HOST ) {
    var busca={};
    var API = RedeService;
    var vm = this;

    vm.toggleFiltering = function () {
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
    };


    vm.remove = function (ev, item) {
      if (confirm("Deseja realmente remover?")) {
        var data = vm.gridOptions.data;

        API.delete({
          id: item._id
        }, function () {
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.removeServico = function (ev, item) {
      if (confirm("Deseja realmente remover?")) {
        var data = item.grid.options.data;

        let service = item.entity.tipoServico == 'Consulta' ? RedeConsultasService : RedeExamesService

        service.delete({
          id: item.entity._id
        }, function () {
          var index = data.indexOf(item.entity);
          data.splice(index, 1);
        });
      }
    };

    vm.edit = function (ev, item) {


      $mdDialog.show({
        controller: function () {

          var vm = this;
          vm.form = {};
          vm.form.especialidades = []
          vm.form.tipoRede = []

          vm.especialidade_save = function () {
            RedeEspecialidadeService.save({
              "name": vm.nova_especialidade
            }, vm.refresh_especialidades);
          }

          vm.refresh_especialidades = function () {
            vm.cadastrar_nova_especialidade = false;
          }


          vm.updateAddress = function (cep) {
            AuthenticationFactory.getCEP(cep)
              .then(function (endereco) {
                vm.form.localAtendimento = endereco.logradouro;
                vm.form.cidade = endereco.localidade;
                vm.form.bairro = endereco.bairro;
                vm.form.uf = endereco.uf.toLowerCase();
              });
          };

          if (item) {
            vm.form = angular.copy(item);
          }

          //Tipos de rede
          // Carrega
          RedeTipoService.query().$promise.then(function (resp) {
            vm.tipos = resp.map(function (tipo) {
              return tipo.nome
            });
          })
          // Filtra
          vm.searchTipo = function (search) {
            return vm.tipos.filter(function (term) {
              if (!term) {
                return false;
              }
              return term.toUpperCase().indexOf(search.toUpperCase()) >= 0 || term;
            });
          }


          // Chip
          // vm.transformChipEspecialidade = function transformChipEspecialidade(chip) {
          //   if (angular.isObject(chip)) {
          //     return chip;
          //   }
          // }

          // ESPECIALIDADE //
          // Carrega
          RedeEspecialidadeService.query().$promise.then(function (resp) {
            vm.especialidades = resp;
          })
          // Filtra
          vm.searchEspecialidade = function (search) {
            return vm.especialidades.filter(function (term) {
              if (!term.nome) {
                return false;
              }
              return term.nome.toUpperCase().indexOf(search.toUpperCase()) >= 0;
            });
          }
          vm.refresh = function () {
            httpBusca(busca)  
            vm.hide();
          };

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.save = function () {

            if (vm.form._id) {
              API.update({ id: vm.form._id }, vm.form, vm.refresh);
              
              // if (vm.form.status === 'HABILITADO' && !vm.form.zoop_seller_id) {
              //   $http.post(API_PAGAMENTO_DRACHEI_HOST + '/api/v1/sellers', { id: vm.form._id })
              //     .success(function() {
              //       vm.refresh();
              //     }).error(function(err) {
              //       console.log(err);
              //       alert('Ocorreu um erro ao cadastrar a rede na Zoop');
              //     });
              // }
              
            } else {
              API.save(vm.form, vm.refresh);
            }

          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/rede/dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.editServico = function (ev, item) {


      $mdDialog.show({
        controller: function () {

          var vm = this;
          vm.form = {};

          if (item) {
            vm.form = angular.copy(item);
          }

          //#region Rede
          RedeService.query().$promise.then(function (response) {
            vm.redes = response
            if (item)
              vm.selectedRede = response.filter(function (item) {
                return item._id == vm.form.rede
              })[0]
          })


          vm.selectedItemChangeRede = function (rede) {
            if (rede) {
              vm.form.rede = rede._id;
              vm.form.codigoUnidade = rede.codigoUnidade;
              vm.form.nomeRede = rede.nomeRede;
            } else {
              vm.form.rede = null;
              vm.form.codigoUnidade = null
            }
          };
          vm.searchRede = function (search) {
            return vm.redes.filter(function (item) {
              if (item.nomeRede)
                return item.nomeRede.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.codigoUnidade == search);
            });
          };

          //#endregion

          //#region Especialidade
          // Carrega
          RedeEspecialidadeService.query().$promise.then(function (resp) {
            vm.especialidades = resp;
          })
          // Filtra
          vm.searchEspecialidade = function (search) {
            return vm.especialidades.filter(function (term) {
              if (!term.nome) {
                return false;
              }
              return term.nome.toUpperCase().indexOf(search.toUpperCase()) >= 0;
            });
          }
          //#endregion

          vm.refresh = function () {
            getPage();
            vm.hide();
          };

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };



          vm.save = function () {
            let request = transformarRequest(vm.form);
            if (vm.form._id) {
              request.service.update({
                id: vm.form._id
              }, request, vm.refresh);
            } else {
              request.service.save(request, vm.refresh);
            }

          };

          var transformarRequest = function (request) {
            if (request.tipoServico == 'Consulta') {
              request.codigoConsulta = request.codigoServico
              request.descricaoConsulta = request.descricaoServico
              
              request.service = RedeConsultasService
              return request
            } else if (request.tipoServico == 'Exame') {
              request.codigoExame = request.codigoServico
              request.nomeExame = request.descricaoServico
              request.service = RedeExamesService
              return request
            } else {
              return request
            }
          }

        },
        controllerAs: 'ctrl',
        templateUrl: 'app/rede/dialogServico.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.view = function (ev, item) {


      $mdDialog.show({
        controller: function () {

          var vm = this;
          //Controllar a lista de locais de atendimento
          vm.locais_atendimentos = [];
          vm.show_local_atendimento = false;
          vm.adicionar_local = function (array) {
            vm.locais_atendimentos.push(array);
          };

          vm.editarLocal = function (i) {
            vm.editing = true;
            vm.key_edit = i;
            vm.show_local_atendimento = true;
            vm.local_atendimento = angular.copy(vm.locais_atendimentos[i]);
          }

          vm.atualizar_local = function (local_updated) {
            vm.locais_atendimentos[vm.key_edit] = local_updated;
            vm.editing = false;
            vm.show_local_atendimento = false;

          }

          vm.especialidade_save = function () {
            RedeEspecialidadeService.save({
              "name": vm.nova_especialidade
            }, vm.refresh_especialidades);
          }

          vm.refresh_especialidades = function () {
            vm.especialidades = RedeEspecialidadeService.query();
            vm.cadastrar_nova_especialidade = false;
          }


          vm.updateAddress = function (cep, tipo) {
            AuthenticationFactory.getCEP(cep)
              .then(function (endereco) {
                if (tipo == 'cadastro_principal') {
                  vm.form.prestador_endereco = endereco.logradouro;
                  vm.form.cidade = endereco.localidade;
                  vm.form.bairro = endereco.bairro;
                  vm.form.uf = endereco.uf.toLowerCase();
                } else {
                  vm.local_atendimento.endereco = endereco.logradouro;
                  vm.local_atendimento.cidade = endereco.localidade;
                  vm.local_atendimento.bairro = endereco.bairro;
                  vm.local_atendimento.estado = endereco.uf.toLowerCase();
                }
              });
          };



          if (item) {
            vm.form = angular.copy(item);
            vm.locais_atendimentos = vm.form.locais_atendimentos;
            if (vm.form.tipo) {
              vm.selectedItemTipo = vm.form.tipo;
            }
            if (vm.form.especialidade) {
              vm.selectedItemEspecialidade = vm.form.especialidade;
            }
          }
          vm.isNewTipo = false;
          vm.isNewEspecialidade = false;

          //Busco todas as redes
          vm.tipos = RedeTipoService.query();
          //Busco todas as especialidades
          vm.especialidades = RedeEspecialidadeService.query({});

          // if(!vm.tipos.length){
          //   vm.isNewTipo = true;
          // }
          if (!vm.especialidades.length) {
            vm.isNewEspecialidade = true;
          }
          //vm.searchTextChangeTipo = function () { };

          //vm.searchTextChangeEspecialidade = function () { };

          vm.searchTipo = function (search) {
            return vm.tipos.filter(function (term) {
              if (!term.name) {
                return false;
              }
              return term.name.toUpperCase().indexOf(search.toUpperCase()) >= 0;
            });
          }

          vm.searchEspecialidade = function (q) {
            return vm.especialidades.filter(function (especialidade) {
              if (!especialidade.name) {
                return false;
              }
              return especialidade.name.toUpperCase().indexOf(q.toUpperCase()) >= 0;
            });
          }

          vm.selectedItemChangeTipo = function (item) {
            if (item) {

              vm.isNewTipo = false;
              vm.form.tipo = item;
            } else {
              // vm.isNewTipo = true;
              return false;
            }
          }

          vm.selectedItemChangeEspecialidade = function (item) {
            if (item) {
              vm.isNewEspecialidade = false;
              vm.form.especialidade = item;
            } else {
              vm.isNewEspecialidade = true;
            }
          }

          vm.refresh = function () {
            getPage();
            vm.hide();
          };

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.save = function () {
            // if(vm.isNewTipo){
            //   RedeTipoService.save({'name':vm.searchTextTipo},function(saved){
            //     vm.form.tipo = saved;
            //     vm.forceSave();
            //   });
            // }
            if (vm.isNewEspecialidade) {
              RedeEspecialidadeService.save({
                'name': vm.searchTextEspecialidade
              }, function (saved) {
                vm.form.especialidade = saved;
                vm.forceSave();
              });
            }
            vm.forceSave();
          };

          vm.forceSave = function () {
            vm.form.locais_atendimentos = vm.locais_atendimentos;
            if (vm.form.tipo && vm.form.especialidades) {
              if (vm.form._id) {
                API.update({
                  id: vm.form._id
                }, vm.form, vm.refresh);
              } else {
                API.save(vm.form, vm.refresh);
              }
            }
          }
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/rede/view.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.mapValue = function (val) {
      return val ? 'Sim' : 'Não';
    }

    vm.gridOptions = {
      expandableRowTemplate: '/app/rede/expandableRowTemplate.html',      
      expandableRowHeight: 400,
      expandableRowHeaderWidth: 60,
      expandableRowScope: {
        subGridVariable: 'subGridScopeVariable'
      },
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      enableGridMenu: true,
      exporterExcelFilename: 'rede.xlsx',
      showColumnFooter: false,
      columnDefs: [{
          name: 'createdAt',
          enableSorting: true,
          displayName: 'Data Cadastro',
          width: 170,
          type: 'date',
          cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
          
        },
        {
          name: 'nomeRede',
          enableSorting: true,
          displayName: 'Nome',
          width: 300,
          cellClass: function () {
            return 'text-left';
          },
          cellTemplate: '<div class="ui-grid-cell-contents" style="cursor:pointer;" permission="btnViewRede" module="rede" ng-click="grid.appScope.view($event, row.entity)">{{row.entity.nomeRede}}</div>'
        },
        {
          name: 'codigoUnidade',
          enableSorting: true,
          displayName: 'Codigo da Unidade',
          width: 150
        },
        {
          name: 'cnpj',
          enableSorting: true,
          displayName: 'CNPJ',
          width: 150
        },
        {
          name: 'zoop_seller_id',
          enableSorting: false,
          displayName: 'ID Rede Zoop',
          width: 270
        },
        {
          name: 'tipoRede',
          enableSorting: true,
          displayName: 'Tipo da rede',
          width: 400,
          cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity[col.field].join(" - ")}}</div>'
        },
        {
          name: 'localAtendimento',
          enableSorting: true,
          displayName: 'Local de atendimento',
          width: 250
        },
        {
          name: 'numero',
          enableSorting: true,
          displayName: 'Número',
          width: 250
        },
        {
          name: 'complemento',
          enableSorting: true,
          displayName: 'Complemento',
          width: 250
        },
        {
          name: 'bairro',
          enableSorting: true,
          displayName: 'Bairro',
          width: 200
        },
        {
          name: 'cidade',
          enableSorting: true,
          displayName: 'Cidade',
          width: 200
        },
        {
          name: 'uf',
          enableSorting: true,
          displayName: 'Estado',
          width: 150
        },
        {
          name: 'email',
          enableSorting: true,
          displayName: 'E-mail',
          width: 200
        },
        {
          name: 'telefoneFixo',
          enableSorting: true,
          displayName: 'Telefone fixo',
          width: 150
        },
        {
          name: 'telefoneCelular',
          enableSorting: true,
          displayName: 'Telefone Celular',
          width: 150
        },
        {
          name: 'faturamento',
          displayName: 'Faturamento',
          width: 150,
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.mapValue(row.entity.faturamento)}}</div>'
        },
        {
          name: 'drAchei',
          displayName: 'Dr. Achei',
          width: 150,
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.mapValue(row.entity.drAchei)}}</div>'
        },
        {
          name: 'agendamento',
          displayName: 'Agendamento',
          width: 150,
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.mapValue(row.entity.agendamento)}}</div>'
        },
        {
          name: 'taxaAdm',
          displayName: 'Taxa Adm',
          width: 150,
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.mapValue(row.entity.taxaAdm)}}</div>'
        },
        {
          name: 'valorTaxaAdm',
          displayName: 'Valor Taxa Adm',
          width: 150
        },
        {
          name: 'delivery',
          displayName: 'Delivery',
          width: 150,
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.mapValue(row.entity.delivery)}}</div>'
        },
        {
          name: 'taxaDelivery',
          displayName: 'Taxa Delivery',
          width: '10%'
        },
        {
          name: 'coletaDomiciliar',
          displayName: 'Coleta Domiciliar',
          width: 150,
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.mapValue(row.entity.coletaDomiciliar)}}</div>'
        },
        {
          name: 'taxaDomiciliar',
          displayName: 'Taxa Coleta Domiciliar',
          width: '15%'
        },
        {
          name: 'pagamentoOnline',
          displayName: 'Pagamento Online',
          width: 150,
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.mapValue(row.entity.pagamentoOnline)}}</div>'
        },
        {
          name: 'pagamentoUnidade',
          displayName: 'Pagamento Unidade',
          width: 150,
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.mapValue(row.entity.pagamentoUnidade)}}</div>'
        },
        {
          name: 'banco',
          enableSorting: true,
          displayName: 'Banco',
          width: 150
        },
        {
          name: 'agencia',
          enableSorting: true,
          displayName: 'Agencia',
          width: 150
        },
        {
          name: 'conta',
          enableSorting: true,
          displayName: 'Conta',
          width: 150
        },
        {
          name: 'dataFaturamento',
          enableSorting: true,
          displayName: 'Data de faturamento',
          width: 150
        },
        {
          name: 'porcentagemDrAchei',
          enableSorting: true,
          displayName: 'Porcentagem DrAchei',
          width: 150
        },
        {
          name: 'status',
          enableSorting: true,
          displayName: 'Status',
          width: 150
        },
        {
          name: 'view',
          enableColumnResizing: false,
          pinnedRight: false,
          width: 50,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" permission="btnListRedeDocumento" module="rede" ng-click="grid.appScope.go(row.entity)">business_center</i>'
        },
        {
          name: 'edit',
          enableColumnResizing: false,
          pinnedRight: false,
          width: 50,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" permission="btnEditRede" module="rede" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'
        },
        {
          name: 'remove',
          enableColumnResizing: false,
          pinnedRight: false,
          width: 50,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteRede" module="rede" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'
        }
      ],
      onRegisterApi: function (gridApi) {
        vm.gridApi = gridApi;
        gridApi.expandable.on.rowExpandedStateChanged($scope, function (row) {
          if (row.isExpanded) {
            row.entity.subGridOptions = {
              enableFiltering: true,
              enableGridMenu: true,
              appScopeProvider: vm,              
              exporterExcelFilename: 'exames-' + row.entity.nomeRede + '.xlsx',
              columnDefs: [{
                  name: 'tipoServico',
                  field: 'tipoServico',
                  width: 150
                },
                {
                  name: 'codigoServico',
                  field: 'codigoServico',
                  width: 150,
                  type: 'number'
                },
                {
                  name: 'codigoSecundario',
                  field: 'codigoSecundario',
                  width: 150,
                  type: 'number'
                },
                {
                  name: 'descricaoServico',
                  field: 'descricaoServico',
                  width: 500
                },
                {
                  name: 'valorParticular',
                  field: 'valorParticular',
                  width: 150,
                  cellFilter: 'number:2',
                  cellClass: 'currency',
                  type: 'number'
                },
                {
                  name: 'valorSinSaude',
                  field: 'valorSinSaude',
                  width: 150,
                  cellFilter: 'number:2',
                  cellClass: 'currency',
                  type: 'number'
                },
                {
                  name: 'valorDrAchei',
                  field: 'valorDrAchei',
                  width: 150,
                  cellFilter: 'number:2',
                  cellClass: 'currency'
                },
                {
                  name: 'porcentagemDesconto',
                  field: 'porcentagemDesconto',
                  width: 250,
                  cellFilter: 'number:2',
                  cellClass: 'number'
                },
                {
                  name: 'especialidade',
                  field: 'nomeEspecialidade',
                  width: 250
                },
                {
                  name: 'edit',
                  enableColumnResizing: false,
                  pinnedRight: false,
                  width: 50,
                  enableFiltering: false,
                  enableSorting: false,
                  displayName: '',
                  enableColumnMenu: false,
                  cellClass: function () {
                    return 'text-center';
                  },
                  cellTemplate: '<i class="material-icons btn-icon" permission="btnEditRede" module="rede" ng-click="grid.appScope.editServico($event, row.entity)">edit</i>'
                },
                {
                  name: 'remove',
                  enableColumnResizing: false,
                  pinnedRight: false,
                  width: 50,
                  enableFiltering: false,
                  enableSorting: false,
                  displayName: '',
                  enableColumnMenu: false,
                  cellClass: function () {
                    return 'text-center';
                  },
                  cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteRede" module="rede" ng-click="grid.appScope.removeServico($event, row)">remove_circle</i>'
                }
              ]
            };

            var subGrid = []

            $http.get(endpoint + 'consultas?rede_id=' + row.entity._id).then(function (result) {

              result.data.data.map(function (item) {
                let consulta = item.consultas
                subGrid.push({
                  _id: consulta._id,
                  tipoServico: "Consulta",
                  codigoServico: consulta.codigoConsulta,
                  codigoSecundario: consulta.codigoSecundario,
                  descricaoServico: consulta.descricaoConsulta,
                  valorParticular: consulta.valorParticular,
                  valorSinSaude: consulta.valorSinSaude,
                  valorDrAchei: consulta.valorDrAchei,
                  porcentagemDesconto: consulta.porcentagemDesconto,
                  nomeEspecialidade: item.especialidade[0].nome,
                  especialidade: item.especialidade[0]._id,
                  rede: item._id
                })
              });
            }).catch(function (error) {
              console.log(error);
            })

            $http.get(endpoint + 'exames?rede_id=' + row.entity._id).then(function (result) {
              result.data.data.map(function (item) {
                let exame = item.exames
                subGrid.push({
                  _id: exame._id,
                  tipoServico: "Exame",
                  codigoServico: exame.codigoExame,
                  codigoSecundario: exame.codigoSecundario,
                  descricaoServico: exame.nomeExame,
                  valorParticular: exame.valorParticular,
                  valorSinSaude: exame.valorSinSaude,
                  valorDrAchei: exame.valorDrAchei,
                  porcentagemDesconto: exame.porcentagemDesconto,
                  rede: item._id
                })
              });
            }).catch(function (error) {
              console.log(error);
            })

            row.entity.subGridOptions.data = subGrid;
          }
        });
      }
    };

    vm.gridOptions.exporterFieldCallback = function ( grid, row, col, value ) {
      if ( col.name === 'createdAt' ) {
        value = new Date(value).toLocaleDateString();
      }
      return value;
    }

    //Habilita Redirect para rede selecionada
    vm.go = function (rede) {
      $state.go('redeDocumento', {
        redeId: rede._id
      });
    }

    vm.exportCsv = function () {
      var exportService = uiGridExporterService;
      var grid = vm.gridApi.grid;
      var fileName = 'Redes.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function () {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };

    vm.exportcvs = function () {
      var myElement = angular.element($document.querySelectorAll(".custom-csv-link-location"));
      vm.gridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL, myElement);
    };

    // abre amodal de importacao
    vm.importarDialog = function (ev) {


      $mdDialog.show({
        controller: function ($http, toastr, $scope) {
          var vm = this;
          vm.submiting = false;

          vm.ImportarPlanilha = function () {
            //Planilha importada convertida em JSON
            vm.submiting = true;
            vm.InserirRede($scope.planilha)
          }

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.InserirRede = function (redes) {
            $http.post(endpoint + 'rede/import', redes)
              .then(function (success) {
                vm.submiting = false;
                toastr.success(success.data);
                getPage();
                vm.hide();
              }).catch(function (error) {
                vm.submiting = false;
                toastr.error('Ops! Algo deu errado...' + error.statusText);
                getPage();
                vm.hide();
              });
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/rede/dialog-import.html',
        parent: angular.element($document.body),
        preserveScope: true,
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.expandAllRows = function () {
      vm.gridApi.expandable.expandAllRows();
    };

    vm.collapseAllRows = function () {
      vm.gridApi.expandable.collapseAllRows();
    };

    var getPage = function () {
      API.query().$promise.then(function (resp) {
        
        vm.gridOptions.data = resp;
        
      }).catch(function (err) {
        console.log(err);
      });
    };
    vm.busca = function(formBusca){
      busca = formBusca;
      httpBusca(busca)  
    }
    var httpBusca = function (formBusca){
      vm.loading = true;
      busca=formBusca;
      var urlBusca = endpoint+"rede/findAdmin?"
      var mudanca =0;
      if(formBusca in window){
      }else{
        for(var form in formBusca){
          if(formBusca[form] in window){
            if(formBusca.nomeRede){
              urlBusca+=form+"="+formBusca[form];
              mudanca+=1;
            }
          }else{
            if(formBusca[form] && mudanca == 0){
              urlBusca+=form+"="+formBusca[form];
              mudanca+=1;
            }else if(formBusca[form]){
              urlBusca+="&"+form+"="+formBusca[form];
            }
          }
        }
      }
      $http.get(urlBusca).then(function (resp){
        vm.gridOptions.data=resp.data;
        getPage2();
      })
    }

    var getPage2 = function () {
      vm.loading = false
    }
  }
})();
(function() {
    'use strict';
  
    angular
      .module('gruposinAdmin')
      .controller('ProdutosController', ProdutosController)      
      .factory('ProdutosService', function ($resource, endpoint) {
        var data = $resource(endpoint + 'produtos/:id', {id: '@id'}, {
        update:{
            method:'PUT'
            }
        });
        return data;
    });
  
    /** @ngInject */
    function ProdutosController($timeout, toastr, ProdutosService, $scope, uiGridConstants, $mdDialog, $document) {
      
      var API = ProdutosService;
      var vm = this;
  
      vm.toggleFiltering = function(){
        vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
        vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
      };
  
      vm.edit = function(ev, item) {
  
          var obj = {};
  
          if(item){
            obj = item;
          }
  
          $mdDialog.show({
                  controller: function() {
  
                    var vm = this;
                    vm.form = angular.copy(obj);
  
                      vm.refresh = function(){
                          getPage();
                          vm.hide();
                      };
  
                      vm.hide = function() {
                          $mdDialog.hide();
                      };
  
                      vm.cancel = function() {
                          $mdDialog.cancel();
                      };
  
                      vm.save = function() {
                        
                        if(vm.form._id){
                          API.update({id: vm.form._id}, vm.form, vm.refresh);
                        }else{
                          API.save(vm.form, vm.refresh);
                        }
                      };
                  },
                  controllerAs: 'ctrl',
                  templateUrl: 'app/produtos/dialog.html',
                  parent: angular.element($document.body),
                  targetEvent: ev,
                  locals: {local: [vm.editDialog, vm]},
                  clickOutsideToClose: false,
                  fullscreen: true
          });
      };
  
      vm.remove = function(ev, item){
        if(confirm("Deseja realmente remover?")){
          var data = vm.gridOptions.data;
  
          API.delete({id: item._id}, function(){
            var index = data.indexOf(item);
            data.splice(index, 1);
          });
        }
      };
  
      vm.gridOptions = {
        appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
        columnDefs: [
          { name: 'createdAt', enableColumnResizing: false, width: 170, enableColumnMenu: false, displayName:'Data Cadastro', type: 'date', cellFilter: 'date:"dd/MM/yyyy HH:mm:ss"' },
          { name: 'name', enableSorting: true, displayName: 'Nome do Plano' },
          { name: 'price', enableSorting: true, displayName: 'Valor' },
          { name: 'status', enableSorting: true, displayName: 'Status' },
          { name: 'idProdutoVindi', enableSorting: true, displayName: 'ID Vindi' },
          { name: 'edit', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditProdutos" module="plan" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
          { name: 'remove', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteProdutos" module="plan" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
        ],
        onRegisterApi: function(gridApi) {
          vm.gridApi = gridApi;
        }
      };
      
      vm.loading = true;   
      var getPage = function() {
        API.query().$promise.then(function(resp){
          vm.gridOptions.data = resp;
          vm.loading = false;
        });
      };
     
      getPage();
    
    }
  })();
  
(function () {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('PlanController', PlanController)
    .directive('upload', function () {

      var directive = {
        restrict: 'A',
        transclude: false,
        replace: true,
        template: '<div class="fileUpload btn btn-lg btn-primary" ng-disabled="uploading">' +
          '<input id="uploadfiles" type="file" accept="image/*" class="upload" />' +
          '<span ng-show="uploading"><md-progress-circular class="md-hue-2" md-diameter="20px"></md-progress-circular></span><span></span>' +
          '</div>',
        scope: {
          perfil: "=?",
          filename: '@'
        },
        link: function (scope, element) {

          scope.uploading = false;

          var previewImage = function (file) {

            scope.perfil[scope.filename] = file;
            scope.uploading = false;
            scope.$apply();
          };

          (function () {

            var uploadfiles = element[0].querySelector("input"); //document.querySelector('#uploadfiles');
            uploadfiles.addEventListener('change', function () {
              scope.uploading = true;
              scope.$apply();

              var files = this.files;
              for (var i = 0; i < files.length; i++) {
                uploadFile(this.files[i]);
              }
            }, false);

            function uploadFile(file) {
              var url = "https://gruposin.com.br/uploadify.php";
              var xhr = new XMLHttpRequest();
              var fd = new FormData();
              xhr.open("POST", url, true);
              xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && xhr.status == 200) {
                  previewImage(xhr.responseText);
                }
              };
              fd.append('uploaded_file', file);
              xhr.send(fd);
            }
          }());
        }
      };
      return directive;
    })
    .factory('PlanService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'plan/:id', { id: '@id' }, {
        update: {
          method: 'PUT'
        }
      });
      return data;
    });

  /** @ngInject */
  function PlanController($timeout, toastr, PlanService, $scope, uiGridConstants, $mdDialog, $document, ProdutosService, $http, endpoint) {

    var API = PlanService;
    var vm = this;

    vm.toggleFiltering = function () {
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
    };

    vm.edit = function (ev, item) {

      var obj = {};

      if (item) {
        obj = item;
      }

      $mdDialog.show({
        controller: function () {

          var vm = this;
          vm.form = angular.copy(obj);

          vm.form.produtos = vm.form.produtos ? vm.form.produtos : [];
          vm.form.price = vm.form.produtos ? vm.form.price : 0;

          vm.CalcValorTotal = function (items, prop) {
            vm.form.price = items.reduce(function (a, b) {
              return a + b.price;
            }, 0);
          };

          vm.addProduto = function () {
            vm.form.produtos.push(vm.form.produtoSelecionado)
            vm.CalcValorTotal(vm.form.produtos, 'price')
            vm.form.produtoSelecionado = null
          }
          vm.deleteProduto = function (index) {
            vm.form.produtos = vm.form.produtos.splice(index)
            vm.CalcValorTotal(vm.formSIN.produtos, 'price')

          }

          ProdutosService.query().$promise.then(function (resp) {
            vm.TodosProdutos = resp;
          })


          vm.BuscarProdutos = function (searchText) {
            return vm.TodosProdutos.filter(function (item) {
              return item.name.toUpperCase().indexOf(searchText.toUpperCase()) >= 0;
            });
          };

          vm.searchTextChangeProduto = function () { };

          vm.refresh = function () {
            getPage();
            vm.hide();
          };

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          function ExibirRetorno(status, msgRetorno) {
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .title(status)
                .textContent(msgRetorno)
                .ok('Ok!')
            );
          };

          vm.save = function () {
            if (vm.form._id) {
              API.update({ id: vm.form._id }, vm.form, vm.refresh);
            } else {
              $http.post(endpoint + "plan", vm.form).then(function (status) {
                vm.refresh()
                ExibirRetorno('Sucesso', status.data)
              }).catch(function(error) {
                vm.refresh()
                ExibirRetorno('Erro!', error.data)
              });

            }
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/plan/dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        locals: { local: [vm.editDialog, vm] },
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.remove = function (ev, item) {
      if (confirm("Deseja realmente remover?")) {
        var data = vm.gridOptions.data;

        API.delete({ id: item._id }, function () {
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        { name: 'createdAt', enableColumnResizing: false, width: 170, enableColumnMenu: false, displayName: 'Data Cadastro', type: 'date', cellFilter: 'date:"dd/MM/yyyy HH:mm:ss"' },
        { name: 'name', enableSorting: true, displayName: 'Nome do Plano' },
        { name: 'price', enableSorting: true, displayName: 'Valor Total', cellFilter: "currency" },
        //{ name: 'adesao', enableSorting: true, displayName: 'Taxa de Adesão', cellFilter: "currency" },
        { name: 'produtos', displayName: 'Produtos', field: 'produtosGrid' },
        { name: 'viewOnTheSite', enableSorting: true, displayName: 'Mostrar no Site' },
        //{ name: 'imagem', enableSorting: true, displayName: 'Imagem' },
        { name: 'tipoPlano', displayName: 'Tipo do plano' },
        { name: 'idPlanoVindi', enableSorting: true, displayName: 'ID Vindi' },
        { name: 'edit', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditPlano" module="plan" ng-click="grid.appScope.edit($event, row.entity)">edit</i>' },
        { name: 'remove', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeletePlano" module="plan" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>' }
      ],
      onRegisterApi: function (gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.loading = true;
    var getPage = function () {
      API.query().$promise.then(function (resp) {

        //Reestruturando o array de produtos para apresentar no grid
        for (let index = 0; index < resp.length; index++) {
          const plano = resp[index];
          var produtos = [].concat.apply([], plano.produtos);
          var produtosString = produtos.map(function (val, index) {
            return val.name
          }).join("/");
          resp[index].produtosGrid = produtosString;
        }

        vm.gridOptions.data = resp
        vm.loading = false;
      });
    };

    getPage();
  }
})();

(function() {
  'use strict';

    /** @ngInject */
    function AppController($scope, $window, $location, UserAuthFactory, AuthenticationFactory, $mdSidenav){
      var vm = this;
      vm.logout = function(){
        UserAuthFactory.logout();
      }

      vm.toggleMenu = function(){
        vm.lockOpen = vm.lockOpen == true ? false : true;
      }

      vm.go = function(){
          $mdSidenav('left').close();
      }
    }


    /** @ngInject */
    function LoginController($scope, $window, $location, UserAuthFactory, AuthenticationFactory, $rootScope){
      
      var vm = this;
      vm.user = {
        username: '',
        password: ''
      };

      vm.sending = false;
   
      vm.login = function() {

        var username = vm.user.username,
            password = vm.user.password;
   
        if (username !== '' && password !== '') {

          vm.sending = true;

          UserAuthFactory.login(username, password).success(function(data) {
         
            vm.sending = false;

            AuthenticationFactory.profile = data;
            AuthenticationFactory.isLogged = true;
            AuthenticationFactory.user = data.user.username;
            AuthenticationFactory.userRole = data.user.role;

            var array = [];
            for(var x in data.user.permission){
              array.push(data.user.permission[x]);
            }

            $rootScope.permission = array;
            AuthenticationFactory.permission = array;

            $window.sessionStorage.token = data.token;
            $window.sessionStorage.user = data.user.username; // to fetch the user details on refresh
            $window.sessionStorage.userRole = data.user.role; // to fetch the user details on refresh
            $window.sessionStorage.permission = angular.toJson(array); // to fetch the user details on refresh
            $window.sessionStorage.profile = angular.toJson(data);

            $location.path("/");
   
          }).error(function() {
            $window.alert('Nome de usuário ou senha incorretos.');
            vm.sending = false;
          });
        } else {
          $window.alert('Insira o nome de usuário e a senha.');
        }
      };
    }



angular.module('gruposinAdmin')
    .controller('AppController', AppController)
    .controller('LoginController', LoginController);

})();
(function () {
    'use strict';


    angular
        .module('gruposinAdmin')
        .controller('LogController', LogController)
        .factory('LogService', function ($resource, endpoint) {
            var data = $resource(endpoint + 'Log/:id', { id: '@id' }, {
                update: {
                    method: 'PUT'
                }
            });
            return data;
        });


    /** @ngInject */
    function LogController(LogService, $mdDialog, endpoint, $document, uiGridConstants) {

        var API = LogService;
        var vm = this;

        vm.exibirDetalhes = function (ev, item) {


            $mdDialog.show({
                controller: function () {
                    var vm = this;

                    vm.cancel = function () {
                        $mdDialog.cancel();
                    };
                    vm.operacao = item.operacao;
                    vm.detalhes = item.detalhes;
                    vm.options = { // default values
                        toggleBranchText: 'clique para visualizar'
                    }
                },
                controllerAs: 'ctrl',
                templateUrl: 'app/log/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true
            })
        }

        var getPage = function () {
            vm.loading = true;
            API.query().$promise.then(function(response) {
                vm.gridOptions.data = response;
                vm.loading = false;
            })
        }

        vm.gridOptions = {appScopeProvider : vm,
            enableFiltering: true,
            enableHorizontalScrollbar: true,
            fastWatch: true,
            paginationPageSizes: [15, 25, 40, 50, 100],
            paginationPageSize: 15,
            enableGridMenu: true,
            showColumnFooter: false,
            columnDefs: [
                {
                    name: 'createdAt', enableSorting: true, displayName: 'Data/Hora', width: 300, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
                    sort: {
                        direction: 'desc',
                        priority: 0
                    }
                },
                { name: 'usuario', enableSorting: true, displayName: 'Login usuário', width: 300, cellClass: function () { return 'text-left'; } },
                { name: 'operacao', enableSorting: true, displayName: 'Operação', width: 300, cellClass: function () { return 'text-left'; } },
                { name: 'modulo', enableSorting: true, displayName: 'Módulo', width: 300 },
                { name: 'detalhes', width: 300, displayName: 'Detalhes', cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" title="Detalhes" ng-click="grid.appScope.exibirDetalhes($event, row.entity)">folder_shared</i>' }
            ]
        };

        getPage();

    }
})();
(function() {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('juridicaCobrancaController', juridicaCobrancaController)
    .factory('juridicaCobrancaService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'juridicaCobranca/:id?populate=juridica', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });


  /** @ngInject */
  function juridicaCobrancaController($timeout, toastr, juridicaCobrancaService, $scope, uiGridConstants, $mdDialog, UserService, AuthenticationFactory, uiGridExporterService, uiGridExporterConstants, ClientService, endpoint, $mdToast) {

    var API = juridicaCobrancaService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.exportExcel = function(router){
      AuthenticationFactory.exportReport(router);
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    // Export CSV
    vm.exportCsv = function(){
      var exportService=uiGridExporterService;
      var grid=vm.gridApi.grid;
      var fileName= 'juridica-Cobranca.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function() {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };
    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      showColumnFooter: true,
      columnDefs: [
        { name: 'createdAt', enableCellEdit: false, enableSorting: true, displayName: 'Data do Cadastro', width: 170, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'', filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
          filters: [{
            // condition: uiGridConstants.filter.GREATER_THAN
            filterName: 'maiorQue',
            condition: function(searchTerm, cellValue) {

              var search = new Date(searchTerm);
              var cValue = new Date(cellValue);

              return cValue.getTime() > search.getTime()
              // var data = searchTerm.split('/');
              // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
              // return strippedValue.indexOf(searchTerm) >= 0;
            }},
            {
              // condition: uiGridConstants.filter.GREATER_THAN
              filterName: 'menorQue',
              condition: function(searchTerm, cellValue) {

                var search = new Date(searchTerm);
                var cValue = new Date(cellValue);

                return cValue.getTime() < search.getTime()
                // var data = searchTerm.split('/');
                // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
                // return strippedValue.indexOf(searchTerm) >= 0;
              }
            }]
        },
        { name: 'juridica.name', enableCellEdit: false, enableSorting: true, width: 250, displayName: 'Empresa' },
        { name: 'qtdeFuncionarios', enableCellEdit: false, enableSorting: true, width: 120, displayName: 'Cartões' },
        { name: 'price', enableCellEdit: false, enableSorting: true, width: 150, displayName: 'Preço', cellFilter: "currency", aggregationType: uiGridConstants.aggregationTypes.sum, footerCellFilter: 'currency' },
        { name: 'valor', enableCellEdit: false, enableSorting: true, width: 150, displayName: 'Valor Total', cellFilter: "currency", aggregationType: uiGridConstants.aggregationTypes.sum, footerCellFilter: 'currency' },
        { name: 'dataCobranca',enableCellEdit: false, width: 150,enableSorting: true, displayName: 'Dt Cobrança', type: 'date', cellFilter: 'date:\'dd/MM/yyyy\'', filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
          filters: [{
            // condition: uiGridConstants.filter.GREATER_THAN
            filterName: 'maiorQue',
            condition: function(searchTerm, cellValue) {

              var search = new Date(searchTerm);
              var cValue = new Date(cellValue);

              return cValue.getTime() > search.getTime()
              // var data = searchTerm.split('/');
              // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
              // return strippedValue.indexOf(searchTerm) >= 0;
            }},
            {
              // condition: uiGridConstants.filter.GREATER_THAN
              filterName: 'menorQue',
              condition: function(searchTerm, cellValue) {

                var search = new Date(searchTerm);
                var cValue = new Date(cellValue);

                return cValue.getTime() < search.getTime()
                // var data = searchTerm.split('/');
                // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
                // return strippedValue.indexOf(searchTerm) >= 0;
              }
            }]
        },
        { name: 'dataPagamento', enableCellEdit: true, enableSorting: true, displayName: 'Dt Pagamento', type: 'date', width: 150, cellFilter: 'date:\'dd/MM/yyyy\'' },
        { name: 'remove', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeletePJ" module="pjuridica" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
        vm.gridApi.edit.on.afterCellEdit($scope, function(rowEntity) {
          API.update({id : rowEntity._id}, rowEntity).$promise.then(function(){

              $mdToast.show(
                $mdToast.simple()
                  .textContent('Cobrança atualizada com sucesso.')
                  .position('top right')
                  .hideDelay(3000)
              );

          })
          $scope.$apply();
        });
      }
    };

    vm.loading = true;
    var getPage = function() {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;
      var obj = {};

      if(role === 'Vendedor'){
        obj = {vendedor : id};
      }

      API.query(obj).$promise.then(function(resp){

        if(role === 'Vendedor'){
          resp = resp.filter(function(item){
            if(item.juridica && item.juridica.vendedor){
              if(item.juridica.vendedor == id){
                return item;
              }
            }
          });
        }
        
        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };
   
    getPage();
  }

})();
(function() {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('JuridicaController', JuridicaController)
    .factory('JuridicaService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'juridica/:id?populate=vendedor', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });


  /** @ngInject */
  function JuridicaController($timeout, toastr, JuridicaService, $scope, uiGridConstants, $mdDialog, UserService, AuthenticationFactory, uiGridExporterService, uiGridExporterConstants, ClientService, endpoint, $document) {

    var API = JuridicaService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.exportExcel = function(router){
      AuthenticationFactory.exportReport(router);
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    // abre pra escolher o mes
    vm.gerarCobranca = function(ev){
      

      $mdDialog.show({
        controller: function($http, toastr, $mdToast, $window, AuthenticationFactory) {

          var vm = this;
          vm.submiting = false;

          //Controla o autoComplete
          vm.selectedItem = vm.juridica;
          //Faz a Busca de empresas
          JuridicaService.query().$promise.then(function(resp) {
              vm.empresas = resp;
          });
          
          // empresa
          vm.searchTextChangeEmpresa = function() {};
          vm.selectedItemChangeEmpresa = function(company) {
              if(company){
                vm.juridica = { id: company._id, label: company.name };
              }else{
                vm.juridica = null;
              }
          };
          vm.searchCompanyEmpresa = function(search) {
              return vm.empresas.filter(function(item) {
                  return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0;
              });
          };

          vm.hide = function() {
              $mdDialog.hide();
          };

          vm.cancel = function() {
              $mdDialog.cancel();
          };

          vm.submit = function() {

            if(!vm.form.mes){
              $window.alert('Selecione o mês');
              return false;
            }

            vm.submiting = true;

            var profile = AuthenticationFactory.profile;
            var role = profile.user.role;
            var id = profile.user._id;

            var url = endpoint + 'juridicaCobranca/gerarCobranca?mes=' + vm.form.mes;

            
            if(vm.juridica){
              url = url + '&empresaId=' + vm.juridica.id;
            }

            if(role === 'Vendedor'){
              url = url + '&id=' + id;
            }


            //toastr.success('Cobranças efetuadas com sucesso.', 'Gerar Cobrança');
            $http.get(url).then(function(resp){

              var message = 'Nenhuma cobrança efetuada para o vencimento escolhido';

              if(resp.data.length === 1){
                message = '1 Cobrança efetuada para o vencimento escolhido'
              }else if(resp.data.length > 1) {
                message = resp.data.length + ' Cobranças efetuadas para o vencimento escolhido'
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(message)
                  .position('top right')
                  .hideDelay(3000)
              );
              vm.submiting = false;
              vm.hide();
            })
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/juridica/dialog-gerarCobranca.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    // Export CSV
    vm.exportCsv = function(){
      var exportService=uiGridExporterService;
      var grid=vm.gridApi.grid;
      var fileName= 'PJ.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function() {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };


    vm.edit = function(ev, item) {

        var obj = {};

        if(item){
          obj = item;
          obj.dataVencimento = obj.dataVencimento.toString();
        }

        $mdDialog.show({
                controller: function($http, AuthenticationFactory, UserService) {

                  var vm = this;
                  vm.selectedItem = obj.vendedor;
                  vm.form = angular.copy(obj);
                  vm.vendedores = [];

                  // carrega a lista de vendedores
                  UserService.query({role: 'Vendedor'}).$promise.then(function(resp) {
                      vm.vendedores = resp;
                  });

                  vm.updateAddress = function() {
                    AuthenticationFactory.getCEP(vm.form.cep)
                        .then(function(endereco) {
                            vm.form.endereco = endereco.logradouro;
                            vm.form.cidade = endereco.localidade;
                            vm.form.bairro = endereco.bairro;
                            vm.form.uf = endereco.uf.toLowerCase();
                    });
                  };


                  vm.searchTextChange = function() {};
                  vm.selectedItemChange = function(company) {
                      if(company){
                          vm.form.vendedor = company._id;
                      }else{
                        vm.form.vendedor = null;
                      }
                  };
                  vm.searchCompany = function(search) {
                      return vm.vendedores.filter(function(item) {
                          return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.cpf && item.cpf.toUpperCase().indexOf(search.toUpperCase()) >= 0);
                      });
                  };


                  vm.refresh = function(){
                      getPage();
                      vm.hide();
                  };

                  vm.hide = function() {
                      $mdDialog.hide();
                  };

                  vm.cancel = function() {
                      $mdDialog.cancel();
                  };

                  vm.save = function() {
                      if(vm.form._id){
                        API.update({id: vm.form._id}, vm.form, vm.refresh);
                      }else{
                        API.save(vm.form, vm.refresh);
                      }
                  };
                },
                controllerAs : 'ctrl',
                templateUrl: 'app/juridica/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      showColumnFooter: true,
      columnDefs: [
        { name: 'createdAt',enableSorting: true, displayName: 'Data Cadastro', width: 170, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'', filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
          filters: [{
            // condition: uiGridConstants.filter.GREATER_THAN
            filterName: 'maiorQue',
            condition: function(searchTerm, cellValue) {

              var search = new Date(searchTerm);
              var cValue = new Date(cellValue);

              return cValue.getTime() > search.getTime()
              // var data = searchTerm.split('/');
              // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
              // return strippedValue.indexOf(searchTerm) >= 0;
            }},
            {
              // condition: uiGridConstants.filter.GREATER_THAN
              filterName: 'menorQue',
              condition: function(searchTerm, cellValue) {

                var search = new Date(searchTerm);
                var cValue = new Date(cellValue);

                return cValue.getTime() < search.getTime()
                // var data = searchTerm.split('/');
                // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
                // return strippedValue.indexOf(searchTerm) >= 0;
              }
            }]
        },
        { name: 'vendedor.name', enableSorting: true, displayName: 'Vendedor', width: 200 },
        { name: 'vendedor.comissaoVendedor', enableSorting: true, displayName: '% Cms Vendedor', width: 150 },
        { name: 'name', enableSorting: true, displayName: 'Nome', width: 200 },
        { name: 'cnpj', enableSorting: true, displayName: 'CNPJ', width: 200 },
        { name: 'email', enableSorting: true, displayName: 'E-mail', width: 200 },
        { name: 'price', enableSorting: true, displayName: 'Valor', cellFilter: "currency", width: 150, aggregationType: uiGridConstants.aggregationTypes.sum, footerCellFilter: 'currency' },
        { name: 'dataVencimento', enableSorting: true, displayName: 'Dia Pagamento', width: 100 },
        { name: 'QtdeCliente', enableSorting: true, displayName: 'Qtde Func', width: 100, aggregationType: uiGridConstants.aggregationTypes.sum },
        { name: 'QtdeClienteHabilitado', enableSorting: true, displayName: 'Habilitados', width: 120, aggregationType: uiGridConstants.aggregationTypes.sum },
        { name: 'ValorCobrancaMensal', enableSorting: true, displayName: 'Valor Cobr.', width: 200, cellFilter: "currency", aggregationType: uiGridConstants.aggregationTypes.sum, footerCellFilter: 'currency'  },
        { name: 'ValorVendedorMensal', enableSorting: true, displayName: 'Valor Vend. Mensal', width: 200, cellFilter: "currency",aggregationType: uiGridConstants.aggregationTypes.sum, footerCellFilter: 'currency' },
        { name: 'status', enableSorting: true, displayName: 'Status', width: 100 },
        { name: 'edit', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditPJ" module="pjuridica" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeletePJ" module="pjuridica" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.loading = true;
    var getPage = function() {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;
      var obj = {};

      if(role === 'Vendedor'){
        obj = {vendedor : id};
      }

      // Recupera a lista de Clientes
      ClientService.query(obj).$promise.then(function(clientes){

        API.query(obj).$promise.then(function(resp){
          resp.forEach(function(empresa){
            empresa.QtdeCliente = clientes.filter(function(cliente){
              if(cliente.juridica){
                return (cliente.juridica._id == empresa._id)
              }
            }).length;

            empresa.QtdeClienteHabilitado = clientes.filter(function(cliente){
              if(cliente.juridica){
                return (cliente.juridica._id == empresa._id && cliente.status === 'Habilitado');
              }
            }).length;

            empresa.ValorCobrancaMensal = empresa.QtdeClienteHabilitado * empresa.price;
            empresa.ValorVendedorMensal = (empresa.ValorCobrancaMensal * (empresa.vendedor ? empresa.vendedor.comissaoVendedor : 0)) / 100;

          });

          vm.gridOptions.data = resp;
          vm.loading = false;
        });

      }); 

    };
   
    getPage();
  }

})();
(function() {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('InicioController', InicioController)


  /** @ngInject */
  function InicioController() {
  }

})();

(function () {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('ExameController', ExameController)
    .factory('ExameService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'exame/:id', { id: '@id' }, {
        update: {
          method: 'PUT'
        }
      });
      return data;
    });

    function ExameController(ExameService, $mdDialog, endpoint, $document, uiGridConstants, $http) {

      var API = ExameService;
      var vm = this;
  
      vm.importarDialog = function (ev) {
  
  
        $mdDialog.show({
          controller: function ($http, toastr, $scope) {
            var vm = this;
            vm.submiting = false;
  
            vm.ImportarPlanilha = function () {
              //Planilha importada convertida em JSON
              vm.submiting = true;
              vm.InserirExames($scope.planilha)
            }
  
            vm.hide = function () {
              $mdDialog.hide();
            };
  
            vm.cancel = function () {
              $mdDialog.cancel();
            };
  
            vm.InserirExames = function (redes) {
              $http.post(endpoint + 'exame/import', redes)
                .then(function (success) {
                  vm.submiting = false;
                  toastr.success(success.data);
                  getPage();
                  vm.hide();
                }
                ).catch(function (error) {
                  vm.submiting = false;
                  toastr.error('Ops! Algo deu errado...' + error.statusText);
                  getPage();
                  vm.hide();
                });
            };
          },
          controllerAs: 'ctrl',
          templateUrl: 'app/exames/dialog-import.html',
          parent: angular.element($document.body),
          preserveScope: true,
          targetEvent: ev,
          clickOutsideToClose: false,
          fullscreen: true
        });
      };
      
      var getPage = function () {
        vm.loading = true;
        API.query().$promise.then(function(response) {
          vm.gridOptions.data = response;
          vm.loading = false;
        })
      }
  
      vm.remove = function (ev, item) {
        if (confirm("Deseja realmente remover?")) {
          var data = vm.gridOptions.data;
  
          API.delete({ id: item._id }, function () {
            var index = data.indexOf(item);
            data.splice(index, 1);
          });
        }
      };
  
      vm.edit = function (ev, item) {
  
  
        $mdDialog.show({
          controller: function () {
            let vm = this;
            vm.cancel = function () {
              $mdDialog.cancel();
            };
  
            vm.form = {}
            if (item)
              vm.form = item                 
            
           
  
            vm.refresh = function () {
              getPage();
              vm.hide();
            };
  
            vm.hide = function () {
              $mdDialog.hide();
            };
            
            vm.save = function () {
              if (vm.form._id) {
                API.update({ id: vm.form._id }, vm.form, vm.refresh);
              } else {
                API.save(vm.form, vm.refresh);
              }
            };
  
          },
          controllerAs: 'ctrl',
          templateUrl: 'app/exames/dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          fullscreen: true
        });
      };
  
  
        vm.gridOptions = {
        appScopeProvider : vm,
        enableFiltering: false,
        enableHorizontalScrollbar: true,
        fastWatch: true,
        paginationPageSizes: [15, 25, 40, 50, 100],
        paginationPageSize: 15,
        enableGridMenu: true,
        exporterExcelFilename: 'exame.xlsx',
        showColumnFooter: false,
        columnDefs: [
          {
            name: 'codigoExame', enableSorting: true, displayName: 'Codigo do Exame', width: 200, type: 'number', sort: {
              direction: uiGridConstants.ASC,
              priority: 0
            }
          },
          { name: 'nomeExame', enableSorting: true, displayName: 'Nome do exame', width: 800, cellClass: function () { return 'text-left'; } },            
          { name: 'edit' , enableColumnResizing: false, pinnedRight: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditExames" module="exames" ng-click="grid.appScope.edit($event, row.entity)">edit</i>' },
          { name: 'remove', enableColumnResizing: false, pinnedRight: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteExames" module="exames" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>' }
        ]
      };

      vm.busca = function (formBusca){
        vm.loading = true;
        var urlBusca = endpoint+"exame/findAdmin?"
        var mudanca =0;
        if(formBusca in window){
        }else{
          for(var form in formBusca){
            if(formBusca[form] in window){
              if(formBusca.codigoExame){
                urlBusca+=form+"="+formBusca[form];
                mudanca+=1;
              }
            }else{
              if(formBusca[form] && mudanca == 0){
                urlBusca+=form+"="+formBusca[form];
                mudanca+=1;
              }else if(formBusca[form]){
                urlBusca+="&"+form+"="+formBusca[form];
              }
            }
          }
        }
        $http.get(urlBusca).then(function (resp){
          vm.gridOptions.data=resp.data;
          getPage2();
        })
      }
    var getPage2 = function () {
      vm.loading = false
    }
  
  }
})();
(function() {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('EmprestimoController', EmprestimoController)
    .factory('EmprestimoService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'emprestimo/:id', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });

  /** @ngInject */
  function EmprestimoController($timeout, toastr, EmprestimoService, $scope, uiGridConstants, $mdDialog, $document) {

    var API = EmprestimoService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.edit = function(ev, item) {

        var obj = {};

        if(item){
          obj = item;
        }

        $mdDialog.show({
                controller: function() {

                  var vm = this;
                  vm.form = angular.copy(obj);
                  vm.refresh = function(){
                      getPage();
                      vm.hide();
                  };

                  vm.hide = function() {
                      $mdDialog.hide();
                  };

                  vm.cancel = function() {
                      $mdDialog.cancel();
                  };

                  vm.save = function() {

                      if(vm.form._id){
                        API.update({id: vm.form._id}, vm.form, vm.refresh);
                      }else{
                        API.save(vm.form, vm.refresh);
                      }
                  };
                },
                controllerAs: 'ctrl',
                templateUrl: 'app/emprestimo/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {local: [vm.editDialog, vm]},
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        { name: 'name', enableSorting: true, displayName: 'Nome' },
        { name: 'email', enableSorting: true, displayName: 'E-mail' },
        { name: 'cidade', enableSorting: true, displayName: 'Cidade' },
        { name: 'telefone', enableSorting: true, displayName: 'Telefone' },
        { name: 'valorEstimado', enableSorting: true, displayName: 'Valor Estimado' },
        { name: 'edit', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditEmprestimo" module="emprestimo" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteEmprestimo" module="emprestimo" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };
   
    vm.loading = true;   
    var getPage = function() {
      API.query().$promise.then(function(resp){
        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };
   
    getPage();
  }
})();

(function() {
  'use strict';

  /** @ngInject */
  function EmailController($timeout, toastr, EmailService, $scope, uiGridConstants, $mdDialog, $document, AuthenticationFactory, uiGridExporterService, uiGridExporterConstants) {

    var API = EmailService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.exportExcel = function(router){
      AuthenticationFactory.exportReport(router);
    };

    vm.exportCsv = function(){
      var exportService=uiGridExporterService;
      var grid=vm.gridApi.grid;
      var fileName= 'Emails.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function() {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.edit = function(ev, item) {

        var obj = {};

        if(item){
          obj = item;
        }

        $mdDialog.show({
                controller: function() {

                  var vm = this;
                  vm.form = angular.copy(obj);

                  vm.refresh = function(){
                      getPage();
                      vm.hide();
                  };

                  vm.hide = function() {
                      $mdDialog.hide();
                  };

                  vm.cancel = function() {
                      $mdDialog.cancel();
                  };

                  vm.save = function() {

                      if(vm.form._id){
                        API.update({id: vm.form._id}, vm.form, vm.refresh);
                      }else{
                        API.save(vm.form, vm.refresh);
                      }
                  };
                },
                controllerAs: 'ctrl',
                templateUrl: 'app/email/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {local: [vm.editDialog, vm]},
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        { name: 'createdAt', enableSorting: true, displayName: 'Data Cadastro',  type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'' },
        { name: 'email', enableSorting: true, displayName: 'E-mail' },
        { name: 'edit', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditEmail" module="email" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteEmail" module="email" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };
   
    vm.loading = true;   
    var getPage = function() {
      API.query().$promise.then(function(resp){
        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };
   
    getPage();
  }


  angular
    .module('gruposinAdmin')
    .controller('EmailController', EmailController)
    .factory('EmailService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'email/:id', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });


})();

(function() {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('DocumentoController', DocumentoController)
    .factory('DocumentoService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'documento/:id?populate=vendedor', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });

  /** @ngInject */
  function DocumentoController($timeout, toastr, DocumentoService, $scope, url_images, uiGridConstants, $mdDialog, AuthenticationFactory, UserService, $document) {

    var API = DocumentoService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.edit = function(ev, item) {

        var obj = {};

        if(item){
          obj = item;
        }

        var profile = AuthenticationFactory.profile;
        var role = profile.user.role;
        var id = profile.user._id;

        if(role === 'Vendedor'){
          obj.vendedor = id;
        }

        $mdDialog.show({
                controller: function() {

                  var vm = this;
                  vm.form = angular.copy(obj);
                  vm.loading = false;

                  if(vm.form.vendedor){
                    vm.selectedItem = vm.form.vendedor;
                  }

                  vm.items = [{
                    name: 'Planilhas',
                    group: 'Saúde'
                  }, {
                    name: 'Cadastro clientes físico (modelo)',
                    group: 'Saúde'
                  }, {
                    name: 'Contrato empreendedores (modelo)',
                    group: 'Saúde'
                  }, {
                    name: 'Termo de adesão (modelo)',
                    group: 'Saúde'
                  }, {
                    name: 'Book Operacional',
                    group: 'Saúde'
                  }, {
                    name: 'Outros',
                    group: 'Saúde'
                  }, {
                    name: 'Protocolos',
                    group: 'EMPRÉSTIMOS'
                  }, {
                    name: 'Engenharias',
                    group: 'EMPRÉSTIMOS'
                  }, {
                    name: 'Contratos',
                    group: 'EMPRÉSTIMOS'
                  }, {
                    name: 'Cadastros',
                    group: 'EMPRÉSTIMOS'
                  }, {
                    name: 'Outros',
                    group: 'EMPRÉSTIMOS'
                  }, {
                    name: 'Contratos',
                    group: 'Seguros'
                  }, {
                    name: 'Modelos Contratos',
                    group: 'Seguros'
                  }, {
                    name: 'Clientes',
                    group: 'Seguros'
                  }, {
                    name: 'Outros',
                    group: 'Seguros'
                  }];

                  // carrega a lista de vendedores
                  UserService.query({role:'Vendedor'}).$promise.then(function(resp) {
                      vm.vendedores = resp;
                  });

                  // vendedor
                  vm.searchTextChange = function() {};
                  vm.selectedItemChange = function(company) {
                      if(company){
                          vm.form.vendedor = company._id;
                      }else{
                        vm.form.vendedor = null;
                      }
                  };
                  vm.searchCompany = function(search) {
                      return vm.vendedores.filter(function(item) {
                          return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.cpf && item.cpf.toUpperCase().indexOf(search.toUpperCase()) >= 0);
                      });
                  };


                // Here I'm just calculating the groups when the controller runs
                // You would probably want to use a $watch if you expected the list to change
                  vm.groupList = vm.items.reduce(function(previous, current) {
                    if (previous.indexOf(current.group) === -1) {
                      previous.push(current.group);
                    }

                    return previous;
                  }, []);


                    vm.refresh = function(){
                        getPage();
                        vm.hide();
                        vm.loading = false;
                    };

                    vm.hide = function() {
                        $mdDialog.hide();
                    };

                    vm.cancel = function() {
                        $mdDialog.cancel();
                    };

                    vm.save = function() {
                      vm.loading = true;

                      if(vm.form._id){
                        API.update({id: vm.form._id}, vm.form, vm.refresh);
                      }else{
                        API.save(vm.form, vm.refresh);
                      }
                    };
                },
                controllerAs: 'ctrl',
                templateUrl: 'app/documento/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {local: [vm.editDialog, vm]},
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        { name: 'createdAt', enableColumnResizing: false, width: 170, enableColumnMenu: false, displayName:'Data Cadastro', type: 'date', cellFilter: 'date:"dd/MM/yyyy HH:mm:ss"' },
        { name: 'name', enableSorting: true, displayName: 'Nome do documento' },
        { name: 'tipo.group', enableSorting: true, displayName: 'Tipo' },
        { name: 'tipo.name', enableSorting: true, displayName: 'Sub-Tipo' },
        { name: 'vendedor.name', enableSorting: true, displayName: 'Vendedor' },
        { name: 'arquivo', enableSorting: false, displayName: '', width: 50, enableFiltering: false, enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<a href="{{url_images}}{{row.entity.arquivo}}" target="_blank" title="Download"><i class="material-icons">file_download</i></a>' },
        { name: 'edit', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditDocumento" module="documento" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteDocumento" module="documento" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.loading = true;
    var getPage = function() {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;
      var obj = {};

      if(role === 'Vendedor'){
        obj = {'vendedor' : id};
      }


      API.query(obj).$promise.then(function(resp){
        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };

    getPage();
  }
})();

(function() {
  'use strict';

  angular
    .module('gruposinAdmin')
    .controller('CupomController', CupomController)
    .factory('CupomService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'cupom/:id?populate=vendedor', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });

  /** @ngInject */
  function CupomController(toastr, CupomService, $scope, uiGridConstants, $mdDialog, AuthenticationFactory, uiGridExporterService, uiGridExporterConstants, $document) {

    var API = CupomService;
    var vm = this;

    vm.getTableHeight = function() {
       var rowHeight = 30; // your row height
       var headerHeight = 30; // your header height
       return {
          height: (vm.gridOptions.data.length * rowHeight + headerHeight) + "px"
       };
    };

    vm.exportReport = function(router){
      AuthenticationFactory.exportReport(router);
    };

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.export = function(){
      var exportService=uiGridExporterService;
      var grid=vm.gridApi.grid;
      var fileName= 'Cupons.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function() {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };


    vm.edit = function(ev, item) {

        var obj = {};

        if(item){
          obj = item;

          if(obj.dataValidade){
            obj.dataValidade = new Date(obj.dataValidade);
          }
        }

        $mdDialog.show({
            controller: function($scope, local, UserService) {

                var vm = this;
                vm.form = angular.copy(obj);

                vm.users = UserService.query({role: 'Vendedor'});

                if(vm.form.vendedor){
                  vm.selectedItem = vm.form.vendedor;
                }

                vm.searchTextChange = function() {};
                vm.selectedItemChange = function(item) {
                    if(item){
                        vm.form.vendedor = item._id;
                    }
                };

                vm.refresh = function(){
                    getPage();
                    vm.hide();
                };

                vm.search = function(search) {
                    return vm.users.filter(function(item) {
                        return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0;
                    });
                };

                vm.hide = function() {
                    $mdDialog.hide();
                };

                vm.cancel = function() {
                    $mdDialog.cancel();
                };

                vm.save = function() {

                  if(vm.form._id){
                    API.update({id: vm.form._id}, vm.form, vm.refresh);
                  }else{
                    API.save(vm.form, vm.refresh);
                  }

                };
            },
            controllerAs: 'ctrl',
            templateUrl: 'app/cupom/dialog.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            locals: {local: [vm.editDialog, vm]},
            clickOutsideToClose: false,
            fullscreen: true
        });
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.rowFormatter = function( row ) {
      return row.entity.gender === 'male';
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      enableVerticalScrollbar: false,
      columnDefs: [
        { name: 'createdAt', enableColumnResizing: false, width: 170, enableColumnMenu: false, displayName:'Data Cadastro', type: 'date', cellFilter: 'date:"dd/MM/yyyy HH:mm:ss"' },
        { name: 'name', enableSorting: true, displayName: 'Nome do Cupom' },
        { name: 'dataValidade', enableSorting: true, displayName: 'Dt Validade', type: 'date', width: 150, cellFilter: 'date:\'dd/MM/yyyy\'' },
        { name: 'descontoCliente', enableSorting: true, displayName: '% Desconto Cliente' },
        { name: 'qtde', enableSorting: true, displayName: 'Qtde Cadastrada' },
        { name: 'qtdeUtilizada', enableSorting: true, displayName: 'Qtde Utilizada' },
        { name: 'comissaoVendedor', enableSorting: true, displayName: '% Comissão Vendedor' },
        { name: 'vendedor.name', enableSorting: true, displayName: 'Vendedor' },
        { name: 'status', enableSorting: true, displayName: 'Habilitado' },
        { name: 'edit', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditCupom" module="cupom" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteCupom" module="cupom" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
        ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };
   
    vm.loading = true;   
    var getPage = function() {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;
      var obj = {};

      if(role === 'Vendedor'){
        obj = {vendedor : id};
      }

      API.query(obj).$promise.then(function(resp){
        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };

   
    getPage();
  }
})();
(function () {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('CorpoClinicoController', CorpoClinicoController)
    .factory('CorpoClinicoService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'corpoClinico/:id', { id: '@id' }, {
        update: {
          method: 'PUT'
        }
      });
      return data;
    });


  /** @ngInject */
  function CorpoClinicoController(CorpoClinicoService, $mdDialog, endpoint, $document, uiGridConstants, RedeEspecialidadeService, RedeService) {

    var API = CorpoClinicoService;
    var vm = this;

    vm.importarDialog = function (ev) {


      $mdDialog.show({
        controller: function ($http, toastr, $scope) {
          var vm = this;
          vm.submiting = false;

          vm.ImportarPlanilha = function () {
            //Planilha importada convertida em JSON
            vm.submiting = true;
            vm.InserirCorpoClinico($scope.planilha)
          }

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.InserirCorpoClinico = function (redes) {
            $http.post(endpoint + 'corpoClinico/import', redes)
              .then(function (success) {
                vm.submiting = false;
                toastr.success(success.data);
                getPage();
                vm.hide();
              }
              ).catch(function (error) {
                vm.submiting = false;
                toastr.error('Ops! Algo deu errado...' + error.statusText);
                getPage();
                vm.hide();
              });
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/corpoClinico/dialog-import.html',
        parent: angular.element($document.body),
        preserveScope: true,
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    var getPage = function () {
      API.query({ populate: 'especialidade' }).$promise.then(function(response) {
        vm.loading = true;
        vm.gridOptions.data = response;
        vm.loading = false;
      })
    }

    vm.remove = function (ev, item) {
      if (confirm("Deseja realmente remover?")) {
        var data = vm.gridOptions.data;

        API.delete({ id: item._id }, function () {
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.edit = function (ev, item) {


      $mdDialog.show({
        controller: function () {
          let vm = this;
          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.form = {}

          if (item) {
            vm.form = item
            vm.form.status = item.status
          }

          //#region Especialidade
          RedeEspecialidadeService.query().$promise.then(function(response) {
            vm.especialidades = response;
          })
          //#endregion

          //#region Rede
          RedeService.query().$promise.then(function(response){
            vm.redes = response
            if (item)
              vm.selectedRede = response.filter(function(item) { return item._id == vm.form.rede })[0]
          })


          vm.selectedItemChangeRede = function (rede) {
            if (rede) {
              vm.form.rede = rede._id;
              vm.form.codigoUnidade = rede.codigoUnidade;
              vm.form.nomeRede = rede.nomeRede;
            } else {
              vm.form.rede = null;
              vm.form.codigoUnidade = null
            }
          };
          vm.searchRede = function (search) {
            return vm.redes.filter(function (item) {
              if (item.nomeRede)
                return item.nomeRede.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.codigoUnidade == search);
            });
          };

          //#endregion


          vm.refresh = function () {
            getPage();
            vm.hide();
          };

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.save = function () {
            if (vm.form._id) {
              API.update({ id: vm.form._id }, vm.form, vm.refresh);
            } else {
              API.save(vm.form, vm.refresh);
            }
          };

        },
        controllerAs: 'ctrl',
        templateUrl: 'app/corpoClinico/dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };


    vm.gridOptions = {
      
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      showColumnFooter: false,
      columnDefs: [
        {name: 'status', enableSorting: true, displayName: 'Status', width: 150},
        {
          name: 'codigoUnidade', enableSorting: true, displayName: 'Codigo da Unidade', width: 150, type: 'number', sort: {
            direction: uiGridConstants.ASC,
            priority: 0
          }
        },
        { name: 'nomeRede', enableSorting: true, displayName: 'Prestador', width: 300, cellClass: function () { return 'text-left'; } },
        { name: 'nome', enableSorting: true, displayName: 'Corpo Clinico', width: 300, cellClass: function () { return 'text-left'; } },
        { name: 'especialidade._id', enableSorting: true, displayName: 'Cod Especialidade', width: 150 },
        { name: '_id', visible: false },
        { name: 'especialidade.nome', enableSorting: true, displayName: 'Especialidade', width: 300 },
        { name: 'tipoRegistro', enableSorting: true, displayName: 'Tipo do registro', width: 150 },
        { name: 'numeroRegistro', enableSorting: true, displayName: 'Número do registro', width: 300 },
        { name: 'edit' , enableColumnResizing: false, pinnedRight: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditCorpoClinico" module="corpoClinico" ng-click="grid.appScope.edit($event, row.entity)">edit</i>' },
        { name: 'remove', enableColumnResizing: false, pinnedRight: false, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function () { return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteCorpoClinico" module="corpoClinico" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>' }
      ]
    };

    getPage();

  }
})();
(function() {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('clientCobrancaController', clientCobrancaController)
    .factory('clientCobrancaService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'clientCobranca/:id?populate=cartao cartao.pedido', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });


  /** @ngInject */
  function clientCobrancaController($timeout, toastr, clientCobrancaService, $scope, uiGridConstants, $mdDialog, UserService, AuthenticationFactory, uiGridExporterService, uiGridExporterConstants, ClientService, endpoint, $mdToast) {

    var API = clientCobrancaService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.exportExcel = function(router){
      AuthenticationFactory.exportReport(router);
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    // Export CSV
    vm.exportCsv = function(){
      var exportService=uiGridExporterService;
      var grid=vm.gridApi.grid;
      var fileName= 'Cobranca-Cliente.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function() {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      showColumnFooter: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        { name: 'createdAt', enableCellEdit: false, enableSorting: true, displayName: 'Data do Cadastro', width: 170, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'', filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
          filters: [{
            // condition: uiGridConstants.filter.GREATER_THAN
            filterName: 'maiorQue',
            condition: function(searchTerm, cellValue) {

              var search = new Date(searchTerm);
              var cValue = new Date(cellValue);

              return cValue.getTime() > search.getTime()
              // var data = searchTerm.split('/');
              // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
              // return strippedValue.indexOf(searchTerm) >= 0;
            }},
            {
              // condition: uiGridConstants.filter.GREATER_THAN
              filterName: 'menorQue',
              condition: function(searchTerm, cellValue) {

                var search = new Date(searchTerm);
                var cValue = new Date(cellValue);

                return cValue.getTime() < search.getTime()
                // var data = searchTerm.split('/');
                // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
                // return strippedValue.indexOf(searchTerm) >= 0;
              }
            }]
        },
        { name: 'name', enableCellEdit: false, enableSorting: true, width: 250, displayName: 'Nome do Cliente' },
        { name: 'cpf', enableCellEdit: false, enableSorting: true, width: 150, displayName: 'CPF do Cliente' },
        { name: 'numeroCartao', enableCellEdit: false, width: 150, enableSorting: true, displayName: 'Nº do Cartão' },
        { name: 'dataVencimento', enableCellEdit: false, width: 150, enableSorting: true, displayName: 'Dia do Vencimento'},
        { name: 'valorMensalidade', enableCellEdit: false, width: 150, enableSorting: true, displayName: 'Valor da Mensalidade', cellFilter: "currency", aggregationType: uiGridConstants.aggregationTypes.sum, footerCellFilter: 'currency' },
        { name: 'dataPagamento', enableCellEdit: true, width: 150, enableSorting: true, displayName: 'Dt Pagamento', type: 'date', cellFilter: 'date:\'dd/MM/yyyy\'' },
        { name: 'remove', enableColumnResizing: false, pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeletePJ" module="pjuridica" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
        vm.gridApi.edit.on.afterCellEdit($scope, function(rowEntity) {
          API.update({id : rowEntity._id}, rowEntity).$promise.then(function(){

              var message = 'Cobrança atualizada com sucesso';

              $mdToast.show(
                $mdToast.simple()
                  .textContent(message)
                  .position('top right')
                  .hideDelay(3000)
              );

          })
          $scope.$apply();
        });
      }
    };

    vm.loading = true;
    var getPage = function() {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;
      var obj = {};

      if(role === 'Vendedor'){
        obj = {vendedor : id};
      }

      API.query(obj).$promise.then(function(resp){

        if(role === 'Vendedor'){
          resp = resp.filter(function(item){
            if(item.cartao && item.cartao.pedido && item.cartao.pedido.vendedor){
              if(item.cartao.pedido.vendedor._id == id){
                return item;
              }
            }
          });
        }

        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };
   
    getPage();
  }

})();
/* eslint-disable angular/json-functions */
(function () {
  'use strict';


  angular
    .module('gruposinAdmin')
    .factory('ClientService', function ($resource, endpoint) {
      return $resource(endpoint + 'client/:id?populate=vendedor juridica', {
        id: '@id'
      }, {
        'update': {
          method: 'PUT'
        },
        'check_user': {
          method: 'POST',
          url: endpoint + "client/checkUser",
          isArray: false,
          cache: false
        },
        sync: {
          method: 'GET',
          url: endpoint + "client/sync",
          isArray: true,
          cache: false
        }
      });
    })
    .controller('ClientController', ClientController);


  /** @ngInject */
  function ClientController($timeout, toastr, ClientService, $scope, uiGridConstants, $mdDialog, $filter, UserService, JuridicaService, uiGridExporterConstants, uiGridExporterService, AuthenticationFactory, $mdToast, endpoint, $document, $window, url_upload, $http) {

    var API = ClientService;
    var vm = this;

    vm.toggleFiltering = function () {
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
    };

    vm.exportReport = function (router) {
      AuthenticationFactory.exportReport(router);
    };

    // abre pra escolher o mes
    vm.gerarCobranca = function (ev) {


      $mdDialog.show({
        controller: function ($http, toastr, $mdToast, $window, AuthenticationFactory) {
          var vm = this;
          vm.submiting = false;

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.submit = function () {

            if (!vm.form.mes) {
              $window.alert('Selecione o dia');
              return false;
            }

            if (!vm.form.mes_selecionado) {
              $window.alert('Selecione o mês');
              return false;
            }

            vm.submiting = true;

            //toastr.success('Cobranças efetuadas com sucesso.', 'Gerar Cobrança');


            var profile = AuthenticationFactory.profile;
            var role = profile.user.role;
            var id = profile.user._id;

            var url = endpoint + 'clientCobranca/gerarCobranca?mes=' + vm.form.mes + '&mes_selecionado=' + vm.form.mes_selecionado;

            if (role === 'Vendedor') {
              url = url + '&id=' + id;
            }


            $http.get(url).then(function (resp) {


              var message = 'Nenhuma cobrança efetuada para o vencimento escolhido';

              if (resp.data.length === 1) {
                message = '1 Cobrança efetuada para o vencimento escolhido'
              } else if (resp.data.length > 1) {
                message = resp.data.length + ' Cobranças efetuadas para o vencimento escolhido'
              }

              $mdToast.show(
                $mdToast.simple()
                .textContent(message)
                .position('top right')
                .hideDelay(3000)
              );
              vm.submiting = false;
              vm.hide();
            })
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/client/dialog-gerarCobranca.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    // abre amodal de importacao
    vm.importarDialog = function (ev) {


      $mdDialog.show({
        controller: function ($http, toastr, $mdToast, $scope) {
          var vm = this;
          vm.submiting = false;
          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.onSubmit = function () {
            vm.submiting = true;
            var xhr = new XMLHttpRequest();
            var fd = new FormData();
            xhr.open("POST", url_upload, true);
            xhr.onreadystatechange = function () {
              if (xhr.readyState == 4 && xhr.status == 200) {
                //Pode dar merda se der use o Json.parse
                vm.clientes = angular.fromJson(xhr.response);
                if (angular.isArray(vm.clientes)) {
                  vm.inserirCliente(vm.clientes);
                }
              }
            };
            fd.append('uploaded_file', $scope.file01[0].lfFile);
            xhr.send(fd);
          };

          vm.inserirCliente = function (clientes) {
            $http.post(endpoint + 'client/import', clientes).then(
              function () {
                vm.submiting = false;
                toastr.success('Clientes cadastrados com sucesso');
                getPage();
                vm.hide();
              }
            );
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/client/dialog-importCliente.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.export = function () {
      var exportService = uiGridExporterService;
      var grid = vm.gridApi.grid;
      var fileName = 'Clientes.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function () {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };

    vm.exportcvs = function () {
      var myElement = angular.element($document.querySelectorAll(".custom-csv-link-location"));
      vm.gridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL, myElement);
    };

    vm.remove = function (ev, item) {
      if (confirm("Deseja realmente remover?")) {
        var data = vm.gridOptionsBusca.data;

        API.delete({
          id: item._id
        }, function () {
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };


    vm.status = function (ev, item) {

      var obj = {};
      obj.dataNascimento = new Date();

      if (item) {
        item.dataNascimento = $window.moment(item.dataNascimento).toDate(); //new Date(item.dataNascimento);

        if (item.dependentes) {
          item.dependentes.forEach(function (d) {
            d.Data_Nascimento = $window.moment(d.dataNascimento,"DD/MM/YYYY").toDate()
          });
        }

        if (item.cep) {
          item.cep = item.cep.replace(/[^\d]/g, '');
        }
        if (item.cpf) {
          item.cpf = item.cpf.replace(/[^\d]/g, '');
        }

        obj = item;
      }

      $mdDialog.show({
        controller: function ($http, AuthenticationFactory) {

          var vm = this;
          vm.form = angular.copy(obj);
          vm.companies = [];
          vm.vendedores = [];
          obj.dataNascimento = new Date();
          var profile = AuthenticationFactory.profile;
          var role = (profile.user.role);
          var _id = (profile.user._id);

          var rolesVendedor = {
            role: 'Vendedor'
          };
          var juridicaVendedor = {};

          if (role === 'Vendedor') {
            rolesVendedor._id = _id
            juridicaVendedor.vendedor = _id;
          }

          vm.refresh = function () {
            getPage2();
            vm.hide();
          };

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.save = function (form) {

            if (form.$invalid) {
              alert('Verifique o status no formulário');
              return false;
            }


            if (vm.form._id) {
              API.update({id: vm.form._id}, vm.form, vm.refresh);
            } else {
              API.save(vm.form, vm.refresh, function (err) {
                if (err.data.code) {
                  alert(err.data.errmsg)
                }
              });
            }
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/client/dialogStatus.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.edit = function (ev, item) {

      var obj = {};
      
      if (item) {
        if (item.dependentes) {
          item.dependentes.forEach(function (d) {
            d.Data_Nascimento = $window.moment(d.dataNascimento,"DD/MM/YYYY").toDate()
          });
        }

        if (item.cep) {
          item.cep = item.cep.replace(/[^\d]/g, '');
        }
        if (item.cpf) {
          item.cpf = item.cpf.replace(/[^\d]/g, '');
        }

        obj = item;
        
        if(item.dataNascimento){
        obj.dataNascimento = $window.moment(item.dataNascimento).toDate(); //new Date(item.dataNascimento);
        }else{
          obj.dataNascimento = new Date();
        }
      }

      $mdDialog.show({
        controller: function ($http, AuthenticationFactory) {
          var vm = this;
          vm.form = angular.copy(obj);
          vm.companies = [];
          vm.vendedores = [];

          vm.selectedItem = obj.vendedor;
          vm.selectedItemEmpresa = obj.juridica;
          /*
          if(vm.form.dataNascimento){
            vm.form.dataNascimento = $window.moment(vm.form.dataNascimento).toDate();
          }
          */
          var profile = AuthenticationFactory.profile;
          var role = (profile.user.role);
          var _id = (profile.user._id);

          var rolesVendedor = {
            role: 'Vendedor'
          };
          var juridicaVendedor = {};

          if (role === 'Vendedor') {
            rolesVendedor._id = _id
            juridicaVendedor.vendedor = _id;
          }


          // carrega a lista de empresas
          JuridicaService.query({}).$promise.then(function (resp) {
            vm.companies = resp;
          });


          // carrega a lista de vendedores
          UserService.query(rolesVendedor).$promise.then(function (resp) {
            vm.vendedores = resp;
          });

          vm.updateAddress = function () {
            AuthenticationFactory.getCEP(vm.form.cep)
              .then(function (endereco) {
                vm.form.enderecoResidencial = endereco.logradouro;
                vm.form.cidade = endereco.localidade;
                vm.form.bairro = endereco.bairro;
                vm.form.uf = endereco.uf.toLowerCase();
              });
          };


          // vendedor
          vm.searchTextChange = function () {};
          vm.selectedItemChange = function (company) {
            if (company) {
              
              vm.form.vendedor = company._id;
              
            } else {
              vm.form.vendedor = null;
            }
          };
          vm.searchCompany = function (search) {
            return vm.vendedores.filter(function (item) {
              return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.cpf && item.cpf.toUpperCase().indexOf(search.toUpperCase()) >= 0);
            });
          };


          // empresa
          vm.searchTextChangeEmpresa = function () {};
          vm.selectedItemChangeEmpresa = function (company) {
            if (company) {
              vm.form.juridica = company._id;
            } else {
              vm.form.juridica = null;
            }
          };
          vm.searchCompanyEmpresa = function (search) {
            return vm.companies.filter(function (item) {
              return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.cnpj && item.cnpj.toUpperCase().indexOf(search.toUpperCase()) >= 0);
            });
          };


          vm.refresh = function () {
            getPage2();
            vm.hide();
          };

          vm.addDependentes = function (item) {

            if (!item.dependentes) {
              item.dependentes = [];
            }

            if (item.dependentes.length === 5) {
              $window.alert('Só pode adicionar 5 dependentes');
              return false;
            }

            item.dependentes.push({
              name: '',
              cpf: '',
              dataNascimento: '',
              NomeMae_Depedente: ''
            });
          };

          vm.removerDependente = function (item) {
            var index = vm.form.dependentes.indexOf(item);
            vm.form.dependentes.splice(index, 1);
          }

          vm.hide = function () {
            $mdDialog.hide();
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.save = function (form) {

            if (form.$invalid) {
              alert('Verifique alguns campos do formulário');
              return false;
            }


            if (vm.form._id) {
              
              $http.put(endpoint+"client/"+vm.form._id,vm.form).then(function (resp){
                if(resp){
                  vm.refresh();
                }
              })
             // API.update({id: vm.form._id}, vm.form.client, vm.refresh);
            } else {
              
              vm.form.vendedor= vm.form.vendedor;
              vm.form.juridica= vm.form.juridica;
             
              API.save(vm.form, vm.refresh, function (err) {
                if (err) {
                  $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Erro ' + err.data.status)
                    .textContent(err.data)
                    .ok('Corrigir')
                    .multiple(true)
                  )

                  return false;
                }
                
              });
              
            }
          };
        },
        controllerAs: 'ctrl',
        templateUrl: 'app/client/dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true
      });
    };

    vm.gridOptions = {
      appScopeProvider: vm,
      enableFiltering: false,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.ALWAYS,
      columnDefs: [{
          name: 'createdAt',
          enableSorting: true,
          displayName: 'Data Cadastro',
          width: 170,
          type: 'date',
          cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
          filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
          filters: [{
              // condition: uiGridConstants.filter.GREATER_THAN
              filterName: 'maiorQue',
              condition: function (searchTerm, cellValue) {

                var search = new Date(searchTerm);
                var cValue = new Date(cellValue);

                return cValue.getTime() > search.getTime()
                // var data = searchTerm.split('/');
                // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
                // return strippedValue.indexOf(searchTerm) >= 0;
              }
            },
            {
              // condition: uiGridConstants.filter.GREATER_THAN
              filterName: 'menorQue',
              condition: function (searchTerm, cellValue) {

                var search = new Date(searchTerm);
                var cValue = new Date(cellValue);

                return cValue.getTime() < search.getTime()
                // var data = searchTerm.split('/');
                // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
                // return strippedValue.indexOf(searchTerm) >= 0;
              }
            }
          ]
        },
        {
          name: 'name',
          width: 170,
          enableSorting: true,
          displayName: 'Nome'
        },
        {
          name: 'idClienteVindi',
          width: 100,
          enableSorting: true,
          displayName: 'ID Vindi'
        },
        {
          name: 'juridica.name',
          width: 170,
          enableSorting: true,
          displayName: 'Empresa'
        },
        {
          name: 'vendedor.name',
          width: 170,
          enableSorting: true,
          displayName: 'Vendedor'
        },
        {
          name: 'cpf',
          width: 170,
          enableSorting: true,
          displayName: 'CPF'
        },
        {
          name: 'email',
          width: 170,
          enableSorting: true,
          displayName: 'E-mail'
        },
        {
          name: 'password',
          width: 170,
          enableSorting: true,
          displayName: 'Senha'
        },
        {
          name: 'dependente',
          width: 150,
          enableSorting: true,
          displayName: 'Dependente?',
          cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.dependente ? "Sim" : "Não"}}</div>'
        },
        {
          name: 'status',
          enableSorting: true,
          displayName: 'Status',
          width: 300,
          cellClass: function (grid, row) {
            if (row.entity.status) {
              switch (row.entity.status) {
                case 'Inadimplente':
                  return 'status-pendente text-left'
                default:
                  return 'text-left'
              }
            }
            return 'text-left'
          }
          //cellTemplate: '<div class="ui-grid-cell-contents" style="cursor:pointer;" permission="btnStatusClient" module="client" ng-click="grid.appScope.view($event, row.entity)">{{row.entity.status}}</div>'
        },
        {
          name: 'edit',
          enableColumnResizing: false,
          width: 50,
          pinnedRight: true,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" permission="btnEditClient" module="client" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'
        },
        {
          name: 'remove',
          enableColumnResizing: false,
          width: 50,
          pinnedRight: true,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteClient" module="client" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'
        }
      ],
      onRegisterApi: function (gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.sincronizarClientesVindi = function () {
      API.sync().$promise.then(function(response) {
        let msg = '';
        response.forEach(function(cliente) {
          if (cliente)
            if (cliente.sincronizado)
              msg += '<ul><b>Cliente: </b>' + cliente.cliente + ' <b>Mensagem:</b> ' + cliente.message + '</ul>'
            else
              msg += '<ul><b>Cliente: </b>' + cliente.cliente + ' <b>Mensagem:</b> ' + cliente.message + ' <b>Erros:</b> ' + JSON.stringify(cliente.data) + '</ul>'
        })

        $mdDialog.show(
          $mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Relatorio clientes sincronizados/Não sincronizados')
          .htmlContent(msg)
          .ok('Ok')
        );

        getPage();
      }).catch(function (errors) {

        $mdDialog.show(
          $mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Erro ao sincronizar')
          .htmlContent(errors.stringify())
          .ok('Ok')
        );

        getPage();
      })
    }

    var getPage = function () {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;
      var obj = {};

      if (role === 'Vendedor') {
        obj = {
          vendedor: id
        };
      }

      if (role === 'Master') {
        obj = {
          juridica: profile.user.juridica
        };
      }


      API.query(obj).$promise.then(function (resp) {
        vm.gridOptions.data = resp;
        angular.forEach(vm.gridOptions.data, function (val) {
          val.date = new Date(val.createdAt);
        });
        vm.loading = false;
      });
    };
    vm.busca = function (formBusca){
      
      vm.loading = true;
      var urlBusca = endpoint+"client/findAdmin?"
      var mudanca =0;
      if(formBusca in window){
      }else{
        for(var form in formBusca){
          if(formBusca[form] in window){
            if(formBusca.empresa){
              urlBusca+=form+"="+formBusca[form];
              mudanca+=1;
            }
          }else{
            if(formBusca[form] instanceof Date){
              if (mudanca == 0){
                urlBusca+=form+"="+moment(formBusca[form]).format("DD/MM/YYYY");
                mudanca+=1;
              }
              else{
                urlBusca+="&"+form+"="+moment(formBusca[form]).format("DD/MM/YYYY");
              }
            }
            else{
              if(mudanca == 0){
                urlBusca+=form+"="+formBusca[form];
                mudanca+=1;
              }else if(formBusca[form]){
                urlBusca+="&"+form+"="+formBusca[form];
              }
            }
          }
        }
      }
      $http.get(urlBusca).then(function (resp){
        
        vm.gridOptionsBusca.data=resp.data;
        getPage2();
      })
      .catch(function (){
        vm.loading = false;
      })
    }
    vm.gridOptionsBusca = {
      appScopeProvider : vm,
      enableFiltering: false,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs:[
        {name: 'juridica.name', enableSorting: true, displayName: "Empresa", width:170, cellClass: function () { return 'text-center'; }},
        {name: 'name', enableSorting:true, displayName: "Nome Cliente", width: 200, cellClass: function () { return 'text-center'; }},
        {name: "cpf", enableSorting:true, displayName: "CPF", width: 170, cellClass: function () { return 'text-center'; }},
        {name: "telefoneFixo", enableSorting:true, displayName:"Telefone ", width:150, cellClass: function () { return 'text-center'; }},
        {name: "telefoneCelular", enableSorting:true, displayName:"Celular", width:150, cellClass: function () { return 'text-center'; }},
        {name: 'createdAt', enableSorting:true, displayName: 'Data Cadastro',width:170, type: "date",cellFilter: 'date:\'dd/MM/yyyy \'', cellClass: function () { return 'text-center'; }},
        {name: "status", enableSorting:true, displayName:"Status Cliente",width:170, cellClass: function () { return 'text-center'; }},
        {
          name: 'edit',
          enableColumnResizing: false,
          width: 50,
          pinnedRight: true,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" permission="btnEditClient" module="client" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'
        },
        {
          name: 'remove',
          enableColumnResizing: false,
          width: 50,
          pinnedRight: true,
          enableFiltering: false,
          enableSorting: false,
          displayName: '',
          enableColumnMenu: false,
          cellClass: function () {
            return 'text-center';
          },
          cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteClient" module="client" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'
        }
      ],
      onRegisterApi:function(gridApi){
        vm.gridApi = gridApi
        vm.loading = false;
      } 
    };

    var getPage2 = function () {
      
      vm.loading = false
    }
  }

})();

(function() {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('CartaoController', CartaoController)
    .factory('CartaoService', function ($resource, endpoint) {
      var data = $resource(endpoint + 'cartao/:id', {id: '@id'}, {
      update:{
          method:'PUT'
          }
      });
      return data;
  });


  /** @ngInject */
  function CartaoController($timeout, toastr, JuridicaService, $scope, uiGridConstants, $mdDialog, UserService, CartaoService, ClientService, SaudeService, AuthenticationFactory, uiGridExporterService, uiGridExporterConstants, $window, $document, $http, endpoint) {

    var API = CartaoService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.exportExcel = function(router){
      AuthenticationFactory.exportReport(router);
    };

    vm.exportReport = function (router) {
      AuthenticationFactory.exportReport(router);
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptionsBusca.data;

        API.delete({id: item.cartao._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.dateValidate = function(grid, row){
      return  $window.moment(row.entity.createdAt).add(row.entity.plano.months, 'month').format('DD/MM/YYYY HH:mm:ss');
    };

    vm.possuiDependentes = function(grid, row){
      if(!row.entity) return 'Não possui '
      var array = row.entity.dependentes || [];
      return array.length > 0 ? 'Sim' : 'Não';
    }

    vm.cpfDependentes = function(grid, row){
      var array = row.entity.client.dependentes || [];
      return array.map(function(item){ item.CPF_Depedente; })
    };

/*
   function parse (str) {

    if(str){
        // validate year as 4 digits, month as 01-12, and day as 01-31
        if ((str = str.match (/^(\d{4})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/))) {
           // make a date
           str[0] = new Date (+str[1], +str[2] - 1, +str[3]);
           // check if month stayed the same (ie that day number is valid)
           if (str[0].getMonth () === +str[2] - 1)
              return str[0];
        }
    }

    return undefined;
   }
*/
    vm.exportCsv = function(){
      var exportService=uiGridExporterService;
      var grid=vm.gridApi.grid;
      var fileName= 'Cartoes.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function() {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };

    vm.details = function(ev, item) {

        var obj = {};
        obj.pedido = item.pedido;
        
        if(item){
          obj = item;
          if(item.cartao){
            if(item.cartao.status=="Habilitado"){
              obj.cartao.dataAtivacao = $window.moment(item.cartao.dataAtivacao).toDate();
            }else if(item.cartao.status=="Desabilitado"){
              obj.cartao.dataAtivacao = $window.moment(item.cartao.dataCancelamento).toDate();
            }
          }
         
        }

        obj.VencimentoPlano = $window.moment(item.createdAt).add(item.plano.months, 'month').toDate();
        obj.createdAt = $window.moment(item.createdAt).toDate();
        obj.vads_sub_effect_date = $window.moment(item.vads_sub_effect_date).toDate();
        
        

        $mdDialog.show({
                controller: function() {

                  var vm = this;
                  vm.form = angular.copy(obj);
                  vm.clientes = [];
                  vm.pedidos = [];

                  vm.loading = false;

                  vm.selectedItemClient = obj.client;
                  vm.selectedItemSaude = obj;
                 
                  /*
                  // carrega a lista de vendedores
                  ClientService.query().$promise.then(function(resp) {
                      vm.clientes = resp;
                  });

                  // carrega a lista de vendedores
                  SaudeService.query().$promise.then(function(resp) {
                      vm.pedidos = resp;
                      console.log(resp)
                      console.log(vm.pedidos)
                  });
                  
                  // autocomplete de cliente
                  vm.searchTextChangeClient = function() {};
                  vm.selectedItemChangeClient = function(resp) {
                      if(resp){
                          vm.form.client = resp._id;
                      }else{
                        vm.form.client = null;
                      }
                  };
                  vm.searchClient = function(search) {
                      return vm.clientes.filter(function(item) {
                          return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || item.cpf.toUpperCase().indexOf(search.toUpperCase()) >= 0;
                      });
                  };

                  
                  // autocomplete de vendedores
                  vm.searchTextChangeSaude = function() {};
                  vm.selectedItemChangeSaude = function(resp) {
                      if(resp){
                          vm.form = resp._id;
                      }else{
                        vm.form = null;
                      }
                  };
                  vm.searchSaude = function(search) {
                      return vm.pedidos.filter(function(item) {

                          var orderId =  item.vads_order_id || '';
                          var email =  item.vads_cust_email || '';
                          var nome =  item.vads_cust_first_name || '';

                          return orderId.toUpperCase().indexOf(search.toUpperCase()) >= 0 || email.toUpperCase().indexOf(search.toUpperCase()) >= 0 || nome.toUpperCase().indexOf(search.toUpperCase()) >= 0;
                      });
                  };
                  */
                  vm.refresh = function(){

                      vm.loading = false;

                      getPage2();
                      vm.hide();
                  };

                  vm.hide = function() {
                      $mdDialog.hide();
                  };

                  vm.cancel = function() {
                      $mdDialog.cancel();
                  };

                  vm.save = function() {

                      vm.loading = true;

                      if(vm.form.cartao._id){
                        API.update(vm.form.cartao._id, vm.form.cartao, vm.refresh);
                      }else{
                        API.save(vm.form.cartao, vm.refresh);
                      }
                  };
                },
                controllerAs: 'ctrl',
                templateUrl: 'app/cartao/detail-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.edit = function(ev, item) {

        var obj = {};
        obj.status = 'Desabilitado';

        if(item){
          obj = item;
          obj.editable = true;
          if(item.cartao){
            if(item.cartao.status=="Habilitado"){
              obj.cartao.dataAtivacao = $window.moment(item.cartao.dataAtivacao).toDate();
            }else if(item.cartao.status=="Desabilitado"){
              obj.cartao.dataAtivacao = $window.moment(item.cartao.dataCancelamento).toDate();
            }
          }
        }

        $mdDialog.show({
                controller: function(AuthenticationFactory) {

                  var vm = this;
                  vm.form = angular.copy(obj);
                  vm.clientes = [];
                  vm.pedidos = [];

                  vm.loading = false;

                  vm.selectedItemClient = obj.client;
                  vm.selectedItemSaude = obj;

                  // Está comentado porque estava dando warning no console
                // var profile = AuthenticationFactory.profile;
                // var role = (profile.user.role);
                // var _id = (profile.user._id);

                var pedidoVendedor = {};
                  
                  // carrega a lista de pedidos
                    SaudeService.query(pedidoVendedor).$promise.then(function(resp) {
                      vm.pedidos = resp;
                      
                  }); 
                  vm.refresh = function(){

                      vm.loading = false;

                      getPage2();
                      vm.hide();
                  };

                  vm.hide = function() {
                      $mdDialog.hide();
                  };

                  vm.cancel = function() {
                      $mdDialog.cancel();
                  };
                  vm.save = function() {
                    if(!vm.form._id){
                      for(var i=0;i<vm.pedidos.length;i++){
                        if(vm.pedidos[i].vads_order_id==vm.form.vads_order_id){
                          vm.form.cartao.pedido = vm.pedidos[i]._id
                          break;
                        }
                      }
                    }
                    if(vm.form.cartao.pedido!=null){
                      if(vm.form.cartao._id){
                        if(vm.form.cartao.status === 'Habilitado' && !vm.form.cartao.dataAtivacao){
                          vm.form.cartao.dataAtivacao = new Date();
                        }
                        if(vm.form.cartao.status === 'Desabilitado' && !vm.form.cartao.dataCancelamento){
                          vm.form.cartao.dataCancelamento = new Date();
                        } 
                        let cartaoUpdate = {
                          motivo:"",
                          status:"",
                          dataCancelamento:"",
                      }
                        cartaoUpdate.motivo = vm.form.cartao.motivo;
                        cartaoUpdate.status = vm.form.cartao.status;
                        cartaoUpdate.dataCancelamento = vm.form.cartao.dataCancelamento;
                        
                        $http.put(endpoint+"cartao/"+vm.form.cartao._id,cartaoUpdate).then(function (resp){
                          if(resp){
                            vm.refresh()
                          } 
                        })
                        //API.update(vm.form.cartao._id, cartaoUpdate, vm.refresh);
                      }else{
                        if(vm.form.cartao.status === 'Habilitado'){
                          
                          vm.form.cartao.dataAtivacao = new Date();
                        }
                        
                        API.save(vm.form.cartao, vm.refresh);
                      }
                    }else{
                      vm.loading=false;
                      alert("Adicione um numero de Pedido valido")
                    }
                  };
                },
                controllerAs:'ctrl',
                templateUrl: 'app/cartao/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true
        });
    };
    vm.busca = function (formBusca){
      vm.loading = true;
      var urlBusca = endpoint+"saude/findAdmin?"
      var mudanca =0;
      if(formBusca in window){ // Serve para ver se  o formBusca está vazio
        // o que entrara aqui?
        //form Busca Vazio ele não faz nada 
      }else{
        for(var form in formBusca){ 
          if(formBusca[form] in window){
            //Não sei porque mas quando eu mando apenas preencho o 1 input ele entra aqui,
            // porém se eu prencher qualquer outro ele segue o fluxo que deveria
            if(formBusca.emailCliente){
              urlBusca+=form+"="+formBusca[form];
              mudanca+=1;
            }
          }else{
            if(formBusca[form] instanceof Date){
              if (mudanca==0){
                urlBusca+=form+"="+moment(formBusca[form]).format("DD/MM/YYYY");
                mudanca+=1;
              }
              else{
                urlBusca+="&"+form+"="+moment(formBusca[form]).format("DD/MM/YYYY");
              }
            }
            else{
              if(mudanca == 0){
                urlBusca+=form+"="+formBusca[form];
                mudanca+=1;
              }else if(formBusca[form]){
                urlBusca+="&"+form+"="+formBusca[form];
              }
            }
          }
        }
      }
      $http.get(urlBusca).then(function (resp){
        vm.gridOptionsBusca.data=resp.data;
        getPage2();
      })
    }
    vm.gridOptionsBusca = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs:[
        {name: 'client.createdAt', enableSorting:true, displayName: 'Data Cadastro',width:130, type: "date",cellFilter: 'date:\'dd/MM/yyyy \'' },
        {name: "createdAt", enableSorting: true, displayName: "Data Pedido", width: 130, type : "date", cellFilter: 'date:\'dd/MM/yyyy \'' },
        { name: 'cartao.numeroCartao', enableSorting: true, displayName: 'Nº Cartão', width: 150 },
        { name: 'client.name', enableSorting: true, displayName: 'Nome do Cliente', width: 270 },
        { name: 'client.dependentes', enableSorting: true, displayName: 'Possui Dependentes?', width: 170, cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.possuiDependentes(grid, row)}}</div>'},
        { name: 'client.email', enableSorting: true, displayName: 'Email do Cliente', width: 200 },
        { name: 'client.cpf', enableSorting: true, displayName: 'CPF do Cliente', width: 130 },
        { name: 'plano.name', enableSorting: true, displayName: 'Plano', width: 180 },
        { name: 'plano.price', enableSorting: true, displayName: 'Mensalidade', width: 170, cellFilter: "currency" },
        { name: 'cartao.status', enableSorting: true, displayName: 'Status do Cartão', width: 120 },
        { name: 'dataVencimentoFatura', enableSorting: true, width: 170, displayName: 'Vencimento da Mensalidade', type: 'date', cellFilter: 'date:\'dd/MM/yyyy\'' },
        { name: 'vads_payment_cards.descricao', enableSorting: true, width: 170, displayName: 'Forma de Pagamento' },
        { name: 'details', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" ng-click="grid.appScope.details($event, row.entity)">folder_shared</i>'},
        { name: 'edit', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditCartao" module="cartao" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteCartao" module="cartao" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ]
      
    }

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        { name: 'createdAt', enableSorting: true, displayName: 'Data Cadastro', width: 170, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'', filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
          filters: [{
            // condition: uiGridConstants.filter.GREATER_THAN
            filterName: 'maiorQue',
            condition: function(searchTerm, cellValue) {

              var search = new Date(searchTerm);
              var cValue = new Date(cellValue);

              return cValue.getTime() > search.getTime()
              // var data = searchTerm.split('/');
              // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
              // return strippedValue.indexOf(searchTerm) >= 0;
            }},
            {
              // condition: uiGridConstants.filter.GREATER_THAN
              filterName: 'menorQue',
              condition: function(searchTerm, cellValue) {

                var search = new Date(searchTerm);
                var cValue = new Date(cellValue);

                return cValue.getTime() < search.getTime()
                // var data = searchTerm.split('/');
                // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
                // return strippedValue.indexOf(searchTerm) >= 0;
              }
            }]
        },
        { name: 'pedido.createdAt', enableSorting: true, displayName: 'Data da Pedido', width: 170, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'' },
        { name: 'pedido.vads_trans_id', enableSorting: true, displayName: 'Nº Pedido', width: 170 },
        { name: 'numeroCartao', enableSorting: true, displayName: 'Nº Cartão', width: 170 },
        { name: 'dataAtivacao', enableSorting: true, displayName: 'Data da Ativação', width: 170, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'' },
        { name: 'pedido.client.name', enableSorting: true, displayName: 'Nome do Cliente', width: 270 },
        { name: 'pedido.client.email', enableSorting: true, displayName: 'Email do Cliente', width: 170 },
        { name: 'pedido.client.cpf', enableSorting: true, displayName: 'CPF do Cliente', width: 170 },
        { name: 'pedido.plano.name', enableSorting: true, displayName: 'Plano', width: 170 },
        { name: 'status', enableSorting: true, displayName: 'Status do Cartão', width: 170 },
        { name: 'pedido.client.dependentes', enableSorting: true, displayName: 'Possui Dependentes?', width: 170, cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.possuiDependentes(grid, row)}}</div>'},
        { name: 'pedido.plano.price', enableSorting: true, displayName: 'Mensalidade', width: 170, cellFilter: "currency" },
        { name: 'pedido.dataVencimentoFatura', enableSorting: true, width: 170, displayName: 'Vencimento da Mensalidade', type: 'date', cellFilter: 'date:\'dd/MM/yyyy\'' },
        { name: 'pedido.sendPayzen', enableSorting: true, width: 170, displayName: 'Pagou pela Payzen?' },
        { name: 'pedido.vads_payment_cards', enableSorting: true, width: 170, displayName: 'Forma de Pagamento' },
        { name: 'pedido.plano', enableSorting: true, width: 170, displayName: 'Validade', cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.dateValidate(grid, row)}}</div>', type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'', cellClass: function(){ return ''; }},
        { name: 'pedido.vendedor.name', enableSorting: true, width: 170, displayName: 'Vendedor' },
        { name: 'details', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" ng-click="grid.appScope.details($event, row.entity)">folder_shared</i>'},
        { name: 'edit', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditCartao" module="cartao" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteCartao" module="cartao" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };

    

    var getPage2 = function () {
      
      vm.loading = false;
    }
    var getPage = function() {

      var profile = AuthenticationFactory.profile;
      var role = profile.user.role;
      var id = profile.user._id;

      API.query({}).$promise.then(function(resp){

        if(role === 'Vendedor'){
          resp = resp.filter(function(item){
            return (item.vendedor && item.vendedor._id == id);
          })
        }

        if (role === 'Master') {
          resp = resp.filter(function(item){
            return (item && item.juridica && item.juridica._id == profile.user.juridica);
          })
        }
       // vm.gridOptions.data = resp;
      });
    };
  }

})();

//language=JavaScript
/**
 * Classe criada para gerar Apolice em PDF (Outra apólice, deixei esse arquivo como backup caso ela mude e peça o modelo antigo denovo)
 * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
 * @param row Recebe os dados que serão utilizados para preenchimento
 * @param $filter Angular Filter service para conversão de datas
 * @constructor new Relatorio()
 * @return {Relatorio}
 */
function Relatorio(row, $filter) {
    var self = this;
    this.card = 'data:image/png;base64,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';
    this.img_efarma = 'data:image/png;base64,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';
    this.img_sim_sauda_card = 'data:image/png;base64,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';
    this.doc = new jsPDF('a4');
    this.data = row;
    this.host = '';
    this.logos = [];
    this.showLogos = false;

    /**
     * Função responsável por transformar imagem de url pra base64
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @param src Recebe o caminho da imagem
     * @param callback Importante tratar em callback
     */
    this.toDataURL = function (src, callback) {
        var img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var dataURL;
            canvas.height = this.height;
            canvas.width = this.width;
            ctx.drawImage(this, 0, 0);
            dataURL = canvas.toDataURL();
            callback(dataURL);
        };
        img.src = src;
        if (img.complete || angular.isUndefined(img.complete)) {
            img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
            img.src = src;
        }
    };

    /**
     * Função responsável por codificar cada imagem anexada à apolice
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @param callback Necessário para saber quando terminou a codificação
     * @return {Array} Retorna um array de images codificadas em base 64
     */
    this.images_to_base64 = function (callback) {
        var images = this.data.images, img = [];
        if (images.length === 0) return [];

        if (images.length) {
            images.forEach(function (image) {
                self.toDataURL(self.host + image, function (dataUrl) {
                    img.push(dataUrl);
                    if (images.length === img.length) {
                        callback(img);
                    }
                })
            });
        }
    };

    /**
     * Função responsável por inicializar a classe de apolice e gerar as imagem com base 64
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @param url_images Host com diretorio onde as imagens estão salvas
     * @param callback Necessario pois o javascript é assincrono então não da pra saber sem
     * callback pois o callback vai avisar exatamente quando terminar os encodes de imagens
     */
    this.create = function (url_images, callback) {
        self.host = url_images;
        self.images_to_base64(function (images) {
            if (images.length) {
                self.logos = images;
                self.showLogos = true;
            }
            self.toDataURL('https://gruposin.com.br/images/logo/logo.da508ba2.png',
                function (dataUrl) {
                    callback(dataUrl);
                }
            );
        });
    };

    /**
     * Função responsavel por mostrar as logos anexadas a apolice
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @return {boolean}
     */
    this.mostrarLogos = function () {
        var left_position = 0;
        if (!self.logos.length) return false;
        self.logos.forEach(function (image_encoded) {
            left_position += 20;
            self.doc.addImage(image_encoded, 'JPEG', left_position, 50, 166, 40, null, null, 180);
        });
    };

    /**
     * Função para gerar cabeçalho
     */
    this.headerReport = function () {
        this.doc.addImage(this.logoEmpresa, 'JPEG', 130, 20, 60, 15, null, null, 180);
    };

    /**
     * Função para gerar Quadrado no jsPDF
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @param left {Number} Define a posição esquerda
     * @param top {Number} Define a posição de cima
     * @param width {Number}  Define a largura
     * @param height {Number} Define a altura
     * @returns {jsPDF} Quadrado
     */
    this.geraQuadrado = function (left, top, width, height) {
        var position_top = top + height,
            position_bot = left + width;
        return this.doc.line(left, top, left, position_top).line(position_bot, top, position_bot, position_top).line(left, position_top, position_bot, position_top).line(left, top, position_bot, top);
    };

    /**
     * Função responsável por gerar um checkbox
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @param left Define a posição esquerda
     * @param top Define a posição do topo
     * @param label Define o texto
     * @returns {jsPDF} Checkbox com label
     */
    this.checkbox_simulate = function (left, top, label) {
        this.geraQuadrado(left, top, 5, 5);
        return this.doc.text(left + 7, top + 4, label);
    };

    /**
     * Função criada para simular um input com label
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @param left Define a posição esquerda
     * @param top Define a posição do topo
     * @param width Define a largura
     * @param label Define um Texto
     * @param value Define o valor para preencher o input
     * @return {jsPDF} Retorna um fake input
     */
    this.gerarInput = function (left, top, width, label, value) {
        this.doc.setFontSize(8);
        this.doc.text(left, top, label);
        if (value) {
            this.doc.text(left + 3, top + 5, value.toString());
        }
        return this.geraQuadrado(left, top + 2, width, 5);
    };

    /**
     * Função para centralizar um texto
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @param text Define o texto que será centralizado
     * @param y Define a posição do topo
     * @returns {jsPDF} Retorna o texto centralizado
     */
    this.centerText = function (text, y) {
        var textWidth = this.doc.getStringUnitWidth(text) * this.doc.internal.getFontSize() / this.doc.internal.scaleFactor;
        var textOffset = (this.doc.internal.pageSize.width - textWidth) / 2;
        this.doc.text(textOffset, y, text);
    };

    /**
     * Função para retornar um Date no formato dd/MM/yyyy
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @param data {Date} Recebe a data que será convertida
     * @requires $filter Diretiva do angular
     * @return {Date} Retorna a data no formato pt-BR
     */
    this.date_to_br = function (data) {
        return $filter('date')(data, 'dd/MM/yyyy');
    };

    /**
    *   Função  par apreencher Coberturas
    *   @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
    *   @return {JsPDF} Object
    */
    this.preenche_coberturas = function (){
        var data = this.data, position_y = 185, left_valor = 110, left_cobertura = 25;
        this.doc.setFontSize(8);
        if(data.coberturaAteIdade === true){
        	data.coberturaAteIdadeValor = (data.coberturaAteIdadeValor) ? data.coberturaAteIdadeValor : '';
            this.doc.text(left_cobertura, position_y, 'Cobertura até 70 anos');
            this.doc.text(left_valor, position_y, data.coberturaAteIdadeValor);
            position_y += 3;
        }
        if(data.coberturaAuxFuneralFamilia === true){
        	data.coberturaAuxFuneralFamiliaValor = (data.coberturaAuxFuneralFamiliaValor) ? data.coberturaAuxFuneralFamiliaValor : '';
            this.doc.text(left_cobertura, position_y, 'Auxilio Funeral Familiar');
            this.doc.text(left_valor, position_y, data.coberturaAuxFuneralFamiliaValor);
            position_y += 3;
        }
        if(data.coberturaMorteAcidental === true){
        	data.coberturaMorteAcidentalValor = (data.coberturaMorteAcidentalValor) ? data.coberturaMorteAcidentalValor : '';
            this.doc.text(left_cobertura, position_y, 'Morte acidental/invalidez parcial');
            this.doc.text(left_valor, position_y, data.coberturaMorteAcidentalValor);
            position_y += 3;
        }
        var prefix = (data.coberturaSinSaudeMedicamento) ? 'Com' : 'Sem';
        this.doc.text(left_cobertura, position_y, prefix + ' Saude Medicamento');
        data.coberturaCestaBasicaValor = (data.coberturaCestaBasicaValor) ? data.coberturaCestaBasicaValor : '';
        this.doc.text(left_valor, position_y, data.coberturaCestaBasicaValor);
        position_y += 3;
        if(data.coberturaCestaBasica === true){
            var comentario = (data.coberturaMorteAcidentalComentario) ? data.coberturaMorteAcidentalComentario : '';
            this.doc.text(left_cobertura, position_y, 'Cesta Básica/Falecimento');
            this.doc.text(left_valor, position_y, comentario);
        }
    }

    /**
     * Função para gerar
     */
    this.gerar = function () {
        var row = this.data;
        //Page 1
        this.headerReport();
        //Exibir Logos
        if (this.showLogos) {
            this.mostrarLogos();
        }
        this.geraQuadrado(20, 120, 110, 40);
        this.geraQuadrado(130, 120, 60, 20);
        this.geraQuadrado(130, 140, 60, 20);
        this.doc.setFontSize(8);
        this.doc.text(25, 125, 'PARA USO DOS CORREIOS');
        this.doc.text(133, 125, 'Reintegrado ao serviço postal \n em:');
        this.doc.text(133, 145, 'Responsável:');
        this.checkbox_simulate(25, 127, 'Mudou-se');
        this.checkbox_simulate(25, 133, 'Desconhecido');
        this.checkbox_simulate(25, 139, 'Falecido');
        this.checkbox_simulate(25, 145, 'Ausente');
        this.checkbox_simulate(25, 151, 'Recusado');
        this.checkbox_simulate(65, 127, 'Não encontrado');
        this.checkbox_simulate(65, 133, 'Endereço não suficiente');
        this.checkbox_simulate(65, 139, 'Não existe o nº indicado');
        this.checkbox_simulate(65, 145, 'Informações escritas por porteiro');
        this.centerText('Grupo Sin - Av. Rio Branco, 45 - 1406 - Centro, Rio de Janeiro - RJ, 20090-003', 170);
        this.geraQuadrado(20, 230, 110, 20);
        //this.doc.text(25, 235, 'Nome do Cliente');
        //this.doc.text(25, 240, 'Endereço');
        //Flip Layout
        this.doc.text(183, 240, 'Nome do Cliente',null,180);
        this.doc.text(183, 245, 'Endereço', null,180);
        //page 2
        var campo1 = (row.campo_customizado_1) ? row.campo_customizado_1 : 'Parabéns!\nAgora você é membro da Igreja Cristo em Casa.\nCom seu cartão, ficou fácil e econômico ter uma vida\nsaudável e ainda ter acesso a diversos benefícios\npara você e sua família.\nwww.gruposin.com.br';
        var campo2 = (row.campo_customizado_2) ? row.campo_customizado_2 : 'Igreja Cristo em Casa';

        this.doc.addPage();
        this.headerReport();
        this.doc.setFontSize(11);
        this.doc.text(20, 20, campo1);
        this.doc.text(20, 30, 'Seja bem-vindo (a), ' + row.client.name);
        this.doc.setFontSize(10);
        this.doc.addImage(this.card, 'JPEG', 115, 69, 80, 36);
        this.doc.text(20, 40, 'Agora você é um membro da ' + campo2 + '!\n\nCom seu cartão você tem diversos benefícios na área da saúde e bem estar.\nVocê possuí vantagens e serviços diversos, tais como rede de clínicas, médicos e\nlaboratórios conveniados a baixo custo, descontos em farmácias e seguro conforme contratação abaixo.');
        this.doc.setFontSize(8);
        if(row.leia_me){
            var leia_me = this.doc.splitTextToSize(row.leia_me, 110);
            this.doc.text(20, 65, leia_me);
        }else{
            this.doc.text(20, 65, 'Leia aqui IMPORTANTES informações para utilização do seu cartão e benefícios.\n1-Para obter os benefícios contratados abaixo você deverá manter o pagamento mensal do seu cartão.\n2-Caso pare de pagar a mensalidade do cartão Cristo em Casa, no prazo\nmáximo de 45 dias, seu cartão será cancelado e você perderá todos os\nbenefícios contratados abaixo e não será membro da Igreja deixando de\ncolaborar com nosso dízimo;\n3-Para agendamento de consultas e exames médicos com descontos será\nnecessário ligar para Central de Atendimento no número 3003-0926;\n4-Para descontos em medicamentos verifique as farmácias credenciadas no\nsite www.cristoemcasa.com.br. Após verificação, procure a farmácia\ncredenciada mais próxima de você e apresente o VERSO DO SEU CARTÃO\ne mostre a logo:');
            this.doc.text(20, 110, '5- Para acionar algum dos seus seguros contratados abaixo entre em contato no telefone 0800-777- 1213 e informe o número da Apólice Abaixo;');
        }
        this.doc.setFontSize(10);
        this.doc.text(20, 115, 'Comece agora a aproveitar as inúmeras vantagens do seu Cartão ' + campo2 + '!');
        this.doc.setFontSize(12);
        this.doc.addImage(this.img_efarma, 'JPEG', 20, 118, 80, 36);
        this.doc.addImage(this.img_sim_sauda_card, 'JPEG', 105, 118, 80, 36);


      this.doc.text(20, 135, 'CERTIFICADO INDIVIDUAL SEGURO DE PESSOAS');

        //inputs line 1
        var position_block_line_1 = 140;
        this.gerarInput(20, position_block_line_1, 83, 'Estipulante', row.juridica.name);
        this.gerarInput(150, position_block_line_1, 40, 'Apólice', row.numeroApolice);

        //inputs line 2
        var position_block_line_2 = 153;
        this.gerarInput(20, position_block_line_2, 83, 'Segurado Principal', row.client.name);
        this.gerarInput(107, position_block_line_2, 83, 'Subestipulante', row.vendedor.name);

        //inputs line 3
        var position_block_line_3 = 166;
        this.gerarInput(20, position_block_line_3, 35, 'CPF', row.client.cpf);
        this.gerarInput(60, position_block_line_3, 25, 'Nascimento', this.date_to_br(row.client.dataNascimento));
        this.gerarInput(90, position_block_line_3, 35, 'Início Individual do Risco', this.date_to_br(row.inicioIndividualRisco));
        this.gerarInput(160, position_block_line_3, 30, 'Data Emissão', this.date_to_br(row.data));

        this.doc.setFontSize(10);
        this.geraQuadrado(20, 175, 83, 30);
        this.doc.text(25, 180, 'Coberturas');
        this.geraQuadrado(107, 175, 83, 30);
        this.doc.text(110, 180, 'Valor');
        this.preenche_coberturas();
        this.doc.setFontSize(6);
        this.geraQuadrado(20, 207, 170, 80);
        var lines = '';
        if(!row.termos){
            row.termos = 'ALLIANZ SEGUROS S.A. – Rua Eugênio de Medeiros nº 303 , Pinheiros, CEP: 05425-000, SÃO PAULO-SP Código 517-7 – CNPJ 61.573.796/0001-66– Processo SUSEP nº 10.002288/00-11 Para mais informações entre em contato com a Linha Direta Allianz: 3156-4340 (Grande São Paulo) e 0800-7777243 (Outras Localidades). Atendimento à pessoa com deficiência auditiva ou de fala 24h: 0800 121 239 / Para SAC 24h: 0800 115 215 e para Ouvidoria: 0800 771 3313.';
        }
        lines = this.doc.splitTextToSize('Morte Acidental Garante aos beneficiários o pagamento do capital segurado contratado para esta cobertura em caso de morte do Segurado causada, exclusivamente, por acidente pessoal coberto, exceto se decorrente de riscos excluídos, observadas as demais cláusulas destas Condições Gerais e do Contrato./ Invalidez Permanente Total ou Parcial por Acidente desde que contratada, garante ao Segurado uma indenização, nas hipóteses e nos graus estabelecidos na tabela seguinte, proporcional ao valor do capital segurado contratado para esta cobertura, caso haja a perda, redução ou impotência funcional definitiva, total ou parcial, de um membro ou órgão, em virtude de lesão física causada por acidente devidamente coberto, quando este ocorrer dentro do período de vigência deste seguro, mediante comprovação por laudo médico, e desde que tais lesões sejam insuscetíveis de reabilitação ou recuperação pelos meios terapêuticos disponíveis no momento de sua constatação, exceto se decorrente de riscos excluídos e observadas as demais cláusulas destas Condições Gerais e do Contrato. A aposentadoria por invalidez concedida por instituições oficiais de previdência ou assemelhadas não caracteriza, por si só, o estado de invalidez permanente previsto nesta cobertura./ Morte Acidental por Crime desde que contratada, garante ao(s) beneficiário(s) o pagamento do Capital Segurado contratado para a cobertura em caso de falecimento do Segurado vítima de crime, exceto se decorrentes de riscos excluídos, e observadas as demais cláusulas destas Condições Gerais e do Contrato./ Morte Acidental em Transporte Público desde que contratada, garante ao(s) beneficiário(s) o pagamento do Capital Segurado contratado para a cobertura em caso de falecimento do Segurado exclusivamente em decorrência de causas acidentais e desde que o acidente ocorra enquanto o Segurado for passageiro, em algum tipo de transporte coletivo, fornecido e operado por uma empresa devidamente licenciada para o transporte regular de pessoas por terra, água ou ar, exceto se decorrentes de riscos excluídos, e observadas as demais cláusulas destas Condições Gerais e do Contrato./ Invalidez Permanente Total ou Parcial em Transporte Público desde que contratada, garante ao Segurado uma indenização, nas hipóteses e nos graus estabelecidos na Tabela seguinte, proporcional ao valor do capital segurado contratado para esta cobertura, caso haja perda, redução ou impotência funcional definitiva, total ou parcial, de um membro ou órgão, em virtude de lesão física por acidente devidamente coberto e desde que o acidente ocorra enquanto o Segurado for passageiro, em algum tipo de transporte coletivo, fornecido e operado por uma empresa devidamente licenciada para o transporte regular de pessoas por terra, água ou ar, quando este ocorrer dentro do período de vigência deste seguro, mediante comprovação por laudo médico, e desde que tais lesões sejam insuscetíveis de reabilitação ou recuperação pelos meios terapêuticos disponíveis no momento de sua constatação, exceto se decorrentes de riscos excluídos, e observadas as demais cláusulas destas Condições Gerais e do Contrato./ Diárias por Internação Hospitalar desde que contratada, garante ao Segurado, o pagamento de Diárias correspondente ao número de diárias utilizadas pelo Segurado em cada período de internação, deduzida a franquia, no caso da sua internação hospitalar decorrente de acidente, entende-se como tal todas as internações que não sejam eletivas, independente das despesas efetuadas pelo segurado, e exclusivamente para tratamentos clínicos ou cirúrgicos que não possam ser realizados em regime ambulatorial, domiciliar ou em consultório, exceto se decorrentes de riscos excluídos, e observadas as demais cláusulas destas Condições Gerais e do Contrato./Auxílio Funeral Garante aos familiares do Segurado o reembolso das despesas efetuadas para o funeral do Segurado, desde que respeitados o limite máximo de indenização , os valores Garante aos familiares do Segurado o reembolso das despesas efetuadas para o funeral do Segurado, desde que respeitados o limite máximo de indenização, os valores efetivamente dispendidos e satisfatoriamente comprovados e as hipóteses de exclusão de cobertura./ Auxílio Cesta Básica Garante aos Familiares do Segurado o pagamento do Capital Segurado contratado para esta cobertura, em caso de falecimento do Segurado, seja natural, seja acidental, devidamente coberta pelo seguro, exceto se decorrentes de riscos excluídos, e observadas as demais cláusulas destas Condições Gerais e do Contrato.' + row.termos, 166);
        this.doc.text(22, 211, lines);

        this.print();
        this.save();
    };

    /**
     * Função para chamar o imprimir do navegador
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     */
    this.print = function () {
        return this.doc.autoPrint();
    };

    /**
     * Efetua o Download do PDF criado
     * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
     * @return {jsPDF} Document
     */
    this.save = function () {
        return this.doc.save('apolice' + this.data.client.name + '.pdf');
    }
}

//language=JavaScript
/**
 * Classe criada para gerar Apolice em PDF
 * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
 * @param row Recebe os dados que serão utilizados para preenchimento
 * @param $filter Angular Filter service para conversão de datas
 * @constructor new Relatorio()
 * @return {Relatorio}
 *
 *
 *
 * Essa classe está uma confusao devido as constantes mudancas de scopo da Maria do gruposin
 * @todo Necessita ser refaturada
 */
function Relatorio(row, $filter) {
  var self = this;
  this.imagem_line = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAW4AAAACCAYAAAB44zYaAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QkDFCsH/VLMfgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAABKSURBVEjH7dCxDYAACATAJ9HOgeykdCRHYCRK6RiIjgJ3MDGx+BvhZGYQEUdm7iCiT3X3WlUbJ+gtVb0XAHD308wulhAR/ZuIzANdixT1f1dPkwAAAABJRU5ErkJggg==';
  this.imagem_cristoemcasa = 'data:image/jpeg;base64,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';
  this.imagem_melodia = 'data:image/png;base64,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';
  this.imagem_familia = 'data:image/jpeg;base64,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';
  this.card = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASIAAACWCAYAAAB6koVhAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiNGM5NjI5Ny03NDUxLTQxZmQtOGFiZC0wNWNjOTM2ZWY4MDEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QkI1NzFEMUUxRjdDMTFFNjlFM0VCMzVDNjg1NEE4OTMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QkI1NzFEMUQxRjdDMTFFNjlFM0VCMzVDNjg1NEE4OTMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowNzlkNmJmMC05ZjMzLTRkZGQtYTc3OC05Nzg3MTQ0YWU3NTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6YjRjOTYyOTctNzQ1MS00MWZkLThhYmQtMDVjYzkzNmVmODAxIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+U8T1zwAAF2JJREFUeNrsnc+v5FZWx+91ud573e91N9MDUpASCaRseqRhNRL/AaOMhERIgkYgITF0FiMhBKuQLRJoNLBgMdmwZUaEmWQBowxhgaIIBEgkCommO4sOJNIERa3Qne73Xv22fTjn3muXq8r1wy6Xyy5/v63qV1Wusl0u30+dc+79XmsiUlXrzTffVBC0Dz399NPJ/dkzn+afyCVat4S2eO/yuyu3tcnrbt26VYvvxcepCbVRu4fQRuSoGEJU1kc+fBDdvHnzLAiCP51MJs/y7ckwDP19RG2HKq21euKJJ9Tp6SkgVHcIUbHXbwihMd/737sffvhv/Pfv5faVW7fG+/pOvDqdIDdu3PjOxcXFF+fn5388GAx+iYEECJXdCPl43r9/XzHkAaH2Qkh0xLdf5tvv8O2H/OxHdz+8+5utBtH169e7/Av9H48fP36JGwjSxR0riiL1+eefA0ItgxBlfmSKX/MUL3/9zt273+Fb5VyoBYg4/fqXXq/3q0BEder3++ry8rKFEKLWQmjD5S/x7c9bByKOhv4SENqPHjx4oNqQ+tKaxt4sCNEuIRQ/89Kdu3eeaw2IpDDNv8x/BCTsR1InOj8/B4TKgBAtXzflhBDlAN66fVoJoczlyRN/9dM7d45aAaIgCL7Ltw6QsD89fPjwYKOiSiFUKAqiHAHVYsF5LYRyL5+Jkp7kPy+0AkT8i/zrQMF+FYahevz48cEBqP4QypPVbTr+pwQIzUZJz7YFRE8ABfvXo0ePDiYqopyw2BxoLYHQ7IKvaV0NIvYKIhmsCAzsX5weH0StKLN7nspYVyshJE/+YisiIgxWrI+++OKLRn8fB+sb2x+E5L92FKshREWA0JptlQAhKgYh8z6tASIIUVG7IaTKgVCRKGn6vmrOB4AImomKmjTauhrLRt0gRKVAaDFKmoZfM++r6HcJIIJmJD1ogNDG5Ng4vSoPQus+8mYQ2ixCMo+6ABFUuUajkfGhAUIlQajA62sEIfn/GkAE7UVSK6o/hNprXl3hoC8XQvJH60p6zgAiaEGDwcBERvWGkIKDPsfyQhCqUAAR1IioCA76vMtpLYRoAwjpisrVABGUqV6vZ3rRWgWhw3PQr4TQ+ufJ/AOIoP01fj4j9x0VNcO8WmsH/eYQokUIbWORAYig0nRxcWGmld1vFLQ9hFppXs0LoWXPVTS0GiCClkogtA/bB8yrO/GNLUY86yAkHEJEBNVBVc9VBPNqVRBSayFk7mnUiKAaSKaTlcI1IHTIEKJsCJn3IjWDaqIqbB9w0O/OQb8eQsufU3DfQ3XRrgc4ttO8mg9CRaKkbSCUgI+QmkEtiIraa16t0EGf+frVEFp7wAAiaB+S6UHKHuAI82qF5tUNo6N9QAgggjZv6HyGltmVj8s/7xdCtAmEKmQRQARtLAFRGTM4wkG/Ol2rAkLzPwJZEMKARqiWKmMGR5hXiy/fGYSWro+q6jQDiKB82maAI8yreZeX46AvCqEqBRBBuTQcDgt15cO8mnd5eQ76whCi6oAEEEG5lacrH5d/rti8urb+Q6vHDS3sF2pEUE0ldaIwDHNCAw763BBSOSGk8kQ9WevLiIxgeoXqqk268uGgr4+DfimEaA2E5H+YXqE6a1XRGubV+plXMyG0QY0IvWZQrSVd+VmufJhX62leLQKhCmvVABFUXlSEyz/X2LxaBEIyYzUGNEJ1l1yIUeYrqgZCuPzzduZVWlojohVQwgyNUCMkXfm4/HMDzKtbRUYAEVRzzU6wDwd91RCiMiBEKyCEidGgJkggZP1ncNDPh121Mq+ugpCaGzeEcURQE3UuRWs46FWdzatLa0RqETrpxxoWD6gpEu+ZeNCaCaHmXP55W99Y7sioQgFEUDlRUYFJ03D55+rMq+siI7UkMiLUiKAmSepEea4KCwd91ebV1VCiuRGb8WOMrIYapTxTycJBvwfz6oaPpxBaFQECRFCD0zM46FelXbs1rxaBkEhjGhCoaZJR1nINtEIggXm1OITU9hCiDAhRha5XgAjaeVQECOWBEO0FQksjI3TfQ02UOPLTk6bBQZ8XQqo+EEKNCGqq0kVrXP65HAjRBmOAqAQIZaVnVQkggnaSnu10oGKpEDoAB/0OIyONaUCgpkomTZMpQnYCITjoV0ZGqvTICDUiqMlR0cykaXDQV+KgV2vMqwUeIzWDGi3pxpfICA769RBSGfWerSFUwmMjpGZQkyVF64uL89pDqOjyJjnoi0KIKgyJACJoZ7o4v6jQvAoHfXEILfrMqGIHPkAE7UzZRetNopri5tW1EGqhg34ddGY3M/cYxWroIKKii4v8qVhBCMFBT9tBZ4Hk6L6HDkQSEdmi9e4hpHYFoYY76ItCqMoxjQARtFPZovVFsyGkNk276umgL/J4enFFpGbQAaVncNCvgZDaHkJUEoRUdfwBiKDqtLxofcjmVaqVebVoeqYwHxF0aFFRaRBSzTSvNg1CVQ6uBoigSjTgiGg6PUiTzKvlQGifDvrChWqMI4IOTdOiddPMq8130G8HIRSroYNLz84zz2046Oc+wB4jowUIYWI06NAUTAI1HAx3AqE6mFfr7KCnrMcbREYY0AgdaFR0sRMIFV3eBgc9LTOzokYEtVUyp7VciLG95tU9OOizHm8IIXjNoIOUKVpfXq6t9ayFUOPNq2VHRusd9Osio8xCNVIz6FB1uWZMUTvMq9U56NUyKK2DUIUCiKDKNR6P1Wg0WgohtSsI1da8ulsHPS0c5vUQin8MNEAEHX5UBPPqssdFoLMZYOZDzmwIJYcBNSLokCVF6+Qkh3lV7dZBvzwyWvcapGbQQUt6znqXPVz+OeMx7Twy2rTLHhOjQS3QRtOD4PLPe4MQTK9QKyQF68lkshWEVMUQarZ5lXJByO4EakRQC3Q5M6YIl3/epXmV5g7xWgiJkJpBbVBPQESLVnyYV4tHRmqjIvSmzyE1g1ogmaNIrgpbFwgdgnk1P4Ro6euQmkGtS89w+ecqzKvZI6iXggkREdQWSUQUBOFSyOwNQivrPc0yr+aDkIL7HmqfZGBjv9fLAaF2X/45v2+sOIQwjghqZXq20Phx+ecSzKvFIyGMI4JaJRlPJGZYXP558ygnj3l1ATi0STqGqWKhVkZFF+sh1ObLP29hXp0BU1ZkmAUhVdkwIoAIqo/6vb6iiOCgn3tcjnmVlsJm1fNw30Otkxhh++kxRYUhpA708s/b+cbyQshM0IgrvUJtVG9Z0bowhA7n8s9VQ8jmZkjNoBZqOByqMAgUHPSqXPNq1rGbL9YrtRx2ABHUuqio39sphJrvoFf5zavrjp1atPyh1wxqN4jM7I1w0JdrXt0AQip7GUAEtVJyRVg7pmhdrahdl3/eyrxaYwgBRFBtNbV84PLPZZhX6wwhgAiqL4j6fW4kUSEIqYx6z9YQUk100C/vGdsEQkTwmkEtl4wpGg6GcNDvAUIVzhALEEH1lyla7wxCqmEOeqoMQpihEYJSkjFFEhntFkLNufzzVubVTAiRWt19rzBDIwTFtSI46FdASG0GoVUF6wp5AxBBDQVRrwcH/ZYO+lUR0joIYT4iCFJunqKZa5/BQa8qghAiIghKaRCnZ3DQVw4hdN9DUJyeDfpLUy846JsdCQFEUGMUhZEaDUf5zau1hlB1DvptIISJ0SAoHRX1+4uNMN0A4aDPgFMJkRDmI4KgqWRMUWz5yG3Z2GNkVCcHfd3SMYAIapwkRbAwygkhOOi3gxDmI4KgWQ36g/wQUnDQbxMJodcMguY0Go1UFIUZUUsNzKs7g9D2DvomCCCCmlUrmnHkVzutx1IIHbCDHiOrISgrPRsMKjSvwkFfFYoAIqhREstHGAYZEFIVm1cb5KDfSqgRQVCB9KyOo6Ob66CvaBgRQAQdWnqm4KAvUxhZDUHZCsNQBcFkYwiVZV5to4MexWoIWpWeDYcwr1YQsGAcEQSt0NQEewDm1ZpCqMqYCCCCGpueTSbjStOznZlXd+ygb0JuBhBBzY2KRqPDNa/WZi4hpGYQVHp61lrzauGACKkZBK2UXGrIpGcwrzZeABHU+KhopunDvFpyYlZNaubjVIaarPF4XK55VQFCSM0gaJv0TB3e5Z8POR2biYhe/O1vqm5HK+/KqRpEpEL55CEpr+ubo2BmfwlDdeRp7/joRIUdT759FfFzIUX2isCaXz8TwukZlmp3QGVslNx/7rnn0IKg8qKi0Vh1/W5lvrGlwMk5FogacpWN2y++uHkExTtuxkCSNg2eceFp31eex3fCiCPYoRoxPrQ8NjTQKgomyh9dOfNCFSnNQIkkI5S1dKaHxoRMnY4aK+0NhwNeq1a+35FtMLa0b74oYi4Z0iSH39O8I6RpAfay6b/70Wvmdd984Xm0IqiU9Ozq6dVKIEQL3ChmXm3KpX5u3Ljhc9v2Z3ZRZ+ZwUfxJzGLNqPE0BzIU0STwZMaEkInR6fiCE3nWBDDm9V5H+Z2O5xF5JsSNIxbdMUTx5AnPAYbJ4gl3hHhhaF/rybY8u2ck4BEa2j2OtJBN64WDrt1/pNGAoPLSsyAI+GT2C0Jos/pPG683dvXszOem6mutZjOc9H1twaNpttij+Xth4ETChU5HoiMvfmPkgiHDC93xIt+LQhMFcQxj4GOiGCEgr4bv+pZwsowMk2SDHS3P8GPBoOGN9siNwjLr9+xWSEKwGQIlvFSa0ICgctMz/6oP31jJ+vLNL59w+74q7dvTcdBhyyzkuGB71iL3IbSrwwiATLTCd3XMgchU6PixsgwRtgT8Bt8ngzDyHMs8wYhbo/z1bfqVHLOOwMoFSiZicp44L31QZfNmJ5S7/ovWam45BJUqmTANECpf129cv8Z/hjNx0GwDjtt+lC6/kCn2uGNl0iNeTiYSCpOPTioghwdb43ExDBn4WBDxgeGQTDvomMqThGeyUc/CSXdshGRiKW+6n9qLaLpHZHc00klkZcMh0sARVJ7Eeya3jtcBhErU6ZUrp5poKLFLlBpVZAIRadc67kM0eVaUIlVkAhETPZGUkANTsjFlG75vsGOCHOFL4LuQRtgh0JFBGSc2v9L2OQMs7UBjoyRlwePbTeojBzVPAOPSObt7pA3ByBSlbOqnbZkqjrggqLyoaDxRnZNO8RrRNhBa1jPWYAiJjk6Or3HLHmm7o55lhWRClIQ7ps5iDo0OHIciCxo1Th024UUgJR9TAhIg2aAkklX4ZKrScdhksMG0MuCxRBPQmDo0RUrHpR7yXejlpb5sz9SK7EtMxBSHbg5H3rRKZTJNgAgqPT07PjkuBiFceTVTfse/ym39NF2d1oYXNgKyY7B0qCTKUeRLPcg2czdnuKRlBkwUOFAFvExCFAaQgMqmcH4QSSFJ8jDpcjeRUeBK1yrpj9fKcwVpGVY04RV0Ld3UsTu4R9qGZZFZ5upaJNX2eDCALUYJST3LIW3GFtiBSBC0vaTnzPbcakCoBHHbDLmNdrlVn9jucO266CUlM8dYeBCQdm2bzH3bK6+1jDKVFGzkIqGJ4YMJaHTkeDF271P+NV73RHKyyNKtow2YIhMPuTBLxwVrZUIqF2KZv2PzVytJz67wjQElsDLkSxXAbScZb6YraZ6LmgREAX9Y2Eyg8mA0CVS3292hb6wdEBINh8O+thlR134I0/k0SX2oyMFIaj+heyzLB7xwbGtBCQ8iAyYdw4yXRa4zi8MW/5hBI52eEwMhj6Mikg79ZEyRDb1obPvCTComuZ103Y+VrR35ZsOkeKfphN93zNgRKF3htURkBzpJRBXFtSgLJ5PKnfP9m2g+UJnpmd/1dwSh9lx5VfTgwYP7nmdIIMFDqG1bjuz4aVt4NhAiGjAw5Dbi1wz5SE4clALtuuy1rcoEZigjJb1vkTFy8Ct8t2YTznK4EoXx29xWTOe+ksFI2g5OSsHE9KKZnJBsoZuBxI+lWN3lt1zl569p81eduXqS+QBmY5zq9fv9d/jX69fQfKAy0zNAqBzd++ije93j41ECHVuxNiUcvj9gSPT5dsHP9U0sY+s/kWWMCzz4sS35SM+5Nild5Ex0kWfLQlEwZ3qdP05kik2diDxPjcYyRNsMXjTdb7yCIJJISashPznkN0uENLYFKOrxPj/gx5/yxn+mSX/KMHtEWgdSazK9cLzuf37rre93Oh0UiaAy6xrya1orCDXRvNofDHrvvvvuf165cjIyQ3ZMjVdSLP2I2/unRPpn/By3b8XtXPXIlmkMAySr46M6NFkTMSvkxtwIOEkTjkS6wzffDnhUyTiiNfKMyTUaDIbeybUzmxiGpLqedMPFX7Xp5LdjBGQEtgyE1KZgHZhcUKvH/NojftE1vv9z/Iaf5w934+LinHr9/j+dHB8/gyYElRkVdY+6ayC0KXDqdPnn6vT222//++np2X3bYUUXHOn8H3/ORxIBSfZjOp1IB+TGCzFoAhs5OZ+p6VmzPV1DDpI6YiNjIg2GQ3Xqdzm48W3JyR2bjbvQtQNNJDUkkhTNdn45GEVuw54JzXineCfHprZk6kuman7Jf+/zq+/xm97jD/MBP/7kH37847/2vM7HaD5QaSAKg+IQqvXln6vR+x988NP3/uu9n5xdP/uAd5/bqX6Pb/e4Xd/ndnvJR5Ohw9kPR0DE7Zts55V0cHnSzRWSSoIU6X+XWTqEGXYw43TE9Uy8k3cn9fSQR24kpWxU3G0GRrYkTuY5BmPA6RjvrJj3icMzvhlAqXNe0ycMq3f477++8Y8/edb3/XtoQlAZkhHWh3j550og9P777/zg+z/4syefeupvuG2+w+39E4bPuTalF9MLJtAZc+Yz1qYXzI5BjGzhJ5q52XKQc1WsSbzKTtHlny2lT5/T8YBJBy8TQdkpjKTe9PCZr3/9/b999dWvnJycvMJACtGUoG0Uj90/uMs/71CDweD8jTfeeOXll1/+3a/+yldf5Tb7MNVfFQ9KtL3grvhsop4pZuJ+r0La1RielAEuinNGm8LZwZHG8OZGS3o/ev11GYsUDYfDP/jSzS/9yWQ8+YvxePwb/Mv2C4zaDhGs+lBOGME3tvr4EIWj0egL1r3/+fjjt1753vde/eyzz/77927flnTryHbVm6wmSn1U1yOWHN2orBKYv+vTQdn60XSQNn9Tv/X88+YD/PC117yYVjJKiR+Lsbb/wnPPf5sXf/uZb3yjy8+f8v0jmTvAjhjX8YGMa1eZ+b6bnCmZeMTOHKdTJwol8aJOn7M6tbMqnu8gHq0bu+i0yjAnpQtqi2dk2uSbjKPQsWXG7mfqfeTchNrtQzz1wvSz0szlgO2I4unymeOS2ubs8Zu+w/04JKfYwrq1Tmbfk94O+5dm1pfeZjK2mVKfPT6Oevr9zaT8c9ucXT77voVLIZMddqL1dLvx4dTJvFiUHPP0cUlvO73dpedacuxoST3VbSo+BzOONcUNmpxXPZlig5I1Z32HqbW4cyM525PzPGvfl5yX8iLJQIbf+v3bfTKuB7M8SE3YE7kP4wmUdKYBf3vpP7z9LbMnPUZD1zMDidREsibPDRjyfVP56V1cqpOzU/PhA37NUce3flyKxx25Q0NTZ70XHyIzW2P6BF08KHrutEtc+24KEaLZ98ac6Bgnf8eOjFJzX3h8b+ELWDLFE8W019Pd03OVMQcu0jN0Td43fZ2X2p/U15r8sqaczAkUrX8w6Y3U6eOUnnUq9TlnDoya+yzWWRjPemDHtNudpyi9CkoaO8WTVS1MrmlDcE+nrxSWjHqdmxg4Iz7RKpkYYnpMaXqQ08eZ7HwQ9kdZJ69NjiQlpkfbkHXqG8o4HlrFP0CRnVxiZpupH6QoBoCa+y5T32E873Hq3BADKEWLRdTUCTjdlvNALB4rSn4JtU6dS9qtKIr3i6brTC9PjO+eGeCnuY2GyY9dND39dcoA4zygrnTiDPH2hyY5g1NUJXf66NQvd2R69dOQtHN9eM4PK7bVcTAxsyLI8kG/r66enimSWRIocNVtpf5fgAEAI2XHS7/xncMAAAAASUVORK5CYII=';
  this.img_efarma = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAABTCAYAAAD0vGmMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjgzRERERUFDQkQ2MTFFNEFERDFDMzA2MUQwNzgxNTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjgzRERERUJDQkQ2MTFFNEFERDFDMzA2MUQwNzgxNTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyODNERERFOENCRDYxMUU0QUREMUMzMDYxRDA3ODE1MiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyODNERERFOUNCRDYxMUU0QUREMUMzMDYxRDA3ODE1MiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppg/JWAAABsrSURBVHja7F0HfBVV1j9JSEIKkFCCEHpCFxQQECmiKILiiq4LKH7K+qlYsWF3FZVVsbvquha+VXftrIoKig1RLBQFlKIU6b0kBBIISXh7Tu5/vnczzMybl/cSHvGe3+/+CPOm3Hvu+Z9275yJCwQCZMiQoeqhOAM4Q4YM4AwZMoAzZMiQAZwhQwZwhgwZMoAzZMgAzpAhAzhDhgwZwBky9LsCXNzkVZV7UmoK0eYtRHPnEyUl8o3iDPcNHS7qya0HtzJuX3H7NZKbBV4e4/vcWob3hn5nNJLbVdyOBeBmc3uA27fV8fB4w39DvyO6g9sb3Ppzq8Mtg9swbt9wO71mAU5cyLIy1Yw7aaj6qSu3iR6/T+WWXtWdqD6XspSBlppKlMiPLC3lJzs+uh+3y8K8s7gFO7lt4DYfLoIbXcRtkO1YHrcbcB9DNZf+1wcW/sDttZoBuOJioqxGRDk5RIuXENWrx9HmQftZEsj+T4RP+oXb49yed/jtLG5nOxwfbwBX4ynbxzkta1YMt28/US4Drn59oqIipzPyo/CUDtye4/aROLK23zY7nL+Jm1kbqfm0wsc5S2oW4A4cIEpjtzKnNVFJSVU/bQi3mUbODIGeC/H7Nm7TaxbgJFlSyJYtO1tZuf3FVf3EE7ldaGStRlECtzbcGoV53Rpu13r8fo5kGsK8Z2ufruphiOEsEstWry57yy2IFiwkqp3s56o53P7s4CLWBvOHcrvY5dr7uL1i5LRGUUNutyF8+B6ejLiDa0Nc9zdSybWruXVCKCHrbw9ym+cD6G25dSa1hJCLZ78Q24ATKyexXIvmRKtZ6RQWquzloQkUnSQLuczltx+5TeH2IrcvuSXZfmdkU3ecZ+jIJ0luzSWVHLubVMJrPH5bjePLAMCfEbvpuYF30LyoMcDcEa0Lt/bcmlrBEbdbuD0RbuejDbjjuJ1Kas2jEbRCHgYtWujj/4/l6tZhfZFD9MOCUGCzLFko+o5UdvIWh9/6egDObjVl208/MDgBiZbF3GZw2x1m8kYmigdJTbilQlh2IFGzBNq1xEWbZsPlD6CP0rZyK7LFqf0gIHOgdISacUvkdlAbnzx3L/7Ohlcg2jodCu0nxDBOiascnC9jEpdkOwRbFozD2esnzzoe1kX6UB/H89C/VZin1T7uVcDtRm53wYu5Hi5ea/TVIhmzbN1aijEK3xdSMIGWi3mSdjR40hb8OyQLUVmgRRtwfTDoQR7n3AyNcwdbuQ+oaB+zphUbeJa9bRyvpqf7AV4o+twFcNkheFAK7fUyt1NczhNBvJ/bwyH6IFuHxnE7wUd/N+GZsrVoj81lWukw6cLfL/DvY1BsFg3WACfu0VG2azPw7zPcLnURKFEo9+LeFj1Kap3Sjd7mNhagcSPxMm7nNoJbpg++CPAnQomGokL070XMz1kOIO+BZo/p4tE3P/QMwL3rcCdNboGmHuTjXNEi75eDUxa/E1iRt8bSR+RgI4+g10uxLIPGXewBNktgH0Jzo1dJbR06wWd/myIWWWpTCnEugFgMC/yZDWxkswp2jyCAZwnvr3S5t1A9AOw8/H9WCLAJ/QmWo47L7xfCwoz1CTZCjCQyNTqMuRceDud2BvnbF9nKJ9g+hed2daRgiwbg/oKAM1y6k63czeVWrgl7W1lZKq6LnDq4HN8aQuhnhiEMNyEmtNNL3M53ueZgCHe0GVVMSQtA9jto8uEAmx+tb7fOEt+e6XOMfwfYBvg8X/rvtNFgCCx4bQ+38IDHff8Nly8cmo4Q4hJyXnf1SxzrlG+SEM/hh2jFXJEArh/cDzvtgmk/H5ryAQcBEJpEZWW5lJykdqCUemZk/S5M3+xyfJHHNTKhWfh7I7c3Yam8FkHH2f4vcclFLi7jKG7N0VpDEJyErKuD22PnwVPc6npobDfK1MZoud6vQ6jcrPkAW2JKeDLN4xmjEEvqVvp1D0XdQePLICgEJxpbSfmcjLl9qBJe0jgo1feinfGJJIZ73sXlEeZt046Ji/UCJi3jEA1WVnY8paexk8Nejryb57yxudgH+O93EboAgvtQ9CB8dD2JIcriVodze/gUil4AsUV7IAiW62anTh7a1L6xdgus3XpuaUh8hKKNiKN0l2sCsn1eFv0RG6+nu7iQsgt/ihZvZjic8yxV3ERcgLj0CyROGtjObxOBjBYh5JkB49A3BNDeQ6y5gqqIKgu4E5Eu1WkfGO6U5ZL4YoyDxuhNJaU9KT19HqWk8JBLVFx3KPXm9qGWrSNk/OrAD28dQjEUhhjPVMRSdroN8URXByFIwZgJWS07TbOBzZ5oeDQCj+MhKIdiH1lXXfH0d8gAToDr1NXhmtdsYBOaDb48HcLKdnXpx2Me4/oabnO0E3tfIKnjtTR0EPFolVJlBtOYnHdvPE7eeyGnIkvZpcLRsrLzKSlpHiUnc9Sy3w1wDRAMh0tiUW70cd7DIbJwduFJBch+0jKTCZrrGwdt7aWwnMjPBurJ5JyJJR9KxS3d/pkLQJ7xON+J0mwx7RRbOCB/b/DoY8dK8sQPhYpfk3DOB7EGuP6IWeyUA9cqweW6/Q6JANYrB3uXv6qTlKTelYse7Yb7E8q6lSLD5UZrfAjXxhDPkLUrSdPL2t5QhxjQL4lFu7KS184L4Xo50XqX4/t8PG9XiKyeKKVG8E7E1fsz+FNVdJqPc06JRcD1Ieds4Ei0cKklxcfHcYvmjn3RrNcgzglFOxBHkIeicAOq83hUwqE7BEiSApIJrR+Fcc0KkdULpVgoDMta7AGsMgouyPtJbsl5J0FRd4VLng3AJVLVU13E06FoYCy6lNkU3U3PTSkQSOXmZYn2wYrEu0yy7CZYBx/9XVI7CcIRRC+wB3wrDuWa+o0Dyjy8ATdaUkVzHQjTlQvnlX3JSF4KxXO4qJ/D+CWr3NAWS3dFyLQ1lgDnpvFLEHiGA8Y4BtpuSuBLaiWoLKUzfUvei9KRUDzawQiEKxfxXEoIF3cNkg7y718rAbi9VcSDOJdjkdbCkOWHk0O4yLJ0shhJppGwhNEmu+WSxWxrQ/sNVHHTgcTXb8US4H5FMsKeFpa067NhAi6eEhLKqPhAUfnCd0KCVwYpluktF7BJil8yfTMAMsuKN6HQW8SiNV+Hi65xAZso5ufBF5ElfTljaBX1pY/t/yO0v2U3y5fa/4+PNcDNg0bq45Dl2Rn23eT1nHUcm+/YoWpXOlNCDAuWuCHdHI5LNvESl2taUc2ncS7xssjNSpdrUqugH3LP47T/S9Ip3xYXv0rBbWT9Yy2Gkw2lXzsATnaV3BXiWlkzO7uC23KgZDllZEynuhzX7itSC+BHFvV20eJe2cTMGg62RuS8JetpD7AJta6Cvsi+Vmtr2Wx4YXaSZa7TMS8CzgaVMh4+45dwqRDa2ymOucbjuiSY7ie09jjHbc0pPv5ILp2X4pKE8MomjqnhgHPbyOy1TNCFwt836Yf6a3My3CNkOdvhmpgAnNByUtlAO8kbtZO4tdOOpWMwSxw02FJKTnqOCgo4KtzjVjov1mmni3JxW3CXtco/HaGxql/a5qJwxrp4VfIO2odVxJOhmpLzslriWlpvbw+oKsZEIuGyUHmag999M5osmsqCqiz41nO8QyBwenmiJH+3Kr3gr9xCrJFboaJHMHHfYKIbIYlwqse9EmsI4CSb+oND2NEZiRLZIC67XpIR/17sca9I4ndRfD2Rd/BTZuMyyLW4mDfEGuB2wz/+zsWtCrXuMoot2tryV3S2bD0SYzeLJK39D26XO/z2BzRyifPsg65PNYdud1FGsuh9Wxj3aRBBH6wap6eFcY3M13R4Y6ujzZRIF7DltZejybvasZ3k9fxhbN3eLM9KbtyoMpTKurmVmm4SpfE2dDjWlLzXm9Jcjuvm+ApSa05+SBbxzyXngjfWWmMcOb9D5heQTm+4Z4SZxEnxsC61XHimP0Pi9fFhzM3dLkDsT97rm140gtQe37wwrpF6prJOd1WsWTiLfgNTRMPLO3C96dBCPkJSA0M20D5UHjxLvCZrb+s26OtvolHm2vz2eByLBolr0Uq7fxwUgFecsM6hT3EO8YCARdYiLyDnbNsaUutxDwBsstVooK0vVpkF2Wr2FUAd0PiwyOc4ZT9glu1ar10qP9vGKH1x3vuqqAieTbztGYtt58kujlUQ3oEO8pYPl1vKI8ibJC2Q2AjY3EKZs2VhznV9GIL7KyEnV5N6v88qvxE1qorvw8lE58AVqAUhWg1gamxMUhW7vvve61sDRyp1hZVJwfjXQ+H8nkm8lHawppJQke1Ty6liLRevOK6sEoDbT+4bs0NRBryRkMVTD/f34bZRxRdQXXrJQJflgIRa1VGFubrpJwq+umNI0WaqfMmDyrxGEmn9kfyqYIL5PpwhQ9VIBnCGDBnAGTJUlSS1cxJUq+YPJx25mYqDpUQpHBenZahtYRITlnCMvHcn/8YxYZzRJYZc5CatIVFCIkeGB4j27fYqXhUDgEvPCHa8aA/e+63GfZAHOX5OY6DVa0K09keiea/jM8YMsKPaEbXtr7TW7s0qKUPm88YRk/A2vpYS0Fjsm98iwiI7mS2J8tYSffmCkpeTLifatkr9Vg1yHD7gdm5S/yanEjXN5c6uIzrAliU+zB04wqSkFKLE2gzcQv/XZDYn2rWG6Id3iRa8WVEIJC+46AOiAZcSNetCtGONLHz4A51oObl/XQZysvSpgKhwhxK0mPSK4BalZijlt9+qMxsX+jrR7iKopcXeQib8kPGnZqpzy+dqlztP5Hy5ryjDEj5/77bo808HWHojJXfyjJJ9/DzUbXIa00G+JovldfMyorfGsdywF7RhLt+jAdHxo4nyWUEX71XXylgPqSARHxXdHf46XC3sRkpKJzr7WqILJ7A1YTcuf4dK8fthWBkLSFY2X8PXzfqaYc/gPSDWstRFYAJKUBq3JVrxLdEHdyoh86Iz7iHqeDLR1hW4ZRwEiPufzi5FoExNULmQ8G/pWdxYsOb/h2gLX9N+AFHLbqxg1jq7p6IRa9eFMLLCKdyl+uTLlbW9YF6ufKQ2Z4pq8gb8Hu7bgULn+5WDJomfXY+FZjErCL42uxODgUFXlOes/KxrklODAijniVIpt2DMlzqNVF/k2eKWS1/qNyOa+RzzfTbRkPGsyI5mRbYaQh1XcQxyfhoL8ML3WXExP9v2VUovpDKOV+cIT532IMhx4Y+AwwK1KOvvXyNat0B5PB14rlt1VyHFvnwFwvKlpwTVr4yj+NyFRFOux3M06nUhz/eJzJs6ag5lTgv5PgcYxLWSlbyIbB90Xp0IPDWkCgFn1x6D2Zrc+LzaDyDLhPtYS+zaohiTwqBMraM06v69arJrsZZMY4Zt5Um9iYV6y3qiP04iatSGf0tSYNy/R2nsVGZkUqoSwBTW5Es/I5oaxja80+8mOmYYMy8fApGk+rHiGzVhbU9QEyML76L5fvueLedrQcVw9sNEbXqq64XxwisRaAFCw1Y8Tu774hlEDfjvDgP5HBlnkdKeMnESU9ZOV+MX2legJr92elDoBawpDNxdG4gKtnI/flGatttZLCRN+e+ioMCKFpd7y/3qMji+ZCDMfUX1tePpLDijGDQs6Pnrg3Gt8FsEKEmsE4+jlD2C2ZOJNi0nOusvCkDioQjPBVTCj7b9FIhlPmY+y894Gf4Q32PEk3xNV76G+1gsVmU7jylVAUx4+umTyvMQMI58mijneD5nl+q7PN+Kr8vlLqDiKeGJjFmEWvohVlvOsayZ8FWAtGwm0caf1b2lhumGORXnW3gwcKzqe8F2xVc5V+4pimnGfV6Czf2HIu7E4B14hRqPKDHhy+o5yutxAtz6OdUIOKGcXkQnn68mqFVnFvIBaluu7JPctJIFjQeczf7ydnY/339W7TJZxJatYGPQDcpkwOXyRGey5WvIbmPj9koj5W1UEyNWZ2klKpj1vUxpKJkg0VBLPmE3GDuQ2rBW68qT9Mssbi5fmx0+SVkGsXQiEC3Y6h3VXrmunzAgS7GRoQ0DruNJChzJ6Uq5iHu6jce/HxMlgiqAWvKpih9EsDLZgmxaSjTnVRZK7fMDSZkKQAI6ETbhe0YTZVVFkH7+iOPXf9kCBO7nsPuUtt7JvK7D497DgreFwZW3Xo29YH1QUyeyYJ56k9LkP33IfcXur+zjiLoPZwXEgrTEznPux9GsDJp25L6wMs3po+Ll7b8RLec5/XVGRW+m20hlgerznDZl2UhkxZW3QYGibmNloX6arub32GFqPkTAJS4X106suDzzcwZv8Y7Q812nBfPgVmVp8zj8mf82g21++PFn7iCiLqcpK7p5YQgvPQwMycnhNF80lAPRMQ8oYdKFwS+JBm/WKzYTHimsyXNO9hEds2Bl2t6nTG4UefbU0vxedAqD6PL3WEtfx4LXpGr50YIBl9rY37lZbE3PnMgeESu4K9jt7Dbq0HNSj4pSdiKl2kQiHPxEx8IZij0S9690f2z2rVlP5Y4XbakRrA4HQwZwhgwZwBkyZABnAGfIkAGcIUMGcIYMGcAZwBkydHgBF8k6nLwu3/kwjVE+dN4Tz29ZiesHcjs2xuZNFiqlnoeUpziG3D9EX5Uk32lz+/af32+31QZvk2IYI2eR+/fgpTTG0eECzm+LZBVWvv7y3GFglpRZk7LU8rXKyn7YUGpDnuDxu5RXu6uaxyVfjZEvt1wJhRI4DLwdRM7fwRbhfMznPaTw0Tuk6nDGIqVBdt1qqUiR3peq6uGRbOWWLf5W5SopGCTbKqRylWyks+rHywavG3HuUzgmGvR7TRuKNp8DrSIVmmWznP4tcClBJwVh5IsrUmHrNzBkMO6jl5uTymFSpOZJ8i4e83dSdTVlU2M9CHsDXCel9KRqk2x5+JhUNSvZriEFQudz+8TWNxEwqRq8RdPqfXB/qRo1Ct6AfLrYqjxVH32VfWvYqFhepUu2R8gWm39TsHiN1Pe8COf+02U8wreO+N2pbog8X0rGSXHWj8B3UVzWl1/b4/4yR3qZcpk7KTFXAt4T+Ct9l2KvT2uKQbwGqdgm72wsxzWW1TwJc+X2qeJrAAQpniu70pvi/2LxvwMfx6MvTmX2ZeznYn4+wjHZgHo9/n0G/ZXzytDPQnhIVjWzseCLPFf/8uuFsHpSbi/inQSRWLgyDXDC4HtIffdaGNQYEydVdqWC1TAK1m0UMFmFOUXYroLF+RoCN5FUjUIhqQ84EmDeCnAKY94nVfH5EQoW+/wG2smq7tvOo+8vYjK7AbDdMWGTwfA0TJQI+3Ha8yZRsOCrbL68AJO4As8WQVkDDSoAngphSgR42+GcxRDy67gtIFXpTKzCaGjeGXheTyigHPBpmsNYJpCqGJwG0PZ1cJ/m4h7/glLJgAKw6FXw4FoKlmj/ESASHl0KYW6Cuc6E4rTKF16JsbaFJexEqpDUOPRZnv0Gt/scrOGbOF8U3UwI/YPgS3v0bS7+vstB6QjPPgDwRSnfC96twHMbQY4SAbxBANtoTdm9Ax7KXN6uWT9R7EOgIGdRND4qGUEMN1kbfB4Fi7XOhsadABBZJICROu93gvkErXMcmDkYmmQqBjpA06qWpukDwZB/W2Ei7oQV0Ut/TSPvwqzvg+GjINDl+SAKVhsTUP8f/p4PsORiwjcAKPrHEb/CeHtTxTqGY2BJZCI3QbHI11te1865ByA8DcCT8RVAcXxmE9K94IMeWwVgvdpCSO0frV+nxSvNoAC6a16G0JcA6l8A7LGw0BZ9gvChAQBsWegA5n0NBT+kKPO2Gn3bhmcR+ie8aaHd9xII/zGQgVJYpb9pHtFLUOJWKPCbg8IJoP+94CmJ5/ZHKP3BeEYy5O5yzXUUT6I/VSwU+wIUUxfc90T0XTym/0SKoWi9HbhIA8d2WL/2tg5Og6W7BQM/A9pyPpg1EhZTBrkQzPtKu96qDX8mmLkFmmgVrv9YO3cKgOhGMrEHofUW4FhjbTIbUrDqcBKeMwGuxr2wjvo7Gd8AsFmwfJa7XBdCvAntIMClA+5uWJzOAM4muOQN8Wz93JlQNhYvWoFnPQCEKXTo98rlmdaHVzZAkAfb3KMiCtZ+LIFl1bb9l/9tAWYABN/6fkAOlOlMTfnMRp/WwlISLM5KWPl1OJYLnl4FqzQR89ER97b6Nh9/p2rX6oCbA8uUAIBuwT2Ggp+/at6cZb2Eb/lQCN9p95sO2WuPcZ0DBTPJAezVauGmwBRbzLQ+2PEtACExj/U+RQaAdJ4GHv3zQQFNo72F1hnHrY+FzINlyafg557mYpL64twsTas/CRf1VAfX+Qv072ItrmgO8FoJodmaNXxVixVuR9ImAIGpA2twNYTesupDcI6VbdyIGPceClYo7oeYZ5wtSbITlvFlzVK3wzn6J3mba8JFENxrbWP9mYJf9LwJ98vF3MTBagXA779CUVlJG6v0/A64mhMp+P3rodr4BCQP4PhtOF4Plu9WLd4tpIofdhlBFb+nPREZzne1pNUbmvs7mg6t7jxeG/NFePYzmsfTQlNCn2GMlpz9CKVVpmXcF2keTUDr7z2wds0x/9Vu4dZogvwLBV/VXQkh/CcmZSYm7nFNW38FgbSSI9cBAO9gAlsjmL0DQFsKN2UyQDQWvngBBPBOTNB0AHIRJqE93KFcDUwETZUHgbO0VgnGkYB+noPY5QLcdxr69Q/8fyhcj5XoWzGebX0AYg4m7m0ogE2IE6+ClfoYFvYJAPoMgHsDXLHzAOLPYWGyYS31D2SIdbgBAroS473CNk8j0AcrhrwS507HPCxHX3cBvFng2VN41jr8tg7u/nD0cy+8Gen3+bj/MYiZZkIJjcbYToRSGGFzVd/SLEwe5ORR8GCrpjzjtNDlV9v45sKqDYLsjMa4eiC22wEFNhIy8hri0kxcuwYu91TcOwWgXgkFNQtzVx88GQN5bVbdFs6L9K/CdPe5htNSWxvL0jJ+j2Jy9Q9FdNCSIi1sMU0PW/bqFXL+uEWoRFIiMpUW9aLgxzTawrXMQV9/hGvjRD0o+BERnQ9LEeTr1FMbd0fbca8xZKB/XtTLISvdTetbokPmupOm+ZM0V7mXdm4b2zNIyxLqx70+j9TOdm1l1vB6w10nl/600WSru8P1zW2yY1ET8F9fZ0yqLIZifadJKizVucgi/RDm9S0hFKui3K8GSKoUIxZKgIX2+1pxW2TidmJcho5gqtKtXYYMGao8GcAZMmQAZ8iQAZwhQ4YM4AwZMoAzZMiQAZwhQwZwhgwZwBkyZMgAzpAhAzhDhgwZwBkyFHP0XwEGAP6q3oz31G1/AAAAAElFTkSuQmCC';
  this.img_sim_sauda_card = 'data:image/png;base64,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';
  this.doc = new jsPDF('a4');
  this.data = row;
  this.host = '';
  this.logos1 = [];
  this.showLogos1 = false;
  this.logos2 = [];
  this.showLogos2 = false;
  this.logos3 = [];
  this.showLogos3 = false;
  this.logos4 = [];
  this.showLogos4 = false;
  this.logos5 = [];
  this.showLogos5 = false;
  this.logos6 = [];
  this.showLogos6 = false;
  this.logos7 = [];
  this.showLogos7 = false;

  /**
   * Função responsável por transformar imagem de url pra base64
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @param src Recebe o caminho da imagem
   * @param callback Importante tratar em callback
   */
  this.toDataURL = function (src, callback, rotate) {
    var img = new Image();
    try {
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        var dataURL;
        canvas.height = this.height;
        canvas.width = this.width;
        if (rotate) {
          ctx.translate(canvas.width, canvas.height);
          ctx.rotate(360 * Math.PI / 360);
        }
        ctx.drawImage(this, 0, 0);
        dataURL = canvas.toDataURL();
        callback(dataURL);
      };
      img.src = src;
      if (img.complete || angular.isUndefined(img.complete)) {
        img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
        img.src = src;
      }
    } catch (e) {
      //console.log('Catch', e);
      return false;
    }
  };

  /**
   * Função responsável por codificar cada imagem anexada à apolice
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @param callback1 Necessário para saber quando terminou a codificação
   * @param callback2 Necessário para saber quando terminou a codificação
   * @param callback3 Necessário para saber quando terminou a codificação
   * @param callback4 Necessário para saber quando terminou a codificação
   * @param callback5 Necessário para saber quando terminou a codificação
   * @param callback6 Necessário para saber quando terminou a codificação
   * @param callback7 Necessário para saber quando terminou a codificação
   * @return {Array} Retorna um array de images codificadas em base 64
   */
  //this.images_to_base64 = function (callback1, callback2, callback3, callback4, callback5, callback6, callback7) {
  this.images_to_base64 = function (callback1) {
    var images = this.data.images, img1 = [];
    var image_logo1 = this.data.image_logo1, img2 = [];
    var image_logo2 = this.data.image_logo2, img3 = [];
    var image_logo3 = this.data.image_logo3, img4 = [];
    var image_cartao1 = this.data.image_cartao1, img5 = [];
    var image_cartao2 = this.data.image_cartao2, img6 = [];
    var image_apresentacao = this.data.image_apresentacao, img7 = [];

    if (typeof images !== "undefined" && images.length !== 0 && images.length) {
      images.forEach(function (image) {
        img_src = self.host + image;
        self.toDataURL(img_src, function (dataUrl) {
          img1.push(dataUrl);
          if (images.length === img1.length) {
            callback1(img1);
          }
        }, true);
      });
    }

    // if (typeof image_logo1 !== "undefined" && image_logo1.length !== 0 && image_logo1.length) {
    //   image_logo1.forEach(function (image) {
    //     img_src = self.host + image;
    //     self.toDataURL(img_src, function (dataUrl) {
    //       img2.push(dataUrl);
    //       if (image_logo1.length === img2.length) {
    //         callback2(img2);
    //       }
    //     }, true);
    //   });
    // }

    // if (typeof image_logo2 !== "undefined" && image_logo2.length !== 0 && image_logo2.length) {
    //   image_logo2.forEach(function (image) {
    //     img_src = self.host + image;
    //     self.toDataURL(img_src, function (dataUrl) {
    //       img3.push(dataUrl);
    //       if (image_logo2.length === img3.length) {
    //         callback3(img3);
    //       }
    //     }, true);
    //   });
    // }

    // if (typeof image_logo3 !== "undefined" && image_logo3.length !== 0 && image_logo3.length) {
    //   image_logo3.forEach(function (image) {
    //     img_src = self.host + image;
    //     self.toDataURL(img_src, function (dataUrl) {
    //       img4.push(dataUrl);
    //       if (image_logo3.length === img4.length) {
    //         callback4(img4);
    //       }
    //     }, true);
    //   });
    // }

    // if (typeof image_cartao1 !== "undefined" && image_cartao1.length !== 0 && image_cartao1.length) {
    //   image_cartao1.forEach(function (image) {
    //     img_src = self.host + image;
    //     self.toDataURL(img_src, function (dataUrl) {
    //       img5.push(dataUrl);
    //       if (image_cartao1.length === img5.length) {
    //         callback5(img5);
    //       }
    //     }, true);
    //   });
    // }

    // if (typeof image_cartao2 !== "undefined" && image_cartao2.length !== 0 && image_cartao2.length) {
    //   image_cartao2.forEach(function (image) {
    //     img_src = self.host + image;
    //     self.toDataURL(img_src, function (dataUrl) {
    //       img6.push(dataUrl);
    //       if (image_cartao2.length === img6.length) {
    //         callback6(img6);
    //       }
    //     }, true);
    //   });
    // }

    // if (typeof image_apresentacao !== "undefined" && image_apresentacao.length !== 0 && image_apresentacao.length) {
    //   image_apresentacao.forEach(function (image) {
    //     img_src = self.host + image;
    //     self.toDataURL(img_src, function (dataUrl) {
    //       img6.push(dataUrl);
    //       if (image_apresentacao.length === img7.length) {
    //         callback7(img7);
    //       }
    //     }, true);
    //   });
    // }
  };

  /**
   * Função responsável por inicializar a classe de apolice e gerar as imagem com base 64
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @param url_images Host com diretorio onde as imagens estão salvas
   * @param callback Necessario pois o javascript é assincrono então não da pra saber sem
   * callback pois o callback vai avisar exatamente quando terminar os encodes de imagens
   */
  this.create = function (url_images, callback) {
    self.host = url_images;
    self.images_to_base64(
      // Imagem Principal
      function (images) {
        if (images.length) {
          self.logos1 = images;
          self.showLogos1 = true;
        }
        self.toDataURL('https://gruposin.com.br/images/logo/logo.da508ba2.png',
          function (url_logo_normal) {
            self.toDataURL('https://gruposin.com.br/images/logo/logo.da508ba2.png',
              function (url_logo_invertida) {
                callback(url_logo_normal, url_logo_invertida);
              },
              true
            );
          }
        );
      }
      // Logo 1
      // function (images) {
      //   if (images.length) {
      //     self.logos2 = images;
      //     self.showLogos2 = true;
      //     aImage = images.pop;
      //     self.toDataURL(aImage,
      //       function (url_logo_normal) {
      //         self.toDataURL(aImage,
      //           function (url_logo_invertida) {
      //             callback(url_logo_normal, url_logo_invertida);
      //           },
      //           true
      //         );
      //       }
      //     );
      //   } else {
      //
      //     self.toDataURL('https://gruposin.com.br/images/logo/logo.da508ba2.png',
      //       function (url_logo_normal) {
      //         self.toDataURL('https://gruposin.com.br/images/logo/logo.da508ba2.png',
      //           function (url_logo_invertida) {
      //             callback(url_logo_normal, url_logo_invertida);
      //           },
      //           true
      //         );
      //       }
      //     );
      //   }
      // },
      // // Logo 2
      // function (images) {
      //   if (images.length) {
      //     self.logos3 = images;
      //     self.showLogos3 = true;
      //   }
      // },
      // // Logo 3
      // function (images) {
      //   if (images.length) {
      //     self.logos4 = images;
      //     self.showLogos4 = true;
      //   }
      // },
      // // Cartao 1
      // function (images) {
      //   if (images.length) {
      //     self.logos5 = images;
      //     self.showLogos5 = true;
      //   }
      // },
      // // Cartao 2
      // function (images) {
      //   if (images.length) {
      //     self.logos6 = images;
      //     self.showLogos6 = true;
      //   }
      // },
      // // Apresentacao 1
      // function (images) {
      //   if (images.length) {
      //     self.logos7 = images;
      //     self.showLogos7 = true;
      //   }
      // }
    );
  };

  /**
   * Função responsavel por mostrar as logos anexadas a apolice
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @return {boolean}
   */
  this.mostrarLogos1 = function () {
    var left_position = 0;
    if (!self.logos1.length) return false;
    self.logos1.forEach(function (image_encoded) {
      left_position += 20;
      self.doc.addImage(image_encoded, 'JPEG', left_position, 20, 79, 50);
    });
  };

  /**
   * Função responsavel por mostrar as logos anexadas a apolice
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @return {boolean}
   */
  this.mostrarLogos2 = function () {
    var left_position = 0;
    if (!self.logos2.length) return false;
    self.logos2.forEach(function (image_encoded) {
      left_position += 20;
      self.doc.addImage(image_encoded, 'JPEG', left_position, 20, 79, 50);
    });
  };

  /**
   * Função responsavel por mostrar as logos anexadas a apolice
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @return {boolean}
   */
  this.mostrarLogos3 = function (tamanho) {
    if (!self.logos3.length) return false;
    self.logos3.forEach(function (image_encoded) {
      self.doc.addImage(image_encoded, 'JPEG', 140, tamanho, 64, 25);
    });
  };

  /**
   * Função responsavel por mostrar as logos anexadas a apolice
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @return {boolean}
   */
  this.mostrarLogos4 = function () {
    if (!self.logos4.length) return false;
    self.logos4.forEach(function (image_encoded) {
      self.doc.addImage(image_encoded, 'JPEG', 0, 0, 40, 40);
    });
  };

  /**
   * Função responsavel por mostrar as logos anexadas a apolice
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @return {boolean}
   */
  this.mostrarLogos5 = function (tamanho) {
    if (!self.logos5.length) return false;
    self.logos5.forEach(function (image_encoded) {
      self.doc.addImage(image_encoded, 'JPEG', 30, tamanho, 40, 18);
    });
  };

  /**
   * Função responsavel por mostrar as logos anexadas a apolice
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @return {boolean}
   */
  this.mostrarLogos6 = function (tamanho) {
    if (!self.logos6.length) return false;
    self.logos6.forEach(function (image_encoded) {
      self.doc.addImage(image_encoded, 'JPEG', 80, tamanho, 40, 18);
    });
  };

  /**
   * Função responsavel por mostrar as logos anexadas a apolice
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @return {boolean}
   */
  this.mostrarLogos7 = function (tamanho) {
    if (!self.logos7.length) return false;
    self.logos7.forEach(function (image_encoded) {
      self.doc.addImage(image_encoded, 'JPEG', 46, tamanho, 108, 72);
    });
  };


  /**
   * Função para gerar cabeçalho
   */
  this.headerReport = function () {
    this.doc.addImage(this.logoEmpresa, 'JPEG', 20, 20, 60, 15);
  };

  /**
   * Função para gerar cabeçalho
   */
  this.headerReportFront = function () {
    this.doc.addImage(this.logoEmpresaInvertida, 'JPEG', 119, 37, 60, 15);
  };

  /**
   * Função para gerar Quadrado no jsPDF
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @param left {Number} Define a posição esquerda
   * @param top {Number} Define a posição de cima
   * @param width {Number}  Define a largura
   * @param height {Number} Define a altura
   * @returns {jsPDF} Quadrado
   */
  this.geraQuadrado = function (left, top, width, height) {
    var position_top = top + height,
      position_bot = left + width;
    return this.doc.line(left, top, left, position_top).line(position_bot, top, position_bot, position_top).line(left, position_top, position_bot, position_top).line(left, top, position_bot, top);
  };

  /**
   * Função responsável por gerar um checkbox
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @param left Define a posição esquerda
   * @param top Define a posição do topo
   * @param label Define o texto
   * @returns {jsPDF} Checkbox com label
   */
  this.checkbox_simulate = function (left, top, label) {
    this.geraQuadrado(left, top, 5, 5);
    return this.doc.text(left + 7, top + 4, label);
  };

  /**
   * Função criada para simular um input com label
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @param left Define a posição esquerda
   * @param top Define a posição do topo
   * @param width Define a largura
   * @param label Define um Texto
   * @param value Define o valor para preencher o input
   * @return {jsPDF} Retorna um fake input
   */
  this.gerarInput = function (left, top, width, label, value) {
    this.doc.setFontSize(8);
    this.doc.setFontType("bold");
    this.doc.text(left, top + 1, label);
    this.doc.setFontType("normal");
    if (value) {
      this.doc.text(left + 3, top + 1 + 5, value.toString());
    }
    return this.geraQuadrado(left, top + 2, width, 5);
  };

  /**
   * Função para centralizar um texto
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @param text Define o texto que será centralizado
   * @param y Define a posição do topo
   * @returns {jsPDF} Retorna o texto centralizado
   */
  this.centerText = function (text, y) {
    var textWidth = this.doc.getStringUnitWidth(text) * this.doc.internal.getFontSize() / this.doc.internal.scaleFactor;
    var textOffset = (this.doc.internal.pageSize.width - textWidth) / 2;
    this.doc.text(textOffset, y, text);
  };

  /**
   * Função para retornar um Date no formato dd/MM/yyyy
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @param data {Date} Recebe a data que será convertida
   * @requires $filter Diretiva do angular
   * @return {Date} Retorna a data no formato pt-BR
   */
  this.date_to_br = function (data) {
    return $filter('date')(data, 'dd/MM/yyyy');
  };

  /**
   *   Funcao para formatar real
   *   @author Ricardo Sierra <sierra.csi@gmail.com>
   *   @return {JsPDF} Object
   */
  this.formatReal = function (value, decimais) {
    decimais = decimais || 2;
    value = value.replace("R$ ", "");
    value = parseFloat(value.replace("R$", ""));
    return value.toFixed(decimais).replace(".", ",");
  };

  /**
   *   Função  par apreencher Coberturas
   *   @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   *   @modificado Ricardo Sierra <sierra.csi@gmail.com> Transformando cobertura em limite por idade, colocando R$, entre outras alteracoes
   *   @return {JsPDF} Object
   */
  this.preenche_coberturas = function (altura) {
    var data = this.data, position_y = altura + 10, left_valor = 110, left_cobertura = 25;
    this.doc.setFontSize(8);
    this.doc.setFontType("bold");
    var textExtraCobertura = '';
    if (data.coberturaAteIdade === true) {
      if (!data.coberturaAteIdadeValor) {
        data.coberturaAteIdadeValor = 70;
      }
      textExtraCobertura = ' (Até ' + data.coberturaAteIdadeValor + ' anos)';
    }
    if (data.coberturaAuxFuneralFamilia === true) {
      data.coberturaAuxFuneralFamiliaValor = (data.coberturaAuxFuneralFamiliaValor) ? data.coberturaAuxFuneralFamiliaValor : '';
      this.doc.text(left_cobertura, position_y, 'Auxilio Funeral Familiar');
      this.doc.text(left_valor, position_y, 'R$ ' + this.formatReal(data.coberturaAuxFuneralFamiliaValor) + textExtraCobertura);
      position_y += 5;
    }
    if (data.coberturaMorteAcidental === true) {
      data.coberturaMorteAcidentalValor = (data.coberturaMorteAcidentalValor) ? data.coberturaMorteAcidentalValor : '';
      this.doc.text(left_cobertura, position_y, 'Morte acidental/invalidez parcial');
      this.doc.text(left_valor, position_y, 'R$ ' + this.formatReal(data.coberturaMorteAcidentalValor) + textExtraCobertura);
      position_y += 5;
    }

    if (data.coberturaCestaBasica === true) {
      this.doc.text(left_cobertura, position_y, 'Cesta Básica/Falecimento');
      data.coberturaCestaBasicaValor = (data.coberturaCestaBasicaValor) ? 'R$ ' + this.formatReal(data.coberturaCestaBasicaValor) : '';
      this.doc.text(left_valor, position_y, data.coberturaCestaBasicaValor + textExtraCobertura + " por 1 ano");
      position_y += 5;
    }

    // Cobertura sim saude card
    var prefix = (data.coberturaSinSaudeMedicamento) ? 'com' : 'sem';
    this.doc.text(left_cobertura, position_y, 'Sin saúde card ' + prefix + ' medicamentos titular + 3 dependentes');
    var comentario = (data.coberturaSinSaudeMedicamentoComentario) ? data.coberturaSinSaudeMedicamentoComentario : '';
    var textComentario = this.doc
      .setFont('helvetica', 'neue')
      .setFontSize(8)
      .setFontType("bold")
      .splitTextToSize(comentario, 70);
    this.doc.text(textComentario, left_valor, position_y);
  };

  /**
   * Função para gerar
   */
  this.gerar = function () {
    var row = this.data;
    //Page 1
    this.headerReportFront();
    //Exibir Logos
    if (this.showLogos1) {
      this.mostrarLogos1();
    }
    var tamanho = 120;
    this.geraQuadrado(20, tamanho, 110, 40);
    this.geraQuadrado(130, tamanho, 60, 20);
    this.geraQuadrado(130, tamanho + 20, 60, 20);
    this.doc.setFontSize(9);
    tamanho = tamanho + 5;
    this.doc.text(25, tamanho, 'PARA USO DOS CORREIOS');
    this.doc.text(133, tamanho, 'Reintegrado ao serviço postal \n em:');
    tamanho = tamanho + 20; //145
    this.doc.text(133, tamanho, 'Responsável:');
    this.checkbox_simulate(25, 127, 'Mudou-se');
    this.checkbox_simulate(25, 133, 'Desconhecido');
    this.checkbox_simulate(25, 139, 'Falecido');
    this.checkbox_simulate(25, tamanho, 'Ausente');
    this.checkbox_simulate(25, 151, 'Recusado');
    this.checkbox_simulate(65, 127, 'Não encontrado');
    this.checkbox_simulate(65, 133, 'Endereço não suficiente');
    this.checkbox_simulate(65, 139, 'Não existe o nº indicado');
    this.checkbox_simulate(65, tamanho, 'Informações escritas por porteiro');

    var campoenderecopersonalizado = (row.endereco_customizado) ? row.endereco_customizado : "Grupo Sin - Av. Rio Branco, 45 - 1406 - Centro, Rio de Janeiro - RJ, 20090-003";
    this.centerText(campoenderecopersonalizado, 170);

    tamanho = tamanho + 75;
    this.geraQuadrado(20, tamanho, 175, 20);
    //this.doc.text(25, 235, 'Nome do Cliente');
    //this.doc.text(25, 240, 'Endereço');
    //Flip Layout
    tamanho = tamanho + 8; //240

    this.doc.setFontType("bold");
    this.doc.text(183, tamanho + 6, 'NOME DO CLIENTE:', null, 180);
    this.doc.setFontType("normal");
    this.doc.text(152, tamanho + 6, ' ' + this.data.client.name, null, 180);
    this.doc.setFontType("bold");
    this.doc.text(
      183,
      tamanho,
      'ENDEREÇO:',
      null,
      180
    );
    this.doc.setFontType("normal");
    this.doc.text(
      163,
      tamanho,
      ' ' + this.data.client.enderecoResidencial + ', ' + this.data.client.enderecoNumero + ', ' + this.data.client.endereComplemento + ', ' + this.data.client.bairro + ', ' + this.data.client.cidade + ', ' + this.data.client.uf + ' - ' + this.data.client.cep,
      null,
      180
    );

    /**
     * //page 2
     */
    this.doc.addPage();
    tamanho = 10;
    var campo2 = (row.campo_customizado_2) ? row.campo_customizado_2 : 'da Igreja Cristo em Casa';


    // if (this.showLogos3) {
    //   this.mostrarLogos3(tamanho);
    // } else {
    this.doc.addImage(this.imagem_cristoemcasa, 'JPEG', 140, tamanho, 64, 25);
    // }
    // if (this.showLogos4) {
    //   this.mostrarLogos4();
    // } else {
    this.doc.addImage(this.imagem_melodia, 'JPEG', 0, 0, 40, 40);
    // }

    this.doc.setFontSize(16);
    tamanho = tamanho + 10;
    this.doc.setFontType("bold");

    // BemVIndoField
    var campo_bemvindo = (row.campo_bemvindo) ? row.campo_bemvindo : 'Seja bem-vindo';
    margenParaEsquerda = 75;
    if (campo_bemvindo.length > 15) {
      margenParaEsquerda = 65;
    }
    if (campo_bemvindo.length > 20) {
      margenParaEsquerda = 60;
    }
    if (campo_bemvindo.length > 25) {
      margenParaEsquerda = 55;
    }
    if (campo_bemvindo.length > 30) {
      margenParaEsquerda = 50;
    }
    if (campo_bemvindo.length > 33) {
      margenParaEsquerda = 45;
    }
    this.doc.text(margenParaEsquerda, tamanho, campo_bemvindo);

    tamanho = tamanho + 10;
    var campo1 = (row.campo_customizado_1) ? row.campo_customizado_1 : 'Membro da Igreja Cristo em Casa!';
    this.doc.text(50, tamanho, campo1);
    this.doc.setFontSize(10);
    this.doc.setFontType("normal");

    tamanho = tamanho + 10;

    // if (this.showLogos7) {
    //   this.mostrarLogos7(tamanho);
    // } else {
    this.doc.addImage(this.imagem_familia, 'JPEG', 46, tamanho, 108, 72);
    // }

    tamanho = 120;
    this.doc.setFontSize(13);
    this.doc.setFontType("bold");
    this.doc.text(105, tamanho, 'Aproveite os beneficios de ser membro ' + campo2 + '!', "center");
    this.doc.setFontType("normal");
    this.doc.setFontSize(8);

    //inputs line 1
    tamanho = tamanho + 10;
    var position_block_line_1 = tamanho;
    this.gerarInput(20, position_block_line_1, 83, 'Estipulante', row.juridica.name);
    this.gerarInput(107, position_block_line_1, 83, 'Apólice', row.numeroApolicePersonalizado);

    //inputs line 2
    var position_block_line_2 = position_block_line_1 + 13;
    this.gerarInput(20, position_block_line_2, 83, 'Segurado Principal', row.client.name);
    this.gerarInput(107, position_block_line_2, 83, 'Subestipulante', row.vendedor.name);

    //inputs line 3
    var position_block_line_3 = position_block_line_2 + 13;
    this.gerarInput(20, position_block_line_3, 65, 'CPF', row.client.cpf);
    this.gerarInput(90, position_block_line_3, 25, 'Nascimento', this.date_to_br(row.client.dataNascimento));
    this.gerarInput(120, position_block_line_3, 35, 'Início Individual do Risco', this.date_to_br(row.inicioIndividualRisco));
    this.gerarInput(160, position_block_line_3, 30, 'Data Emissão', this.date_to_br(row.data));

    tamanho = position_block_line_3 + 9; //175

    this.doc.setFontSize(10);
    this.geraQuadrado(20, tamanho, 83, 30);
    this.doc.text(25, tamanho + 5, 'Coberturas');
    this.geraQuadrado(107, tamanho, 83, 30);
    this.doc.text(110, tamanho + 5, 'Valor');
    this.preenche_coberturas(tamanho);
    this.doc.setLineWidth(160);

    tamanho = tamanho + 33;
    this.doc.addImage(this.imagem_line, 'JPEG', 20, tamanho, 170, 2);

    this.doc.setFontType("bold");
    tamanho = tamanho + 10;
    this.doc.setFontSize(9);
    var campo_desbloqueio_cartao = (row.campo_customizado_3) ? row.campo_customizado_3 : 'Para desbloqueio do cartão ou agendamento de consultas e exames médicos com descontos ligue para';
    this.doc.text(105, tamanho, campo_desbloqueio_cartao, 'center');
    tamanho = tamanho + 4;
    var campo_central_atendimento = (row.campo_customizado_4) ? row.campo_customizado_4 : 'Central de Atendimento no número (21)2263-9325 ou (21)3176-6301';
    this.doc.text(105, tamanho, campo_central_atendimento, 'center');
    tamanho = tamanho + 5;


    this.doc.addImage(this.imagem_line, 'JPEG', 20, tamanho, 170, 2);


    tamanho = tamanho + 6;
    this.doc.setFontSize(9);
    var campo_auxilio_funeral = (row.leia_me) ? row.leia_me : 'Para acionar seu seguro  ou auxílio funeral (até 70anos) ligue 0800551640';
    this.doc.text(105, tamanho, campo_auxilio_funeral, 'center');
    tamanho = tamanho + 4;
    var campo_nao_somos_plano = (row.campo_customizado_5) ? row.campo_customizado_5 : 'Não somos plano de saúde. Não cobrimos emergência.';
    this.doc.text(105, tamanho, campo_nao_somos_plano, 'center');


    this.doc.setFontSize(10);
    this.doc.setFontType("bold");
    tamanho = tamanho + 8;
    this.doc.addImage(this.card, 'JPEG', 110, tamanho, 100, 45);


    tamanho = tamanho + 4;
    var campo_final = (row.termos) ? row.termos : 'Para descontos em medicamentos verifique as farmácias credenciadas em nosso site www.cristoemcasa.com.br. Após verificação, procure a farmácia credenciada mais próxima de você, apresente o VERSO DO SEU CARTÃO E MOSTRE A LOGO:';
    var textLines = this.doc
      .setFont('helvetica', 'neue')
      .setFontSize(10)
      .setFontType("bold")
      .splitTextToSize(campo_final, 100);
    this.doc.text(textLines, 20, tamanho);
    this.doc.setFontType("normal");


    tamanho = tamanho + 15;

    // if (this.showLogos5) {
    //   this.mostrarLogos5(tamanho);
    // } else {
    this.doc.addImage(this.img_efarma, 'JPEG', 30, tamanho, 40, 18);
    // }

    // if (this.showLogos6) {
    //   this.mostrarLogos6(tamanho);
    // } else {
    this.doc.addImage(this.img_sim_sauda_card, 'JPEG', 80, tamanho, 40, 18);
    // }

    tamanho = tamanho + 21;
    this.doc.setFontSize(8);
    var campo_final_adicional = (row.termos_adicional) ? row.termos_adicional : '*Auxílio funeral familiar, cesta básica falecimento e seguro morte acidental/invalidez,válidos apenas para dependentes sendo filhos ou cônjuge.';
    var textLines2 = this.doc
      .setFont('helvetica', 'neue')
      .setFontSize(6)
      .setFontType("bold")
      .splitTextToSize(campo_final_adicional, 100);
    this.doc.text(textLines2, 20, tamanho);


    this.print();
    this.save();
  };

  /**
   * Função para chamar o imprimir do navegador
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   */
  this.print = function () {
    return this.doc.autoPrint();
  };

  /**
   * Efetua o Download do PDF criado
   * @author Ricardo Sierra <ricardo@sierratecnologia.com.br>
   * @return {jsPDF} Document
   */
  this.save = function () {
    return this.doc.save('apolice' + this.data.client.name + '.pdf');
  }
}

(function () {
    'use strict';


    angular
        .module('gruposinAdmin')
        .controller('ApoliceController', ApoliceController)
        .factory('ApoliceService', function ($resource, endpoint) {
            return $resource(endpoint + 'apolice/:id', {id: '@id'}, {
                update: {
                    method: 'PUT'
                }
            });
        });


    /** @ngInject */
    function ApoliceController(AuthenticationFactory, $scope, toastr, $mdToast, url_upload, url_images, ApoliceService, uiGridConstants, $mdDialog, uiGridExporterService, uiGridExporterConstants, ClientService, JuridicaService, UserService, $document, $filter) {

        var API = ApoliceService;
        var vm = this;

        vm.toggleFiltering = function () {
            vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
            vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        };

        // Exporta o Grid em Excel
        vm.exportExcel = function (router) {
            AuthenticationFactory.exportReport(router);
        };
        vm.exportCsv = function () {
            var exportService = uiGridExporterService;
            var grid = vm.gridApi.grid;
            var fileName = 'Apolices.csv';

            exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function () {
                var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

                var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
                var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
                exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
            });
        };

        vm.remove = function (ev, item) {
            if (confirm("Deseja realmente remover?")) {
                var data = vm.gridOptions.data;

                API.delete({id: item._id}, function () {
                    var index = data.indexOf(item);
                    data.splice(index, 1);
                });
            }
        };

        vm.gerarPDF = function (ev, row) {
          if(!row.images.length){
            toastr.error('Nao foi encontrado imagens dentro desta apolice!');
            return false;
          }
          var apolice = new Relatorio(row, $filter);
          apolice.create(url_images, function (url_encoded, url_encoded_invertida) {
              apolice.logoEmpresa = url_encoded;
              apolice.logoEmpresaInvertida = url_encoded_invertida;
              apolice.gerar();
          });
        };

        vm.edit = function (ev, item) {


            $mdDialog.show({
                controller: function (ClientService, JuridicaService, UserService, AuthenticationFactory, $scope, url_upload, url_images, $timeout) {

                    var vm = this;

                    var profile = AuthenticationFactory.profile;
                    var role = (profile.user.role);
                    var _id = (profile.user._id);
                    var rolesVendedor = {
                        role: 'Vendedor'
                    };

                    var objFilterVendedor = {};

                    if (role === 'Vendedor') {
                        objFilterVendedor = {
                            vendedor: _id
                        };

                        rolesVendedor._id = _id
                    }

                    vm.form = {
                        coberturaMorteAcidentalValor: 5000
                    };

                    if (item) {
                        var obj = angular.copy(item);
                        vm.form = obj;
                        vm.form.data = new Date(obj.data);
                        vm.form.inicioIndividualRisco = new Date(obj.inicioIndividualRisco);
                        vm.selectedItemCliente = obj.client;
                        vm.selectedItemEmpresa = obj.juridica;
                        vm.selectedItem = obj.vendedor;
                        if (vm.form.images.length) {
                            $timeout(
                                function () {
                                    angular.forEach(vm.form.images, function (item) {
                                        $scope.api.addRemoteFile(url_images + item, item, 'image');
                                    })
                                }
                            );
                        }
                    }

                    // carrega a lista de clientes pf
                    ClientService.query(objFilterVendedor).$promise.then(function (resp) {
                        vm.clientes = resp;
                    });

                    // carrega a lista de empresas
                    JuridicaService.query(objFilterVendedor).$promise.then(function (resp) {
                        vm.juridica = resp;
                    });

                    // carrega a lista de vendedores
                    UserService.query(rolesVendedor).$promise.then(function (resp) {
                        vm.vendedores = resp;
                    });
                    // clientes
                    vm.searchTextChangeCliente = function () {
                    };
                    vm.selectedItemChangeCliente = function (company) {
                        if (company) {


                            if (company.vendedor) {
                                vm.selectedItem = company.vendedor;
                                vm.form.vendedor = company.vendedor;
                            } else {
                                vm.selectedItem = null;
                                vm.form.vendedor = null;
                            }

                            vm.form.client = company;
                            vm.form.client.dataNascimento = new Date(company.dataNascimento);

                        } else {
                            vm.form.client = null;
                            vm.form.vendedor = null;
                        }

                    };
                    vm.searchCompanyCliente = function (search) {
                        return vm.clientes.filter(function (item) {
                            return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || item.cpf.toUpperCase().indexOf(search.toUpperCase()) >= 0;
                        });
                    };


                    // vendedor
                    vm.searchTextChange = function () {
                    };
                    vm.selectedItemChange = function (company) {
                        if (company) {
                            vm.form.vendedor = company;
                        } else {
                            vm.form.vendedor = null;
                        }

                    };
                    vm.searchCompany = function (search) {
                        return vm.vendedores.filter(function (item) {
                            return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || (item.cpf && item.cpf.toUpperCase().indexOf(search.toUpperCase()) >= 0);
                        });
                    };


                    // empresa
                    vm.searchTextChangeEmpresa = function () {
                    };
                    vm.selectedItemChangeEmpresa = function (company) {
                        if (company) {
                            vm.form.juridica = company;
                        } else {
                            vm.form.juridica = null;
                        }

                    };
                    vm.searchCompanyEmpresa = function (search) {
                        return vm.juridica.filter(function (item) {
                            return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0 || item.cnpj.toUpperCase().indexOf(search.toUpperCase()) >= 0;
                        });
                    };


                    vm.refresh = function () {
                        getPage();
                        vm.hide();
                    };

                    vm.hide = function () {
                        $mdDialog.hide();
                    };

                    vm.cancel = function () {
                        $mdDialog.cancel();
                    };

                    vm.upload = function (file) {
                      var xhr = new XMLHttpRequest();
                      var fd = new FormData();
                      xhr.open("POST", url_upload, true);
                      xhr.onreadystatechange = function () {
                        if (xhr.readyState == 4 && xhr.status == 200) {
                          vm.form.images.push(xhr.response);
                          vm.force_save();
                        }
                      };
                      fd.append('uploaded_file', file);
                      xhr.send(fd);
                    };

                    // vm.uploadLogo1 = function (fileslogo1) {
                    //   var xhr = new XMLHttpRequest();
                    //   var fd = new FormData();
                    //   xhr.open("POST", url_upload, true);
                    //   xhr.onreadystatechange = function () {
                    //     if (xhr.readyState == 4 && xhr.status == 200) {
                    //       vm.form.image_logo1.push(xhr.response);
                    //       vm.force_save();
                    //     }
                    //   };
                    //   console.log('1',fileslogo1);
                    //   fd.append('uploaded_file', fileslogo1);
                    //   xhr.send(fd);
                    // };

                    // vm.uploadLogo2 = function (fileslogo2) {
                    //   var xhr = new XMLHttpRequest();
                    //   var fd = new FormData();
                    //   xhr.open("POST", url_upload, true);
                    //   xhr.onreadystatechange = function () {
                    //     if (xhr.readyState == 4 && xhr.status == 200) {
                    //       vm.form.image_logo2.push(xhr.response);
                    //       vm.force_save();
                    //     }
                    //   };
                    //   console.log('2',fileslogo2);
                    //   fd.append('uploaded_file', fileslogo2);
                    //   xhr.send(fd);
                    // };

                    // vm.uploadLogo3 = function (fileslogo3) {
                    //   var xhr = new XMLHttpRequest();
                    //   var fd = new FormData();
                    //   xhr.open("POST", url_upload, true);
                    //   xhr.onreadystatechange = function () {
                    //     if (xhr.readyState == 4 && xhr.status == 200) {
                    //       vm.form.image_logo3.push(xhr.response);
                    //       vm.force_save();
                    //     }
                    //   };
                    //   fd.append('uploaded_file', fileslogo3);
                    //   xhr.send(fd);
                    // };

                    // vm.uploadCartao1 = function (filescartao1) {
                    //   var xhr = new XMLHttpRequest();
                    //   var fd = new FormData();
                    //   xhr.open("POST", url_upload, true);
                    //   xhr.onreadystatechange = function () {
                    //     if (xhr.readyState == 4 && xhr.status == 200) {
                    //       vm.form.image_cartao1.push(xhr.response);
                    //       vm.force_save();
                    //     }
                    //   };
                    //   console.log('3',filescartao1);
                    //   fd.append('uploaded_file', filescartao1);
                    //   xhr.send(fd);
                    // };

                    // vm.uploadCartao2 = function (filescartao2) {
                    //   var xhr = new XMLHttpRequest();
                    //   var fd = new FormData();
                    //   xhr.open("POST", url_upload, true);
                    //   xhr.onreadystatechange = function () {
                    //     if (xhr.readyState == 4 && xhr.status == 200) {
                    //       vm.form.image_cartao2.push(xhr.response);
                    //       vm.force_save();
                    //     }
                    //   };
                    //   fd.append('uploaded_file', filescartao2);
                    //   xhr.send(fd);
                    // };

                    // vm.uploadApresentacao = function (filesapresentacao) {
                    //   var xhr = new XMLHttpRequest();
                    //   var fd = new FormData();
                    //   xhr.open("POST", url_upload, true);
                    //   xhr.onreadystatechange = function () {
                    //     if (xhr.readyState == 4 && xhr.status == 200) {
                    //       vm.form.image_apresentacao.push(xhr.response);
                    //       vm.force_save();
                    //     }
                    //   };
                    //   fd.append('uploaded_file', filesapresentacao);
                    //   xhr.send(fd);
                    // };



                    vm.save = function () {
                        vm.form.images = [];
                        vm.form.image_logo1 = [];
                        vm.form.image_logo2 = [];
                        vm.form.image_logo3 = [];
                        vm.form.image_cartao1 = [];
                        vm.form.image_cartao2 = [];
                        vm.form.image_apresentacao = [];
                        if ($scope.files.length) {
                          for (var cont1 = 0; cont1 < $scope.files.length; cont1++) {
                            if ($scope.files[cont1].isRemote) {
                              vm.form.images.push($scope.files[cont1].lfFileName);
                              vm.force_save();
                            } else {
                              vm.upload($scope.files[cont1].lfFile);
                            }
                          }
                        }else{
                          vm.force_save();
                        }

                        // if ($scope.fileslogo1.length) {
                        //   for (var cont2 = 0; cont2 < $scope.fileslogo1.length; cont2++) {
                        //     if ($scope.fileslogo1[cont2].isRemote) {
                        //       vm.form.image_logo1.push($scope.fileslogo1[cont2].lfFileName);
                        //       vm.force_save();
                        //     } else {
                        //       vm.uploadLogo1($scope.fileslogo1[cont2].lfFile);
                        //     }
                        //   }
                        // }else{
                        //   vm.force_save();
                        // }

                        // if ($scope.fileslogo2.length) {
                        //   for (var cont3 = 0; cont3 < $scope.fileslogo2.length; cont3++) {
                        //     if ($scope.fileslogo2[cont3].isRemote) {
                        //       vm.form.image_logo2.push($scope.fileslogo2[cont3].lfFileName);
                        //       vm.force_save();
                        //     } else {
                        //       vm.uploadLogo2($scope.fileslogo2[cont3].lfFile);
                        //     }
                        //   }
                        // }else{
                        //   vm.force_save();
                        // }

                        // if ($scope.fileslogo3.length) {
                        //   for (var cont4 = 0; cont4 < $scope.fileslogo3.length; cont4++) {
                        //     if ($scope.fileslogo3[cont4].isRemote) {
                        //       vm.form.image_logo3.push($scope.fileslogo3[cont4].lfFileName);
                        //       vm.force_save();
                        //     } else {
                        //       vm.uploadLogo3($scope.fileslogo3[cont4].lfFile);
                        //     }
                        //   }
                        // }else{
                        //   vm.force_save();
                        // }

                        // if ($scope.filescartao1.length) {
                        //   for (var cont5 = 0; cont5 < $scope.filescartao1.length; cont5++) {
                        //     if ($scope.filescartao1[cont5].isRemote) {
                        //       vm.form.image_cartao1.push($scope.filescartao1[cont5].lfFileName);
                        //       vm.force_save();
                        //     } else {
                        //       vm.uploadCartao1($scope.filescartao1[cont5].lfFile);
                        //     }
                        //   }
                        // }else{
                        //   vm.force_save();
                        // }

                        // if ($scope.filescartao2.length) {
                        //   for (var cont6 = 0; cont6 < $scope.filescartao2.length; cont6++) {
                        //     if ($scope.filescartao2[cont6].isRemote) {
                        //       vm.form.image_cartao2.push($scope.filescartao2[cont6].lfFileName);
                        //       vm.force_save();
                        //     } else {
                        //       vm.uploadCartao2($scope.filescartao2[cont6].lfFile);
                        //     }
                        //   }
                        // }else{
                        //   vm.force_save();
                        // }

                        // if ($scope.filesapresentacao.length) {
                        //   for (var cont7 = 0; cont7 < $scope.filesapresentacao.length; cont7++) {
                        //     if ($scope.filesapresentacao[cont7].isRemote) {
                        //       vm.form.image_apresentacao.push($scope.filesapresentacao[cont7].lfFileName);
                        //       vm.force_save();
                        //     } else {
                        //       vm.uploadApresentacao($scope.filesapresentacao[cont7].lfFile);
                        //     }
                        //   }
                        // }else{
                        //   vm.force_save();
                        // }
                    };

                    vm.force_save = function () {
                        if (
                          vm.form.images.length === $scope.files.length// &&
                          // vm.form.image_logo1.length === $scope.fileslogo1.length &&
                          // vm.form.image_logo2.length === $scope.fileslogo2.length &&
                          // vm.form.image_logo3.length === $scope.fileslogo3.length &&
                          // vm.form.image_cartao1.length === $scope.filescartao1.length &&
                          // vm.form.image_cartao2.length === $scope.filescartao2.length &&
                          // vm.form.image_apresentacao.length === $scope.filesapresentacao.length
                        ) {
                            if (vm.form._id) {
                                API.update({id: vm.form._id}, vm.form, vm.refresh);
                            } else {
                                API.save(vm.form, vm.refresh);
                            }
                        }
                    }
                },
                controllerAs: 'ctrl',
                templateUrl: 'app/apolice/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true
            });
        };

        vm.gridOptions = {
            appScopeProvider : vm,
            enableFiltering: false,
            enableHorizontalScrollbar: true,
            fastWatch: true,
            paginationPageSizes: [15, 25, 40, 50, 100],
            paginationPageSize: 15,
            columnDefs: [
                {
                    name: 'createdAt',
                    enableSorting: true,
                    displayName: 'Data Cadastro',
                    width: 120,
                    type: 'date',
                    cellFilter: 'date:\'dd/MM/yyyy\'',
                    filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
                    filters: [{
                        filterName: 'maiorQue',
                        condition: function (searchTerm, cellValue) {

                            var search = new Date(searchTerm);
                            var cValue = new Date(cellValue);

                            return cValue.getTime() > search.getTime()
                        }
                    },
                        {
                            filterName: 'menorQue',
                            condition: function (searchTerm, cellValue) {

                                var search = new Date(searchTerm);
                                var cValue = new Date(cellValue);

                                return cValue.getTime() < search.getTime()
                            }
                        }]
                },
                {name: 'client.name', enableSorting: true, displayName: 'Nome', width: 200},
                {name: 'client.cpf', enableSorting: true, displayName: 'Documento', width: 150},
                {name: 'juridica.name', enableSorting: true, displayName: 'Estipulante', width: 200},
                {name: 'vendedor.name', enableSorting: true, displayName: 'Subestipulante', width: 200},
                {
                    name: 'view',
                    enableColumnResizing: false,
                    pinnedRight: true,
                    width: 50,
                    enableFiltering: false,
                    enableSorting: false,
                    displayName: '',
                    enableColumnMenu: false,
                    cellClass: function () {
                        return 'text-center';
                    },
                    cellTemplate: '<i class="material-icons btn-icon" permission="btnPdfApolice" module="apolice" ng-click="grid.appScope.gerarPDF($event, row.entity)">print</i>'
                },
                {
                    name: 'edit',
                    enableColumnResizing: false,
                    pinnedRight: true,
                    width: 50,
                    enableFiltering: false,
                    enableSorting: false,
                    displayName: '',
                    enableColumnMenu: false,
                    cellClass: function () {
                        return 'text-center';
                    },
                    cellTemplate: '<i class="material-icons btn-icon" permission="btnEditApolice" module="apolice" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'
                },
                {
                    name: 'remove',
                    enableColumnResizing: false,
                    pinnedRight: true,
                    width: 50,
                    enableFiltering: false,
                    enableSorting: false,
                    displayName: '',
                    enableColumnMenu: false,
                    cellClass: function () {
                        return 'text-center';
                    },
                    cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteApolice" module="apolice" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'
                }
            ],
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
            }
        };

        vm.loading = true;
        var getPage = function () {

            API.query({}).$promise.then(function (resp) {
                vm.gridOptions.data = resp;
                vm.loading = false;
            });

        };

        getPage();
    }

})();

(function() {
  'use strict';


  angular
    .module('gruposinAdmin')
    .controller('AgendamentoController', AgendamentoController)
    .factory('AgendamentoService', function ($resource, endpoint) {
      return $resource(endpoint + 'agendamento/:id?populate=rede cliente', {id: '@id'}, {
        'update':{ method:'PUT' }
      });
  });


  /** @ngInject */
  function AgendamentoController($timeout, url_upload,url_images, toastr, AgendamentoService, $scope, $http, uiGridConstants, $mdDialog, ClientService, RedeService, AuthenticationFactory, uiGridExporterService, uiGridExporterConstants, $window, $document) {

    var API = AgendamentoService;
    var vm = this;

    vm.toggleFiltering = function(){
      vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
      vm.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
    };

    vm.exportExcel = function(router){
      AuthenticationFactory.exportReport(router);
    };

    vm.remove = function(ev, item){
      if(confirm("Deseja realmente remover?")){
        var data = vm.gridOptions.data;

        API.delete({id: item._id}, function(){
          var index = data.indexOf(item);
          data.splice(index, 1);
        });
      }
    };

    vm.dateValidate = function(grid, row){
      return  $window.moment(row.entity.createdAt).add(row.entity.dataAgendamento).format('DD/MM/YYYY HH:mm:ss');
    };

    vm.exportCsv = function(){
      var exportService=uiGridExporterService;
      var grid=vm.gridApi.grid;
      var fileName= 'Agendamentos.csv';

      exportService.loadAllDataIfNeeded(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL).then(function() {
        var exportColumnHeaders = exportService.getColumnHeaders(grid, uiGridExporterConstants.ALL);

        var exportData = exportService.getData(grid, uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        var csvContent = exportService.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
        exportService.downloadFile(fileName, csvContent, grid.options.exporterOlderExcelCompatibility);
      });
    };

    vm.edit = function(ev, item) {

        $mdDialog.show({
                controller: function(url_upload, url_images, $scope, $http, $window, php_host) {
                  var obj = {};
                  var today = new Date();
                  obj.dataAgendamento = $window.moment(today).toDate();

                  if(item){
                    obj = item;
                    obj.dataAgendamento = $window.moment(obj.dataAgendamento).toDate(); //new Date(item.dataNascimento);
                    obj.dataAtendimento = $window.moment(obj.dataAtendimento).toDate(); //new Date(item.dataNascimento);
                    if(obj.anexos.length) {
                        $timeout(
                            function () {
                                angular.forEach(obj.anexos, function (item) {
                                    $scope.api.addRemoteFile(url_images + item, item, 'other');
                                })
                            }
                        );
                    }
                  }

                  var vm = this;
                  vm.form = angular.copy(obj);
                  if(vm.form.rede){
                    vm.selectedItemRede = vm.form.rede;
                  }
                  if(vm.form.cliente){
                    vm.selectedItemCliente = vm.form.cliente;
                  }


                  //Carrega Redes de acordo com a query
                  vm.redes = RedeService.query();
                  //Carrega os clientes de acordo com a query
                  vm.clientes = ClientService.query();

                  vm.searchTextChangeRede = function() {};

                  vm.searchTextChangeCliente = function() {};

                  vm.searchRede = function(search) {
                    return vm.redes.filter(function(item) {
                      return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0;
                    });
                  };

                  vm.searchCliente = function(search) {
                    return vm.clientes.filter(function(item) {
                      return item.name.toUpperCase().indexOf(search.toUpperCase()) >= 0;
                    });
                  };

                  vm.selectedItemChangeRede = function(item) {
                    if(item){
                        vm.form.rede = item._id;
                    }
                  };
                  vm.selectedItemChangeCliente = function(item) {
                    if(item){
                        vm.form.cliente = item._id;
                        vm.cliente = item;
                    }
                  };

                  vm.refresh = function(){
                    getPage();
                    vm.hide();
                  };

                  vm.hide = function() {
                    $mdDialog.hide();
                  };

                  vm.cancel = function() {
                    $mdDialog.cancel();
                  };

                  vm.upload = function (file) {
                    var xhr = new XMLHttpRequest();
                    var fd = new FormData();
                    xhr.open("POST", url_upload, true);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState == 4 && xhr.status == 200) {
                            vm.form.anexos.push(xhr.response);
                            vm.force_save();
                        }
                    };
                    fd.append('uploaded_file', file);
                    xhr.send(fd);
                  };

                  vm.onFileClick = function(obj){
                    $window.open(obj.lfDataUrl);
                  };

                  vm.save = function () {
                    vm.form.anexos = [];
                    if ($scope.files.length) {
                        for (var i = 0; i < $scope.files.length; i++) {
                            if ($scope.files[i].isRemote) {
                                vm.form.anexos.push($scope.files[i].lfFileName);
                                vm.force_save();
                            } else {
                                vm.upload($scope.files[i].lfFile);
                            }
                        }
                    }else{
                      vm.force_save();
                    }
                  };

                  vm.force_save = function () {
                    if (vm.form.anexos.length === $scope.files.length) {
                        if (vm.form._id) {
                            API.update({id: vm.form._id}, vm.form, vm.refresh);
                        } else {
                            API.save(vm.form, vm.enviosEAtualiza);
                        }
                    }
                  };


                  /**
                   *   Funcao para formatar real
                   *   @author Ricardo Sierra <sierra.csi@gmail.com>
                   *   @return {JsPDF} Object
                   */
                  vm.formatReal = function (value, decimais) {

                    decimais = decimais || 2;
                    var mi = value.length - parseInt(decimais);
                    var sm = parseInt(mi / 3);
                    var regx = "", repl = "";
                    //console.log(value);
                    var newvalue = new String(value);
                    //console.log(newvalue);
                    newvalue = newvalue.replace("R$ ", "").replace("R$", "");
                    //console.log(newvalue);

                    for (var i = 0; i < sm; i++) {
                      regx = regx.concat('([0-9]{3})');
                      repl = repl.concat('.$' + (i + 1));
                    }

                    regx = regx.concat('([0-9]{' + decimais + '})') + "$";
                    repl = repl.concat(',$' + (sm + 1));
                    newvalue = newvalue.toString().replace(new RegExp(regx, 'g'), repl);
                    //console.log(newvalue);
                    return (mi % 3) === 0 ? newvalue.substr(1) : newvalue;
                  };

                  vm.enviosEAtualiza = function(){
                      if (vm.form.envioEmail && vm.cliente.email) {
                        if(!vm.cliente.email){
                          toastr.success('Erro ao enviar o email, o cliente nao possui email cadastrado');
                        }else{
                          var url = php_host + "notification/send.php";

                          var telefoneCliente = vm.cliente.telefoneCelular.toString();
                          var telefoneCliente2 = vm.cliente.telefoneFixo.toString();

                          telefoneCliente = telefoneCliente.replace(/D/g,"");             //Remove tudo o que não é dígito
                          telefoneCliente = telefoneCliente.replace(/^(\d\d)(\d)/g,"($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
                          //telefoneCliente = telefoneCliente.replace(/(\d{4})(\d)/,"$1-$2");

                          telefoneCliente2 = telefoneCliente2.replace(/D/g,"");             //Remove tudo o que não é dígito
                          telefoneCliente2 = telefoneCliente2.replace(/^(\d\d)(\d)/g,"($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
                          //telefoneCliente2 = telefoneCliente2.replace(/(\d{4})(\d)/,"$1-$2");

                          var valorCliente = vm.form.valor.toString();
                          valorCliente = parseFloat(valorCliente.replace("R$", ""));
                          valorCliente = 'R$ '+valorCliente.toFixed(2).replace(".",",");

                          var message = ""+
                            "<tr><td>"+vm.form.messageEmail+"</td></tr>"+
                            "<tr><td><strong>Nome do Paciente:</strong> </td><td>"+vm.cliente.name+"</td></tr>"+
                            "<tr><td><strong>Cpf do Paciente:</strong> </td><td>"+vm.cliente.cpf+"</td></tr>"+
                            "<tr><td><strong>Telefone do Paciente:</strong> </td><td>"+telefoneCliente+" / "+telefoneCliente2+"</td></tr>"+
                            "<tr><td><strong>Data de Nascimento do Paciente:</strong> </td><td>"+$window.moment(vm.cliente.dataNascimento).format("DD/MM/YYYY")+"</td></tr>"+
                            "<tr><td><strong>Data do Agendamento:</strong> </td><td>"+$window.moment(vm.form.dataAgendamento).format("DD/MM/YYYY")+"</td></tr>"+
                            "<tr><td><strong>Local de Atendimento:</strong> </td><td>"+vm.form.local+"</td></tr>"+
                            "<tr><td><strong>Atendente:</strong> </td><td>"+vm.form.atendente+"</td></tr>"+
                            "<tr><td><strong>Valor:</strong> </td><td>"+valorCliente+"</td></tr>"+
                            "<tr><td><strong>Observações:</strong> </td><td>"+vm.form.outros+"</td></tr>"+
                          "";
                          var data_message_email = {
                              tipo: "email",
                              name: vm.cliente.name,
                              email: vm.cliente.email,
                              image: vm.form.anexos,
                              dataAgendamento: $window.moment(vm.form.dataAgendamento).format("DD/MM/YYYY"),
                              message: message
                          };
                          $http({
                            url:url,
                            data: data_message_email,
                            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                            method:'POST'}
                          ).then(
                            function(){
                              toastr.success('Email enviado com sucesso');
                            }
                          );
                        }
                      }

                      if (vm.form.envioSMS) {
                        if(!vm.cliente.telefoneCelular){
                          toastr.success('Erro ao enviar o SMS, o cliente nao possui numero cadastrado');
                        }else{
                          var data_message_sms = {
                              tipo: "sms",
                              name: vm.cliente.name,
                              telefone: vm.cliente.telefoneCelular,
                              dataAgendamento: $window.moment(vm.form.dataAgendamento).format("DD/MM/YYYY"),
                              message: vm.form.messageSMS
                          };
                          $http.post( php_host + "notification/send.php", data_message_sms ).then(
                            function(resp){
                              toastr.success(resp.data.msg);
                            },
                            function(err){
                              toastr.danger(err.data.msg);
                            }
                          );
                        }
                      }

                      vm.refresh();
                    }
                },
                controllerAs:'ctrl',
                templateUrl: 'app/agendamento/dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.show = function(ev, item) {

        $mdDialog.show({
                controller: function($scope, $http, $window, php_host, $httpParamSerializerJQLike) {
                  var obj = {};
                  var today = new Date();
                  obj.dataAgendamento = $window.moment(today).toDate();

                  if(item){
                    obj = item;
                    obj.dataAgendamento = $window.moment(obj.dataAgendamento).toDate(); //new Date(item.dataNascimento);
                    obj.dataAtendimento = $window.moment(obj.dataAtendimento).toDate(); //new Date(item.dataNascimento);
                  }

                  var vm = this;
                  vm.form = angular.copy(obj);
                  if(vm.form.rede){
                    vm.selectedItemRede = vm.form.rede;
                  }
                  if(vm.form.cliente){
                    vm.selectedItemCliente = vm.form.cliente;
                  }


                  //Carrega Redes de acordo com a query
                  vm.redes = RedeService.query();
                  //Carrega os clientes de acordo com a query
                  vm.clientes = ClientService.query();

                  vm.searchTextChangeRede = function() {};

                  vm.searchTextChangeCliente = function() {};

                  vm.cancel = function() {
                    $mdDialog.cancel();
                  }
                },
                controllerAs:'ctrl',
                templateUrl: 'app/agendamento/view.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true
        });
    };

    vm.gridOptions = {
      appScopeProvider : vm,
      enableFiltering: false,
      enableHorizontalScrollbar: true,
      fastWatch: true,
      paginationPageSizes: [15, 25, 40, 50, 100],
      paginationPageSize: 15,
      columnDefs: [
        {

          name: 'createdAt', enableSorting: true, displayName: 'Data Cadastro', width: 170, type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'', filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="date" ng-model="colFilter.term" style="font-size:12px"/></div>',
          filters: [{
            // condition: uiGridConstants.filter.GREATER_THAN
            filterName: 'maiorQue',
            condition: function(searchTerm, cellValue) {

              var search = new Date(searchTerm);
              var cValue = new Date(cellValue);

              return cValue.getTime() > search.getTime()
              // var data = searchTerm.split('/');
              // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
              // return strippedValue.indexOf(searchTerm) >= 0;
            }},
            {
              // condition: uiGridConstants.filter.GREATER_THAN
              filterName: 'menorQue',
              condition: function(searchTerm, cellValue) {

                var search = new Date(searchTerm);
                var cValue = new Date(cellValue);

                return cValue.getTime() < search.getTime()
                // var data = searchTerm.split('/');
                // var strippedValue = (cellValue + '').replace(/[^\d]/g, '');
                // return strippedValue.indexOf(searchTerm) >= 0;
              }
            }]
        },
        { name: 'cliente.name', enableSorting: true, displayName: 'Cliente', width: 200,  cellClass: function(){ return 'text-left'; }, cellTemplate: '<div class="ui-grid-cell-contents" style="cursor:pointer;" permission="btnEditAgendamento" module="agendamento" ng-click="grid.appScope.show($event, row.entity)">{{row.entity.cliente.name}}</div>'},
        { name: 'rede.name', enableSorting: true, displayName: 'Prestador', width: 250 },
        { name: 'dataAgendamento', enableSorting: true, displayName: 'Data Agendamento', type: 'date', width: 140, cellFilter: 'date:\'dd/MM/yyyy\'' },
        { name: 'valor', enableSorting: true, displayName: 'Valor', cellFilter: "currency", width: 170 },
        { name: 'local', enableSorting: true, displayName: 'Local de Atendimento', cellFilter: "currency", width: 300 },
        { name: 'edit', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnEditAgendamento" module="agendamento" ng-click="grid.appScope.edit($event, row.entity)">edit</i>'},
        { name: 'remove', enableColumnResizing: false,  pinnedRight:true, width: 50, enableFiltering: false, enableSorting: false, displayName: '', enableColumnMenu: false, cellClass: function(){ return 'text-center'; }, cellTemplate: '<i class="material-icons btn-icon" permission="btnDeleteAgendamento" module="agendamento" ng-click="grid.appScope.remove($event, row.entity)">remove_circle</i>'}
      ],
      onRegisterApi: function(gridApi) {
        vm.gridApi = gridApi;
      }
    };

    vm.loading = true;
    var getPage = function() {

     API.query({}).$promise.then(function(resp){
        vm.gridOptions.data = resp;
        vm.loading = false;
      });
    };

    getPage();
  }

})();

(function() {
  'use strict';

  angular
    .module('gruposinAdmin')
    .run(function($rootScope, $window, $location, AuthenticationFactory) {
      AuthenticationFactory.check();
     
      var destroyStateChangeStart = $rootScope.$on("$stateChangeStart", function(event, nextRoute) {
        if ((nextRoute.access && nextRoute.access.requiredLogin) && !AuthenticationFactory.isLogged) {
          $location.path("/login");
        } else {
          if (!AuthenticationFactory.user) AuthenticationFactory.user = $window.sessionStorage.user;
          if (!AuthenticationFactory.userRole) AuthenticationFactory.userRole = $window.sessionStorage.userRole;
          if($window.sessionStorage.permission){
            if (!AuthenticationFactory.permission) AuthenticationFactory.permission = (angular.fromJson($window.sessionStorage.permission) || []);
          }

          if (!AuthenticationFactory.profile){
            if($window.sessionStorage.profile){
             AuthenticationFactory.profile = (angular.fromJson($window.sessionStorage.profile) || {});
            }
          }
        }
      });
     
      var destroyStateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function() {
        $rootScope.showMenu = AuthenticationFactory.isLogged;
        $rootScope.role = AuthenticationFactory.userRole;
        $rootScope.permission = AuthenticationFactory.permission;

        if (AuthenticationFactory.isLogged == true && $location.path() == '/login') {
          $location.path('/');
        }
      });

      $rootScope.$on('$destroy', destroyStateChangeStart);
      $rootScope.$on('$destroy', destroyStateChangeSuccess);

    });

})();
(function () {
  'use strict';

  angular
    .module('gruposinAdmin')
    .config(routerConfig)
    .factory('AuthenticationFactory', function ($window, $http, $rootScope, endpoint) {

      var auth = {
        isLogged: false,
        permission: [],
        profile: null,
        check: function () {
          if ($window.sessionStorage.token && $window.sessionStorage.user) {
            this.permission = angular.fromJson($window.sessionStorage.permission);
            this.isLogged = true;
          } else {
            this.isLogged = false;
            delete this.user;
          }
        },

        verifyPermission: function (module, action) {

          if ($window.sessionStorage.userRole === 'Administrador') {
            return true;
          } else {

            var permission = this.permission;

            if (!module || !action) {
              return false;
            }

            var mdl = permission.filter(function (item) {
              return item.module === module;
            });

            if (mdl && mdl.length > 0) {
              mdl = mdl[0];

              var rules = mdl.rules;
              rules = rules.filter(function (rule) {
                return (rule.labelAction === action && rule.value === true);
              });

              if (rules && rules.length > 0) {
                return true;
              } else {
                return false;
              }
            }

            return false
          }
        },

        getCEP: function (cep) {
          return $http({
            url: 'https://viacep.com.br/ws/' + cep.replace(/[^\d]/g, '') + '/json/',
            method: 'GET',
            headers: {
              'not-access-token': true
            }
          }).then(function (response) {
            return response.data;
          });
        },

        exportReport: function (router) {
          var href;
          if (router === 'rede-filiais') {
            href = endpoint + "rede/export-filiais-xls";
          } else {
            href = endpoint + router + "/export-xls";
          }


          var profile = auth.profile;
          var role = profile.user.role;
          var id = profile.user._id;

          if (role === 'Vendedor') {
            href = href + '?id=' + id;
          }

          $window.open(href);
        }
      }

      return auth;
    })
    .factory('UserAuthFactory', function ($window, $location, $http, AuthenticationFactory, endpoint) {
      return {
        login: function (username, password) {
          return $http.post(endpoint + 'login', {
            username: username,
            password: password
          });
        },
        logout: function () {

          if (AuthenticationFactory.isLogged) {

            AuthenticationFactory.isLogged = false;
            delete AuthenticationFactory.user;
            delete AuthenticationFactory.userRole;
            delete AuthenticationFactory.permission;

            delete $window.sessionStorage.token;
            delete $window.sessionStorage.user;
            delete $window.sessionStorage.userRole;
            delete $window.sessionStorage.permission;

            $location.path("/login");
          }

        }
      }
    })
    .factory('TokenInterceptor', function ($q, $window) {
      return {
        request: function (config) {
          config.headers = config.headers || {};

          if (!config.headers['not-access-token']) {

            if ($window.sessionStorage.token) {
              config.headers['X-Access-Token'] = $window.sessionStorage.token;
              config.headers['X-Key'] = $window.sessionStorage.user;
              config.headers['Content-Type'] = "application/json";
            }
            return config || $q.when(config);
          } else {

            delete config.headers;
            return config || $q.when(config);

          }
        },

        response: function (response) {
          return response || $q.when(response);
        }
      };
    })
    .directive('permission', function (AuthenticationFactory) {
      return {
        restrict: 'EA',
        scope: {
          permission: '@',
          module: '@'
        },
        link: function postLink(scope, element) {

          var modulo = scope.module;
          var permission = scope.permission;

          function toggleVisibilityBasedOnPermission() {
            if (!AuthenticationFactory.verifyPermission(modulo, permission)) {
              element[0].style.display = "none";
            }
          }

          toggleVisibilityBasedOnPermission();
          scope.$on('permissionsChanged', toggleVisibilityBasedOnPermission);


        }
      };
    })
    .directive('importSheetJs', function SheetJSImportDirective() {
      return {
        scope: { opts: '=' },
        link: function ($scope, $elm) {
          $elm.on('change', function (changeEvent) {
            var reader = new FileReader();

            reader.onload = function (e) {
              /* read workbook */
              var bstr = e.target.result;
              var wb = XLSX.read(bstr, { type: 'binary' });

              /* grab first sheet */
              var wsname = wb.SheetNames[0];
              var ws = wb.Sheets[wsname];

              // /* grab first row and generate column headers */
              var aoa = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, blankrows: false, cellDates: true });
              var cols = [];
              for (var i = 0; i < aoa[0].length; ++i) cols[i] = { field: aoa[0][i].replace('/\s/', '').trim() };

              /* generate rest of the data */
              var data = [];
              for (var r = 1; r < aoa.length; ++r) {
                data[r - 1] = {};
                for (var col = 0; col < cols.length; ++col) {
                  if (aoa[r][col] == null || aoa[r][col] == undefined) continue;
                  let key = cols[col].field
                  data[r - 1][key] = aoa[r][col]
                }
              }


              $scope.$apply(function () {/* update scope */
                $scope.opts = data;
              })
            };

            reader.readAsBinaryString(changeEvent.target.files[0]);
          });
        }
      };
    });















  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider) {

    //$locationProvider.html5Mode();

    $httpProvider.interceptors.push('TokenInterceptor');

    $stateProvider
      .state('agendamento', {
        url: '/agendamento',
        templateUrl: 'app/agendamento/index.html',
        controller: 'AgendamentoController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('client', {
        url: '/client',
        templateUrl: 'app/client/index.html',
        controller: 'ClientController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('clientCobranca', {
        url: '/clientCobranca',
        templateUrl: 'app/clientCobranca/index.html',
        controller: 'clientCobrancaController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('documento', {
        url: '/documento',
        templateUrl: 'app/documento/index.html',
        controller: 'DocumentoController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('vendedor', {
        url: '/vendedor',
        templateUrl: 'app/vendedor/index.html',
        controller: 'VendedorController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('juridica', {
        url: '/juridica',
        templateUrl: 'app/juridica/index.html',
        controller: 'JuridicaController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('rede', {
        url: '/rede',
        templateUrl: 'app/rede/index.html',
        controller: 'RedeController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('corpoClinico', {
        url: '/corpoClinico',
        templateUrl: 'app/corpoClinico/index.html',
        controller: 'CorpoClinicoController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('exames', {
        url: '/exames',
        templateUrl: 'app/exames/index.html',
        controller: 'ExameController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('log', {
        url: '/log',
        templateUrl: 'app/log/index.html',
        controller: 'LogController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('redeDocumento', {
        url: '/redeDocumento',
        templateUrl: 'app/redeDocumento/index.html',
        controller: 'RedeDocumentoController',
        controllerAs: 'ctrl',
        params: {
          redeId: null
        },
        access: { requiredLogin: true }
      })
      .state('redeEspecialidade', {
        url: '/redeEspecialidade',
        templateUrl: 'app/redeEspecialidade/index.html',
        controller: 'RedeEspecialidadeController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('redeTipo', {
        url: '/redeTipo',
        templateUrl: 'app/redeTipo/index.html',
        controller: 'RedeTipoController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('apolice', {
        url: '/apolice',
        templateUrl: 'app/apolice/index.html',
        controller: 'ApoliceController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('juridicaCobranca', {
        url: '/juridicaCobranca',
        templateUrl: 'app/juridicaCobranca/index.html',
        controller: 'juridicaCobrancaController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('cartao', {
        url: '/cartao',
        templateUrl: 'app/cartao/index.html',
        controller: 'CartaoController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('validacao', {
        url: '/validacao',
        templateUrl: 'app/validacao/index.html',
        controller: 'ValidacaoController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('totalizadores', {
        url: '/totalizadores',
        templateUrl: 'app/totalizadores/index.html',
        controller: 'TotalizadoresController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('transferencias', {
        url: '/transferencias',
        templateUrl: 'app/transferencias/index.html',
        controller: 'TransferenciasController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('email', {
        url: '/email',
        templateUrl: 'app/email/index.html',
        controller: 'EmailController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('cupom', {
        url: '/cupom',
        templateUrl: 'app/cupom/index.html',
        controller: 'CupomController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('plan', {
        url: '/plan',
        templateUrl: 'app/plan/index.html',
        controller: 'PlanController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('produtos', {
        url: '/produtos',
        templateUrl: 'app/produtos/index.html',
        controller: 'ProdutosController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('user', {
        url: '/user',
        templateUrl: 'app/user/index.html',
        controller: 'UserController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('inicio', {
        url: '/inicio',
        templateUrl: 'app/inicio/index.html',
        controller: 'InicioController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('seguro', {
        url: '/seguro',
        templateUrl: 'app/seguro/index.html',
        controller: 'SeguroController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('emprestimo', {
        url: '/emprestimo',
        templateUrl: 'app/emprestimo/index.html',
        controller: 'EmprestimoController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('saude', {
        url: '/saude',
        templateUrl: 'app/saude/index.html',
        controller: 'SaudeController',
        controllerAs: 'ctrl',
        access: { requiredLogin: true }
      })
      .state('login', {
        url: "/login",
        templateUrl: 'app/login/index.html',
        controller: 'LoginController',
        controllerAs: 'ctrl',
        access: { requiredLogin: false }
      });
    $urlRouterProvider.otherwise('/inicio');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('gruposinAdmin')
    .constant('malarkey', malarkey)
    .constant('moment', moment)

    // PRODUÇÃO
    .constant('php_host', 'https://gruposin.com.br/')
    .constant('url_images', 'https://gruposin.com.br/uploads/')
    .constant('url_upload', 'https://gruposin.com.br/uploadify.php')
    .constant('API_PAYZEN', 'https://gruposin.com.br/payzen/api.php')
    .constant('php_host', 'https://clients.sierratecnologia.com.br/gruposin/')
    .constant('endpoint', 'https://api.sinsaudecard.com.br/api/') // -- STAGE ANTIGA
    //.constant('endpoint', 'http://localhost:5000/api/')
    // .constant('endpoint', 'https://portal-grupo-sin-stage.herokuapp.com/api/')
    .constant('API_PAGAMENTO_DRACHEI_HOST', 'https://payment.drachei.com.br')
    //.constant('ZOOP_MARKETPLACE_ID', 'ed38249b319441a6bf54565649f201f9')
    //.constant('ZOOP_API_KEY', 'enBrX3Byb2RfT3ZydndwZ21VaVJCSWo4WVNLRTVwME1wOg==')

    //.constant('endpoint', 'http://localhost:5000/api/') //-- DEVELOPMENT
    //-- STAGE NEVES
    // .constant('php_host', 'https://clients.sierratecnologia.com.br/gruposin/')
    // .constant('url_images', 'https://clients.sierratecnologia.com.br/gruposin/uploads/')
    // .constant('url_upload', 'https://clients.sierratecnologia.com.br/gruposin/uploadify.php')
    // .constant('API_PAYZEN', 'https://clients.sierratecnologia.com.br/gruposin/payzen/api.php')
    // .constant('API_PAGAMENTO_DRACHEI_HOST', 'https://powerdevs.minivps.info:3000')
    .constant('ZOOP_MARKETPLACE_ID', '5fd1881858124677af1df83fc36efe27')
    .constant('ZOOP_API_KEY', 'enBrX3Rlc3RfSzRZSFhxSzdXN0ZUd1pndkM4VEJUQW0wOnVuZGVmaW5lZA');

    // .constant('endpoint', 'http://localhost:5000/api/');
    // .constant('php_host', 'http://localhost:8000/')
    // .constant('url_images', 'http://localhost:8000/uploads/')
    // .constant('url_upload', 'http://localhost:8000/uploadify.php')
    // .constant('API_PAYZEN', 'http://localhost:8000/payzen/api.php');
})();

(function() {
  'use strict';

  angular
    .module('gruposinAdmin')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, tagsInputConfigProvider) {
    $logProvider.debugEnabled(true);

    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 10000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    toastrConfig.preventOpenDuplicates = false;

    tagsInputConfigProvider
    .setDefaults('tagsInput', {
      placeholder: 'pesquisa de especialidades'
  });
  }

})();

angular.module("gruposinAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/agendamento/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save() name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Agendamentos</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><md-input-container flex><label>Data de agendamento</label><input type=date ng-model=ctrl.form.dataAgendamento required></md-input-container><md-input-container flex><md-list-item><i class=material-icons>perm_phone_msg</i><p>Receber via SMS</p><md-switch class=md-secondary ng-model=ctrl.form.envioSMS></md-switch></md-list-item><md-list-item><i class=material-icons>local_post_office</i><p>Receber via Email</p><md-switch class=md-secondary ng-model=ctrl.form.envioEmail></md-switch></md-list-item></md-input-container></div><div layout=row><md-input-container flex=50><label>Local de Atendimento</label><input ng-model=ctrl.form.local></md-input-container><md-input-container flex=50 class=md-block ng-if=ctrl.form.envioSMS><label>Mensagem de SMS</label><textarea ng-model=ctrl.form.messageSMS md-maxlength=140 name=messageSMS rows=5 md-select-on-focus></textarea></md-input-container></div><div layout=row><md-input-container flex=100 class=md-block ng-if=ctrl.form.envioEmail><label>Mensagem de Email</label><textarea ng-model=ctrl.form.messageEmail md-maxlength=1000 name=messageEmail rows=5 md-select-on-focus></textarea></md-input-container></div><div layout=row><md-autocomplete flex required md-selected-item=ctrl.selectedItemRede md-search-text-change=ctrl.searchTextChangeRede(searchTextRede) md-search-text=searchTextRede md-require-match=false md-select-on-match=true md-items=\"item in ctrl.searchRede(searchTextRede)\" md-item-text=item.name md-selected-item-change=ctrl.selectedItemChangeRede(item) md-min-length=0 md-floating-label=Prestador md-input-name=autocompleteRede><md-item-template><span md-highlight-text=searchTextRede>{{item.name}} - {{item.uf}}</span></md-item-template></md-autocomplete><md-autocomplete flex required md-selected-item=ctrl.selectedItemCliente md-search-text=searchTextCliente md-search-text-change=ctrl.searchTextChangeCliente(searchTextCliente) md-require-match=false md-select-on-match=true md-items=\"cliente in ctrl.searchCliente(searchTextCliente)\" md-selected-item-change=ctrl.selectedItemChangeCliente(cliente) md-item-text=cliente.name md-min-length=0 md-floating-label=Cliente md-input-name=autocompleteCliente><md-item-template><span md-highlight-text=searchTextCliente>{{cliente.name}}</span></md-item-template></md-autocomplete></div><div layout=row><md-input-container flex class=\"md-icon-float md-block\"><label>Atendente</label><input ng-model=ctrl.form.atendente type=text></md-input-container><md-input-container><label>Data de atendimento</label><input type=date ng-model=ctrl.form.dataAtendimento></md-input-container><md-input-container class=\"md-icon-float md-icon-right md-block\"><label>Valor</label><input ng-model=ctrl.form.valor ui-money-mask></md-input-container></div><div layout=row><md-input-container flex class=md-block><label>Observação</label><textarea ng-model=ctrl.form.outros name=Observacao rows=5 md-select-on-focus></textarea></md-input-container></div><div layout=row><lf-ng-md-file-input lf-files=files lf-on-file-click=vm.onFileClick lf-api=api lf-placeholder=Anexos lf-browse-label=Procurar lf-remove-label=Delete multiple drag preview accept=* progress></lf-ng-md-file-input></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"!formulario.$valid || ctrl.loading\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/agendamento/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewAgendamento module=agendamento><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div permission=btnExportAgendamento module=agendamento><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnExportAgendamento module=agendamento><md-button aria-label=Ativar ng-click=\"ctrl.exportExcel(\'agendamento\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item></md-menu-content></md-menu></div><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Agendamentos</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/agendamento/view.html","<md-dialog aria-label=Dialog class=dialog-size-50><md-toolbar><div class=md-toolbar-tools><h2>Agendamento</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-card><img src=assets/images/curriculum.png class=md-card-image style=\"width: 56px; padding-top: 10px; margin: auto\" alt=Visualizar><md-card-title><md-card-title-text layout-align=\"center center\"><span class=md-headline>{{ ctrl.selectedItemCliente.name }}</span> <span class=md-subheadline>{{ ctrl.selectedItemRede.name }}</span></md-card-title-text></md-card-title><md-card-content><h3>Data: {{ ctrl.form.dataAgendamento | date: \'dd/MM/yyyy\' }}</h3><h3>Local: {{ ctrl.form.local }}</h3><h3>Atendente: {{ctrl.form.atendente}}</h3><h3>Data: {{ ctrl.form.dataAtendimento | date: \'dd/MM/yyyy\' }}</h3><h3>Valor: {{ctrl.form.valor}}</h3><h3>Receber por E-mail: {{ctrl.form.envioEmail ? \'SIM\' : \'NAO\'}}</h3><h3>Mensagem de E-mail: {{ctrl.form.messageEmail}}</h3><h3>Receber por SMS: {{ctrl.form.envioSMS ? \'SIM\' : \'NAO\'}}</h3><h3>Mensagem de SMS: {{ctrl.form.messageSMS}}</h3></md-card-content></md-card></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/apolice/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Apólice</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><!-- cliente --><md-autocomplete flex=100 required class=md-primary md-selected-item=ctrl.selectedItemCliente md-search-text-change=ctrl.searchTextChangeCliente(searchTextCliente) md-require-match=false md-select-on-match=true md-search-text=searchTextCliente md-selected-item-change=ctrl.selectedItemChangeCliente(item) md-items=\"item in ctrl.searchCompanyCliente(searchTextCliente) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Segurado Principal\" md-input-name=autocompleteCliente><md-item-template><span md-highlight-text=searchTextCliente md-highlight-flags=ig>{{item.cpf}} - {{item.name}}</span></md-item-template></md-autocomplete></div><div layout=row><!-- empresa --><md-autocomplete flex required class=md-primary md-selected-item=ctrl.selectedItemEmpresa md-search-text-change=ctrl.searchTextChangeEmpresa(searchTextCliente) md-require-match=false md-select-on-match=true md-search-text=searchTextEmpresa md-selected-item-change=ctrl.selectedItemChangeEmpresa(item) md-items=\"item in ctrl.searchCompanyEmpresa(searchTextEmpresa) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=Estipulante md-input-name=autocompleteEmpresa><md-item-template><span md-highlight-text=searchTextEmpresa md-highlight-flags=ig>{{item.cnpj}} - {{item.name}}</span></md-item-template></md-autocomplete></div><div layout=row><!-- vendedor --><md-autocomplete flex required class=md-primary md-selected-item=ctrl.selectedItem md-search-text-change=ctrl.searchTextChange(searchText) md-require-match=false md-select-on-match=true md-search-text=searchText md-selected-item-change=ctrl.selectedItemChange(item) md-items=\"item in ctrl.searchCompany(searchText) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=Subestipulante md-input-name=autocompleteVendedor><md-item-template><span md-highlight-text=searchText md-highlight-flags=ig>{{item.cpf}} - {{item.name}}</span></md-item-template></md-autocomplete></div><div layout=row><md-input-container flex><label>Número da Apólice</label><input ng-model=ctrl.form.numeroApolicePersonalizado type=text pattern=\\d* maxlength=30></md-input-container></div><div layout=row><md-input-container flex=40><label>Inicio Individual Risco</label><input type=date ng-model=ctrl.form.inicioIndividualRisco required></md-input-container><md-input-container flex=40><label>Data</label><input type=date ng-model=ctrl.form.data required></md-input-container></div><md-toolbar class=md-danger><div class=md-toolbar-tools><h2 class=md-flex>Campos customizados</h2></div></md-toolbar><div layout=row><md-input-container flex><label>Campo de Bem vindo</label><input ng-model=ctrl.form.campo_bemvindo maxlength=20 placeholder=\"Ex: Seja bem-vindo\"></md-input-container></div><div layout=row><md-input-container flex><label>Campo de Apresentação</label><input ng-model=ctrl.form.campo_customizado_1 maxlength=35 placeholder=\"Ex: Membro da Igreja Cristo em Casa.\"></md-input-container></div><div layout=row><md-input-container flex><label>Nome do Cartão</label><input ng-model=ctrl.form.campo_customizado_2 maxlength=30 placeholder=\"Ex: da Igreja Cristo em Casa\"></md-input-container></div><div layout=row><md-input-container flex><label>Texto Personalizado (Para desbloqueio)</label><input ng-model=ctrl.form.campo_customizado_3 maxlength=100 placeholder=\"Ex: Para desbloqueio do cartão ou agendamento de consultas e e..\"></md-input-container></div><div layout=row><md-input-container flex><label>Texto Personalizado (Para desbloqueio auxiliar)</label><input ng-model=ctrl.form.campo_customizado_4 maxlength=100 placeholder=\"Ex: Central de Atendimento no número (21)2263-9325 ou (21)3176-6301\"></md-input-container></div><div layout=row><md-input-container flex><label>Texto do Auxilio Funeral</label><textarea ng-model=ctrl.form.leia_me rows=5 cols=60 maxlength=100 placeholder=\"Ex: Para acionar seu seguro  ou auxílio funeral (até 70anos) ligue 0800551640...\"></textarea></md-input-container></div><div layout=row><md-input-container flex><label>Texto Auxiliar:</label><input ng-model=ctrl.form.campo_customizado_5 maxlength=100 placeholder=\"Ex: Não somos plano de saúde. Não cobrimos emergência...\"></md-input-container></div><div layout=row><md-input-container flex><label>Texto Final</label><textarea ng-model=ctrl.form.termos rows=5 cols=60 maxlength=226 placeholder=\"Ex: Para descontos em medicamentos verifique as farmácias \\n...\"></textarea></md-input-container></div><div layout=row><md-input-container flex><label>Texto Final Adicional</label><textarea ng-model=ctrl.form.termos_adicional rows=5 cols=60 maxlength=320 placeholder=\"Ex: *Auxílio funeral familiar, cesta básica falecimento e seguro morte acidental/invalidez,válidos apenas para dependentes sendo filhos ou cônjuge.\"></textarea></md-input-container></div></div><div layout=row><md-input-container flex><label>Endereço Customizado</label><input ng-model=ctrl.form.endereco_customizado maxlength=80 placeholder=\"Ex: Grupo Sin - Av. Rio Branco, 45 - 1406 - Centro, Rio de Janeiro - RJ, 20090-003\"></md-input-container></div><md-toolbar class=md-warn><div class=md-toolbar-tools><h2 class=md-flex>Coberturas</h2></div></md-toolbar><md-list ng-cloak><md-list-item><p>Auxílio Funeral Familiar</p><md-checkbox class=md-secondary ng-model=ctrl.form.coberturaAuxFuneralFamilia></md-checkbox></md-list-item><md-list-item><p>Cobertura Possui Limit por Idade?</p><md-checkbox class=md-secondary ng-model=ctrl.form.coberturaAteIdade></md-checkbox></md-list-item><md-list-item><p>Cesta básica</p><md-checkbox class=md-secondary ng-model=ctrl.form.coberturaCestaBasica></md-checkbox></md-list-item><md-list-item><p>Seguro Morte acidental</p><md-checkbox class=md-secondary ng-model=ctrl.form.coberturaMorteAcidental></md-checkbox></md-list-item><md-list-item><p>Sin Saúde Card medicamentos</p><md-checkbox class=md-secondary ng-model=ctrl.form.coberturaSinSaudeMedicamento></md-checkbox></md-list-item></md-list><div layout=row layout-wrap><div flex=33><md-input-container><label>{{ctrl.form.coberturaSinSaudeMedicamento ? \'Com\' : \'Sem\'}} Sin Saúde Card medicamentos</label><input ng-model=ctrl.form.coberturaSinSaudeMedicamentoComentario></md-input-container></div><div flex=33 ng-if=ctrl.form.coberturaMorteAcidental><md-input-container><label>Valor seguro morte</label><input ng-model=ctrl.form.coberturaMorteAcidentalValor value=5000 ui-money-mask></md-input-container></div><div flex=33 ng-if=ctrl.form.coberturaAuxFuneralFamilia><md-input-container><label>Auxílio Funeral Familiar Valor</label><input ng-model=ctrl.form.coberturaAuxFuneralFamiliaValor value=3000 ui-money-mask></md-input-container></div><div flex=33 ng-if=ctrl.form.coberturaAteIdade><md-input-container><label>Limite da Cobertura</label><input ng-model=ctrl.form.coberturaAteIdadeValor value=70 placeholder=70> anos</md-input-container></div><div flex=33 ng-if=ctrl.form.coberturaCestaBasica><md-input-container><label>Valor Básica Comentário</label><input ng-model=ctrl.form.coberturaCestaBasicaValor value=200 ui-money-mask></md-input-container></div></div><div layout=row><lf-ng-md-file-input lf-files=files lf-api=api lf-placeholder=\"Imagem Externa a Direita\" lf-browse-label=Buscar lf-remove-label=Delete drag preview accept=image/* progress></lf-ng-md-file-input></div><!--  <div layout=\"row\">\n            <lf-ng-md-file-input lf-files=\"fileslogo1\" lf-api=\"api\" lf-placeholder=\"Selecione uma Logo\"\n                                 lf-browse-label=\"Buscar\" lf-remove-label=\"Delete\" drag preview\n                                 accept=\"image/*\" progress></lf-ng-md-file-input>\n          </div>\n          <div layout=\"row\">\n            <lf-ng-md-file-input lf-files=\"fileslogo2\" lf-api=\"api\" lf-placeholder=\"Selecione uma Logo Primária\"\n                                 lf-browse-label=\"Buscar\" lf-remove-label=\"Delete\" drag preview\n                                 accept=\"image/*\" progress></lf-ng-md-file-input>\n          </div>\n          <div layout=\"row\">\n            <lf-ng-md-file-input lf-files=\"fileslogo3\" lf-api=\"api\" lf-placeholder=\"Selecione uma Logo Secundária\"\n                                 lf-browse-label=\"Buscar\" lf-remove-label=\"Delete\" drag preview\n                                 accept=\"image/*\" progress></lf-ng-md-file-input>\n          </div>\n          <div layout=\"row\">\n            <lf-ng-md-file-input lf-files=\"filescartao1\" lf-api=\"api\" lf-placeholder=\"1° Logo ao Lado do Cartão\"\n                                 lf-browse-label=\"Buscar\" lf-remove-label=\"Delete\" drag preview\n                                 accept=\"image/*\" progress></lf-ng-md-file-input>\n          </div>\n          <div layout=\"row\">\n            <lf-ng-md-file-input lf-files=\"filescartao2\" lf-api=\"api\" lf-placeholder=\"2° Logo ao Lado do Cartão\"\n                                 lf-browse-label=\"Buscar\" lf-remove-label=\"Delete\" drag preview\n                                 accept=\"image/*\" progress></lf-ng-md-file-input>\n          </div>\n          <div layout=\"row\">\n            <lf-ng-md-file-input lf-files=\"filesapresentacao\" lf-api=\"api\" lf-placeholder=\"Image Principal Interna\"\n                                 lf-browse-label=\"Buscar\" lf-remove-label=\"Delete\" drag preview\n                                 accept=\"image/*\" progress></lf-ng-md-file-input>\n          </div> --></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/apolice/index.html","<script src=report.js></script><md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewApolice module=apolice><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div permission=btnExportApolice module=apolice><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdMenu.open($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnExportApolice module=apolice><md-button aria-label=Ativar ng-click=\"ctrl.exportExcel(\'apolice\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item></md-menu-content></md-menu></div><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Apólices</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/cartao/detail-dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Cartões</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=column><!-- cliente --><md-input-container flex=100><label>Cliente</label><input ng-model=ctrl.form.client.name></md-input-container><md-input-container flex=100><label>CPF</label><input ng-model=ctrl.form.client.cpf ui-br-cpf-mask></md-input-container><!-- pedido --><md-input-container flex=100><label>Nº Pedido</label><input ng-model=ctrl.form.idPedidoVindi></md-input-container></div><div layout=row><md-input-container flex=66><label>Nº do Cartäo</label><input ng-model=ctrl.form.cartao.numeroCartao required name=numeroCartao><div ng-messages=formulario.numeroCartao.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=33><label>Status</label><input ng-model=ctrl.form.cartao.status></md-input-container></div><div layout=row><md-input-container flex=100><label>Motivo</label><textarea ng-model=ctrl.form.cartao.motivo rows=3></textarea></md-input-container></div><div layout=row><md-input-container flex=100><label>Data da Venda</label><input ng-model=ctrl.form.createdAt type=date></md-input-container><md-input-container flex=100><label>Vendedor</label><input ng-model=ctrl.form.vendedor.name></md-input-container></div><div layout=row><md-input-container flex=100><label>Data da Ativação</label><input ng-model=ctrl.form.cartao.dataAtivacao type=date></md-input-container></div><div layout=row><md-input-container flex=33><label>Forma de Pagamento</label><input ng-model=ctrl.form.vads_payment_cards.descricao></md-input-container><md-input-container flex=33><label>Plano</label><input ng-model=ctrl.form.plano.name></md-input-container><md-input-container flex=33><label>Valor da Mensalidade</label><input ng-model=ctrl.form.plano.price></md-input-container></div><div layout=row><md-input-container flex=50><label>Vencimento da Mensalidade</label><input ng-model=ctrl.form.vads_sub_effect_date type=date></md-input-container><md-input-container flex=50><label>Vencimento do Plano</label><input ng-model=ctrl.form.VencimentoPlano type=date></md-input-container></div><div layout=row>Possui Depedentes? {{ ctrl.form.client.dependentes.length > 0 ? \'Sim\' : \'Não\' }}</div><div layout=column><div ng-repeat=\"item in ctrl.form.client.dependentes track by $index\">{{item.name}} - {{item.cpf}}</div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/cartao/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Cartões</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=column><!--             <md-autocomplete\n                required class=\"md-primary\"\n                md-selected-item=\"selectedItemClient\"\n                md-search-text-change=\"searchTextChangeClient(searchTextClient)\"\n                md-require-match=\"true\"\n                md-select-on-match=\"true\"\n                md-search-text=\"searchTextClient\"\n                md-selected-item-change=\"selectedItemChangeClient(item)\"\n                md-items=\"item in searchClient(searchTextClient) | orderBy : \'name\'\"\n                md-item-text=\"item.name\"\n                md-min-length=\"0\"\n                md-floating-label=\"Digite o cliente associado\"\n                md-input-name=\"autocompleteClient\">\n                <md-item-template>\n                    <span md-highlight-text=\"searchTextClient\" md-highlight-flags=\"ig\">{{item.cpf}} - {{item.name}}</span>\n                </md-item-template>\n                <div ng-messages=\"formulario.autocompleteClient.$error\">\n                    <div ng-message=\"required\">Campo Obrigatório</div>\n                    <div ng-message=\"md-require-match\">Selecione uma cliente existente na lista.</div>\n                </div>\n            </md-autocomplete>\n --><!-- pedidos --><!--\n            <md-autocomplete\n                require\n                class=\"md-primary\"\n                md-selected-item=\"ctrl.selectedItemSaude\"\n                md-search-text-change=\"ctrl.searchTextChangeSaude(searchTextSaude)\"\n                md-require-match = \"false\"\n                md-select-on-match=\"true\"\n                md-search-text=\"searchTextSaude\"\n                md-selected-item-change=\"ctrl.selectedItemChangeSaude(item)\"\n                md-items=\"item in ctrl.searchSaude(searchTextSaude) | orderBy : \'vads_order_id\'\"\n                md-item-text=\"item.vads_order_id\"\n                md-min-length=\"0\"\n                md-floating-label=\"Digite o pedido associado\"\n                md-input-name=\"autocompleteSaude\">\n                <md-item-template>\n                    <span md-highlight-text=\"searchTextSaude\" md-highlight-flags=\"ig\" >{{item.vads_order_id}-{item.client.name}}</span>\n                </md-item-template>\n                <div ng-messages=\"formulario.autocompleteSaude.$error\">\n                    <div ng-message=\"md-require-match\">Selecione uma pedido existente na lista.</div>\n                </div>\n            </md-autocomplete>\n            --><md-input-container><input ng-model=ctrl.form.vads_order_id required name=vads_order_id placeholder=\"Digite o pedido associado\"><div ng-messages=formulario.autocompleteSaude.$error><div ng-message=md-require-match>Selecione uma pedido existente</div></div></md-input-container></div><div layout=row><md-input-container flex=33><label>Nº do Cartão</label><input ng-model=ctrl.form.cartao.numeroCartao required minlength=16 name=numeroCartao ng-disabled=ctrl.form.editable><div ng-messages=formulario.numeroCartao.$error><div ng-message=required>Campo Obrigatório</div><div ng-message=minlength>O cartão deve ter no mínimo 16 dígitos</div></div></md-input-container><md-input-container flex=33><label>Status</label><md-select ng-model=ctrl.form.cartao.status required name=status><md-option>Selecione o Status</md-option><md-option value=Habilitado>Habilitado</md-option><md-option value=Desabilitado>Desabilitado</md-option><md-option value=Suspenso>Suspenso</md-option><md-option value=Cancelado>Cancelado</md-option></md-select><div ng-messages=formulario.status.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=33><label>Data Ativação</label><input ng-model=ctrl.form.cartao.dataAtivacao type=datetime-local readonly ng-disabled=true></md-input-container></div><div layout=row><md-input-container flex=100><label>Motivo</label><textarea ng-model=ctrl.form.cartao.motivo rows=3></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"!formulario.$valid || ctrl.loading\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/cartao/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewCartao module=cartao><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div permission=btnExportCartao module=cartao><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnExportCartao module=cartao><md-button aria-label=Ativar ng-click=\"ctrl.exportReport(\'cartao\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item></md-menu-content></md-menu></div></div><md-divider></md-divider><div class=header-model><h3>Cartões</h3></div><md-divider class=busca><div><div class=divBusca><label>Email Cliente:</label><br><input class=form-control ng-model=busca.emailCliente type=text></div><div class=divBusca><label for=nomeCliente>Nome Cliente:</label><br><input class=form-control ng-model=busca.nomeCliente type=text></div><div class=divBusca><label for=cpfCliente>CPF:</label><br><input class=form-control ng-model=busca.cpfCliente type=text ui-br-cpf-mask></div><div class=divBusca><label for=telefoneCliente>Numero Cartão:</label><br><input class=form-control ng-model=busca.numeroCartao type=text></div><div class=divBusca><label for=numeroPedido>Numero Pedido:</label><br><input class=form-control ng-model=busca.idPedidoVindi type=text></div><div class=divBusca><label for=id>Id Pedido:</label><br><input class=form-control ng-model=busca.pedidoId type=text></div><div class=divBusca><label for=telefoneCliente>Plano:</label><br><input class=form-control ng-model=busca.plano type=text></div><div class=divBusca><label for=telefoneCliente>Form. Pag :</label><br><input class=form-control ng-model=busca.formaPagamento type=text></div><div class=divBusca><label for=dataCadastro>Data Pedido:</label><br><input class=form-control ng-model=busca.dataInicioPedido type=date></div><div class=divBusca><label for=dataCadastro>Data Vencimento:</label><br><input class=form-control ng-model=busca.dataVencimentoFatura type=date></div><div class=divBusca><md-button class=md-icon-button id=botaoBusca aria-label=Busca ng-click=ctrl.busca(busca)><i class=material-icons>search</i><md-tooltip md-direction=right>Busca</md-tooltip></md-button></div></div></md-divider><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-if=\"!ctrl.loading \" class=wrapper-grid><div ui-grid=ctrl.gridOptionsBusca class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div><div class=custom-csv-link-location hidden><span class=ui-grid-exporter-csv-link>&nbsp</span></div></md-content>");
$templateCache.put("app/client/dialog-gerarCobranca.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.submit(formulario) name=formulario id=formulario novalidate><md-toolbar><div class=md-toolbar-tools><h2>Gerar Cobrança</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>Vencimento das mensalidades</label><md-select ng-model=ctrl.form.dia ng-required=true name=mes><md-option value=\"\">Selecione o vencimento</md-option><md-option value=5>5</md-option><md-option value=10>10</md-option><md-option value=15>15</md-option><md-option value=20>20</md-option><md-option value=25>25</md-option><md-option value=30>30</md-option><md-option value=TODAS>Todas</md-option></md-select><div ng-messages=formulario.mes.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container><label>Selecione o mês</label><md-select ng-model=ctrl.form.mes_selecionado ng-required=true name=mes_selecionado><md-option value=\"\">Selecione o mês</md-option><md-option value=01>Janeiro</md-option><md-option value=02>Fevereiro</md-option><md-option value=03>Março</md-option><md-option value=04>Abril</md-option><md-option value=05>Maio</md-option><md-option value=06>Junho</md-option><md-option value=07>Julho</md-option><md-option value=08>Agosto</md-option><md-option value=09>Setembro</md-option><md-option value=10>Outubro</md-option><md-option value=11>Novembro</md-option><md-option value=12>Dezembro</md-option></md-select><div ng-messages=formulario.mes_selecionado.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"!formulario.$valid || ctrl.submiting\"><span ng-show=!ctrl.submiting>Gerar Cobrança</span><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.submiting></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/client/dialog-importCliente.html","<md-dialog aria-label=Dialog class=dialog-size-50><form action=# method=post enctype=”multipart/form-data” name=file><md-toolbar><div class=md-toolbar-tools><h2>Importação de clientes</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><md-card><img src=assets/images/pessoas.png style=\"width: 100px; padding-top: 10px; margin: auto\" class=md-card-image alt=Importar><md-card-title><md-card-title-text layout-align=\"center center\"><span class=md-headline>Cadastro de clientes</span></md-card-title-text></md-card-title><md-card-content><p>Através deste recurso é possível sua empresa migrar os dados para o GRUPOSIN atraves de planilha utilizando o formato de Excel.<br>Para importar clientes clique no botao abaixo.</p></md-card-content></md-card><div><lf-ng-md-file-input lf-files=file01 lf-browse-label=Arquivo></lf-ng-md-file-input></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button ng-click=ctrl.onSubmit()><span ng-show=!ctrl.submiting>Importar</span><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.submiting></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/client/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Cliente</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=column><md-autocomplete class=md-primary md-selected-item=ctrl.selectedItem md-search-text-change=ctrl.searchTextChange(searchText) md-select-on-match=true md-search-text=searchText md-selected-item-change=ctrl.selectedItemChange(item) md-items=\"item in ctrl.searchCompany(searchText) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite o vendedor associada\" md-input-name=autocompleteVendedor><md-item-template><span md-highlight-text=searchText md-highlight-flags=ig>{{item.cpf}} - {{item.name}}</span></md-item-template></md-autocomplete></div><div layout=column><md-autocomplete class=md-primary md-selected-item=ctrl.selectedItemEmpresa md-search-text-change=ctrl.searchTextChangeEmpresa(searchText) md-require-match=true md-select-on-match=true md-search-text=searchTextEmpresa md-selected-item-change=ctrl.selectedItemChangeEmpresa(item) md-items=\"item in ctrl.searchCompanyEmpresa(searchTextEmpresa) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite a empresa associada\" md-input-name=autocompleteEmpresa><md-item-template><span md-highlight-text=searchTextEmpresa md-highlight-flags=ig>{{item.cpf}} - {{item.name}}</span></md-item-template></md-autocomplete></div><div layout=column><md-input-container permission=btnStatusClient module=client><label>Status</label><md-select ng-model=ctrl.form.status name=status permission=btnStatusClient module=client><md-option>Selecione o Status</md-option><md-option value=Habilitado>Habilitado</md-option><md-option value=Cancelado>Cancelado</md-option><md-option value=Desabilitado>Desabilitado</md-option><md-option value=Inadimplente>Inadimplente</md-option></md-select></md-input-container></div><md-input-container><label>Nome</label><input ng-model=ctrl.form.name required name=nome><div ng-messages=formulario.nome.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><div layout=row><md-input-container flex=60><label>CPF</label><input ng-model=ctrl.form.cpf name=cpf required ui-br-cpf-mask><div ng-messages=formulario.cpf.$error><div ng-message=required>Campo Obrigatório</div><div ng-message=cpf>CPF Inválido</div></div></md-input-container><md-input-container flex=30 class=text-center><md-checkbox md-no-ink aria-label=Dependente ng-model=ctrl.form.dependente class=md-primary>Dependente?</md-checkbox></md-input-container></div><div layout=row><md-input-container flex=33><label>RG</label><input ng-model=ctrl.form.rg name=rg><div ng-messages=formulario.rg.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=33><label>Orgão Emissor</label><input ng-model=ctrl.form.orgaoEmissor name=orgaoEmissor><div ng-messages=formulario.orgaoEmissor.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=33><label>UF Orgão Emissor</label><md-select class=form-control ng-model=ctrl.form.ufOrgaoEmissor name=ufOrgaoEmissor><md-option value=estado>Selecione o Estado</md-option><md-option value=ac>Acre</md-option><md-option value=al>Alagoas</md-option><md-option value=am>Amazonas</md-option><md-option value=ap>Amapá</md-option><md-option value=ba>Bahia</md-option><md-option value=ce>Ceará</md-option><md-option value=df>Distrito Federal</md-option><md-option value=es>Espírito Santo</md-option><md-option value=go>Goiás</md-option><md-option value=ma>Maranhão</md-option><md-option value=mt>Mato Grosso</md-option><md-option value=ms>Mato Grosso do Sul</md-option><md-option value=mg>Minas Gerais</md-option><md-option value=pa>Pará</md-option><md-option value=pb>Paraíba</md-option><md-option value=pr>Paraná</md-option><md-option value=pe>Pernambuco</md-option><md-option value=pi>Piauí</md-option><md-option value=rj>Rio de Janeiro</md-option><md-option value=rn>Rio Grande do Norte</md-option><md-option value=ro>Rondônia</md-option><md-option value=rs>Rio Grande do Sul</md-option><md-option value=rr>Roraima</md-option><md-option value=sc>Santa Catarina</md-option><md-option value=se>Sergipe</md-option><md-option value=sp>São Paulo</md-option><md-option value=to>Tocantins</md-option></md-select><div ng-messages=formulario.ufOrgaoEmissor.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container></div><div layout=row><md-input-container flex=33><label>Sexo</label><md-select required ng-model=ctrl.form.sexo name=sexo required><md-option value=M>Masculino</md-option><md-option value=F>Feminino</md-option></md-select><div ng-messages=formulario.sexo.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=33><label>Estado Civil</label><md-select ng-model=ctrl.form.estadoCivil name=estadoCivil required><md-option value=\"\">Selecione um Estado Civíl</md-option><md-option value=\"Casado (a)\">Casado (a)</md-option><md-option value=\"Separado (a)\">Separado (a)</md-option><md-option value=\"Solteiro (a)\">Solteiro (a)</md-option><md-option value=\"Viúvo (a)\">Viúvo (a)</md-option></md-select><div ng-messages=formulario.estadoCivil.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=33><label>Data de Nascimento</label><input ng-model=ctrl.form.dataNascimento type=date name=dataNascimento required></md-input-container></div><div layout=row><md-input-container flex=50><label>Naturalidade</label><input ng-model=ctrl.form.naturalidade name=naturalidade required><div ng-messages=formulario.naturalidade.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=50><label>Uf</label><md-select ng-model=ctrl.form.ufNaturalidade name=ufNaturalidade required><md-option value=estado>Selecione o Estado</md-option><md-option value=ac>Acre</md-option><md-option value=al>Alagoas</md-option><md-option value=am>Amazonas</md-option><md-option value=ap>Amapá</md-option><md-option value=ba>Bahia</md-option><md-option value=ce>Ceará</md-option><md-option value=df>Distrito Federal</md-option><md-option value=es>Espírito Santo</md-option><md-option value=go>Goiás</md-option><md-option value=ma>Maranhão</md-option><md-option value=mt>Mato Grosso</md-option><md-option value=ms>Mato Grosso do Sul</md-option><md-option value=mg>Minas Gerais</md-option><md-option value=pa>Pará</md-option><md-option value=pb>Paraíba</md-option><md-option value=pr>Paraná</md-option><md-option value=pe>Pernambuco</md-option><md-option value=pi>Piauí</md-option><md-option value=rj>Rio de Janeiro</md-option><md-option value=rn>Rio Grande do Norte</md-option><md-option value=ro>Rondônia</md-option><md-option value=rs>Rio Grande do Sul</md-option><md-option value=rr>Roraima</md-option><md-option value=sc>Santa Catarina</md-option><md-option value=se>Sergipe</md-option><md-option value=sp>São Paulo</md-option><md-option value=to>Tocantins</md-option></md-select><div ng-messages=formulario.ufNaturalidade.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container></div><div layout=row><md-input-container flex=70><label>E-mail</label><input ng-model=ctrl.form.email name=email required type=email><div ng-messages=formulario.email.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=30><label>Senha</label><input ng-model=ctrl.form.password></md-input-container></div><div layout=row><md-input-container flex=30><label>Cep</label><input ng-model=ctrl.form.cep type=text ui-br-cep-mask name=cep ng-blur=ctrl.updateAddress() maxlength=9 required><div ng-messages=formulario.cep.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=50><label>Endereço</label><input ng-model=ctrl.form.enderecoResidencial name=endereco required><div ng-messages=formulario.endereco.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=20><label>Número</label><input ng-model=ctrl.form.enderecoNumero name=numero><div ng-messages=formulario.numero.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container></div><md-input-container flex=20><label>Complemento</label><input ng-model=ctrl.form.endereComplemento name=complemento></md-input-container><div layout=row><md-input-container flex=33><label>Bairro</label><input ng-model=ctrl.form.bairro name=bairro required></md-input-container><md-input-container flex=33><label>Cidade</label><input ng-model=ctrl.form.cidade name=cidade required></md-input-container><md-input-container flex=33><label>Uf</label><md-select ng-model=ctrl.form.uf name=uf required><md-option value=estado>Selecione o Estado</md-option><md-option value=ac>Acre</md-option><md-option value=al>Alagoas</md-option><md-option value=am>Amazonas</md-option><md-option value=ap>Amapá</md-option><md-option value=ba>Bahia</md-option><md-option value=ce>Ceará</md-option><md-option value=df>Distrito Federal</md-option><md-option value=es>Espírito Santo</md-option><md-option value=go>Goiás</md-option><md-option value=ma>Maranhão</md-option><md-option value=mt>Mato Grosso</md-option><md-option value=ms>Mato Grosso do Sul</md-option><md-option value=mg>Minas Gerais</md-option><md-option value=pa>Pará</md-option><md-option value=pb>Paraíba</md-option><md-option value=pr>Paraná</md-option><md-option value=pe>Pernambuco</md-option><md-option value=pi>Piauí</md-option><md-option value=rj>Rio de Janeiro</md-option><md-option value=rn>Rio Grande do Norte</md-option><md-option value=ro>Rondônia</md-option><md-option value=rs>Rio Grande do Sul</md-option><md-option value=rr>Roraima</md-option><md-option value=sc>Santa Catarina</md-option><md-option value=se>Sergipe</md-option><md-option value=sp>São Paulo</md-option><md-option value=to>Tocantins</md-option></md-select></md-input-container></div><md-input-container><label>Nome do Pai</label><input ng-model=ctrl.form.nomePai></md-input-container><md-input-container><label>Nome da Mãe</label><input ng-model=ctrl.form.nomeMae name=nomeMae></md-input-container><div layout=row><md-input-container flex=50><label>Telefone Celular</label><input ng-model=ctrl.form.telefoneCelular ui-br-phone-number name=telefoneCelular required></md-input-container><md-input-container flex=50><label>Telefone Fixo</label><input ng-model=ctrl.form.telefoneFixo ui-br-phone-number name=telefoneFixo required></md-input-container></div><fieldset><legend>Dependentes - <button ng-click=ctrl.addDependentes(ctrl.form) type=button>Cadastrar Dependente</button></legend><div ng-repeat=\"item in ctrl.form.dependentes track by $index\" layout=column><div layout=row><md-input-container flex=50><label>Nome do Dependente {{$index+1}}</label><input type=text placeholder=Nome ng-model=item.name></md-input-container><md-input-container flex=25><label>CPF</label><input type=text ui-br-cpf-mask placeholder=CPF ng-model=item.cpf></md-input-container><md-input-container flex=25><label>Data de Nascimento</label><input type=date placeholder=Idade ng-model=item.Data_Nascimento></md-input-container></div><div layout=row><md-input-container flex=75><label>Nome da mãe</label><input type=text placeholder=\"Nome da mãe\" ng-model=item.NomeMae_Depedente></md-input-container><md-button ng-click=ctrl.removerDependente(item)>Remover</md-button></div></div></fieldset></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/client/dialogStatus.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Cliente</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>Status</label><md-select ng-model=ctrl.form.status required name=status><md-option>Selecione o Status</md-option><md-option value=Habilitado>Habilitado</md-option><md-option value=Desabilitado>Desabilitado</md-option></md-select><div ng-messages=formulario.status.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/client/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewClient module=client><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdMenu.open($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnExportClient module=client><md-button aria-label=Ativar ng-click=\"ctrl.exportReport(\'client\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item><md-menu-item permission=btnImportClient module=client><md-button aria-label=Import ng-click=ctrl.importarDialog()><i class=material-icons>attach_file</i> Importar Dados Excel</md-button></md-menu-item><md-menu-item permission=btnGenerateBilling module=client><md-button aria-label=Export ng-click=ctrl.gerarCobranca()><i class=material-icons>attach_money</i> Gerar Cobrança</md-button></md-menu-item><md-menu-item permission=btnListBilling module=client><md-button aria-label=Generate ui-sref=clientCobranca><i class=material-icons>local_atm</i> Listar Cobranças</md-button></md-menu-item><md-menu-item permission=btnSyncClientes module=client><md-button aria-label=Sync ng-click=ctrl.sincronizarClientesVindi()><i class=material-icons>autorenew</i> Sincronizar Clientes Vindi</md-button></md-menu-item></md-menu-content></md-menu></div></div><md-divider></md-divider><div class=header-model><h3>Clientes</h3></div><md-divider class=busca><div><div class=divBusca><label>Empresa:</label><br><input class=form-control ng-model=busca.empresa type=text></div><div class=divBusca><label for=nomeCliente>Nome Cliente:</label><br><input class=form-control ng-model=busca.nomeCliente type=text></div><div class=divBusca><label for=cpfCliente>CPF:</label><br><input class=form-control ng-model=busca.cpfCliente type=text ui-br-cpf-mask></div><div class=divBusca><label for=telefoneCliente>Telefone Cliente:</label><br><input class=form-control ng-model=busca.telefoneCliente type=text ui-br-phone-number></div><div class=divBusca><label for=celularCLiente>Celular Cliente</label><br><input class=form-control ng-model=busca.celularCliente ui-br-phone-number type=text></div><div class=divBusca><label for=dataCadastro>Data Cadastrado:</label><br><input class=form-control ng-model=busca.dataCadastroCliente type=date></div><div class=divBusca><md-button class=md-icon-button id=botaoBusca aria-label=Busca ng-click=ctrl.busca(busca)><i class=material-icons>search</i><md-tooltip md-direction=right>Busca</md-tooltip></md-button></div></div></md-divider><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-if=\"!ctrl.loading \" class=wrapper-grid><div ui-grid=ctrl.gridOptionsBusca class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div><div class=custom-csv-link-location hidden><span class=ui-grid-exporter-csv-link>&nbsp</span></div></md-content>");
$templateCache.put("app/clientCobranca/index.html","<md-content layout=column flex><div layout=row><div permission=btnExportCartao module=pjuridica><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item><md-button aria-label=Export ng-click=\"ctrl.exportExcel(\'clientCobranca\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item><md-menu-item><md-button aria-label=Export ng-click=ctrl.exportCsv()><i class=material-icons>import_export</i> Exportar Dados da Tabela</md-button></md-menu-item></md-menu-content></md-menu></div><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>P. Física - Cobrança</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-edit ui-grid-cellnav ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/corpoClinico/dialog-import.html","<md-dialog aria-label=Dialog class=dialog-size-50><form name=file enctype=multipart/form-data><md-toolbar><div class=md-toolbar-tools><h2>Importação de corpo clínico</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><md-card><img src=assets/images/pessoas.png style=\"width: 100px; padding-top: 10px; margin: auto\" class=md-card-image alt=Importar><md-card-title><md-card-title-text layout-align=\"center center\"><span class=md-headline>Cadastro de corpo clinico</span></md-card-title-text></md-card-title><md-card-content><p>Efetue a importação da planilha de corpo clínico.</p></md-card-content></md-card><div><!-- <lf-ng-md-file-input lf-files=\"file01\" lf-browse-label=\"Arquivo\"></lf-ng-md-file-input> --><!-- <input type=\"file\" import-sheet-js=\"\"/> --><!-- <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" /> --> <input type=file import-sheet-js=\"\" opts=planilha multiple></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button ng-click=ctrl.ImportarPlanilha(data)><span ng-show=!ctrl.submiting>Importar</span><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.submiting></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/corpoClinico/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario novalidate><md-toolbar><div class=md-toolbar-tools><h2>Rede</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><div flex=75><md-autocomplete class=md-primary md-selected-item=ctrl.selectedRede md-search-text-change=ctrl.searchTextChangeEmpresa(searchText) md-require-match=true md-select-on-match=true md-search-text=searchTextRede md-selected-item-change=ctrl.selectedItemChangeRede(item) md-clear-button=true md-items=\"item in ctrl.searchRede(searchTextRede) | orderBy : [\'codigoUnidade\', \'nomeRede\']\" md-item-text=item.nomeRede md-min-length=0 md-floating-label=\"Digite o prestador\"><md-item-template><span md-highlight-text=searchTextRede md-highlight-flags=ig>{{ item.codigoUnidade }} - {{ item.nomeRede }}</span></md-item-template></md-autocomplete></div><md-input-container flex=25><label>Codigo da Unidade</label><input ng-model=ctrl.form.codigoUnidade type=number ng-required=true disabled aria-disabled=true></md-input-container></div><div layout=row><md-input-container flex=50><label>Status</label><md-select placeholder=\"Seleciona o Status\" ng-model=ctrl.form.status md-floating-label=Status><md-option ng-value=ATIVO>Ativo</md-option><md-option ng-value=INATIVO>Inativo</md-option></md-select></md-input-container></div><div layout=\"\n              row\"><md-input-container flex=50><label>Especialidade</label><md-select placeholder=\"Seleciona a especialidade\" ng-model=ctrl.form.especialidade._id md-floating-label=Especialidade><md-option ng-value=especialidade._id ng-repeat=\"especialidade in ctrl.especialidades\">{{especialidade.nome}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Nome</label><input ng-model=ctrl.form.nome type=text ng-required=true></md-input-container></div><div layout=row><md-input-container flex=50><label>Tipo registro</label><input ng-model=ctrl.form.tipoRegistro type=text ng-required=true></md-input-container><md-input-container flex=50><label>Número de registro</label><input ng-model=ctrl.form.numeroRegistro required type=text></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/corpoClinico/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar permission=btnNewCorpoClinico module=corpoClinico aria-disabled=true ng-click=ctrl.edit($event)><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnImportCorpoClinico module=corpoClinico><md-button aria-label=Import ng-click=ctrl.importarDialog()><i class=material-icons>attach_file</i> Importar Dados Excel</md-button></md-menu-item></md-menu-content></md-menu></div><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Corpo Clinico</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/cupom/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(form) name=formulario id=formulario novalidate><md-toolbar><div class=md-toolbar-tools><h2>Cupom</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=column><md-autocomplete required class=md-primary md-selected-item=ctrl.selectedItem md-search-text-change=ctrl.searchTextChange(searchText) md-require-match=true md-select-on-match=true md-search-text=searchText md-selected-item-change=ctrl.selectedItemChange(item) md-items=\"item in ctrl.search(searchText) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite o vendedor associado\" md-input-name=autocompleteUser><md-item-template><span md-highlight-text=searchText md-highlight-flags=ig>{{item.name}}</span></md-item-template><div ng-messages=form.autocompleteUser.$error><div ng-message=required>Campo Obrigatório.</div><div ng-message=md-require-match>Selecione uma empresa existente na lista.</div></div></md-autocomplete></div><md-checkbox ng-model=ctrl.form.status aria-label=Checkbox>Cupom Habilitado</md-checkbox><md-input-container><label>Nome do Cupom</label><input ng-model=ctrl.form.name required></md-input-container><div layout=row><md-input-container flex><label>Comissão do Vendedor</label><input ng-model=ctrl.form.comissaoVendedor></md-input-container><md-input-container flex><label>Qtde Cadastrada</label><input ng-model=ctrl.form.qtde></md-input-container><md-input-container flex><label>Desconto do Cliente</label><input ng-model=ctrl.form.descontoCliente required></md-input-container><md-input-container flex><label>Data de Validade</label><input ng-model=ctrl.form.dataValidade type=date></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/cupom/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewCupom module=cupom><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div permission=btnExportCupom module=cupom><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnExportCupom module=cupom><md-button aria-label=Ativar ng-click=\"ctrl.exportReport(\'cupom\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item></md-menu-content></md-menu></div><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Cupons</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/documento/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Documentos</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><!-- vendedor --><md-autocomplete class=md-primary md-selected-item=ctrl.selectedItem md-search-text-change=ctrl.searchTextChange(searchText) md-require-match=true md-select-on-match=true md-search-text=searchText md-selected-item-change=ctrl.selectedItemChange(item) md-items=\"item in ctrl.searchCompany(searchText) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite o vendedor associado\" md-input-name=autocompleteVendedor><md-item-template><span md-highlight-text=searchText md-highlight-flags=ig>{{item.cpf}} - {{item.name}}</span></md-item-template></md-autocomplete><md-input-container><label>Nome do Documento</label><input ng-model=ctrl.form.name required name=nomeDocumento></md-input-container><md-input-container><label>Tipo do Documento</label><md-select ng-model=ctrl.form.tipo placeholder=\"Selecione o tipo do documento\" required name=tipoDocumento><md-optgroup label={{currentGroup}} ng-repeat=\"currentGroup in ctrl.groupList\"><md-option ng-value=item ng-selected=\"(item.name == ctrl.form.tipo.name)\" ng-repeat=\"item in ctrl.items | filter: {group: currentGroup}\">{{item.name}}</md-option></md-optgroup></md-select></md-input-container><div class=\"photo-upload row form-group\"><div upload perfil=ctrl.form filename=arquivo></div></div><md-input-container><label>Nome do Arquivo</label><input ng-model=ctrl.form.arquivo readonly required name=nomeArquivo></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"!formulario.$valid || ctrl.loading\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/documento/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewDocumento module=documento><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Documentos</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/email/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(form)><md-toolbar><div class=md-toolbar-tools><h2>E-mail</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>E-mail</label><input ng-model=ctrl.form.email></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/email/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewEmail module=email><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div permission=btnExportEmail module=email><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnExportEmail module=email><md-button aria-label=Ativar ng-click=\"ctrl.exportExcel(\'email\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item><md-menu-item permission=btnExportEmail module=email><md-button aria-label=Ativar ng-click=ctrl.exportCsv()><i class=material-icons>import_export</i> Exportar Dados da Tabela</md-button></md-menu-item></md-menu-content></md-menu></div><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>E-mails</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/emprestimo/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(form)><md-toolbar><div class=md-toolbar-tools><h2>Empréstimo</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>Nome do Cliente</label><input ng-model=ctrl.form.name></md-input-container><md-input-container><label>E-mail</label><input ng-model=ctrl.form.email></md-input-container><md-input-container><label>Cidade</label><input ng-model=ctrl.form.cidade></md-input-container><md-input-container><label>Telefone</label><input ng-model=ctrl.form.telefone></md-input-container><md-input-container><label>Valor Estimado</label><input ng-model=ctrl.form.valorEstimado></md-input-container><md-input-container><label>Mensagem</label><textarea ng-model=ctrl.form.mensagem></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/emprestimo/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewEmprestimo module=emprestimo><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Empréstimos</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/exames/dialog-import.html","<md-dialog aria-label=Dialog class=dialog-size-50><form name=file enctype=multipart/form-data><md-toolbar><div class=md-toolbar-tools><h2>Importação de exames</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><md-card><img src=assets/images/pessoas.png style=\"width: 100px; padding-top: 10px; margin: auto\" class=md-card-image alt=Importar><md-card-title><md-card-title-text layout-align=\"center center\"><span class=md-headline>Cadastro de exames</span></md-card-title-text></md-card-title><md-card-content><p>Efetue a importação da planilha de exames.</p><p style=color:darkred>Utilize a importação somente para <b>INSERIR</b> novos exames, e não atualizar os existentes</p></md-card-content></md-card><div><input type=file import-sheet-js=\"\" opts=planilha multiple></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button ng-click=ctrl.ImportarPlanilha(data)><span ng-show=!ctrl.submiting>Importar</span><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.submiting></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/exames/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-75><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario novalidate><md-toolbar><div class=md-toolbar-tools><h2>Exames</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><md-input-container flex=25><label>Codigo do exame</label><input ng-model=ctrl.form.codigoExame type=number ng-required=true></md-input-container></div><div layout=row><md-input-container flex=100><label>Nome do exame</label><input ng-model=ctrl.form.nomeExame type=text ng-required=true></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/exames/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewExames module=rede><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnImportCorpoClinico module=corpoClinico><md-button aria-label=Import ng-click=ctrl.importarDialog()><i class=material-icons>attach_file</i> Importar Dados Excel</md-button></md-menu-item></md-menu-content></md-menu></div></div><md-divider></md-divider><div class=header-model><h3>Exames</h3></div><md-divider></md-divider><md-divider class=busca><div><div class=divBuscaExame></div><div class=divBuscaExame><label>Codigo Exame:</label><br><input class=form-control ng-model=busca.codigoExame type=text><br></div><div class=divBuscaExame><label for=\"nome Exame\">Nome Exame:</label><br><input class=form-control ng-model=busca.nomeExame type=text><br></div><div class=divBuscaExame><md-button class=md-icon-button id=botaoBusca aria-label=Busca ng-click=ctrl.busca(busca)><i class=material-icons>search</i><md-tooltip md-direction=right>Busca</md-tooltip></md-button></div></div></md-divider><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-if=\"!ctrl.loading \" class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div><div class=custom-csv-link-location hidden><span class=ui-grid-exporter-csv-link>&nbsp</span></div></md-content>");
$templateCache.put("app/inicio/index.html","");
$templateCache.put("app/juridica/dialog-gerarCobranca.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.submit(formulario) name=formulario id=formulario novalidate><md-toolbar><div class=md-toolbar-tools><h2>Gerar Cobrança</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-autocomplete ng-model=ctrl.form.juridica class=md-primary md-selected-item=ctrl.selectedItemEmpresa md-search-text-change=ctrl.searchTextChangeEmpresa(item.name) md-require-match=false md-select-on-match=true md-search-text=searchTextEmpresa md-selected-item-change=ctrl.selectedItemChangeEmpresa(item) md-items=\"item in ctrl.searchCompanyEmpresa(searchTextEmpresa) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite a empresa associada\" md-input-name=autocompleteEmpresa><md-item-template><span md-highlight-text=searchTextEmpresa md-highlight-flags=ig>{{item.cnpj}} - {{item.name}}</span></md-item-template></md-autocomplete><md-input-container><label>Selecione o mês</label><md-select ng-model=ctrl.form.mes ng-required=true name=mes><md-option value=\"\">Selecione o mês</md-option><md-option value=01>Janeiro</md-option><md-option value=02>Fevereiro</md-option><md-option value=03>Março</md-option><md-option value=04>Abril</md-option><md-option value=05>Maio</md-option><md-option value=06>Junho</md-option><md-option value=07>Julho</md-option><md-option value=08>Agosto</md-option><md-option value=09>Setembro</md-option><md-option value=10>Outubro</md-option><md-option value=11>Novembro</md-option><md-option value=12>Dezembro</md-option></md-select><div ng-messages=formulario.mes.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"!formulario.$valid || ctrl.submiting\"><span ng-show=!ctrl.submiting>Gerar Cobrança</span><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.submiting></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/juridica/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario novalidate><md-toolbar><div class=md-toolbar-tools><h2>P. Jurídica</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>Status</label><md-select ng-model=ctrl.form.status ng-required=true name=status><md-option value=\"\">Selecione o Status</md-option><md-option value=Habilitado>Habilitado</md-option><md-option value=Desabilitado>Desabilitado</md-option></md-select><div ng-messages=formulario.status.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><div layout=column><md-autocomplete required class=md-primary md-selected-item=ctrl.selectedItem md-search-text-change=ctrl.searchTextChange(searchText) md-require-match=true md-select-on-match=true md-search-text=searchText md-selected-item-change=ctrl.selectedItemChange(item) md-items=\"item in ctrl.searchCompany(searchText) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite o vendedor associada\" md-input-name=autocompleteVendedor><md-item-template><span md-highlight-text=searchText md-highlight-flags=ig>{{item.cpf}} - {{item.name}}</span></md-item-template></md-autocomplete></div><div layout=row><md-input-container flex=50><label>Valor do Plano</label><input ng-model=ctrl.form.price minlength=1 ng-required=true maxlength=11 ui-money-mask></md-input-container><md-input-container flex=50><label>Dia do Vencimento</label><md-select ng-model=ctrl.form.dataVencimento name=dataVencimento ng-required=true><md-option value=\"\"></md-option><md-option value=5>5</md-option><md-option value=10>10</md-option><md-option value=15>15</md-option><md-option value=20>20</md-option><md-option value=25>25</md-option><md-option value=30>30</md-option></md-select></md-input-container></div><md-input-container><label>Nome da empresa</label><input ng-model=ctrl.form.name required></md-input-container><md-input-container><label>CNPJ</label><input ng-model=ctrl.form.cnpj required ui-br-cnpj-mask></md-input-container><md-input-container flex=70><label>E-mail</label><input ng-model=ctrl.form.email required></md-input-container><div layout=row><md-input-container flex=30><label>Cep</label><input ng-model=ctrl.form.cep required type=text ui-br-cep-mask ng-blur=ctrl.updateAddress() maxlength=9></md-input-container><md-input-container flex=50><label>Endereço</label><input ng-model=ctrl.form.endereco required></md-input-container><md-input-container flex=20><label>Número</label><input ng-model=ctrl.form.enderecoNumero></md-input-container></div><md-input-container flex=20><label>Complemento</label><input ng-model=ctrl.form.endereComplemento></md-input-container><div layout=row><md-input-container flex=33><label>Bairro</label><input ng-model=ctrl.form.bairro></md-input-container><md-input-container flex=33><label>Cidade</label><input ng-model=ctrl.form.cidade></md-input-container><md-input-container flex=33><label>Uf</label><md-select ng-model=ctrl.form.uf><md-option value=estado>Selecione o Estado</md-option><md-option value=ac>Acre</md-option><md-option value=al>Alagoas</md-option><md-option value=am>Amazonas</md-option><md-option value=ap>Amapá</md-option><md-option value=ba>Bahia</md-option><md-option value=ce>Ceará</md-option><md-option value=df>Distrito Federal</md-option><md-option value=es>Espírito Santo</md-option><md-option value=go>Goiás</md-option><md-option value=ma>Maranhão</md-option><md-option value=mt>Mato Grosso</md-option><md-option value=ms>Mato Grosso do Sul</md-option><md-option value=mg>Minas Gerais</md-option><md-option value=pa>Pará</md-option><md-option value=pb>Paraíba</md-option><md-option value=pr>Paraná</md-option><md-option value=pe>Pernambuco</md-option><md-option value=pi>Piauí</md-option><md-option value=rj>Rio de Janeiro</md-option><md-option value=rn>Rio Grande do Norte</md-option><md-option value=ro>Rondônia</md-option><md-option value=rs>Rio Grande do Sul</md-option><md-option value=rr>Roraima</md-option><md-option value=sc>Santa Catarina</md-option><md-option value=se>Sergipe</md-option><md-option value=sp>São Paulo</md-option><md-option value=to>Tocantins</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/juridica/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewPJ module=pjuridica><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnExportPJ module=pjuridica><md-button aria-label=Export ng-click=\"ctrl.exportExcel(\'juridica\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item><md-menu-item permission=btnExportPJ module=pjuridica><md-button aria-label=Export ng-click=ctrl.exportCsv()><i class=material-icons>import_export</i> Exportar Dados da Tabela</md-button></md-menu-item><md-menu-item permission=btnGenerateBillingPJ module=pjuridica><md-button aria-label=Export ng-click=ctrl.gerarCobranca()><i class=material-icons>attach_money</i> Gerar Cobrança</md-button></md-menu-item><md-menu-item permission=btnListBillingPJ module=pjuridica><md-button aria-label=Export ui-sref=juridicaCobranca><i class=material-icons>local_atm</i> Listar Cobranças</md-button></md-menu-item></md-menu-content></md-menu></div><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>P. Jurídica</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/juridicaCobranca/index.html","<md-content layout=column flex><div layout=row><div permission=btnExportCartao module=pjuridica><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item><md-button aria-label=Export ng-click=\"ctrl.exportExcel(\'juridicaCobranca\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item><md-menu-item><md-button aria-label=Export ng-click=ctrl.exportCsv()><i class=material-icons>import_export</i> Exportar Dados da Tabela</md-button></md-menu-item></md-menu-content></md-menu></div><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>P. Jurídica - Cobrança</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-edit ui-grid-cellnav ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/log/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-75 style=\"min-height: 50%\"><md-toolbar><div class=md-toolbar-tools><h2>Log - {{ctrl.operacao}}</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-content class=md-padding><user-friendly-json-tree object=ctrl.detalhes root-name=\"\'Dados\'\" start-expanded=true options=ctrl.options></user-friendly-json-tree></md-content></md-dialog>");
$templateCache.put("app/log/index.html","<md-content layout=column flex><md-divider></md-divider><div class=header-model><h3>Log</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/login/index.html","<div layout=row layout-align=\"center center\"><form ng-submit=ctrl.login() layout=column layout-align=\"center center\"><h4>LOGIN</h4><md-input-container><label>Nome de Usuário</label><input ng-model=ctrl.user.username></md-input-container><md-input-container><label>Senha</label><input type=password ng-model=ctrl.user.password></md-input-container><md-button type=submit class=\"md-raised md-primary md-block\" ng-show=!ctrl.sending>Conectar</md-button><div layout=row layout-sm=column layout-align=space-around ng-show=ctrl.sending><md-progress-circular md-mode=indeterminate></md-progress-circular></div></form></div>");
$templateCache.put("app/plan/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-100><form ng-cloak ng-submit=ctrl.save(form) name=formulario id=formulario novalidate><md-toolbar><div class=md-toolbar-tools><h2>Plano</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>Nome do Plano</label><input ng-model=ctrl.form.name required></md-input-container><md-checkbox ng-model=ctrl.form.viewOnTheSite aria-label=Checkbox>Mostrar no site</md-checkbox><div layout=row><md-autocomplete flex class=md-input md-selected-item=ctrl.form.produtoSelecionado md-items=\"produto in ctrl.BuscarProdutos(ctrl.searchTextProduto)\" md-item-text=produto.name md-require-match=false md-search-text-change=\"ctrl.searchTextChangeProduto(searchTextProduto) | orderBy : \'name\'\" md-search-text=ctrl.searchTextProduto md-select-on-match=true md-min-length=0 md-floating-label=\"Digite o produto do plano\" md-clear-button=true><md-item-template><span md-highlight-text=searchTextProduto>{{produto.name}} - {{produto.price | currency : \' R$ \' : 2}}</span></md-item-template></md-autocomplete><md-input-container flex=35 style=\"margin: 0px\"><div><md-tooltip md-direction=top>Periodo em meses em que esse produto será ativo dentro do plano Ex: 1 mês para taxa de adesão</md-tooltip><label>Ciclo de recorrência</label><md-select id=ciclo name=ciclo ng-model=ctrl.form.produtoSelecionado.ciclo ng-disabled=!ctrl.form.produtoSelecionado ng><md-option value=Ilimitado>Ilimitado</md-option><md-option value=1>1 Mês</md-option><md-option value=2>2 Meses</md-option><md-option value=3>3 Meses</md-option><md-option value=4>4 Meses</md-option><md-option value=5>5 Meses</md-option><md-option value=6>6 Meses</md-option><md-option value=7>7 Meses</md-option><md-option value=8>8 Meses</md-option><md-option value=9>9 Meses</md-option><md-option value=10>10 Meses</md-option><md-option value=11>11 Meses</md-option><md-option value=12>12 Meses</md-option></md-select></div></md-input-container><md-button class=md-icon-button aria-label=Adicionar permission=btnNewProduto module=plan style=\"float: right\" ng-disabled=!ctrl.form.produtoSelecionado.ciclo ng-click=ctrl.addProduto()><i class=material-icons>add_circle</i><md-tooltip>Adicionar Produto</md-tooltip></md-button></div><div><table style=\"margin-bottom: 20px\"><tr><th>Nome do produto</th><th>Valor</th><th>Periodo de recorrência - (Mês)es</th><th></th></tr><tr ng-repeat=\"produto in ctrl.form.produtos as produtos track by $index\"><td>{{produto.name}}</td><td>{{produto.price | currency : \' R$ \' : 2}}</td><td>{{produto.ciclo}}</td><td><md-button class=md-icon-button aria-label=Excluir ng-click=produtos.splice($index,1) permission=btnNewProduto module=plan style=\"float: right\"><i class=material-icons>delete</i><md-tooltip>Excluir Produto</md-tooltip></md-button></td></tr><tr><td style=\"border-bottom: none\">Valor total: {{ctrl.form.price | currency : \' R$ \' : 2}}</td></tr></table></div><!-- <div class=\"photo-upload row form-group\">\n          <div upload perfil=\"ctrl.form\" filename=\"imagem\"></div>\n        </div>   --><div layout=row><md-input-container flex=50><label>Tipo do plano</label><md-select ng-model=ctrl.form.tipoPlano><md-option value=Mensal selected>Mensal</md-option><md-option value=Trimestral>Trimestral</md-option><md-option value=Semestral>Semestral</md-option></md-select></md-input-container></div><md-input-container><label>Descrição</label><input ng-model=ctrl.form.descricaoPlano></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/plan/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewPlano module=plan><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Planos</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/produtos/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(form) name=formulario id=formulario novalidate><md-toolbar><div class=md-toolbar-tools><h2>Produto</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><label>Status</label><md-select ng-model=ctrl.form.status required name=status permission=btnStatusProduto module=produtos><md-option value=Ativo>Ativo</md-option><md-option value=Inativo>Inativo</md-option></md-select><md-input-container><label>Nome do Produto</label><input ng-model=ctrl.form.name required></md-input-container><md-input-container><label>Valor do Produto</label><input ng-model=ctrl.form.price minlength=1 required maxlength=11 ui-money-mask></md-input-container><md-input-container><label>Descrição</label><input ng-model=ctrl.form.descricao></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/produtos/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewProdutos module=produtos><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Produtos</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/rede/dialog-import.html","<md-dialog aria-label=Dialog class=dialog-size-50><form name=file enctype=multipart/form-data><md-toolbar><div class=md-toolbar-tools><h2>Importação de redes</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><md-card><img src=assets/images/pessoas.png style=\"width: 100px; padding-top: 10px; margin: auto\" class=md-card-image alt=Importar><md-card-title><md-card-title-text layout-align=\"center center\"><span class=md-headline>Cadastro de redes</span></md-card-title-text></md-card-title><md-card-content><p>Através deste recurso é possível sua empresa migrar os dados para o GRUPOSIN atraves de planilha utilizando o formato de Excel.<br>Para importar redes clique no botao abaixo.</p></md-card-content></md-card><div><!-- <lf-ng-md-file-input lf-files=\"file01\" lf-browse-label=\"Arquivo\"></lf-ng-md-file-input> --><!-- <input type=\"file\" import-sheet-js=\"\"/> --><!-- <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" /> --> <input type=file import-sheet-js=\"\" opts=planilha multiple></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button ng-click=ctrl.ImportarPlanilha(data)><span ng-show=!ctrl.submiting>Importar</span><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.submiting></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/rede/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-75><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Rede</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><md-input-container flex=70><label>Nome</label><input ng-model=ctrl.form.nomeRede type=text placeholder=\"Ex:. CENTRO MEDICO CLINICARE\" required></md-input-container><md-input-container flex=30><label>Codigo da Unidade</label><input ng-model=ctrl.form.codigoUnidade type=number required></md-input-container></div><div layout=row><md-input-container flex=50><label>CNPJ/CPF</label><input ng-model=ctrl.form.cnpj required type=text></md-input-container><md-input-container flex=50><label>Razao Social</label><input ng-model=ctrl.form.razao_social type=text placeholder=\"Ex:. CENTRO MEDICO CLINICARE LTDA\"></md-input-container></div><div layout=row><md-input-container flex=50><label>CEP</label><input ng-model=ctrl.form.cep ui-br-cep-mask type=text ng-blur=ctrl.updateAddress(ctrl.form.cep) maxlength=9 required></md-input-container><md-input-container flex=50><label>Número logradouro</label><input ng-model=ctrl.form.numero required type=text></md-input-container></div><div layout=row><md-input-container flex=70><label>Logradouro</label><input ng-model=ctrl.form.localAtendimento required type=text></md-input-container><md-input-container flex=30><label>Complemento</label><input ng-model=ctrl.form.complemento></md-input-container></div><div layout=row><md-input-container flex=40><label>Bairro</label><input ng-model=ctrl.form.bairro></md-input-container><md-input-container flex=40><label>Cidade</label><input ng-model=ctrl.form.cidade></md-input-container><md-input-container flex=20><label>Uf</label><md-select ng-model=ctrl.form.uf><md-option value=estado>Selecione o Estado</md-option><md-option value=ac>Acre</md-option><md-option value=al>Alagoas</md-option><md-option value=am>Amazonas</md-option><md-option value=ap>Amapá</md-option><md-option value=ba>Bahia</md-option><md-option value=ce>Ceará</md-option><md-option value=df>Distrito Federal</md-option><md-option value=es>Espírito Santo</md-option><md-option value=go>Goiás</md-option><md-option value=ma>Maranhão</md-option><md-option value=mt>Mato Grosso</md-option><md-option value=ms>Mato Grosso do Sul</md-option><md-option value=mg>Minas Gerais</md-option><md-option value=pa>Pará</md-option><md-option value=pb>Paraíba</md-option><md-option value=pr>Paraná</md-option><md-option value=pe>Pernambuco</md-option><md-option value=pi>Piauí</md-option><md-option value=rj>Rio de Janeiro</md-option><md-option value=rn>Rio Grande do Norte</md-option><md-option value=ro>Rondônia</md-option><md-option value=rs>Rio Grande do Sul</md-option><md-option value=rr>Roraima</md-option><md-option value=sc>Santa Catarina</md-option><md-option value=se>Sergipe</md-option><md-option value=sp>São Paulo</md-option><md-option value=to>Tocantins</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=50><label>Telefone 1</label><input ng-model=ctrl.form.telefoneFixo type=text ui-br-phone-number><div ng-messages=ctrl.form.telefoneFixo.$error><div ng-message=pattern>Telefone inválido</div></div></md-input-container><md-input-container flex=50><label>Telefone 2</label><input ng-model=ctrl.form.telefoneCelular type=text ui-br-phone-number><div ng-messages=ctrl.form.telefoneCelular.$error><div ng-message=pattern>Telefone inválido</div></div></md-input-container></div><div layout=row><md-input-container flex=50><label>E-mail</label><input ng-model=ctrl.form.email type=email placeholder=emaildaclinica@gruposin.com></md-input-container><md-input-container flex=50><label>Status</label><md-select ng-model=ctrl.form.status><md-option value=HABILITADO>Habilitado</md-option><md-option value=DESCREDENCIADO>Descredenciado</md-option><md-option value=PRE_CADASTRO>Pre_Cadastro</md-option></md-select></md-input-container></div><md-input-container><md-chips ng-model=ctrl.form.tipoRede md-autocomplete-snap md-require-match=true><md-autocomplete class=md-primary md-selected-item=ctrl.selectedItemTipo md-search-text=ctrl.searchTextTipo md-require-match=false md-select-on-match=true md-items=\"tipo in ctrl.searchTipo(ctrl.searchTextTipo)\" md-item-text=tipo md-clear-button=true placeholder=\"Tipos de rede\"><span md-highlight-text=ctrl.searchText>{{tipo}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips></md-input-container><!-- md-transform-chip=\"ctrl.transformChipEspecialidade($chip)\" --><md-input-container><md-chips ng-model=ctrl.form.especialidades md-autocomplete-snap md-require-match=true><md-autocomplete class=md-primary md-selected-item=ctrl.selectedItemEspecialidade md-search-text=ctrl.searchTextEspecialidade md-require-match=false md-select-on-match=true md-items=\"especialidade in ctrl.searchEspecialidade(ctrl.searchTextEspecialidade)\" md-item-text=especialidade.nome md-clear-button=true placeholder=Especialidades><span md-highlight-text=ctrl.searchText>{{especialidade.nome}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container><div layout=row><md-input-container flex=33><label>Banco</label><input ng-model=ctrl.form.banco type=text></md-input-container><md-input-container flex=33><label>Agencia</label><input ng-model=ctrl.form.agencia type=text></md-input-container><md-input-container flex=33><label>Conta</label><input ng-model=ctrl.form.conta type=text></md-input-container></div><div layout=row><md-input-container flex=25><md-checkbox flex=25 md-no-ink aria-label=\"Dr Achei\" ng-model=ctrl.form.drAchei class=md-primary>Dr. Achei</md-checkbox></md-input-container><md-input-container flex=25><md-checkbox flex=25 md-no-ink aria-label=Faturamento ng-model=ctrl.form.faturamento class=md-primary>Faturamento</md-checkbox></md-input-container><md-input-container flex=25><md-checkbox flex=25 md-no-ink ng-model=ctrl.form.pagamentoOnline class=md-primary>Pagamento Online</md-checkbox></md-input-container><md-input-container flex=25><md-checkbox flex=25 md-no-ink ng-model=ctrl.form.pagamentoUnidade class=md-primary>Pagamento Unidade</md-checkbox></md-input-container></div><div layout=row><md-input-container flex=25><md-checkbox md-no-ink ng-model=ctrl.form.agendamento class=md-primary>Agendamento</md-checkbox></md-input-container><md-input-container flex=25><label>Data faturamento</label><input ng-model=ctrl.form.dataFaturamento type=text></md-input-container><md-input-container flex=25><md-checkbox md-no-ink aria-label=\"Dr Achei\" ng-model=ctrl.form.taxaAdm class=md-primary>Taxa Adm</md-checkbox></md-input-container><md-input-container flex=25 ng-if=ctrl.form.taxaAdm><label>Valor Taxa Adm</label><input ng-model=ctrl.form.valorTaxaAdm type=number step=any></md-input-container></div><div layout=row><md-input-container flex=25><md-checkbox md-no-ink aria-label=Faturamento ng-model=ctrl.form.delivery class=md-primary>Delivery</md-checkbox></md-input-container><md-input-container flex=25 ng-if=ctrl.form.delivery><label>Valor Taxa Delivery</label><input ng-model=ctrl.form.taxaDelivery type=number step=any></md-input-container><md-input-container flex=25><md-checkbox md-no-ink ng-model=ctrl.form.coletaDomiciliar class=md-primary>Coleta Domiciliar</md-checkbox></md-input-container><md-input-container flex=25 ng-if=ctrl.form.coletaDomiciliar><label>Valor Taxa Coleta Domiciliar</label><input ng-model=ctrl.form.taxaColetaDomiciliar type=number step=any></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/rede/dialogServico.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Serviço (EXAME/CONSULTA)</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><div flex=75><md-autocomplete class=md-primary md-selected-item=ctrl.selectedRede md-search-text-change=ctrl.searchTextChangeEmpresa(searchText) md-require-match=true md-select-on-match=true md-search-text=searchTextRede md-selected-item-change=ctrl.selectedItemChangeRede(item) md-clear-button=true md-items=\"item in ctrl.searchRede(searchTextRede) | orderBy : [\'codigoUnidade\', \'nomeRede\']\" md-item-text=item.nomeRede md-min-length=0 md-floating-label=\"Digite o prestador\"><md-item-template><span md-highlight-text=searchTextRede md-highlight-flags=ig>{{ item.codigoUnidade }} - {{ item.nomeRede }}</span></md-item-template></md-autocomplete></div><md-input-container flex=25><label>Codigo da Unidade</label><input ng-model=ctrl.form.codigoUnidade type=number ng-required=true disabled aria-disabled=true></md-input-container></div><div layout=row><md-input-container flex=33><label>Tipo de serviço</label><md-select ng-model=ctrl.form.tipoServico required ng-disabled=ctrl.form._id><md-option value=Consulta>Consulta</md-option><md-option value=Exame>Exame</md-option></md-select></md-input-container><md-input-container flex=33><label>Codigo do serviço</label><input ng-model=ctrl.form.codigoServico type=number required></md-input-container><md-input-container flex=33><label>Codigo Secundário</label><input ng-model=ctrl.form.codigoSecundario type=number required></md-input-container></div><div layout=row><md-input-container flex=100><label>Descrição do serviço</label><input ng-model=ctrl.form.descricaoServico type=text></md-input-container></div><div layout=row ng-if=\"ctrl.form.tipoServico == \'Consulta\'\"><md-input-container flex=100><label>Especialidade</label><md-select placeholder=\"Seleciona a especialidade\" ng-model=ctrl.form.especialidade md-floating-label=Especialidade><md-option ng-value=especialidade._id ng-repeat=\"especialidade in ctrl.especialidades\">{{especialidade.nome}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=25><label>Valor particular</label><input ng-model=ctrl.form.valorParticular type=number step=any></md-input-container><md-input-container flex=25><label>Valor Sin Saude</label><input ng-model=ctrl.form.valorSinSaude type=number step=any></md-input-container><md-input-container flex=25><label>Valor Dr Achei</label><input ng-model=ctrl.form.valorDrAchei type=number step=any></md-input-container><md-input-container flex=25><label>Porcentagem desconto</label><input ng-model=ctrl.form.porcentagemDesconto type=text></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/rede/expandableRowTemplate.html","<div ui-grid=row.entity.subGridOptions ui-grid-exporter class=myGrid style=width:2100px></div>");
$templateCache.put("app/rede/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar permission=btnNewRede module=rede aria-disabled=true ng-click=ctrl.edit($event)><i class=material-icons>add_circle</i><md-tooltip>Adicionar Nova Rede</md-tooltip></md-button><md-button class=md-icon-button aria-label=Adicionar permission=btnNewRede module=rede aria-disabled=true ng-click=ctrl.editServico($event)><i class=material-icons>local_hospital</i><md-tooltip>Adicionar Novo Serviço</md-tooltip></md-button><div><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnImportRede module=rede><md-button aria-label=Import ng-click=ctrl.importarDialog()><i class=material-icons>attach_file</i> Importar Dados Excel</md-button></md-menu-item></md-menu-content></md-menu></div></div><md-divider></md-divider><div class=header-model><h3>Redes</h3></div><md-divider></md-divider><md-divider class=busca><div><div class=divBusca><label>Nome da Rede:</label><br><input class=form-control ng-model=busca.nomeRede type=text></div><div class=divBusca><label for=codigoUnidade>Cod. da Unidade:</label><br><input class=form-control ng-model=busca.codigoUnidade type=text></div><div class=divBusca><label for=cnpj>CNPJ:</label><br><input class=form-control ng-model=busca.cnpj type=text></div><div class=divBusca><label for=zoopSellerId>Id Rede Zoop:</label><br><input class=form-control ng-model=busca.zoopSellerId type=text></div><div class=divBusca><label for=tipoRede>Tipo Rede:</label><br><input class=form-control ng-model=busca.tipoRede type=text></div><div class=divBusca><label for=localAtendimento>Local Atend.:</label><br><input class=form-control ng-model=busca.localAtendimento type=text></div><div class=divBusca><label for=cidade>Cidade:</label><br><input class=form-control ng-model=busca.cidade type=text></div><div class=divBusca><label for=bairro>Bairro:</label><br><input class=form-control ng-model=busca.bairro type=text></div><div class=divBusca><label for=estado>Estado(Sigla):</label><br><input class=form-control ng-model=busca.estado type=text></div><div class=divBusca><md-button class=md-icon-button id=botaoBusca aria-label=Busca ng-click=ctrl.busca(busca)><i class=material-icons>search</i><md-tooltip md-direction=right>Busca</md-tooltip></md-button></div></div></md-divider><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-if=\"!ctrl.loading \" class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-expandable ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div><div class=custom-csv-link-location hidden><span class=ui-grid-exporter-csv-link>&nbsp</span></div></md-content>");
$templateCache.put("app/rede/view.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario novalidate><md-toolbar><div class=md-toolbar-tools><h2>Rede</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-card><img src=assets/images/curriculum.png class=md-card-image style=\"width: 56px; padding-top: 10px; margin: auto\" alt=Visualizar><md-card-title><md-card-title-text layout-align=\"center center\"><span class=md-headline>{{ ctrl.form.nomeRede.toUpperCase() }}</span> <span class=md-subheadline>{{ ctrl.form.cnpj }}</span></md-card-title-text></md-card-title><md-card-content><h3>Razao Social: {{ctrl.form.razao_social.toUpperCase()}}</h3><h3>Especialidades:</h3><ul ng-repeat=\"oitem in ctrl.form.especialidades\">{{oitem.nome}}</ul><h3>Contato:</h3>{{ctrl.form.nomeRede}}<h3>E-mail:</h3>{{ctrl.form.email}}<h3>Endereco:</h3>{{ ctrl.form.localAtendimento }} - {{ ctrl.form.numero }} , {{ctrl.form.uf.toUpperCase()}} - {{ ctrl.form.cidade }}<h3>Telefone 1:</h3>{{ctrl.form.telefoneFixo}}<h3>Telefone 2:</h3>{{ctrl.form.telefoneCelular}}</md-card-content></md-card></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/redeDocumento/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Documentos de Redes Credenciadas</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>Nome do Documento</label><input ng-model=ctrl.form.name required name=nomeDocumento></md-input-container><md-input-container><label>Tipo do Documento</label><md-select ng-model=ctrl.form.tipo placeholder=\"Selecione o tipo do documento\" required name=tipoDocumento id=tipoDocumento><md-option ng-value=value ng-repeat=\"(value,item) in ctrl.items\">{{item}}</md-option></md-select></md-input-container><div class=\"photo-upload row form-group\"><div upload perfil=ctrl.form filename=arquivo></div></div><md-input-container><label>Nome do Arquivo</label><input ng-model=ctrl.form.arquivo readonly required name=nomeArquivo></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"!formulario.$valid || ctrl.loading\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/redeDocumento/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewRedeDocumento module=documento><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Documentos de Redes Credenciadas</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/redeEspecialidade/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-75><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Especialidades de Redes Credenciadas</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><md-input-container flex=25><label>Codigo da Especialidade</label><input ng-model=ctrl.form._id required type=number><div ng-messages=formulario.name.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container flex=75><label>Nome da Especialidade</label><input ng-model=ctrl.form.nome required name=name><div ng-messages=formulario.name.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"!formulario.$valid || ctrl.loading\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/redeEspecialidade/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewRedeEspecialidade module=redeEspecialidade><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Especialidades</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/redeTipo/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Tipos de Redes Credenciadas</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><!--\n                <div layout=\"column\">\n                     <md-autocomplete\n                        required class=\"md-primary\"\n                        md-selected-item=\"selectedItemClient\"\n                        md-search-text-change=\"searchTextChangeClient(searchTextClient)\"\n                        md-require-match=\"true\"\n                        md-select-on-match=\"true\"\n                        md-search-text=\"searchTextClient\"\n                        md-selected-item-change=\"selectedItemChangeClient(item)\"\n                        md-items=\"item in searchClient(searchTextClient) | orderBy : \'name\'\"\n                        md-item-text=\"item.name\"\n                        md-min-length=\"0\"\n                        md-floating-label=\"Digite o cliente associado\"\n                        md-input-name=\"autocompleteClient\">\n                        <md-item-template>\n                            <span md-highlight-text=\"searchTextClient\" md-highlight-flags=\"ig\">{{item.cpf}} - {{item.name}}</span>\n                        </md-item-template>\n                        <div ng-messages=\"formulario.autocompleteClient.$error\">\n                            <div ng-message=\"required\">Campo Obrigatório</div>\n                            <div ng-message=\"md-require-match\">Selecione uma cliente existente na lista.</div>\n                        </div>\n                    </md-autocomplete>\n                    <md-autocomplete\n                        required\n                        class=\"md-primary\"\n                        md-selected-item=\"ctrl.selectedItemSaude\"\n                        md-search-text-change=\"ctrl.searchTextChangeSaude(searchTextSaude)\"\n                        md-require-match=\"true\"\n                        md-select-on-match=\"true\"\n                        md-search-text=\"searchTextSaude\"\n                        md-selected-item-change=\"ctrl.selectedItemChangeSaude(item)\"\n                        md-items=\"item in ctrl.searchSaude(searchTextSaude) | orderBy : \'vads_cust_first_name\'\"\n                        md-item-text=\"item.vads_order_id\"\n                        md-min-length=\"0\"\n                        md-floating-label=\"Digite o pedido associado\"\n                        md-input-name=\"autocompleteSaude\">\n                        <md-item-template>\n                            <span md-highlight-text=\"searchTextSaude\" md-highlight-flags=\"ig\">{{item.vads_order_id}} - {{item.vads_cust_first_name}} - {{item.vads_trans_status}}</span>\n                        </md-item-template>\n                        <div ng-messages=\"formulario.autocompleteSaude.$error\">\n                            <div ng-message=\"md-require-match\">Selecione uma pedido existente na lista.</div>\n                        </div>\n                    </md-autocomplete>\n                </div>\n         --><div layout=row><md-input-container flex=100><label>Nome da Especialidade</label><input ng-model=ctrl.form.name required name=name><div ng-messages=formulario.name.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"!formulario.$valid || ctrl.loading\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/redeTipo/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewRedeTipo module=redeTipo><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Tipos de Redes Credenciadas</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/saude/dados-fatura.html","<md-dialog aria-label=\"Dados Fatura\" style=\"min-width: 80%\"><form ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>Dados das faturas</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content flex class=md-dialog-content style=\"min-width: 80%\"><div ng-show=ctrl.carregando style=\"min-height: 250px\"><div layout=column layout-align=\"center center\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=50px layout-margin></md-progress-circular></div></div><div ng-show=!ctrl.carregando><table class=table><thead><th>Nº Parcela</th><th>Forma de pagamento</th><th>Data de vencimento da fatura</th><th>Data de vencimento da cobrança</th><th>Data do pagamento</th><th>Status</th><th></th></thead><tbody ng-show=ctrl.faturas><tr ng-repeat=\"fatura in ctrl.faturas\"><td>{{fatura.period.cycle}}</td><td>{{fatura.charges[0].payment_method.public_name}}</td><td>{{fatura.due_at | date : mediumDate}}</td><td>{{fatura.charges[0].due_at | date : mediumDate}}</td><td>{{fatura.charges[0].paid_at | date : mediumDate}}</td><td>{{ctrl.traduzirStatusPagamento(fatura.charges[0].last_transaction.status || fatura.status)}}</td><td><md-button href={{fatura.charges[0].print_url}} target=_blank md-autofocus class=md-primary ng-if=fatura.charges[0].print_url>Boleto <i class=\"material-icons btn-icon\" title=\"Visualizar boleto\">open_in_new</i></md-button></td></tr><h4 ng-show=\"ctrl.faturas == null\">Nenhuma fatura ou cobrança gerada para o pedido, verifique a data configurada para geração da cobrança ou verifique se é um pedido que esteja cadastrado na VINDI.</h4></tbody></table><!-- \n        <div layout=\"row\">\n          <md-input-container flex>\n            <label>Identificador:</label>\n            <input ng-model=\"ctrl.fat.id\" readonly>\n          </md-input-container>\n\n          <md-input-container flex>\n            <label>Forma de pagamento:</label>\n            <input ng-model=\"ctrl.tipoPagamento\" readonly>\n          </md-input-container>\n        </div>\n\n        <div layout=\"row\">\n          <md-input-container flex>\n            <label>Status:</label>\n            <input ng-model=\"ctrl.statusTraduzido\" readonly>\n          </md-input-container>\n\n          <md-input-container flex ng-if=\"ctrl.transacao.gateway_message\">\n            <label>Descrição:</label>\n            <input ng-model=\"ctrl.transacao.gateway_message\" readonly>\n          </md-input-container>\n        </div>\n\n        <div layout=\"row\">\n          <md-input-container flex ng-if=\"ctrl.fat.due_at\">\n            <label>Data de vencimento:</label>\n            <input ng-value=\"ctrl.fat.due_at | date : mediumDate\" readonly>\n          </md-input-container>\n\n          <md-input-container flex ng-if=\"ctrl.cobranca.paid_at\">\n            <label>Data do pagamento:</label>\n            <input ng-value=\"ctrl.cobranca.paid_at | date : mediumDate\" readonly>\n          </md-input-container>\n\n          <md-input-container flex ng-if=\"ctrl.cobranca.next_attempt\">\n            <label>Data da próxima cobrança:</label>\n            <input ng-value=\"ctrl.cobranca.next_attempt | date : mediumDate\" readonly>\n          </md-input-container>\n\n        </div>\n      </div>\n\n    </md-dialog-content>\n    <md-dialog-actions layout=\"row\">\n      <md-button href=\"{{ctrl.cobranca.print_url}}\" target=\"_blank\" md-autofocus class=\"md-primary\" ng-if=\"ctrl.cobranca.print_url\">\n        Visualizar Boleto\n      </md-button>\n    </md-dialog-actions> --></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/saude/dialog-pedido.html","<md-dialog aria-label=Dialog class=fullscreen-dialog><form ng-cloak ng-submit=ctrl.submit(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Novo Pedido</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-grid-list md-cols-lg=12 md-cols-gt-lg=15 md-cols-xs=3 md-cols-sm=6 md-cols-md=9 md-row-height-gt-md=1:1 md-row-height-md=1:1 md-row-height=1:2 md-gutter-gt-md=16px md-gutter-md=8px md-gutter=4px ng-show=!ctrl.formSIN.planoAvulso><h2 class=md-title>Escolha um plano</h2><md-grid-tile flex=33 required ng-repeat=\"item in ctrl.planos track by $index\" ng-show=\"ctrl.planos.length > 0\" ng-click=ctrl.setPlano(item) value={{item.name}} md-colspan=3 md-rowspan-gt-sm=3><md-radio-group ng-model=ctrl.plano_selecionado layout=row><md-radio-button value={{item}}>{{item.name}}<hr>{{item.price | currency : \' R$ \' : 2}}<br><small ng-show={{item.price}}>por mês</small></md-radio-button></md-radio-group></md-grid-tile></md-grid-list><div ng-show=ctrl.loadingPlanos><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px></md-progress-circular>Carregando Planos...</div><md-checkbox md-no-ink aria-label=\"Plano avulso\" ng-model=ctrl.formSIN.planoAvulso class=md-primary aria-checked=true>Pedido avulso<br><span class=\"md-caption md-warn md-align-top-left\">Selecione para adicionar itens avulsos</span></md-checkbox><div ng-show=ctrl.formSIN.planoAvulso><div><label>Escolha o tipo de serviço</label><md-select ng-model=ctrl.formSIN.tipoServico><md-option value=consultas selected>Consultas</md-option><md-option value=exames>Exames</md-option></md-select></div><div ng-show=\"ctrl.formSIN.tipoServico === \'consultas\'\"><div layout=row><md-input-container flex=40><label for=especialidade>Especialidade</label><md-select placeholder=\"Seleciona a especialidade\" ng-model=ctrl.avulso.codigoEspecialidade md-on-open=ctrl.loadEspecialidades() style=\"min-width: 200px\" md-floating-label=Especialidade><md-option ng-value=especialidade._id ng-repeat=\"especialidade in ctrl.especialidades\">{{especialidade.nome}}</md-option></md-select></md-input-container><div flex=40><md-autocomplete flex class=md-input md-selected-item=ctrl.avulso.cidade md-items=\"item in ctrl.BuscarCidades(ctrl.searchTextCidade)\" md-item-text=item.cidade md-require-match=false md-search-text=ctrl.searchTextCidade md-select-on-match=true md-min-length=0 md-floating-label=\"Escolha o local\" md-autofocus=true md-clear-button=true><md-item-template><span md-highlight-text=searchTextCidade>{{item}}</span></md-item-template></md-autocomplete></div><div flex=20 layout=column layout-align=center><md-button class=\"md-raised md-primary\" ng-click=ctrl.BuscarConsultas()>Buscar</md-button></div></div></div><div ng-show=\"ctrl.formSIN.tipoServico === \'exames\'\"><div layout=row><md-autocomplete flex class=md-input md-selected-item=ctrl.exameSelecionado md-items=\"exame in ctrl.FiltrarExames(ctrl.searchTextExame)\" md-item-text=exame.nomeExame md-require-match=false md-search-text=ctrl.searchTextExame md-select-on-match=true md-min-length=0 md-floating-label=\"Digite o exame\" md-autofocus=true md-clear-button=true><md-item-template><span md-highlight-text=searchTextExame>{{exame.nomeExame.toUpperCase()}}</span></md-item-template></md-autocomplete><div flex=40><md-autocomplete flex class=md-input md-selected-item=ctrl.avulso.cidade md-items=\"item in ctrl.BuscarCidades(ctrl.searchTextCidade)\" md-item-text=item.cidade md-require-match=false md-search-text=ctrl.searchTextCidade md-select-on-match=true md-min-length=0 md-floating-label=\"Escolha o local\" md-autofocus=true md-clear-button=true><md-item-template><span md-highlight-text=searchTextCidade>{{item}}</span></md-item-template></md-autocomplete></div><div flex=20 layout=column layout-align=center><md-button class=\"md-raised md-primary\" ng-click=ctrl.BuscarExames()>Buscar</md-button></div></div></div><md-list><md-subheader class=md-no-sticky>{{ctrl.formSIN.tipoServico.toUpperCase()}}</md-subheader><div layout=row layout-align=center><md-input-container flex=60><label>Nome Rede</label><input ng-model=filtroRede></md-input-container><md-input-container flex=40><label>Ordenar</label><md-select ng-model=order><md-option value=valores[0].valor>Menor preço</md-option><md-option value=-valores[0].valor>Maior preço</md-option></md-select></md-input-container></div><!-- Lista de Exames/Consultas --><md-content style=\"max-height: 400px\"><md-list-item ng-repeat=\"rede in ctrl.redes | filter:filtroRede | orderBy: order track by $index \" ng-click=\"ctrl.toggle(rede, $index)\"><!-- <md-checkbox ng-checked=\"ctrl.existeServico(rede)\"></md-checkbox> --><div class=md-list-item-text><h5>Cod. Unidade - Nome Rede - Local Atendimento - Descrição</h5><p>{{rede.codigoUnidade}} - {{rede.nomeRede}} - {{rede.local}} - {{rede.descServico}}</p></div><md-radio-group layout=row ng-model=rede.valor class=md-secondary ng-change=ctrl.CalcValorTotal()><md-radio-button ng-repeat=\"valor in rede.valores\" ng-value=valor.valor ng-disabled={{!valor.valor}}><h5>{{valor.label}}<br><span>{{valor.valor | currency : \' R$ \' : 2}}</span></h5></md-radio-button></md-radio-group></md-list-item></md-content><md-divider></md-divider><div><table style=\"margin-bottom: 20px\"><tr><th>Nome Rede</th><th>Valor</th><th></th></tr><tr ng-repeat=\"produto in ctrl.formSIN.produtos as produtos track by $index\"><td><strong>{{produto.nomeRede}}</strong> - {{produto.descServico}}</td><td>{{produto.valor | currency : \' R$ \': 2}}</td><td><md-button class=md-icon-button aria-label=Excluir ng-click=ctrl.deleteProduto($index) permission=btnNewProduto module=plan style=\"float: right\"><i class=material-icons>delete</i><md-tooltip>Excluir Produto</md-tooltip></md-button></td></tr><tr><td style=\"border-bottom: none\">Valor total: {{ctrl.formSIN.plano.price | currency : \' R$ \' : 2}}</td></tr></table></div></md-list></div><div layout=row layout-xs=column><!-- empresa --><md-autocomplete flex-xs=100 flex=50 class=md-primary md-selected-item=ctrl.selectedItemEmpresa md-search-text-change=ctrl.searchTextChangeEmpresa(searchTextCliente) md-require-match=false md-select-on-match=true md-search-text=searchTextEmpresa md-selected-item-change=ctrl.selectedItemChangeEmpresa(item) md-items=\"item in ctrl.searchCompanyEmpresa(searchTextEmpresa) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite a empresa associada\" md-input-name=autocompleteEmpresa><md-item-template><span md-highlight-text=searchTextEmpresa md-highlight-flags=ig>{{item.cnpf}} - {{item.name}}</span></md-item-template></md-autocomplete><!-- cliente --><md-autocomplete flex-xs=100 flex=50 required class=md-primary md-selected-item=ctrl.selectedItemCliente md-search-text-change=ctrl.searchTextChangeCliente(searchTextCliente) md-require-match=false md-select-on-match=true md-search-text=searchTextCliente md-selected-item-change=ctrl.selectedItemChangeCliente(item) md-items=\"item in ctrl.searchCompanyCliente(searchTextCliente) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite o cliente associado\" md-input-name=autocompleteCliente><md-item-template><span md-highlight-text=searchTextCliente md-highlight-flags=ig>{{item.cpf}} - {{item.name}}</span></md-item-template></md-autocomplete></div><div layout=row layout-xs=column><!-- vendedor --><md-autocomplete flex-xs=100 flex=50 required class=md-primary md-selected-item=ctrl.selectedItem md-search-text-change=ctrl.searchTextChange(searchText) md-require-match=false md-select-on-match=true md-search-text=searchText md-selected-item-change=ctrl.selectedItemChange(item) md-items=\"item in ctrl.searchCompany(searchText) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite o vendedor associada\" md-input-name=autocompleteVendedor><md-item-template><span md-highlight-text=searchText md-highlight-flags=ig>{{item.cpf}} - {{item.name}}</span></md-item-template></md-autocomplete><!-- cupom --><md-autocomplete flex-xs=100 flex=50 class=md-primary md-selected-item=ctrl.selectedItemCupom md-search-text-change=ctrl.searchTextChangeCupom(searchTextCupom) md-require-match=false md-select-on-match=true md-search-text=searchTextCupom md-selected-item-change=ctrl.selectedItemChangeCupom(item) md-items=\"item in ctrl.searchCompanyCupom(searchTextCupom) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite o cupom associado\" md-input-name=autocompleteCupom><md-item-template><span md-highlight-text=searchTextCupom md-highlight-flags=ig>{{item.name}} - {{item.descontoCliente}}% desconto cliente</span></md-item-template></md-autocomplete></div><div layout=column ng-show=!ctrl.formSIN.planoAvulso><ul><li>Valor do Plano: {{ctrl.formSIN.plano.price | currency : \' R$ \' : 2}}</li><li>Validade do Plano: {{ctrl.formSIN.plano.months}} <small>(baseado em meses)</small></li></ul><ul ng-show=ctrl.formSIN.cupom><li>% Cupom de desconto: {{ctrl.formSIN.cupom.descontoCliente || 0}}% = {{((ctrl.formSIN.plano.price) * ctrl.formSIN.cupom.descontoCliente) / 100 | currency : \' R$ \' : 2}}</li><li>Valor do plano com cupom de desconto: {{(ctrl.formSIN.plano.price - ((ctrl.formSIN.plano.price) * ctrl.formSIN.cupom.descontoCliente) / 100) | currency : \' R$ \' : 2}} <span><i class=\"material-icons md-16\">help</i><md-tooltip md-direction=right>Nesse caso, é alterado somente o valor do Plano.</md-tooltip></span></li><li>Valor do plano com cupom de desconto + Taxa de Adesão: {{ctrl.form.vads_amount | currency : \' R$ \' : 2}}</li></ul><ul><li>% Comissão do Vendedor: {{ctrl.formSIN.vendedor.comissaoVendedor || 0}}% <span><i class=\"material-icons md-16\">help</i><md-tooltip md-direction=right>Calculado com base somente no valor do plano (ou no valor digitado) *Nunca soma a taxa de adesão</md-tooltip></span></li><li>Valor que o vendedor vai ganhar: {{ctrl.formSIN.valorVendedorGanhar | currency : \' R$ \' : 2}}</li><li>% Comissão do Vendedor no cupom de desconto: {{ctrl.formSIN.cupom.comissaoVendedor || 0}}%</li><li>Valor que o vendedor vai ganhar: {{ctrl.formSIN.valorVendedorGanharCupom | currency : \' R$ \' : 2}}</li></ul></div><div layout=column ng-show=\"ctrl.formSIN.formadePagamento === \'VISTA\'\" flex=100><div><div ng-show=ctrl.formSIN.cupom><p>Valor total do cupom de desconto: ({{ctrl.formSIN.cupom.descontoCliente || 0}})%</p><p><small>Desconto aplicado apenas no (Valor do Plano * Qtde de Meses)</small></p>{{(((ctrl.formSIN.plano.price * ctrl.formSIN.plano.months) * ctrl.formSIN.cupom.descontoCliente) / 100) | currency : \' R$ \' : 2}}<p>Valor final que o cliente vai pagar</p><p>{{(ctrl.formSIN.plano.price * ctrl.formSIN.plano.months) - (((ctrl.formSIN.plano.price * ctrl.formSIN.plano.months) * ctrl.formSIN.cupom.descontoCliente) / 100)}}</p></div></div><md-input-container flex=100><label>Digitar Preço a Vista (Será somado com o valor da taxa de adesão)</label><input ng-model=ctrl.formSIN.precoDigitado ui-money-mask></md-input-container></div><div layout=row ng-show=\"ctrl.formSIN.plano.name == \'Outros\'\"><md-input-container flex=25><label>Valor do Plano</label><input ng-model=ctrl.formSIN.plano.price ui-money-mask></md-input-container><md-input-container flex=25><label>Qtde de Meses</label><input ng-model=ctrl.formSIN.plano.months min=1 type=number></md-input-container><md-button type=button class=\"md-raised md-primary\" flex=25 ng-click=ctrl.setPlano(ctrl.formSIN.plano)>Calcular Valor Final</md-button></div><md-input-container flex=100 ng-show=\"ctrl.formSIN.plano.name == \'Outros\'\"><label>Preço Final</label><input ng-model=ctrl.form.vads_amount ui-money-mask readonly></md-input-container><label>Forma de Pagamento</label><md-input-container flex=100><md-grid-list md-cols-lg=12 md-cols-gt-lg=15 md-cols-xs=3 md-cols-sm=6 md-cols-md=9 md-row-height-gt-md=1:1 md-row-height-md=1:1 md-row-height=1:2 md-gutter-gt-md=16px md-gutter-md=8px md-gutter=4px><md-grid-tile flex=33 required ng-repeat=\"opt in ctrl.options\" ng-show=\"ctrl.planos.length > 0\" md-colspan=2 md-rowspan-gt-sm=2><md-radio-group ng-model=ctrl.form.vads_payment_cards layout=row required><md-radio-button ng-value={{opt}}>{{opt.descricao}} <img ng-src=\"{{ opt.image }}\"></md-radio-button></md-radio-group></md-grid-tile></md-grid-list></md-input-container><!-- quando for outros --><md-input-container ng-show=\"(ctrl.form.vads_payment_cards.value === \'OUTROS\')\"><label>Outros</label><input ng-model=ctrl.formSIN.vads_payment_cards_name type=input></md-input-container><md-input-container flex ng-show=\"ctrl.form.vads_payment_cards.tipoPagamento === \'Boleto\'\"><label>Dias para vencimento do boleto</label><md-select ng-model=ctrl.formSIN.client.diaVencimentoBoleto ng-value={{dia.value}}><md-option ng-repeat=\"dia in ctrl.optionsDiasVencimentoBoleto\" ng-value=dia.key>{{dia.value}}</md-option></md-select><div class=hint style=\"position: static\">Selecione o número de dias para o vencimento dos boletos emitidos para o cliente</div></md-input-container><div layout=row><md-input-container flex=75><label>Nome do Cliente</label><input ng-model=ctrl.form.vads_cust_first_name readonly disabled></md-input-container><md-input-container flex=25><label>CPF</label><!--\n              Forma Original:\n                <input ng-model=\"ctrl.form.vads_cust_national_id\" ui-br-cpf-mask readonly=\"true\" disabled>\n            --> <input ng-model=ctrl.form.vads_cust_national_id readonly disabled></md-input-container></div><!-- Debito em conta --><fieldset ng-show=\"ctrl.form.vads_payment_cards.tipoPagamento === \'debitoConta\'\"><legend>Dados de pagamento</legend><div layout=row><md-input-container flex=\" 30\"><label>Agência</label><input ng-model=ctrl.formSIN.agencia type=input ng-required=\"ctrl.form.vads_payment_cards.tipoPagamento === \'debitoConta\'\"></md-input-container><md-input-container flex=50><label>Número da conta</label><input ng-model=ctrl.formSIN.numeroConta type=input ng-required=\"ctrl.form.vads_payment_cards.tipoPagamento === \'debitoConta\'\" placeholder=99999-9></md-input-container><md-input-container flex=20><label>Dia para débito</label><input ng-model=ctrl.formSIN.diaDebito type=number ng-required=\"ctrl.form.vads_payment_cards.tipoPagamento === \'debitoConta\'\" placeholder=0-30></md-input-container></div></fieldset><!-- Cartão de crédito --><fieldset ng-show=\"ctrl.form.vads_payment_cards.tipoPagamento === \'cartaoCredito\'\"><legend>Dados de pagamento</legend><div layout=column><md-input-container><label>Nº do Cartão</label><input ng-model=ctrl.form.vads_card_number></md-input-container><div layout=row><md-input-container flex=25><label>Cartão Usado</label><input ng-model=ctrl.form.vads_payment_cards.descricao readonly disabled></md-input-container><md-input-container flex=25><label>Mês de Expiração</label><md-select ng-model=ctrl.form.vads_expiry_month placeholder=Mês><md-option value=01>01</md-option><md-option value=02>02</md-option><md-option value=03>03</md-option><md-option value=04>04</md-option><md-option value=05>05</md-option><md-option value=06>06</md-option><md-option value=07>07</md-option><md-option value=08>08</md-option><md-option value=09>09</md-option><md-option value=10>10</md-option><md-option value=11>11</md-option><md-option value=12>12</md-option></md-select></md-input-container><md-input-container flex=25><label>Ano de Expiração</label><input ng-model=ctrl.form.vads_expiry_year type=number placeholder=\"Ano - Ex: 2025\"></md-input-container><md-input-container flex=25><label>CVV</label><input ng-model=ctrl.form.vads_cvv type=text></md-input-container></div></div></fieldset><div layout=row><md-input-container flex=25><label>Cep</label><!--\n              Formato original :\n              <input ng-model=\"ctrl.form.vads_cust_zip\"  ui-br-cep-mask ng-blur=\"ctrl.updateAddress()\" maxlength=\"9\" \n              readonly=\"true\" disabled>\n            --> <input ng-model=ctrl.form.vads_cust_zip readonly disabled></md-input-container><md-input-container flex=75><label>Endereço</label><input ng-model=ctrl.form.vads_cust_address readonly disabled></md-input-container></div><div layout=row><md-input-container flex=50><label>Cidade</label><input ng-model=ctrl.form.vads_cust_city readonly disabled></md-input-container><md-input-container flex=25><label>Bairro</label><input ng-model=ctrl.form.vads_cust_district readonly disabled></md-input-container><md-input-container flex=25><label>Estado</label><input required ng-model=ctrl.form.vads_cust_state readonly disabled></md-input-container></div><div layout=row><md-input-container flex=50><label>Nome do Pai</label><input ng-model=ctrl.formSIN.client.nomePai readonly disabled></md-input-container><md-input-container flex=50><label>Nome da Mãe</label><input ng-model=ctrl.formSIN.client.nomeMae readonly disabled></md-input-container></div><div layout=row><md-input-container flex=50><label>RG</label><input ng-model=ctrl.formSIN.client.rg readonly disabled></md-input-container><md-input-container flex=25><label>Orgão Emissor</label><input ng-model=ctrl.formSIN.client.orgaoEmissor readonly disabled></md-input-container><md-input-container flex=25><label>Estado</label><input ng-model=ctrl.formSIN.client.ufOrgaoEmissor readonly disabled></md-input-container></div><div layout=row><md-input-container flex=25><label>Data de Nasc</label><input ng-model=ctrl.formSIN.client.dataNascimento type=date readonly disabled></md-input-container><md-input-container flex=25><label>Sexo</label><input required ng-model=ctrl.formSIN.client.sexo readonly disabled></md-input-container><md-input-container flex=25><label>Naturalidade</label><input ng-model=ctrl.formSIN.client.naturalidade readonly disabled></md-input-container><md-input-container flex=25><label>Estado</label><input ng-model=ctrl.formSIN.client.ufNaturalidade readonly disabled></md-input-container></div><div layout=row><md-input-container flex=33><label>Estado Civil</label><input ng-model=ctrl.form.vads_cust_title readonly disabled></md-input-container><md-input-container flex=33><label>Telefone Fixo</label><!--\n              Forma Original:\n              <input ng-model=\"ctrl.form.vads_cust_phone\" ui-br-phone-number readonly=\"true\" disabled>\n            --> <input ng-model=ctrl.form.vads_cust_phone readonly disabled></md-input-container><md-input-container flex=33><label>Telefone Celular</label><!--\n              Forma Original:\n              <input ng-model=\"ctrl.form.vads_cust_cell_phone\" ui-br-phone-number readonly=\"true\" disabled>\n            --> <input ng-model=ctrl.form.vads_cust_cell_phone readonly disabled></md-input-container></div><md-input-container><label>E-mail</label><input ng-model=ctrl.form.vads_cust_email readonly disabled></md-input-container><div ng-repeat=\"item in ctrl.formSIN.client.dependentes track by $index\"><md-input-container><label>Nome Dependente</label><input ng-model=item.NomeDepedente readonly disabled></md-input-container><md-input-container><label>Nome da Mãe</label><input ng-model=item.NomeMae_Depedente readonly disabled></md-input-container><md-input-container><label>CPF</label><!--\n              Forma Original:\n              <input ng-model=\"item.CPF_Depedente\" ui-br-cpf-mask readonly=\"true\" disabled>\n              </md-input-container>\n            --> <input ng-model=item.CPF_Depedente readonly disabled></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"formulario.$invalid || ctrl.loading\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/saude/dialog-status.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save()><md-toolbar><div class=md-toolbar-tools><h2>Status de Pedido</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><md-input-container flex=50><label>Status</label><md-select ng-model=ctrl.form.vads_trans_status><md-option value=\"\">Selecione</md-option><md-option value=PENDENTE>Pendente</md-option><md-option value=PAGO>Pago</md-option></md-select></md-input-container><md-input-container flex=50><label>Data do Pagamento</label><input ng-model=ctrl.form.dataPagamentoFatura type=date></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/saude/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-75><form ng-cloak ng-submit=ctrl.save(form)><md-toolbar><div class=md-toolbar-tools><h2>Pedido - {{ctrl.form.idPedidoVindi}} # {{ctrl.form.createdAt | date : \'dd/MM/yyyy HH:mm:ss\' }}</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><md-input-container flex=75><label>Nome do Cliente</label><input ng-model=ctrl.form.client.name></md-input-container><md-input-container flex=25><label>CPF</label><input ng-model=ctrl.form.client.cpf></md-input-container></div><md-input-container><label>Data do Vencimento</label><input ng-model=ctrl.form.dataVencimentoFatura type=date></md-input-container><md-input-container><label>Cartão de Crédito</label><input ng-model=ctrl.form.vads_card_number></md-input-container><div layout=row><md-input-container><label>Tipo pagamento</label><input ng-model=ctrl.form.vads_payment_cards.descricao></md-input-container><md-input-container><label>Mês de Expiração</label><input ng-model=ctrl.form.vads_expiry_month></md-input-container><md-input-container><label>Ano de Expiração</label><input ng-model=ctrl.form.vads_expiry_year></md-input-container><md-input-container><label>CVV</label><input ng-model=ctrl.form.vads_cvv></md-input-container></div><div layout=row><md-input-container flex=75><label>Endereço</label><input ng-model=ctrl.form.client.enderecoResidencial></md-input-container><md-input-container flex=25><label>Zip</label><input ng-model=ctrl.form.client.cep></md-input-container></div><div layout=row><md-input-container flex=50><label>Cidade</label><input ng-model=ctrl.form.client.cidade></md-input-container><md-input-container flex=25><label>Bairro</label><input ng-model=ctrl.form.client.bairro></md-input-container><md-input-container flex=25><label>Estado</label><input ng-model=ctrl.form.client.uf></md-input-container></div><div layout=row><md-input-container flex=50><label>Nome do Pai</label><input ng-model=ctrl.form.client.nomePai></md-input-container><md-input-container flex=50><label>Nome da Mãe</label><input ng-model=ctrl.form.client.nomeMae></md-input-container></div><div layout=row><md-input-container flex=50><label>RG</label><input ng-model=ctrl.form.client.rg></md-input-container><md-input-container flex=25><label>Orgao Emissor</label><input ng-model=ctrl.form.client.orgaoEmissor></md-input-container><md-input-container flex=25><label>Estado</label><input ng-model=ctrl.form.client.ufOrgaoEmissor></md-input-container></div><div layout=row><md-input-container flex=25><label>Data de Nasc</label><input ng-model=ctrl.form.client.dataNascimento type=date readonly></md-input-container><md-input-container flex=25><label>Sexo</label><input ng-model=ctrl.form.client.sexo></md-input-container><md-input-container flex=25><label>Naturalidade</label><input ng-model=ctrl.form.client.naturalidade></md-input-container><md-input-container flex=25><label>Estado</label><input ng-model=ctrl.form.client.ufNaturalidade></md-input-container></div><md-input-container><label>Estado Civil</label><input ng-model=ctrl.form.client.estadoCivil></md-input-container><div layout=row><md-input-container flex=50><label>Telefone Fixo</label><input ng-model=ctrl.form.client.telefoneFixo></md-input-container><md-input-container flex=50><label>Telefone Celular</label><input ng-model=ctrl.form.client.telefoneCelular></md-input-container></div><md-input-container><label>E-mail</label><input ng-model=ctrl.form.client.email></md-input-container><div ng-repeat=\"item in ctrl.form.client.dependentes track by $index\"><md-input-container><label>Nome Dependente</label><input ng-model=item.name></md-input-container><md-input-container><label>Nome da Mãe</label><input ng-model=item.NomeMae_Depedente></md-input-container><md-input-container><label>CPF</label><input ng-model=item.cpf></md-input-container><md-input-container><label>Data de Nasc.</label><input ng-model=item.dataNascimento></md-input-container></div><fieldset ng-hide=ctrl.form.planoAvulso><legend>Dados do Plano Escolhido</legend><ul><li>Nome do Plano: {{ctrl.form.plano.name}}</li><li>Valor do Plano: {{ctrl.form.plano.price | currency}}</li><li>Qtde de Meses: {{ctrl.form.plano.months}}</li><li>Forma de Pagamento: {{ctrl.form.formadePagamento}}</li><li>Valor final: {{ctrl.form.vads_amount | currency}}</li><li>Valor final Recorrente: {{ctrl.form.vads_sub_amount | currency}}</li><li ng-show=ctrl.form.sendPayzen>Boleto {{ctrl.form.vads_trans_status == \"AUTHORIZED\" ? \"Pago\" : \"Pendente\"}}</li><li ng-show=ctrl.form.sendPayzen>Data de Vencimento {{ctrl.form.dataPagamentoFatura | date : \'dd/MM/yyyy\'}}</li></ul></fieldset><fieldset ng-show=ctrl.form.planoAvulso><legend>Dados do Pedido</legend><table><tr><th>Prestador</th><th>Tipo Serviço</th><th>Descrição Serviço</th><th>Valor</th><th>Especialidade</th></tr><tr ng-repeat=\"produto in ctrl.form.produtos\"><td>{{produto.nomeRede}}</td><td>{{produto.tipoServico}}</td><td>{{produto.descServico}}</td><td>{{produto.valor | currency : \' R$ \' : 2}}</td><td>{{produto.nomeEspecialidade || \'-\'}}</td></tr></table></fieldset><fieldset><legend>Vendedor</legend><ul><li>Nome do Vendedor: {{ctrl.form.vendedor.name || \'Nenhum vendedor vinculado\'}}</li><li>% Comissão do Vendedor: {{ctrl.form.vendedor.comissaoVendedor || \'0\'}}%</li></ul></fieldset><fieldset><legend>Cupom utilizado</legend><ul><li>Nome do Cupom: {{ctrl.form.cupom.name || \'Nenhum cupom foi utilizado\'}}</li><li>% Desconto p/Cliente: {{ctrl.form.cupom.descontoCliente || \'0\'}}%</li><li>% Comissão do Vendedor: {{ctrl.form.cupom.comissaoVendedor || \'0\'}}%</li><li>Vendedor vinculado ao Cupom: {{ctrl.form.cupom.vendedor.name || \'\'}}</li></ul></fieldset><fieldset><legend>Cliente que comprou</legend><ul><li>Id: {{ctrl.form.client._id}}</li><li>ID Transação Plano: {{ ctrl.form.client.idTransacaoPlanoZoop }}</li><li>ID Assinatura Plano: {{ ctrl.form.client.idAssinaturaZoop }}</li><li>Cadastrado no dia: {{ctrl.form.client.createdAt | date : \'dd/MM/yyyy HH:mm:ss\'}}</li></ul></fieldset></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/saude/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.insert($event) permission=btnNewSaude module=saude><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div permission=btnExportSaude module=saude><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item permission=btnExportSaude module=saude><md-button aria-label=Export ng-click=\"ctrl.exportExcel(\'saude\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item><md-menu-item permission=btnExportSaude module=saude><md-button aria-label=Export ng-click=ctrl.exportCsv()><i class=material-icons>import_export</i> Exportar Dados da Tabela</md-button></md-menu-item></md-menu-content></md-menu></div></div><md-divider></md-divider><div class=header-model><h3>Saúde</h3></div><md-divider class=busca><div><div class=divBusca><label>Empresa:</label><br><input class=form-control ng-model=busca.empresa type=text></div><div class=divBusca><label for=numeroPedido>Numero Pedido:</label><br><input class=form-control ng-model=busca.idPedidoVindi type=text></div><div class=divBusca><label for=id>Id Pedido:</label><br><input class=form-control ng-model=busca.pedidoId type=text></div><div class=divBusca><label for=nomeCliente>Nome Cliente:</label><br><input class=form-control ng-model=busca.nomeCliente type=text></div><div class=divBusca><label for=cpfCliente>CPF:</label><br><input class=form-control ng-model=busca.cpfCliente type=text ui-br-cpf-mask></div><div class=divBusca><label for=plano>Plano:</label><br><input class=form-control ng-model=busca.plano type=text></div><div class=divBusca><label for=dataCadastro>Data Cadastrado:</label><br><input class=form-control ng-model=busca.dataInicioPedido type=date></div><div id=divBotao><md-button class=md-icon-button id=botaoBusca aria-label=Busca ng-click=ctrl.busca(busca)><i class=material-icons>search</i><md-tooltip md-direction=center>Busca</md-tooltip></md-button></div></div></md-divider><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-if=\"!ctrl.loading \" class=wrapper-grid><div ui-grid=ctrl.gridOptionsBusca class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div><div class=custom-csv-link-location hidden><span class=ui-grid-exporter-csv-link>&nbsp</span></div></md-content>");
$templateCache.put("app/seguro/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(form)><md-toolbar><div class=md-toolbar-tools><h2>Seguro</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>Nome do Cliente</label><input ng-model=ctrl.form.name></md-input-container><md-input-container><label>E-mail</label><input ng-model=ctrl.form.email></md-input-container><md-input-container><label>Cidade</label><input ng-model=ctrl.form.cidade></md-input-container><md-input-container><label>Telefone</label><input ng-model=ctrl.form.telefone></md-input-container><md-input-container><label>Mensagem</label><textarea ng-model=ctrl.form.mensagem></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/seguro/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewSeguro module=seguro><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Seguros</h3></div><md-divider></md-divider><div><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pagination></div></div></div></md-content>");
$templateCache.put("app/totalizadores/index.html","<md-content layout=column flex><div class=header-model><h3>Totalizadores</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading layout-align=\"center center\"><md-card style=\"width: 70%\" md-theme=\"{{ showDarkTheme ? \'dark-grey\' : \'default\' }}\" md-theme-watch><md-card-content><table style=\"width: 100%\"><thead><tr><th style=\"text-align: left\">Tipo</th><th style=\"text-align: left\">Total</th></tr></thead><tbody><tr><td style=\"text-align: left\">Cartão de Crédito</td><td style=\"text-align: left\">{{ ctrl.totalCreditValue }}</td></tr><tr><td style=\"text-align: left\">Pagamento Pendente</td><td style=\"text-align: left\">{{ ctrl.totalBoletoPaymentValue }}</td></tr><tr><td style=\"text-align: left\">Zoop</td><td style=\"text-align: left\">{{ ctrl.zoopCurrentBalance }}</td></tr></tbody></table></md-card-content></md-card></div></md-content>");
$templateCache.put("app/transferencias/index.html","<md-content layout=column flex><div layout=row><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Transferências Zoop</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/user/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Usuários</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>Nome</label><input ng-model=ctrl.form.name required></md-input-container><md-input-container><label>Nome de Usuário</label><input ng-model=ctrl.form.username required></md-input-container><md-input-container><label>Senha</label><input ng-model=ctrl.form.password required></md-input-container><md-input-container><label>Tipo de Usuário</label><md-select ng-model=ctrl.form.role ng-required=true ng-disabled=\"ctrl.role != \'Administrador\'\"><md-option ng-repeat=\"role in ctrl.roles | orderBy:\'role\'\" ng-value=role>{{role}}</md-option></md-select></md-input-container><div layout=column ng-show=ctrl.validarUserRede()><md-autocomplete class=md-primary md-selected-item=ctrl.selectedRede md-search-text-change=ctrl.searchTextChangeEmpresa(searchText) md-require-match=true md-select-on-match=true md-search-text=searchTextRede md-selected-item-change=ctrl.selectedItemChangeRede(item) md-clear-button=true md-items=\"item in ctrl.searchRede(searchTextRede) | orderBy : [\'codigoUnidade\', \'nomeRede\']\" md-item-text=item.nomeRede md-min-length=0 md-floating-label=\"Digite o prestador\"><md-item-template><span md-highlight-text=searchTextRede md-highlight-flags=ig>{{ item.codigoUnidade }} - {{item.nomeRede }}</span></md-item-template></md-autocomplete></div><div layout=column ng-hide=\"ctrl.form.role != \'Master\'\"><md-autocomplete class=md-primary md-selected-item=ctrl.selectedItemEmpresa md-search-text-change=ctrl.searchTextChangeEmpresa(searchText) md-require-match=true md-select-on-match=true md-search-text=searchTextEmpresa ng-required=\"ctrl.form.role == \'Master\'\" md-selected-item-change=ctrl.selectedItemChangeEmpresa(item) md-items=\"item in ctrl.searchCompanyEmpresa(searchTextEmpresa) | orderBy : \'name\'\" md-item-text=item.name md-min-length=0 md-floating-label=\"Digite a empresa associada\" md-input-name=autocompleteEmpresa><md-item-template><span md-highlight-text=searchTextEmpresa md-highlight-flags=ig>{{item.cnpf}} - {{item.name}}</span></md-item-template></md-autocomplete></div><div ng-hide=\"ctrl.role != \'Administrador\'\" ng-show=\"ctrl.form.role != \'Atendente\'\"><fieldset><legend>Permissões de Acesso</legend><div><div ng-repeat=\"item in ctrl.form.permission track by $index\"><h4>{{item.moduleName}}</h4><div><div ng-repeat=\"rule in item.rules\"><md-checkbox ng-model=rule.value>{{rule.label}}</md-checkbox></div></div></div></div></fieldset></div></div></md-dialog-content><div layout=row layout-sm=column layout-align=space-around ng-show=loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><md-dialog-actions layout=row ng-show=!loading><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=\"!formulario.$valid || ctrl.loading\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Salvar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/user/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=\"ctrl.edit($event, {})\" permission=btnNewUser module=user><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Usuários</h3></div><md-divider></md-divider><md-content layout=row flex layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></md-content><md-content layout=column flex ng-show=!ctrl.loading><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></md-content></md-content>");
$templateCache.put("app/validacao/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.update(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Validação</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><div layout=row><md-input-container flex><label>Nome</label><input ng-model=ctrl.form.cliente.name ng-readonly=true></md-input-container><md-input-container flex><label>CPF</label><input ng-model=ctrl.form.cliente.cpf ng-readonly=true></md-input-container></div><div layout=row><md-input-container flex><label>Telefone Celular</label><input ng-model=ctrl.form.cliente.telefoneCelular ng-readonly=true></md-input-container><md-input-container flex><label>E-mail</label><input ng-model=ctrl.form.cliente.email ng-readonly=true></md-input-container></div><div layout=row><md-input-container flex><label>Tipo Pedido</label><input ng-model=ctrl.form.tipoPedido ng-readonly=true></md-input-container><md-input-container flex ng-if=\"ctrl.form.tipoPedido === \'CONSULTA\'\"><label>Data/Hora Agendamento</label><input ng-model=ctrl.dataHoraAgendamento ng-readonly=true></md-input-container><md-input-container flex><label>Status do Pagamento</label><input ng-model=ctrl.form.statusPagamento ng-readonly=true></md-input-container></div><div layout=row><md-input-container flex><label>Status do Atendimento</label><input ng-model=ctrl.form.statusAtendimento ng-readonly=true></md-input-container><md-input-container flex><label>Valor Total</label><input ng-model=ctrl.valorTotalFormatado ng-readonly=true></md-input-container></div><div layout=row><md-input-container flex><label>Unidade</label><input ng-model=ctrl.form.unidade.nomeRede ng-readonly=true></md-input-container><md-input-container flex><label>Cidade</label><input ng-model=ctrl.form.unidade.cidade ng-readonly=true></md-input-container><md-input-container flex><label>Estado</label><input ng-model=ctrl.form.unidade.estado ng-readonly=true></md-input-container></div><div layout=row><md-input-container flex><label>Endereço</label><input ng-model=ctrl.form.unidade.localAtendimento ng-readonly=true></md-input-container><md-input-container flex><label>Número</label><input ng-model=ctrl.form.unidade.numero ng-readonly=true></md-input-container></div><div layout=row><md-input-container flex><label>Complemento</label><input ng-model=ctrl.form.unidade.complemento ng-readonly=true></md-input-container></div><div layout=row><md-input-container flex><label>Bairro</label><input ng-model=ctrl.form.unidade.bairro ng-readonly=true></md-input-container><md-input-container flex><label>CEP</label><input ng-model=ctrl.form.unidade.cep ng-readonly=true></md-input-container><md-input-container flex><label>Telefone Fixo</label><input ng-model=ctrl.form.unidade.telefoneFixo ng-readonly=true></md-input-container><md-input-container flex><label>Telefone Celular</label><input ng-model=ctrl.form.unidade.telefoneCelular ng-readonly=true></md-input-container></div><div layout=row ng-if=\"ctrl.form.tipoPedido === \'CONSULTA\'\"><md-input-container flex><label>Especialidade</label><input ng-model=ctrl.form.consulta.especialidade.nome ng-readonly=true></md-input-container></div><div layout=row ng-if=\"ctrl.form.tipoPedido === \'EXAME\'\"><fieldset><legend>Exames</legend><div><div ng-repeat=\"exame in ctrl.form.exames track by $index\"><p><md-checkbox ng-model=exame.atendido ng-checked=true></md-checkbox>{{ exame.codigoExame }} - {{ exame.nomeExame }}</p></div></div></fieldset></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button class=\"md-raised md-primary\" type=submit ng-disabled=\"!formulario.$valid || ctrl.loading\" ng-if=\"(ctrl.form.statusPagamento === \'CONCLUIDO\' && ctrl.form.statusAtendimento === \'AGUARDANDO\') || (ctrl.form.pagamentoAto && ctrl.form.statusAtendimento === \'AGUARDANDO\')\"><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px ng-show=ctrl.loading></md-progress-circular><span ng-show=!ctrl.loading>Marcar como Realizado!</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/validacao/index.html","<md-content layout=column flex><div layout=row><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Validação</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-pinning ui-grid-exporter ui-grid-pagination></div></div></md-content>");
$templateCache.put("app/vendedor/dialog.html","<md-dialog aria-label=Dialog class=dialog-size-50><form ng-cloak ng-submit=ctrl.save(formulario) name=formulario id=formulario><md-toolbar><div class=md-toolbar-tools><h2>Vendedor</h2><span flex></span><md-button class=md-icon-button ng-click=ctrl.cancel()><i class=material-icons>close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content layout=column><md-input-container><label>Status</label><md-select ng-model=ctrl.form.status ng-required=true name=status><md-option value=\"\">Selecione o Status</md-option><md-option value=Habilitado>Habilitado</md-option><md-option value=Desabilitado>Desabilitado</md-option></md-select><div ng-messages=formulario.status.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container><label>Nome</label><input ng-model=ctrl.form.name required name=nome><div ng-messages=formulario.nome.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container><label>Nome de Usuário</label><input ng-model=ctrl.form.username required><div ng-messages=formulario.username.$error><div ng-message=required>Campo Obrigatório</div></div></md-input-container><md-input-container><label>CPF</label><input ng-model=ctrl.form.cpf name=cpf required ui-br-cpf-mask><div ng-messages=formulario.cpf.$error><div ng-message=required>Campo Obrigatório</div><div ng-message=cpf>CPF Inválido</div></div></md-input-container><md-input-container><label>% Comissão do Vendedor</label><input ng-model=ctrl.form.comissaoVendedor type=number required min=0></md-input-container><div layout=row><md-input-container flex=33><label>RG</label><input ng-model=ctrl.form.rg ng-required=true></md-input-container><md-input-container flex=33><label>Orgão Emissor</label><input ng-model=ctrl.form.orgaoEmissor required></md-input-container><md-input-container flex=33><label>UF Orgão Emissor</label><md-select class=form-control required ng-model=ctrl.form.ufOrgaoEmissor><md-option value=estado>Selecione o Estado</md-option><md-option value=ac>Acre</md-option><md-option value=al>Alagoas</md-option><md-option value=am>Amazonas</md-option><md-option value=ap>Amapá</md-option><md-option value=ba>Bahia</md-option><md-option value=ce>Ceará</md-option><md-option value=df>Distrito Federal</md-option><md-option value=es>Espírito Santo</md-option><md-option value=go>Goiás</md-option><md-option value=ma>Maranhão</md-option><md-option value=mt>Mato Grosso</md-option><md-option value=ms>Mato Grosso do Sul</md-option><md-option value=mg>Minas Gerais</md-option><md-option value=pa>Pará</md-option><md-option value=pb>Paraíba</md-option><md-option value=pr>Paraná</md-option><md-option value=pe>Pernambuco</md-option><md-option value=pi>Piauí</md-option><md-option value=rj>Rio de Janeiro</md-option><md-option value=rn>Rio Grande do Norte</md-option><md-option value=ro>Rondônia</md-option><md-option value=rs>Rio Grande do Sul</md-option><md-option value=rr>Roraima</md-option><md-option value=sc>Santa Catarina</md-option><md-option value=se>Sergipe</md-option><md-option value=sp>São Paulo</md-option><md-option value=to>Tocantins</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=33><label>Sexo</label><md-select required ng-model=ctrl.form.sexo><md-option value=Masculino>Masculino</md-option><md-option value=Feminino>Feminino</md-option></md-select></md-input-container><md-input-container flex=33><label>Estado Civil</label><md-select ng-model=ctrl.form.estadoCivil required><md-option value=\"\">Selecione um Estado Civíl</md-option><md-option value=\"Casado (a)\">Casado (a)</md-option><md-option value=\"Separado (a)\">Separado (a)</md-option><md-option value=\"Solteiro (a)\">Solteiro (a)</md-option><md-option value=\"Viúvo (a)\">Viúvo (a)</md-option></md-select></md-input-container><md-input-container flex=33><label>Data de Nascimento</label><input type=date ng-model=ctrl.form.dataNascimento required></md-input-container></div><div layout=row><md-input-container flex=50><label>Naturalidade</label><input ng-model=ctrl.form.naturalidade required></md-input-container><md-input-container flex=50><label>Uf</label><md-select ng-model=ctrl.form.ufNaturalidade required><md-option value=estado>Selecione o Estado</md-option><md-option value=ac>Acre</md-option><md-option value=al>Alagoas</md-option><md-option value=am>Amazonas</md-option><md-option value=ap>Amapá</md-option><md-option value=ba>Bahia</md-option><md-option value=ce>Ceará</md-option><md-option value=df>Distrito Federal</md-option><md-option value=es>Espírito Santo</md-option><md-option value=go>Goiás</md-option><md-option value=ma>Maranhão</md-option><md-option value=mt>Mato Grosso</md-option><md-option value=ms>Mato Grosso do Sul</md-option><md-option value=mg>Minas Gerais</md-option><md-option value=pa>Pará</md-option><md-option value=pb>Paraíba</md-option><md-option value=pr>Paraná</md-option><md-option value=pe>Pernambuco</md-option><md-option value=pi>Piauí</md-option><md-option value=rj>Rio de Janeiro</md-option><md-option value=rn>Rio Grande do Norte</md-option><md-option value=ro>Rondônia</md-option><md-option value=rs>Rio Grande do Sul</md-option><md-option value=rr>Roraima</md-option><md-option value=sc>Santa Catarina</md-option><md-option value=se>Sergipe</md-option><md-option value=sp>São Paulo</md-option><md-option value=to>Tocantins</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=100><label>E-mail</label><input ng-model=ctrl.form.email></md-input-container></div><div layout=row><md-input-container flex=30><label>Cep</label><input ng-model=ctrl.form.cep required type=text ng-blur=ctrl.updateAddress() ui-br-cep-mask></md-input-container><md-input-container flex=50><label>Endereço</label><input ng-model=ctrl.form.enderecoResidencial></md-input-container><md-input-container flex=20><label>Número</label><input ng-model=ctrl.form.enderecoNumero required></md-input-container></div><md-input-container flex=20><label>Complemento</label><input ng-model=ctrl.form.endereComplemento></md-input-container><div layout=row><md-input-container flex=33><label>Bairro</label><input ng-model=ctrl.form.bairro></md-input-container><md-input-container flex=33><label>Cidade</label><input ng-model=ctrl.form.cidade></md-input-container><md-input-container flex=33><label>Uf</label><md-select ng-model=ctrl.form.uf><md-option value=estado>Selecione o Estado</md-option><md-option value=ac>Acre</md-option><md-option value=al>Alagoas</md-option><md-option value=am>Amazonas</md-option><md-option value=ap>Amapá</md-option><md-option value=ba>Bahia</md-option><md-option value=ce>Ceará</md-option><md-option value=df>Distrito Federal</md-option><md-option value=es>Espírito Santo</md-option><md-option value=go>Goiás</md-option><md-option value=ma>Maranhão</md-option><md-option value=mt>Mato Grosso</md-option><md-option value=ms>Mato Grosso do Sul</md-option><md-option value=mg>Minas Gerais</md-option><md-option value=pa>Pará</md-option><md-option value=pb>Paraíba</md-option><md-option value=pr>Paraná</md-option><md-option value=pe>Pernambuco</md-option><md-option value=pi>Piauí</md-option><md-option value=rj>Rio de Janeiro</md-option><md-option value=rn>Rio Grande do Norte</md-option><md-option value=ro>Rondônia</md-option><md-option value=rs>Rio Grande do Sul</md-option><md-option value=rr>Roraima</md-option><md-option value=sc>Santa Catarina</md-option><md-option value=se>Sergipe</md-option><md-option value=sp>São Paulo</md-option><md-option value=to>Tocantins</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=50><label>Telefone Celular</label><input ng-model=ctrl.form.telefoneCelular required ui-br-phone-number></md-input-container><md-input-container flex=50><label>Telefone Fixo</label><input ng-model=ctrl.form.telefoneFixo ui-br-phone-number></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.cancel()>Cancelar</md-button><md-button type=submit ng-disabled=!formulario.$valid>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/vendedor/index.html","<md-content layout=column flex><div layout=row><md-button class=md-icon-button aria-label=Adicionar ng-click=ctrl.edit($event) permission=btnNewVendedor module=vendedores><i class=material-icons>add_circle</i><md-tooltip>Adicionar</md-tooltip></md-button><div permission=btnExportVendedor module=vendedores><md-menu><md-button aria-label=\"Open Menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=material-icons>more_vert</i><md-tooltip>Mais ações</md-tooltip></md-button><md-menu-content width=4><md-menu-item><md-button aria-label=Ativar ng-click=\"ctrl.exportReport(\'user\')\"><i class=material-icons>import_export</i> Exportar Dados</md-button></md-menu-item></md-menu-content></md-menu></div><span flex></span><md-button class=md-icon-button aria-label=Pesquisar ng-click=ctrl.toggleFiltering()><i class=material-icons>search</i><md-tooltip md-direction=left>Filtrar</md-tooltip></md-button></div><md-divider></md-divider><div class=header-model><h3>Vendedores</h3></div><md-divider></md-divider><div layout=row layout-sm=column layout-align=\"center center\" ng-show=ctrl.loading><md-progress-circular md-mode=indeterminate></md-progress-circular></div><div layout=column ng-show=!ctrl.loading class=wrapper-grid><div ui-grid=ctrl.gridOptions class=myGrid ui-grid-auto-resize ui-grid-exporter ui-grid-pinning ui-grid-pagination></div></div></md-content>");}]);